import { useId } from 'react'

export { ReactComponent as IconText } from '../images/icons/text.svg'
export { ReactComponent as ErrorCatSVG } from '../images/allicons/errorCat.svg'
export { ReactComponent as IconAvatarDollar } from '../images/allicons/avatar_dollar.svg'
export { ReactComponent as IconPrivateStream } from '../images/allicons/liveNotification.svg'
export { ReactComponent as IconLiveNotification } from '../images/allicons/video-camera.svg'

interface SVGProps {
    width?: string
    height?: string
    color?: string
    backgroundColor?: string
    circleColor?: string
    bubbleColor?: string
    dotsColor?: string
    opacity?: number
}

export const IconCalendarInactive = () => {
    return (
        <svg
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M18.7969 1.82812H18.639L18.3281 1.40625V0.703125C18.3281 0.314812 18.0133 0 17.625 0C17.2367 0 16.9219 0.314812 16.9219 0.703125V1.40625L16.4699 1.82812H11.5922L11.2969 1.40625V0.703125C11.2969 0.314812 10.9821 0 10.5938 0C10.2054 0 9.89062 0.314812 9.89062 0.703125V1.40625L9.51839 1.82812H4.56619L4.21875 1.40625V0.703125C4.21875 0.314812 3.90394 0 3.51562 0C3.12731 0 2.8125 0.314812 2.8125 0.703125V1.40625L2.44027 1.82812H1.92188L0 5.67188V20.4375C0 20.8258 0.314812 21.1406 0.703125 21.1406H20.4375C20.8258 21.1406 21.1406 20.8258 21.1406 20.4375V5.67188L18.7969 1.82812Z'
                fill='#AFAFAF'
            />
            <path
                d='M21.1406 2.10938C21.1406 1.72106 20.8258 1.40625 20.4375 1.40625H18.3281V3.51562C18.3281 3.90394 18.0133 4.21875 17.625 4.21875C17.2367 4.21875 16.9219 3.90394 16.9219 3.51562V1.40625H11.2969V3.51562C11.2969 3.90394 10.9821 4.21875 10.5938 4.21875C10.2054 4.21875 9.89062 3.90394 9.89062 3.51562V1.40625H4.21875V3.51562C4.21875 3.90394 3.90394 4.21875 3.51562 4.21875C3.12731 4.21875 2.8125 3.90394 2.8125 3.51562V1.40625H0.703125C0.314812 1.40625 0 1.72106 0 2.10938V5.67188H21.1406V2.10938ZM6.32812 8.48438H3.51562C3.12731 8.48438 2.8125 8.79919 2.8125 9.1875V12C2.8125 12.3883 3.12731 12.7031 3.51562 12.7031H6.32812C6.71644 12.7031 7.03125 12.3883 7.03125 12V9.1875C7.03125 8.79919 6.71644 8.48438 6.32812 8.48438ZM12 8.48438H9.1875C8.79919 8.48438 8.48438 8.79919 8.48438 9.1875V12C8.48438 12.3883 8.79919 12.7031 9.1875 12.7031H12C12.3883 12.7031 12.7031 12.3883 12.7031 12V9.1875C12.7031 8.79919 12.3883 8.48438 12 8.48438ZM14.8125 8.48438C14.4242 8.48438 14.1094 8.79919 14.1094 9.1875V12C14.1094 12.3883 14.4242 12.7031 14.8125 12.7031H17.625C18.0133 12.7031 18.3281 12.3883 18.3281 12V9.1875C18.3281 8.79919 18.0133 8.48438 17.625 8.48438H14.8125ZM12 14.1094H9.1875C8.79919 14.1094 8.48438 14.4242 8.48438 14.8125V17.625C8.48438 18.0133 8.79919 18.3281 9.1875 18.3281H12C12.3883 18.3281 12.7031 18.0133 12.7031 17.625V14.8125C12.7031 14.4242 12.3883 14.1094 12 14.1094ZM6.32812 14.1094H3.51562C3.12731 14.1094 2.8125 14.4242 2.8125 14.8125V17.625C2.8125 18.0133 3.12731 18.3281 3.51562 18.3281H6.32812C6.71644 18.3281 7.03125 18.0133 7.03125 17.625V14.8125C7.03125 14.4242 6.71644 14.1094 6.32812 14.1094ZM19.0312 14.1094C16.3173 14.1094 14.1094 16.3173 14.1094 19.0312C14.1094 21.771 16.3173 24 19.0312 24C21.7573 24 24 21.7468 24 19.0312C24 16.3173 21.771 14.1094 19.0312 14.1094ZM20.4375 19.7344H19.0312C18.6429 19.7344 18.3281 19.4196 18.3281 19.0312V17.625C18.3281 17.2367 18.6429 16.9219 19.0312 16.9219C19.4196 16.9219 19.7344 17.2367 19.7344 17.625V18.3281H20.4375C20.8258 18.3281 21.1406 18.6429 21.1406 19.0312C21.1406 19.4196 20.8258 19.7344 20.4375 19.7344Z'
                fill='#F5F5F6'
            />
        </svg>
    )
}

export const IconCalendarActive = () => {
    return (
        <svg
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M18.7969 1.82812H18.639L18.3281 1.40625V0.703125C18.3281 0.314812 18.0133 0 17.625 0C17.2367 0 16.9219 0.314812 16.9219 0.703125V1.40625L16.4699 1.82812H11.5922L11.2969 1.40625V0.703125C11.2969 0.314812 10.9821 0 10.5938 0C10.2054 0 9.89062 0.314812 9.89062 0.703125V1.40625L9.51839 1.82812H4.56619L4.21875 1.40625V0.703125C4.21875 0.314812 3.90394 0 3.51562 0C3.12731 0 2.8125 0.314812 2.8125 0.703125V1.40625L2.44027 1.82812H1.92188L0 5.67188V20.4375C0 20.8258 0.314812 21.1406 0.703125 21.1406H20.4375C20.8258 21.1406 21.1406 20.8258 21.1406 20.4375V5.67188L18.7969 1.82812Z'
                fill='url(#paint0_linear_4945_24049)'
            />
            <path
                d='M21.1406 2.10938C21.1406 1.72106 20.8258 1.40625 20.4375 1.40625H18.3281V3.51562C18.3281 3.90394 18.0133 4.21875 17.625 4.21875C17.2367 4.21875 16.9219 3.90394 16.9219 3.51562V1.40625H11.2969V3.51562C11.2969 3.90394 10.9821 4.21875 10.5938 4.21875C10.2054 4.21875 9.89062 3.90394 9.89062 3.51562V1.40625H4.21875V3.51562C4.21875 3.90394 3.90394 4.21875 3.51562 4.21875C3.12731 4.21875 2.8125 3.90394 2.8125 3.51562V1.40625H0.703125C0.314812 1.40625 0 1.72106 0 2.10938V5.67188H21.1406V2.10938ZM6.32812 8.48438H3.51562C3.12731 8.48438 2.8125 8.79919 2.8125 9.1875V12C2.8125 12.3883 3.12731 12.7031 3.51562 12.7031H6.32812C6.71644 12.7031 7.03125 12.3883 7.03125 12V9.1875C7.03125 8.79919 6.71644 8.48438 6.32812 8.48438ZM12 8.48438H9.1875C8.79919 8.48438 8.48438 8.79919 8.48438 9.1875V12C8.48438 12.3883 8.79919 12.7031 9.1875 12.7031H12C12.3883 12.7031 12.7031 12.3883 12.7031 12V9.1875C12.7031 8.79919 12.3883 8.48438 12 8.48438ZM14.8125 8.48438C14.4242 8.48438 14.1094 8.79919 14.1094 9.1875V12C14.1094 12.3883 14.4242 12.7031 14.8125 12.7031H17.625C18.0133 12.7031 18.3281 12.3883 18.3281 12V9.1875C18.3281 8.79919 18.0133 8.48438 17.625 8.48438H14.8125ZM12 14.1094H9.1875C8.79919 14.1094 8.48438 14.4242 8.48438 14.8125V17.625C8.48438 18.0133 8.79919 18.3281 9.1875 18.3281H12C12.3883 18.3281 12.7031 18.0133 12.7031 17.625V14.8125C12.7031 14.4242 12.3883 14.1094 12 14.1094ZM6.32812 14.1094H3.51562C3.12731 14.1094 2.8125 14.4242 2.8125 14.8125V17.625C2.8125 18.0133 3.12731 18.3281 3.51562 18.3281H6.32812C6.71644 18.3281 7.03125 18.0133 7.03125 17.625V14.8125C7.03125 14.4242 6.71644 14.1094 6.32812 14.1094ZM19.0312 14.1094C16.3173 14.1094 14.1094 16.3173 14.1094 19.0312C14.1094 21.771 16.3173 24 19.0312 24C21.7573 24 24 21.7468 24 19.0312C24 16.3173 21.771 14.1094 19.0312 14.1094ZM20.4375 19.7344H19.0312C18.6429 19.7344 18.3281 19.4196 18.3281 19.0312V17.625C18.3281 17.2367 18.6429 16.9219 19.0312 16.9219C19.4196 16.9219 19.7344 17.2367 19.7344 17.625V18.3281H20.4375C20.8258 18.3281 21.1406 18.6429 21.1406 19.0312C21.1406 19.4196 20.8258 19.7344 20.4375 19.7344Z'
                fill='url(#paint1_linear_4945_24049)'
            />
            <defs>
                <linearGradient
                    id='paint0_linear_4945_24049'
                    x1='10.5703'
                    y1='21.1406'
                    x2='10.5703'
                    y2='0'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#4AA6F0' />
                    <stop offset='1' stopColor='#00C0FF' />
                </linearGradient>
                <linearGradient
                    id='paint1_linear_4945_24049'
                    x1='12'
                    y1='24'
                    x2='12'
                    y2='1.40625'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#ADDCFF' />
                    <stop offset='0.5028' stopColor='#EAF6FF' />
                    <stop offset='1' stopColor='#EAF6FF' />
                </linearGradient>
            </defs>
        </svg>
    )
}

export const IconDolarCircleInactive = () => {
    return (
        <svg
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z'
                fill='#AFAFAF'
            />
            <path
                d='M13.0922 18.5455C13.0922 19.1484 12.6042 19.6364 12.0012 19.6364C11.3983 19.6364 10.9103 19.1484 10.9103 18.5455V17.2472C10.3141 17.0362 9.77928 16.6727 9.38473 16.1474C9.02255 15.6658 9.11841 14.9818 9.59993 14.6196C10.0772 14.2596 10.7633 14.3512 11.1276 14.8348C11.7029 15.5998 13.0922 15.1289 13.0922 14.1818C13.0922 13.5799 12.6021 13.0909 12.0012 13.0909C10.1966 13.0909 8.72852 11.6228 8.72852 9.81819C8.72852 8.39783 9.64328 7.19819 10.9103 6.74641V5.45456C10.9103 4.85158 11.3983 4.36365 12.0012 4.36365C12.6042 4.36365 13.0922 4.85158 13.0922 5.45456V6.75281C13.6884 6.96387 14.2232 7.32728 14.6178 7.85267C14.9799 8.33419 14.8841 9.01819 14.4026 9.38037C13.9252 9.74045 13.2413 9.64779 12.8748 9.16517C12.666 8.88706 12.3464 8.72728 12.0012 8.72728C11.4004 8.72728 10.9103 9.2163 10.9103 9.81819C10.9103 10.4201 11.4004 10.9091 12.0012 10.9091C13.8059 10.9091 15.274 12.3772 15.274 14.1818C15.274 15.6022 14.3592 16.8018 13.0922 17.2536V18.5455Z'
                fill='#F5F5F6'
            />
        </svg>
    )
}

export const IconDolarCircleActive = () => {
    return (
        <svg
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z'
                fill='url(#paint0_linear_4945_23953)'
            />
            <path
                d='M13.0922 18.5455C13.0922 19.1484 12.6042 19.6364 12.0012 19.6364C11.3983 19.6364 10.9103 19.1484 10.9103 18.5455V17.2472C10.3141 17.0362 9.77928 16.6727 9.38473 16.1474C9.02255 15.6658 9.11841 14.9818 9.59993 14.6196C10.0772 14.2596 10.7633 14.3512 11.1276 14.8348C11.7029 15.5998 13.0922 15.1289 13.0922 14.1818C13.0922 13.5799 12.6021 13.0909 12.0012 13.0909C10.1966 13.0909 8.72852 11.6228 8.72852 9.81819C8.72852 8.39783 9.64328 7.19819 10.9103 6.74641V5.45456C10.9103 4.85158 11.3983 4.36365 12.0012 4.36365C12.6042 4.36365 13.0922 4.85158 13.0922 5.45456V6.75281C13.6884 6.96387 14.2232 7.32728 14.6178 7.85267C14.9799 8.33419 14.8841 9.01819 14.4026 9.38037C13.9252 9.74045 13.2413 9.64779 12.8748 9.16517C12.666 8.88706 12.3464 8.72728 12.0012 8.72728C11.4004 8.72728 10.9103 9.2163 10.9103 9.81819C10.9103 10.4201 11.4004 10.9091 12.0012 10.9091C13.8059 10.9091 15.274 12.3772 15.274 14.1818C15.274 15.6022 14.3592 16.8018 13.0922 17.2536V18.5455Z'
                fill='url(#paint1_linear_4945_23953)'
            />
            <defs>
                <linearGradient
                    id='paint0_linear_4945_23953'
                    x1='12'
                    y1='24'
                    x2='12'
                    y2='0'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#4AA6F0' />
                    <stop offset='1' stopColor='#00C0FF' />
                </linearGradient>
                <linearGradient
                    id='paint1_linear_4945_23953'
                    x1='12.0012'
                    y1='19.6364'
                    x2='12.0012'
                    y2='4.36365'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#ADDCFF' />
                    <stop offset='0.5028' stopColor='#EAF6FF' />
                    <stop offset='1' stopColor='#EAF6FF' />
                </linearGradient>
            </defs>
        </svg>
    )
}

export const IconList = ({ color, width = '22', height = '18' }: SVGProps) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox='0 0 22 18'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <rect
                x='6.5'
                width='15.5'
                height='3.09115'
                rx='1.54557'
                fill={color ?? '#AFAFAF'}
            />
            <rect
                width='3.66667'
                height='3.09115'
                rx='1.54557'
                fill={color ?? '#AFAFAF'}
            />
            <rect
                x='6.5'
                y='7.45435'
                width='15.5'
                height='3.09115'
                rx='1.54557'
                fill={color ?? '#AFAFAF'}
            />
            <rect
                y='7.45435'
                width='3.66667'
                height='3.09115'
                rx='1.54557'
                fill={color ?? '#AFAFAF'}
            />
            <rect
                x='6.5'
                y='14.9088'
                width='15.5'
                height='3.09115'
                rx='1.54557'
                fill={color ?? '#AFAFAF'}
            />
            <rect
                y='14.9088'
                width='3.66667'
                height='3.09115'
                rx='1.54557'
                fill={color ?? '#AFAFAF'}
            />
        </svg>
    )
}

export const IconTwitter = ({ color }: SVGProps) => {
    return (
        <svg
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M18.2439 2.25H21.5519L14.3249 10.51L22.8269 21.75H16.1699L10.9559 14.933L4.98991 21.75H1.67991L9.40991 12.915L1.25391 2.25H8.07991L12.7929 8.481L18.2439 2.25ZM17.0829 19.77H18.9159L7.08391 4.126H5.11691L17.0829 19.77Z'
                fill={color ?? '#AFAFAF'}
            />
        </svg>
    )
}

export const IconImageOutline = ({
    color,
    width = '20',
    height = '20'
}: SVGProps) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox='0 0 20 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g clipPath='url(#clip0_4945_25533)'>
                <path
                    d='M14.3 0.75H5.65002C2.65002 0.75 0.75 2.89003 0.75 5.91003V14.1C0.75 17.1 2.63002 19.26 5.65002 19.26H14.3C17.3 19.26 19.2 17.12 19.2 14.1V5.95996C19.21 2.88996 17.33 0.75 14.3 0.75Z'
                    stroke={color ?? '#200E32'}
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M8.69999 6.78994C8.69998 7.15626 8.59121 7.51443 8.38749 7.81887C8.18376 8.12332 7.89426 8.36043 7.55564 8.50015C7.21701 8.63987 6.84452 8.67586 6.48539 8.60366C6.12625 8.53147 5.79663 8.35436 5.5383 8.09463C5.27998 7.8349 5.10459 7.50432 5.03434 7.1448C4.96409 6.78528 5.00216 6.41296 5.14371 6.0751C5.28527 5.73724 5.5239 5.44893 5.82944 5.24685C6.13499 5.04478 6.49364 4.93799 6.85996 4.93997C7.10244 4.93996 7.34255 4.98787 7.56644 5.08096C7.79033 5.17405 7.99359 5.31053 8.16459 5.48245C8.33558 5.65437 8.4709 5.8584 8.56278 6.08279C8.65466 6.30719 8.7013 6.54747 8.69999 6.78994V6.78994Z'
                    stroke={color ?? '#200E32'}
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M19.21 12.95C18.2811 12.0076 17.2779 11.1415 16.21 10.36C15.6857 10.0561 15.0641 9.96654 14.4753 10.11C13.8864 10.2535 13.3758 10.619 13.05 11.13C12.28 12.13 11.81 13.45 10.65 14.07C9.23002 14.85 8.39001 13.6 7.20001 13.07C6.01001 12.54 4.86998 13.52 4.09998 14.47C3.32998 15.42 2.54 16.38 1.75 17.33'
                    stroke={color ?? '#200E32'}
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </g>
            <defs>
                <clipPath id='clip0_4945_25533'>
                    <rect width='19.96' height='19.95' fill='white' />
                </clipPath>
            </defs>
        </svg>
    )
}

export const IconVideoOutline = ({ color, circleColor }: SVGProps) => {
    return (
        <svg
            width='24'
            height='18'
            viewBox='0 0 24 18'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M17.0399 13.6469C17.0601 14.0964 16.9892 14.5453 16.8313 14.968C16.6734 15.3907 16.4316 15.7788 16.1198 16.1103C15.8079 16.4417 15.4321 16.7099 15.0139 16.8995C14.5957 17.0891 14.1433 17.1964 13.6826 17.2152C13.5397 17.2258 13.3963 17.2258 13.2535 17.2152H6.58163C6.1227 17.2524 5.66077 17.2004 5.22252 17.0624C4.78427 16.9245 4.37837 16.7031 4.0283 16.4112C3.67823 16.1193 3.39093 15.7627 3.18296 15.3619C2.97499 14.961 2.85047 14.524 2.81663 14.0759C2.80592 13.9331 2.80592 13.7897 2.81663 13.6469V6.32186C2.79648 5.87239 2.86738 5.42342 3.02528 5.00072C3.18317 4.57802 3.42495 4.18985 3.7368 3.85842C4.04864 3.52698 4.42443 3.25878 4.84264 3.06918C5.26084 2.87958 5.71326 2.77231 6.17402 2.75348H13.2642C14.1904 2.68683 15.1061 2.97906 15.8129 3.56672C16.5197 4.15439 16.9606 4.99012 17.0399 5.89278C17.0399 6.02882 17.0399 6.16487 17.0399 6.30091V13.6469Z'
                stroke={color ?? '#200E32'}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M17.0391 9.10538L21.4369 5.59984C21.6552 5.42515 21.9353 5.34144 22.2164 5.36691C22.4975 5.39238 22.757 5.52497 22.9386 5.73588C23.0985 5.92415 23.1858 6.16105 23.1853 6.40556V13.5946C23.186 13.7926 23.1291 13.9868 23.0212 14.1545C22.9133 14.3222 22.7588 14.4566 22.5757 14.5421C22.3926 14.6275 22.1884 14.6606 21.9868 14.6374C21.7852 14.6141 21.5946 14.5356 21.4369 14.4108L17.0391 10.9053'
                stroke={color ?? '#200E32'}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <circle
                cx='4'
                cy='4'
                r='3.5'
                fill={circleColor ?? '#FF0000'}
                stroke='white'
            />
        </svg>
    )
}

export const IconAudioOutline = ({
    color,
    width = '18',
    height = '20'
}: SVGProps) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox='0 0 18 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M0.828125 9.00159C0.905877 10.9252 1.8009 12.7464 3.32501 14.0822C4.84911 15.4181 6.88353 16.1645 9.00041 16.1645C11.1173 16.1645 13.1517 15.4181 14.6758 14.0822C16.1999 12.7464 17.0949 10.9252 17.1727 9.00159'
                stroke={color ?? '#200E32'}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M9.00586 19.2474V16.4275'
                stroke={color ?? '#200E32'}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M9.1381 12.6644H8.87323C7.80196 12.6644 6.77456 12.2774 6.01705 11.5886C5.25955 10.8998 4.83398 9.96558 4.83398 8.99148V4.42557C4.83398 3.45147 5.25955 2.51727 6.01705 1.82847C6.77456 1.13968 7.80196 0.752686 8.87323 0.752686H9.14913C10.2204 0.752686 11.2478 1.13968 12.0053 1.82847C12.7628 2.51727 13.1884 3.45147 13.1884 4.42557V8.99148C13.1884 9.96558 12.7628 10.8998 12.0053 11.5886C11.2478 12.2774 10.2204 12.6644 9.14913 12.6644H9.1381Z'
                stroke={color ?? '#200E32'}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}

export const IconChartOutline = ({ color }: SVGProps) => {
    return (
        <svg
            width='20'
            height='18'
            viewBox='0 0 20 18'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <rect
                y='8'
                width='5'
                height='10'
                rx='2'
                fill={color ?? '#200E32'}
            />
            <rect
                x='7.7'
                y='0.7'
                width='4.6'
                height='16.6'
                rx='1.3'
                stroke={color ?? '#200E32'}
                strokeWidth='1.4'
            />
            <rect
                x='15'
                y='5'
                width='5'
                height='13'
                rx='2'
                fill={color ?? '#200E32'}
            />
        </svg>
    )
}

export const IconSquarePlusOutline = ({
    color,
    width = '30',
    height = '30'
}: SVGProps) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox='0 0 30 30'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M15 9.87909V20.107'
                stroke={color ?? 'white'}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M20.121 14.9861H9.87915'
                stroke={color ?? 'white'}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M21.5443 1.04654H8.45593C3.90709 1.04654 1.04663 4.2837 1.04663 8.84649V21.1674C1.04663 25.7302 3.83733 28.9535 8.45593 28.9535H21.5443C26.1071 28.9535 28.9536 25.7302 28.9536 21.1674V8.84649C28.9536 4.2837 26.1629 1.04654 21.5443 1.04654Z'
                stroke={color ?? 'white'}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}
export const IconThreeDotsMessage = ({ color }: SVGProps) => {
    return (
        <svg
            width='15'
            height='3'
            viewBox='0 0 19 3'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className='icon-three-dots'
        >
            <circle
                cx='17.5'
                cy='1.5'
                r='1.5'
                transform='rotate(90 17.5 1.5)'
                fill={color ?? 'white'}
            />
            <circle
                cx='9.5'
                cy='1.5'
                r='1.5'
                transform='rotate(90 9.5 1.5)'
                fill={color ?? 'white'}
            />
            <circle
                cx='1.5'
                cy='1.5'
                r='1.5'
                transform='rotate(90 1.5 1.5)'
                fill={color ?? 'white'}
            />
        </svg>
    )
}

export const IconThreeDots = ({ color }: SVGProps) => {
    return (
        <svg
            width='19'
            height='3'
            viewBox='0 0 19 3'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className='icon-three-dots'
        >
            <circle
                cx='17.5'
                cy='1.5'
                r='1.5'
                transform='rotate(90 17.5 1.5)'
                fill={color ?? 'white'}
            />
            <circle
                cx='9.5'
                cy='1.5'
                r='1.5'
                transform='rotate(90 9.5 1.5)'
                fill={color ?? 'white'}
            />
            <circle
                cx='1.5'
                cy='1.5'
                r='1.5'
                transform='rotate(90 1.5 1.5)'
                fill={color ?? 'white'}
            />
        </svg>
    )
}

export const IconThreeDotsVertical = ({ color }: SVGProps) => {
  return (
    <svg
      width="3"
      height="19"
      viewBox="0 0 3 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="icon-three-dots-vertical"
    >
      <circle
        cx="1.5"
        cy="1.5"
        r="1.5"
        fill={color ?? 'white'}
      />
      <circle
        cx="1.5"
        cy="9.5"
        r="1.5"
        fill={color ?? 'white'}
      />
      <circle
        cx="1.5"
        cy="17.5"
        r="1.5"
        fill={color ?? 'white'}
      />
    </svg>
  )
}

export const IconCheckmark = ({ color = '#fff' }: SVGProps) => {
    return (
        <svg
            width='12'
            height='10'
            viewBox='0 0 12 10'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M11.7046 0.336241C12.0985 0.784788 12.0985 1.51188 11.7046 1.9602L4.94099 9.66376C4.54716 10.1121 3.90896 10.1121 3.51513 9.66376L0.295373 5.99645C-0.0984575 5.54812 -0.0984575 4.82103 0.295373 4.37271C0.689006 3.92416 1.3274 3.92416 1.72104 4.37271L4.22796 7.22793L10.2788 0.336241C10.6726 -0.11208 11.311 -0.11208 11.7046 0.336241Z'
                fill={color}
            />
        </svg>
    )
}

export const IconCheckmarkSm = ({ color = '#0D1444' }: SVGProps) => {
    return (
        <svg
            width='10'
            height='8'
            viewBox='0 0 10 8'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M9.75386 0.268993C10.082 0.62783 10.082 1.2095 9.75386 1.56816L4.11749 7.73101C3.7893 8.08966 3.25747 8.08966 2.92927 7.73101L0.246144 4.79716C-0.0820479 4.4385 -0.0820479 3.85682 0.246144 3.49817C0.574171 3.13933 1.10617 3.13933 1.4342 3.49817L3.5233 5.78234L8.56564 0.268993C8.89383 -0.0896644 9.42583 -0.0896644 9.75386 0.268993Z'
                fill={color}
            />
        </svg>
    )
}

export const IconCircleCheckmark = () => {
    return (
        <svg
            width='22'
            height='22'
            viewBox='0 0 22 22'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M18.7787 3.22127C16.7002 1.14274 13.9378 0 11 0C8.06217 0 5.2998 1.14274 3.22127 3.22127C1.14274 5.2998 0 8.06217 0 11C0 13.9378 1.14274 16.7002 3.22127 18.7787C5.2998 20.8573 8.06217 22 11 22C13.9378 22 16.7002 20.8573 18.7787 18.7787C20.8573 16.7002 22 13.9378 22 11C22 8.06217 20.8573 5.2998 18.7787 3.22127ZM11 20.7853C5.60573 20.7853 1.21472 16.3943 1.21472 11C1.21472 5.60573 5.60573 1.21472 11 1.21472C16.3943 1.21472 20.7853 5.60573 20.7853 11C20.7853 16.3943 16.3943 20.7853 11 20.7853Z'
                fill='url(#paint0_linear_5928_26606)'
            />
            <path
                d='M13.5681 8.4627L9.78442 12.2508L8.43023 10.8966C8.19178 10.6582 7.80937 10.6582 7.57092 10.8966C7.33248 11.1351 7.33248 11.5175 7.57092 11.7559L9.35702 13.542C9.47399 13.659 9.63146 13.722 9.78442 13.722C9.93739 13.722 10.0949 13.6635 10.2118 13.542L14.4274 9.3265C14.6658 9.08806 14.6658 8.70564 14.4274 8.4672C14.1934 8.22425 13.8065 8.22425 13.5681 8.4627Z'
                fill='url(#paint1_linear_5928_26606)'
            />
            <defs>
                <linearGradient
                    id='paint0_linear_5928_26606'
                    x1='-0.00768981'
                    y1='10.9901'
                    x2='21.9923'
                    y2='10.9901'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#26B99A' />
                    <stop offset='1' stopColor='#35E1BD' />
                </linearGradient>
                <linearGradient
                    id='paint1_linear_5928_26606'
                    x1='7.38957'
                    y1='11.0008'
                    x2='14.6037'
                    y2='11.0008'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#26B99A' />
                    <stop offset='1' stopColor='#35E1BD' />
                </linearGradient>
            </defs>
        </svg>
    )
}

export const IconClose = ({ color }: SVGProps) => {
    return (
        <svg
            width='16'
            height='15'
            viewBox='0 0 16 15'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M10.652 10.606L4.4648 4.41884C4.22084 4.17489 4.22084 3.77891 4.4648 3.53496C4.70875 3.29101 5.10473 3.29101 5.34868 3.53496L11.5359 9.72214C11.7798 9.9661 11.7798 10.3621 11.5359 10.606C11.2919 10.85 10.8959 10.85 10.652 10.606Z'
                fill={color ?? '#B7B7B9'}
            />
            <path
                d='M4.46414 10.606C4.22018 10.3621 4.22018 9.9661 4.46414 9.72214L10.6513 3.53496C10.8953 3.29101 11.2913 3.29101 11.5352 3.53496C11.7792 3.77891 11.7792 4.17489 11.5352 4.41884L5.34802 10.606C5.10407 10.85 4.70809 10.85 4.46414 10.606Z'
                fill={color ?? '#B7B7B9'}
            />
        </svg>
    )
}

export const IconCloseLarge = ({
    color,
    width = '14',
    height = '14'
}: SVGProps) => {
    return (
        <svg
            width={`${width}`}
            height={`${height}`}
            viewBox='0 0 14 14'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M8.28261 7.0001L13.7339 1.54851C14.0887 1.1939 14.0887 0.620557 13.7339 0.265953C13.3793 -0.088651 12.806 -0.088651 12.4514 0.265953L6.99992 5.71755L1.5486 0.265953C1.19384 -0.088651 0.620668 -0.088651 0.266072 0.265953C-0.0886906 0.620557 -0.0886906 1.1939 0.266072 1.54851L5.71739 7.0001L0.266072 12.4517C-0.0886906 12.8063 -0.0886906 13.3797 0.266072 13.7343C0.442789 13.9111 0.675145 14 0.907335 14C1.13953 14 1.37172 13.9111 1.5486 13.7343L6.99992 8.28266L12.4514 13.7343C12.6283 13.9111 12.8605 14 13.0927 14C13.3249 14 13.557 13.9111 13.7339 13.7343C14.0887 13.3797 14.0887 12.8063 13.7339 12.4517L8.28261 7.0001Z'
                fill={color ?? '#A3A3A3'}
            />
        </svg>
    )
}

export const IconModalClose = ({ color = '#A3A3A3' }: SVGProps) => {
    return (
        <svg
            width='14'
            height='14'
            viewBox='0 0 14 14'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M8.28261 7.0001L13.7339 1.54851C14.0887 1.1939 14.0887 0.620557 13.7339 0.265953C13.3793 -0.088651 12.806 -0.088651 12.4514 0.265953L6.99992 5.71755L1.5486 0.265953C1.19384 -0.088651 0.620668 -0.088651 0.266072 0.265953C-0.0886906 0.620557 -0.0886906 1.1939 0.266072 1.54851L5.71739 7.0001L0.266072 12.4517C-0.0886906 12.8063 -0.0886906 13.3797 0.266072 13.7343C0.442789 13.9111 0.675145 14 0.907335 14C1.13953 14 1.37172 13.9111 1.5486 13.7343L6.99992 8.28266L12.4514 13.7343C12.6283 13.9111 12.8605 14 13.0927 14C13.3249 14 13.557 13.9111 13.7339 13.7343C14.0887 13.3797 14.0887 12.8063 13.7339 12.4517L8.28261 7.0001Z'
                fill={color}
            />
        </svg>
    )
}

export const IconStatsClose = ({ color }: SVGProps) => {
    return (
        <svg
            width='12'
            height='12'
            viewBox='0 0 12 12'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M7.09938 6.00009L11.7719 1.32729C12.076 1.02334 12.076 0.531906 11.7719 0.22796C11.468 -0.0759865 10.9766 -0.0759865 10.6726 0.22796L5.99993 4.90076L1.32737 0.22796C1.02329 -0.0759865 0.532001 -0.0759865 0.228062 0.22796C-0.0760205 0.531906 -0.0760205 1.02334 0.228062 1.32729L4.90062 6.00009L0.228062 10.6729C-0.0760205 10.9768 -0.0760205 11.4683 0.228062 11.7722C0.379533 11.9238 0.578696 12 0.777716 12C0.976736 12 1.17576 11.9238 1.32737 11.7722L5.99993 7.09942L10.6726 11.7722C10.8242 11.9238 11.0233 12 11.2223 12C11.4213 12 11.6203 11.9238 11.7719 11.7722C12.076 11.4683 12.076 10.9768 11.7719 10.6729L7.09938 6.00009Z'
                fill={color ?? 'white'}
            />
        </svg>
    )
}

export const IconCloseSm = ({ color = '#778797' }: SVGProps) => {
    return (
        <svg
            width='10'
            height='10'
            viewBox='0 0 10 10'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M5.91615 5.00007L9.80995 1.10608C10.0634 0.852787 10.0634 0.443255 9.80995 0.189966C9.55667 -0.0633221 9.14714 -0.0633221 8.89386 0.189966L4.99994 4.08396L1.10614 0.189966C0.85274 -0.0633221 0.443335 -0.0633221 0.190051 0.189966C-0.0633505 0.443255 -0.0633505 0.852787 0.190051 1.10608L4.08385 5.00007L0.190051 8.89407C-0.0633505 9.14736 -0.0633505 9.55689 0.190051 9.81018C0.316278 9.93653 0.482246 10 0.648097 10C0.813947 10 0.979797 9.93653 1.10614 9.81018L4.99994 5.91618L8.89386 9.81018C9.0202 9.93653 9.18605 10 9.3519 10C9.51775 10 9.6836 9.93653 9.80995 9.81018C10.0634 9.55689 10.0634 9.14736 9.80995 8.89407L5.91615 5.00007Z'
                fill={color}
            />
        </svg>
    )
}

export const IconCloseXSm = ({ color = '#0D1444' }: SVGProps) => {
    return (
        <svg
            width='8'
            height='8'
            viewBox='0 0 8 8'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M0.18439 0.203525C0.430708 -0.0434503 0.830602 -0.0439833 1.07758 0.202335L7.81442 6.92124C8.0614 7.16756 8.06193 7.56746 7.81561 7.81443C7.56929 8.06141 7.1694 8.06194 6.92242 7.81562L0.185581 1.09671C-0.0613947 0.850394 -0.0619276 0.450501 0.18439 0.203525Z'
                fill={color}
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M7.74178 0.18263C7.98972 0.427969 7.99184 0.827858 7.7465 1.07581L1.08053 7.81265C0.835189 8.0606 0.435301 8.06271 0.187353 7.81737C-0.0605947 7.57203 -0.0627093 7.17214 0.18263 6.9242L6.8486 0.187353C7.09394 -0.0605947 7.49383 -0.0627093 7.74178 0.18263Z'
                fill={color}
            />
        </svg>
    )
}

export const IconFile = () => {
    return (
        <svg
            width='36'
            height='40'
            viewBox='0 0 36 40'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M24.4602 0H4.39024C1.96532 0 0 2.08235 0 4.65116V35.3488C0 37.9177 1.96532 40 4.39024 40H31.6098C34.0347 40 36 37.9177 36 35.3488V12.2244L24.4602 0Z'
                fill='#DCFAEF'
            />
            <path
                d='M24.5854 0L30.2928 6.04651L36.0001 12.093H29.5854C26.824 12.093 24.5854 9.85445 24.5854 7.09302V0Z'
                fill='#BDE2D5'
            />
        </svg>
    )
}

export const IconCaret = ({ color }: SVGProps) => {
    return (
        <svg
            width='16'
            height='9'
            viewBox='0 0 16 9'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M15.25 0.749999L8.25 7.75L1.25 0.75'
                stroke={color ?? 'white'}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}

export const IconCaretSm = ({ color = '#778797' }: SVGProps) => {
    return (
        <svg
            width='6'
            height='10'
            viewBox='0 0 6 10'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M1 0.999999L5 5L1 9'
                stroke={color}
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}

export const IconCaretMd = ({ color = '#fff' }: SVGProps) => {
    return (
        <svg
            width='8'
            height='14'
            viewBox='0 0 8 14'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M1 1L7 7L1 13'
                stroke={color}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}

export const IconCaretDownSm = ({ color = '#C7C7C7' }: SVGProps) => {
    return (
        <svg
            width='10'
            height='6'
            viewBox='0 0 10 6'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M9 1L5 5L1 1'
                stroke={color}
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}

export const IconCaretUpSm = ({ color = '#C7C7C7' }: SVGProps) => {
    return (
        <svg
            width='10'
            height='6'
            viewBox='0 0 10 6'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M0.999999 5L5 1L9 5'
                stroke={color}
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}

export const IconExpand = ({ fill = 'white' }: { fill?: string }) => {
    return (
        <svg
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g clipPath='url(#clip0_6527_36268)'>
                <path
                    d='M0.66874 0H5.33123C5.49664 0.0160468 5.65015 0.0931049 5.76184 0.216157C5.87353 0.33921 5.93541 0.499441 5.93541 0.665625C5.93541 0.831809 5.87353 0.99204 5.76184 1.11509C5.65015 1.23815 5.49664 1.3152 5.33123 1.33125L2.25624 1.3625L11.8062 10.8625C11.931 10.9878 12.0011 11.1575 12.0011 11.3344C12.0011 11.5112 11.931 11.6809 11.8062 11.8062C11.6801 11.9296 11.5107 11.9986 11.3344 11.9986C11.158 11.9986 10.9886 11.9296 10.8625 11.8062L1.33124 2.31875V5.33125C1.34024 5.42408 1.32973 5.51777 1.30038 5.6063C1.27103 5.69482 1.22348 5.77623 1.1608 5.84529C1.09811 5.91435 1.02168 5.96954 0.936396 6.0073C0.851117 6.04507 0.758882 6.06457 0.665615 6.06457C0.572348 6.06457 0.480113 6.04507 0.394834 6.0073C0.309554 5.96954 0.233119 5.91435 0.170434 5.84529C0.10775 5.77623 0.0602026 5.69482 0.0308495 5.6063C0.00149632 5.51777 -0.00901413 5.42408 -8.58307e-06 5.33125V0.7125C0.0127239 0.535014 0.0861435 0.367315 0.207921 0.23757C0.329699 0.107826 0.492415 0.0239392 0.66874 0V0Z'
                    fill={fill}
                />
                <path
                    d='M2 7.99997C2.17736 7.99997 2.34746 8.07043 2.47288 8.19585C2.59829 8.32126 2.66875 8.49136 2.66875 8.66872V15.3312C2.6704 16.2142 3.0219 17.0606 3.64627 17.6849C4.27065 18.3093 5.11701 18.6608 6 18.6625H15.3313C16.2142 18.6608 17.0606 18.3093 17.685 17.6849C18.3093 17.0606 18.6608 16.2142 18.6625 15.3312V5.99998C18.6608 5.11698 18.3093 4.27062 17.685 3.64625C17.0606 3.02188 16.2142 2.67038 15.3313 2.66873H8.66875C8.57592 2.67773 8.48223 2.66722 8.3937 2.63787C8.30518 2.60851 8.22377 2.56097 8.15471 2.49828C8.08565 2.4356 8.03046 2.35916 7.9927 2.27388C7.95493 2.1886 7.93542 2.09637 7.93542 2.0031C7.93542 1.90983 7.95493 1.8176 7.9927 1.73232C8.03046 1.64704 8.08565 1.5706 8.15471 1.50792C8.22377 1.44523 8.30518 1.39769 8.3937 1.36833C8.48223 1.33898 8.57592 1.32847 8.66875 1.33748H15.3313C16.5679 1.33912 17.7535 1.83068 18.6285 2.70453C19.5035 3.57839 19.9967 4.76334 20 5.99998V15.3312C19.9983 16.5689 19.5059 17.7555 18.6307 18.6307C17.7555 19.5059 16.569 19.9983 15.3313 20H6C4.76228 19.9983 3.57572 19.5059 2.70052 18.6307C1.82532 17.7555 1.3329 16.5689 1.33125 15.3312V8.66872C1.33125 8.49136 1.40171 8.32126 1.52712 8.19585C1.65254 8.07043 1.82264 7.99997 2 7.99997Z'
                    fill={fill}
                />
            </g>
            <defs>
                <clipPath id='clip0_6527_36268'>
                    <rect
                        width='20'
                        height='20'
                        fill={fill}
                        transform='matrix(-1 0 0 1 20 0)'
                    />
                </clipPath>
            </defs>
        </svg>
    )
}

export const IconRefresh = ({ color }: { color?: string }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill={color ?? '#15161C'}
    >
      <path d="M12 2a10 10 0 1 0 9.95 10.9 1 1 0 0 0-2-.2A8 8 0 1 1 12 4a1 1 0 0 0 0-2z" />
      <path d="M21.71 7.29 18.41 4a1 1 0 0 0-1.41 1.41l1.3 1.3A9.93 9.93 0 0 0 12 2v2a7.93 7.93 0 0 1 5.66 2.34l-1.37 1.37a1 1 0 1 0 1.42 1.42l3.29-3.29a1 1 0 0 0 .29-.71z" />
    </svg>
  );
};
export const IconCategories = ({ color }: SVGProps) => {
    return (
        <svg
            width='18'
            height='16'
            viewBox='0 0 18 16'
            fill={color ?? '#778797'}
            xmlns='http://www.w3.org/2000/svg'
        >
            <rect
                x='5.99414'
                width='12.0004'
                height='1.7705'
                rx='0.885251'
                fill={color ?? '#778797'}
            />
            <rect
                width='3.33354'
                height='1.7705'
                rx='0.885251'
                fill={color ?? '#778797'}
            />
            <rect
                x='5.99512'
                y='7.11487'
                width='12.0004'
                height='1.7705'
                rx='0.885251'
                fill={color ?? '#778797'}
            />
            <rect
                y='7.11487'
                width='3.33354'
                height='1.7705'
                rx='0.885251'
                fill={color ?? '#778797'}
            />
            <rect
                x='5.99414'
                y='14.2295'
                width='12.0004'
                height='1.7705'
                rx='0.885251'
                fill={color ?? '#778797'}
            />
            <rect
                y='14.2295'
                width='3.33354'
                height='1.7705'
                rx='0.885251'
                fill={color ?? '#778797'}
            />
        </svg>
    )
}

export const IconAddCategorie = () => {
    return (
        <svg
            width='30'
            height='30'
            viewBox='0 0 30 30'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <rect width='30' height='30' rx='15' fill='#F5F5F6' />
            <rect
                x='2'
                y='2'
                width='26'
                height='26'
                rx='13'
                stroke='white'
                strokeWidth='2'
            />
            <path
                d='M19.4004 14.4003L15.5114 14.412V10.5996C15.5114 10.2674 15.244 10 14.9118 10C14.5797 10 14.3122 10.2674 14.3122 10.5996L14.324 14.4004H10.5996C10.2674 14.4004 10 14.6678 10 15C10 15.3321 10.2674 15.5995 10.5996 15.5995H14.3181V19.4004C14.3181 19.7324 14.5855 20 14.9177 20C15.2499 20 15.5173 19.7324 15.5173 19.4004V15.5996H19.4004C19.7326 15.5996 20 15.332 20 15C20 14.6677 19.7296 14.4003 19.4004 14.4003Z'
                fill='#9B9B9B'
            />
        </svg>
    )
}

export const IconPostStats = () => {
    return (
        <svg
            width='20'
            height='16'
            viewBox='0 0 20 16'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <rect y='8' width='2' height='8' rx='1' fill='white' />
            <rect x='6' y='4' width='2' height='12' rx='1' fill='white' />
            <rect x='12' width='2' height='16' rx='1' fill='white' />
            <rect x='18' y='6' width='2' height='10' rx='1' fill='white' />
        </svg>
    )
}

export const IconPostStatsChat = () => {
    return (
        <svg
            width='16'
            height='12'
            viewBox='0 0 20 16'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <rect y='8' width='2' height='8' rx='1' fill='white' />
            <rect x='6' y='4' width='2' height='12' rx='1' fill='white' />
            <rect x='12' width='2' height='16' rx='1' fill='white' />
            <rect x='18' y='6' width='2' height='10' rx='1' fill='white' />
        </svg>
    )
}


export const IconPostStatsActive = ({ color = '#2689EC' }: SVGProps) => {
    return (
        <svg
            width='20'
            height='16'
            viewBox='0 0 20 16'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <rect y='8' width='2' height='8' rx='1' fill={color} />
            <rect x='6' y='4' width='2' height='12' rx='1' fill={color} />
            <rect x='12' width='2' height='16' rx='1' fill={color} />
            <rect x='18' y='6' width='2' height='10' rx='1' fill={color} />
        </svg>
    )
}

export const IconOptionsStats = ({ color = '#778797' }: SVGProps) => {
    return (
        <svg
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M5.04858 12.8116L7.95556 9.05313L11.2598 11.6425L14.099 7.99035'
                stroke={color}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M17.413 4.43478C18.4405 4.43478 19.2734 3.60424 19.2734 2.57971C19.2734 1.55518 18.4405 0.72464 17.413 0.72464C16.3854 0.72464 15.5525 1.55518 15.5525 2.57971C15.5525 3.60424 16.3854 4.43478 17.413 4.43478Z'
                stroke={color}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M12.4904 1.51691H5.45549C2.54852 1.51691 0.726807 3.58456 0.726807 6.49278V14.2995C0.726807 17.198 2.50007 19.256 5.45549 19.256H13.7888C16.6958 19.256 18.5175 17.2077 18.5175 14.2995V7.53621'
                stroke={color}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}

export const IconHeartOutline = ({ color }: SVGProps) => {
    return (
        <svg
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M9.76583 19.0872C7.654 17.7124 5.69116 16.0994 3.91217 14.2769C2.65484 12.9563 1.69767 11.354 1.11218 9.58975C0.0682759 6.15386 1.2878 2.22565 4.72195 1.06668C5.61172 0.766414 6.5569 0.694467 7.47853 0.856842C8.40017 1.01922 9.27146 1.41117 10.0195 1.99998C10.7664 1.41281 11.636 1.02176 12.5558 0.859409C13.4755 0.697061 14.4189 0.768146 15.3073 1.06668C18.7414 2.22565 19.9707 6.19488 18.9268 9.58975C18.346 11.3563 17.3882 12.9597 16.1268 14.2769C14.3478 16.0994 12.385 17.7124 10.2732 19.0872L10.0487 19.2308L9.76583 19.0872Z'
                stroke={color}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}

export const IconHeartFill = ({ color = '#FF0000' }: SVGProps) => {
    return (
        <svg
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M9.76583 19.0872C7.654 17.7124 5.69116 16.0994 3.91217 14.2769C2.65484 12.9563 1.69767 11.354 1.11218 9.58975C0.0682759 6.15385 1.2878 2.22565 4.72195 1.06667C5.61172 0.76641 6.5569 0.694463 7.47853 0.856839C8.40017 1.01921 9.27146 1.41116 10.0195 1.99998C10.7664 1.41281 11.636 1.02175 12.5558 0.859405C13.4755 0.697057 14.4189 0.768142 15.3073 1.06667C18.7414 2.22565 19.9707 6.19488 18.9268 9.58975C18.346 11.3563 17.3882 12.9597 16.1268 14.2769C14.3478 16.0994 12.385 17.7124 10.2732 19.0872L10.0487 19.2308L9.76583 19.0872Z'
                fill={color}
                stroke={color}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}

export const IconChatOutline = ({ color }: SVGProps) => {
    return (
        <svg
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M13.3458 10.2139C13.344 9.99828 13.4062 9.78696 13.5246 9.60676C13.6429 9.42655 13.8121 9.28557 14.0107 9.20177C14.2092 9.11796 14.4281 9.09508 14.6396 9.13602C14.8511 9.17696 15.0457 9.27988 15.1987 9.43171C15.3517 9.58355 15.4563 9.77749 15.499 9.98886C15.5417 10.2002 15.5207 10.4196 15.4387 10.619C15.3567 10.8184 15.2173 10.9889 15.0383 11.1089C14.8593 11.2289 14.6487 11.293 14.4332 11.293C14.1465 11.293 13.8712 11.1796 13.6676 10.9775C13.4639 10.7754 13.3483 10.501 13.3458 10.2139ZM9.12654 10.2139C9.12654 9.92527 9.24107 9.64843 9.44499 9.44432C9.6489 9.24021 9.92549 9.12557 10.2139 9.12557C10.5023 9.12557 10.7789 9.24021 10.9828 9.44432C11.1867 9.64843 11.3012 9.92527 11.3012 10.2139C11.2988 10.5018 11.1835 10.7772 10.9801 10.9808C10.7767 11.1844 10.5015 11.2999 10.2139 11.3023C9.92549 11.3023 9.6489 11.1876 9.44499 10.9835C9.24107 10.7794 9.12654 10.5026 9.12654 10.2139ZM4.90723 10.2139C4.90723 9.99827 4.97123 9.78747 5.09113 9.60829C5.21102 9.42911 5.38137 9.28965 5.5806 9.20756C5.77983 9.12546 5.99895 9.10445 6.21012 9.1472C6.4213 9.18996 6.61506 9.29452 6.76676 9.44767C6.91845 9.60081 7.02128 9.79564 7.06218 10.0074C7.10308 10.2191 7.08016 10.4382 6.99643 10.6369C6.91271 10.8356 6.77191 11.005 6.59188 11.1234C6.41184 11.2419 6.20071 11.3041 5.98527 11.3023C5.6985 11.2998 5.4243 11.1841 5.22239 10.9802C5.02047 10.7764 4.90722 10.501 4.90723 10.2139Z'
                fill={color ?? 'white'}
            />
            <path
                d='M9.99143 0.697696C7.5266 0.697696 5.16273 1.67772 3.41983 3.42225C1.67693 5.16677 0.697754 7.53289 0.697754 10C0.724154 11.6306 1.15529 13.2289 1.95238 14.6512C2.02474 14.7771 2.06813 14.9176 2.07938 15.0624C2.09064 15.2073 2.06948 15.3528 2.01744 15.4884L1.39478 17.5721C1.34726 17.7177 1.35857 17.8762 1.42632 18.0135C1.49406 18.1509 1.61286 18.2562 1.75725 18.307C1.88647 18.3531 2.02765 18.3531 2.15687 18.307L4.0156 17.7488C4.25654 17.6929 4.50717 17.6941 4.74757 17.7523C4.98797 17.8104 5.21149 17.9239 5.40035 18.0837C6.63738 18.7888 8.0197 19.1999 9.44064 19.2855C10.8616 19.3711 12.2832 19.1288 13.5957 18.5774C14.9083 18.026 16.0768 17.1802 17.011 16.1051C17.9453 15.0301 18.6203 13.7546 18.9841 12.3771C19.3478 10.9996 19.3906 9.55679 19.109 8.16011C18.8275 6.76343 18.2292 5.45016 17.3602 4.32159C16.4913 3.19303 15.3749 2.2793 14.0973 1.65098C12.8197 1.02266 11.4149 0.69654 9.99143 0.697696V0.697696Z'
                stroke={color ?? 'white'}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}

export const IconTrashcan = ({ width, height }: SVGProps) => {
    return (
        <svg
            width={width ?? '10'}
            height={height ?? '12'}
            viewBox='0 0 10 12'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g clipPath='url(#clip0_5928_26669)'>
                <path
                    d='M8.84654 4.48193C8.84654 4.48193 8.54861 8.5259 8.38068 10.2239C8.37076 10.5799 8.23425 10.9171 8.00088 11.1621C7.76751 11.4071 7.4562 11.54 7.13475 11.5319H7.10223C5.68836 11.5319 4.2745 11.5619 2.86063 11.5319C2.54489 11.5433 2.23789 11.416 2.00654 11.1777C1.77519 10.9395 1.63823 10.6096 1.62553 10.2599C1.45218 8.54394 1.15967 4.51196 1.15967 4.51196'
                    stroke='#B0B0B0'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M9.59387 2.54395H0.384766'
                    stroke='#B0B0B0'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M7.82238 2.54395C7.6167 2.54416 7.41733 2.46528 7.25828 2.32085C7.09923 2.17642 6.99035 1.97533 6.95021 1.75191L6.81479 1.01992C6.77639 0.856602 6.69015 0.71205 6.56955 0.608889C6.44896 0.505728 6.30086 0.449824 6.14849 0.449954H3.85704C3.70398 0.449521 3.55509 0.505198 3.43358 0.608303C3.31208 0.711409 3.22479 0.856119 3.18533 1.01992L3.0499 1.75191C3.00977 1.97533 2.90088 2.17642 2.74183 2.32085C2.58278 2.46528 2.38341 2.54416 2.17773 2.54395'
                    stroke='#B0B0B0'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </g>
            <defs>
                <clipPath id='clip0_5928_26669'>
                    <rect width='10' height='12' fill='white' />
                </clipPath>
            </defs>
        </svg>
    )
}

export const IconTrashcanMd = ({ color = '#fff' }: SVGProps) => {
    return (
        <svg
            width='18'
            height='20'
            viewBox='0 0 18 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M15.9223 7.46973C15.9223 7.46973 15.386 14.2097 15.0838 17.0397C15.0659 17.6329 14.8202 18.195 14.4001 18.6033C13.9801 19.0116 13.4197 19.2332 12.8411 19.2197H12.7826C10.2376 19.2197 7.69264 19.2697 5.14768 19.2197C4.57934 19.2387 4.02674 19.0265 3.61031 18.6294C3.19387 18.2323 2.94735 17.6824 2.92449 17.0997C2.61247 14.2397 2.08594 7.51978 2.08594 7.51978'
                stroke={color}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M17.2678 4.24023H0.691406'
                stroke={color}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M14.0783 4.23999C13.7081 4.24035 13.3492 4.10889 13.063 3.86817C12.7767 3.62745 12.5807 3.2923 12.5084 2.91993L12.2647 1.69996C12.1956 1.42775 12.0403 1.18683 11.8232 1.0149C11.6062 0.842961 11.3396 0.749788 11.0653 0.750004H6.94073C6.66521 0.749282 6.39721 0.842077 6.1785 1.01392C5.95979 1.18576 5.80267 1.42695 5.73164 1.69996L5.48787 2.91993C5.41563 3.2923 5.21963 3.62745 4.93334 3.86817C4.64705 4.10889 4.28818 4.24035 3.91797 4.23999'
                stroke={color}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}

export const IconOptionsThrash = ({ color = '#778797' }: SVGProps) => {
    return (
        <svg
            width='18'
            height='20'
            viewBox='0 0 18 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M15.923 7.47C15.923 7.47 15.3868 14.2099 15.0845 17.0399C15.0666 17.6332 14.8209 18.1952 14.4009 18.6035C13.9808 19.0119 13.4204 19.2335 12.8418 19.22H12.7833C10.2383 19.22 7.69337 19.27 5.14841 19.22C4.58007 19.2389 4.02747 19.0268 3.61104 18.6297C3.1946 18.2326 2.94808 17.6827 2.92523 17.1C2.6132 14.24 2.08667 7.52005 2.08667 7.52005'
                stroke={color}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M17.2688 4.24002H0.692383'
                stroke={color}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M14.0803 4.24003C13.7101 4.24038 13.3512 4.10892 13.0649 3.8682C12.7786 3.62748 12.5826 3.29233 12.5104 2.91996L12.2666 1.69999C12.1975 1.42778 12.0423 1.18686 11.8252 1.01493C11.6081 0.842992 11.3416 0.749819 11.0673 0.750035H6.94268C6.66716 0.749313 6.39916 0.842108 6.18045 1.01395C5.96174 1.18579 5.80462 1.42698 5.73359 1.69999L5.48982 2.91996C5.41758 3.29233 5.22159 3.62748 4.93529 3.8682C4.649 4.10892 4.29014 4.24038 3.91992 4.24003'
                stroke={color}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}

export const IconTrashcanLarge = ({
    color = '#200E32',
    width = '28',
    height = '30'
}: SVGProps) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox='0 0 28 30'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M24.7693 11.205C24.7693 11.205 23.9351 21.3149 23.4649 25.5599C23.4371 26.4498 23.0549 27.2928 22.4015 27.9053C21.7481 28.5178 20.8764 28.8502 19.9763 28.83H19.8853C15.9264 28.83 11.9676 28.905 8.0088 28.83C7.12471 28.8584 6.26512 28.5402 5.61733 27.9445C4.96954 27.3488 4.58607 26.5241 4.55051 25.65C4.06514 21.36 3.24609 11.2801 3.24609 11.2801'
                stroke={color}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M26.8626 6.36003H1.07715'
                stroke={color}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M21.9027 6.36004C21.3268 6.36057 20.7685 6.16338 20.3232 5.8023C19.8778 5.44121 19.573 4.9385 19.4606 4.37994L19.0814 2.54998C18.9739 2.14167 18.7324 1.78029 18.3948 1.52239C18.0571 1.26449 17.6424 1.12473 17.2158 1.12505H10.7997C10.3711 1.12397 9.95425 1.26316 9.61404 1.52093C9.27382 1.77869 9.02941 2.14047 8.91892 2.54998L8.53972 4.37994C8.42735 4.9385 8.12247 5.44121 7.67712 5.8023C7.23178 6.16338 6.67354 6.36057 6.09766 6.36004'
                stroke={color}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}

export const IconNoteCurvy = ({ width = '50', height = '48' }: SVGProps) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox={`0 0 ${width} ${height}`}
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g filter='url(#filter0_d_6527_40094)'>
                <path
                    d='M39.121 0H17.9098C17.4175 0 17.0309 0.399939 17.0309 0.909091V23.6364C17.0309 24.6364 16.2399 25.4545 15.273 25.4545C14.7808 25.4545 14.3941 25.8545 14.3941 26.3636C14.3941 26.6182 13.2691 26.8364 12.1616 26.9818C12.5835 27.1818 13.0405 27.2727 13.5152 27.2727H35.6053C38.0312 27.2727 39.9999 25.2364 39.9999 22.7273V0.909091C39.9999 0.399939 39.6133 0 39.121 0Z'
                    fill='url(#paint0_linear_6527_40094)'
                />
                <path
                    d='M10.8789 18.1818C10.3935 18.1818 10 18.5889 10 19.0909V23.6364C10 25.1273 10.8965 26.4363 12.1445 26.9818C12.1621 27 12.1621 26.9818 12.1621 26.9818C12.5586 27.1698 12.9862 27.2614 13.4304 27.2718C15.4102 27.3178 17.0313 25.4933 17.0313 23.445V18.1818H10.8789ZM20.6056 14.5455H27.6369C28.1228 14.5455 28.5159 14.1389 28.5159 13.6364V6.36365C28.5159 5.86117 28.1228 5.45456 27.6369 5.45456H20.6056C20.1198 5.45456 19.7267 5.86117 19.7267 6.36365V13.6364C19.7267 14.1389 20.1198 14.5455 20.6056 14.5455ZM31.2112 7.27274H36.4847C36.9705 7.27274 37.3636 6.86614 37.3636 6.36365C37.3636 5.86117 36.9705 5.45456 36.4847 5.45456H31.2112C30.7254 5.45456 30.3323 5.86117 30.3323 6.36365C30.3323 6.86614 30.7254 7.27274 31.2112 7.27274ZM36.4847 9.09092H31.2112C30.7254 9.09092 30.3323 9.49753 30.3323 10C30.3323 10.5025 30.7254 10.9091 31.2112 10.9091H36.4847C36.9705 10.9091 37.3636 10.5025 37.3636 10C37.3636 9.49753 36.9705 9.09092 36.4847 9.09092ZM36.4847 12.7273H31.2112C30.7254 12.7273 30.3323 13.1339 30.3323 13.6364C30.3323 14.1389 30.7254 14.5455 31.2112 14.5455H36.4847C36.9705 14.5455 37.3636 14.1389 37.3636 13.6364C37.3636 13.1339 36.9705 12.7273 36.4847 12.7273ZM36.4847 16.3637H20.6056C20.1198 16.3637 19.7267 16.7703 19.7267 17.2727C19.7267 17.7752 20.1198 18.1818 20.6056 18.1818H36.4847C36.9705 18.1818 37.3636 17.7752 37.3636 17.2727C37.3636 16.7703 36.9705 16.3637 36.4847 16.3637ZM36.4847 20H20.6056C20.1198 20 19.7267 20.4066 19.7267 20.9091C19.7267 21.4116 20.1198 21.8182 20.6056 21.8182H36.4847C36.9705 21.8182 37.3636 21.4116 37.3636 20.9091C37.3636 20.4066 36.9705 20 36.4847 20Z'
                    fill='#EDF7FF'
                />
            </g>
            <defs>
                <filter
                    id='filter0_d_6527_40094'
                    x='0'
                    y='0'
                    width='50'
                    height='47.2727'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dy='10' />
                    <feGaussianBlur stdDeviation='5' />
                    <feComposite in2='hardAlpha' operator='out' />
                    <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.305882 0 0 0 0 0.67451 0 0 0 0 0.976471 0 0 0 0.2 0'
                    />
                    <feBlend
                        mode='normal'
                        in2='BackgroundImageFix'
                        result='effect1_dropShadow_6527_40094'
                    />
                    <feBlend
                        mode='normal'
                        in='SourceGraphic'
                        in2='effect1_dropShadow_6527_40094'
                        result='shape'
                    />
                </filter>
                <linearGradient
                    id='paint0_linear_6527_40094'
                    x1='10.0672'
                    y1='-27.8181'
                    x2='46.1355'
                    y2='-25.9203'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#93CFFF' />
                    <stop offset='1' stopColor='#2894FF' />
                </linearGradient>
            </defs>
        </svg>
    )
}

export const IconDollarCircleArrows = () => {
    return (
        <svg
            width='50'
            height='50'
            viewBox='0 0 50 50'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g filter='url(#filter0_d_6527_40433)'>
                <path
                    d='M24.9997 24.6716C30.339 24.6716 34.6673 20.3404 34.6673 14.9977C34.6673 9.6549 30.339 5.32373 24.9997 5.32373C19.6604 5.32373 15.332 9.6549 15.332 14.9977C15.332 20.3404 19.6604 24.6716 24.9997 24.6716Z'
                    fill='url(#paint0_linear_6527_40433)'
                />
                <path
                    d='M25.8788 20.2744C25.8788 20.7605 25.4857 21.1538 24.9999 21.1538C24.5141 21.1538 24.121 20.7605 24.121 20.2744V19.2278C23.6407 19.0576 23.2098 18.7647 22.892 18.3411C22.6002 17.9529 22.6774 17.4015 23.0653 17.1095C23.4499 16.8193 24.0026 16.8931 24.2961 17.283C24.7596 17.8997 25.8788 17.5201 25.8788 16.7566C25.8788 16.2714 25.484 15.8771 24.9999 15.8771C23.546 15.8771 22.3633 14.6936 22.3633 13.2388C22.3633 12.0938 23.1002 11.1267 24.121 10.7624V9.721C24.121 9.2349 24.5141 8.84155 24.9999 8.84155C25.4857 8.84155 25.8788 9.2349 25.8788 9.721V10.7676C26.3591 10.9377 26.79 11.2307 27.1079 11.6543C27.3997 12.0425 27.3224 12.5939 26.9345 12.8858C26.55 13.1761 25.999 13.1014 25.7037 12.7124C25.5355 12.4882 25.278 12.3593 24.9999 12.3593C24.5158 12.3593 24.121 12.7536 24.121 13.2388C24.121 13.724 24.5158 14.1182 24.9999 14.1182C26.4538 14.1182 27.6365 15.3018 27.6365 16.7566C27.6365 17.9016 26.8996 18.8687 25.8788 19.2329V20.2744Z'
                    fill='#EDF7FF'
                />
                <path
                    d='M15.6188 5.61117C20.201 1.02438 27.3429 0.538746 32.4813 4.1313C32.0842 4.09348 31.6966 4.31575 31.5639 4.71115C31.4111 5.17233 31.66 5.67045 32.12 5.82418L35.8501 7.0669C36.1508 7.16909 36.5032 7.09997 36.7496 6.85477C36.9848 6.61943 37.0672 6.27076 36.9625 5.95469L35.7197 2.22307C35.5652 1.76188 35.0657 1.51622 34.6074 1.66737C34.1473 1.82022 33.8984 2.3184 34.0512 2.77958L34.1955 3.21192C28.3358 -1.42366 19.7842 -1.0442 14.376 4.36758C10.421 8.3251 9.01348 14.1093 10.7026 19.4625C10.8502 19.9301 11.3458 20.1811 11.8046 20.0371C12.2681 19.8902 12.5238 19.3964 12.3779 18.9335C10.8879 14.2073 12.129 9.10323 15.6188 5.61117ZM39.2974 10.5327C39.1515 10.0698 38.6606 9.81735 38.1954 9.95817C37.7319 10.105 37.4761 10.5989 37.622 11.0618C39.112 15.7879 37.8709 20.892 34.3811 24.3841C29.7989 28.9709 22.6572 29.4565 17.5188 25.864C17.9166 25.9019 18.3034 25.6804 18.4361 25.2841C18.5888 24.8229 18.3399 24.3248 17.8799 24.1711L14.1499 22.9283C13.834 22.8219 13.4873 22.9069 13.2504 23.1405C13.0152 23.3758 12.9328 23.7245 13.0375 24.0406L14.2803 27.7722C14.4338 28.2297 14.9291 28.4824 15.3926 28.3279C15.8527 28.175 16.1016 27.6768 15.9488 27.2157L15.8044 26.7833C18.508 28.922 21.781 30 25.0585 30C28.8847 30 32.7109 28.5426 35.6239 25.6277C39.5789 21.6701 40.9865 15.8859 39.2974 10.5327Z'
                    fill='url(#paint1_linear_6527_40433)'
                />
            </g>
            <defs>
                <filter
                    id='filter0_d_6527_40433'
                    x='0'
                    y='0'
                    width='50'
                    height='50'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dy='10' />
                    <feGaussianBlur stdDeviation='5' />
                    <feComposite in2='hardAlpha' operator='out' />
                    <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.305882 0 0 0 0 0.67451 0 0 0 0 0.976471 0 0 0 0.2 0'
                    />
                    <feBlend
                        mode='normal'
                        in2='BackgroundImageFix'
                        result='effect1_dropShadow_6527_40433'
                    />
                    <feBlend
                        mode='normal'
                        in='SourceGraphic'
                        in2='effect1_dropShadow_6527_40433'
                        result='shape'
                    />
                </filter>
                <linearGradient
                    id='paint0_linear_6527_40433'
                    x1='13.8773'
                    y1='-14.4111'
                    x2='38.9317'
                    y2='-13.1204'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#93CFFF' />
                    <stop offset='1' stopColor='#2894FF' />
                </linearGradient>
                <linearGradient
                    id='paint1_linear_6527_40433'
                    x1='7.74295'
                    y1='-30.6'
                    x2='46.6163'
                    y2='-28.5961'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#93CFFF' />
                    <stop offset='1' stopColor='#2894FF' />
                </linearGradient>
            </defs>
        </svg>
    )
}

export const IconDollarCircleNoFill = () => {
    return (
        <svg
            width='50'
            height='50'
            viewBox='0 0 50 50'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g filter='url(#filter0_d_6527_40099)'>
                <path
                    d='M25 30C20.9934 30 17.2265 28.4397 14.3934 25.6066C11.5603 22.7735 10 19.0066 10 15C10 10.9934 11.5603 7.22654 14.3934 4.39336C17.2265 1.56029 20.9934 0 25 0C29.0066 0 32.7735 1.56029 35.6066 4.39336C38.4397 7.22654 40 10.9934 40 15C40 19.0066 38.4397 22.7735 35.6066 25.6066C32.7735 28.4397 29.0066 30 25 30Z'
                    fill='url(#paint0_linear_6527_40099)'
                />
                <path
                    d='M25 27C21.7947 27 18.7812 25.7518 16.5147 23.4853C14.2482 21.2188 13 18.2053 13 15C13 11.7947 14.2482 8.78123 16.5147 6.51469C18.7812 4.24823 21.7947 3 25 3C28.2053 3 31.2188 4.24823 33.4853 6.51469C35.7518 8.78123 37 11.7947 37 15C37 18.2053 35.7518 21.2188 33.4853 23.4853C31.2188 25.7518 28.2053 27 25 27Z'
                    fill='#EDF7FF'
                />
                <path
                    d='M25.7696 14.411C24.5119 13.8857 23.6875 13.5037 23.6875 13C23.6875 12.2648 24.4445 11.6667 25.375 11.6667C26.3055 11.6667 27.0625 12.2648 27.0625 13C27.0625 13.3682 27.4402 13.6667 27.9062 13.6667C28.3723 13.6667 28.75 13.3682 28.75 13C28.75 11.7597 27.6728 10.7145 26.2188 10.4177V9.66667C26.2188 9.29847 25.841 9 25.375 9C24.909 9 24.5312 9.29847 24.5312 9.66667V10.4177C23.0772 10.7145 22 11.7597 22 13C22 14.3447 23.5837 15.0062 24.9811 15.5898C26.2383 16.1149 27.0625 16.4967 27.0625 17C27.0625 17.7352 26.3054 18.3333 25.375 18.3333C24.4445 18.3333 23.6875 17.7352 23.6875 17C23.6875 16.6318 23.3098 16.3333 22.8438 16.3333C22.3777 16.3333 22 16.6318 22 17C22 18.2403 23.0772 19.2855 24.5312 19.5823V20.3333C24.5312 20.7015 24.909 21 25.375 21C25.841 21 26.2188 20.7015 26.2188 20.3333V19.5823C27.6728 19.2855 28.75 18.2403 28.75 17C28.75 15.6557 27.1666 14.9945 25.7696 14.411Z'
                    fill='url(#paint1_linear_6527_40099)'
                />
            </g>
            <defs>
                <filter
                    id='filter0_d_6527_40099'
                    x='0'
                    y='0'
                    width='50'
                    height='50'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dy='10' />
                    <feGaussianBlur stdDeviation='5' />
                    <feComposite in2='hardAlpha' operator='out' />
                    <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.305882 0 0 0 0 0.67451 0 0 0 0 0.976471 0 0 0 0.2 0'
                    />
                    <feBlend
                        mode='normal'
                        in2='BackgroundImageFix'
                        result='effect1_dropShadow_6527_40099'
                    />
                    <feBlend
                        mode='normal'
                        in='SourceGraphic'
                        in2='effect1_dropShadow_6527_40099'
                        result='shape'
                    />
                </filter>
                <linearGradient
                    id='paint0_linear_6527_40099'
                    x1='25'
                    y1='30'
                    x2='25'
                    y2='0'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#3C9FFF' />
                    <stop offset='1' stopColor='#76C0FF' />
                </linearGradient>
                <linearGradient
                    id='paint1_linear_6527_40099'
                    x1='25.375'
                    y1='21'
                    x2='25.375'
                    y2='9'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#3C9FFF' />
                    <stop offset='1' stopColor='#76C0FF' />
                </linearGradient>
            </defs>
        </svg>
    )
}

export const IconAnalytics = () => {
    return (
        <svg
            width='50'
            height='47'
            viewBox='0 0 50 47'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g filter='url(#filter0_d_6527_40103)'>
                <path
                    d='M30.1235 23.5415L25.8604 19.6611C25.6252 19.4467 25.2965 19.3773 24.9986 19.4801C24.3764 19.6919 23.7249 19.8 23.0606 19.8C20.2548 19.8 17.8044 17.8567 17.1023 15.075C17.0028 14.6777 16.6526 14.4 16.2518 14.4H10.8805C10.3473 14.4 9.93437 14.8838 10.0102 15.4274C10.932 22.0245 16.5427 27 23.0606 27C25.5213 27 27.922 26.3012 30.0033 24.9785C30.5061 24.6603 30.5597 23.9365 30.1235 23.5415ZM32.9104 4.53253C30.4111 1.65234 26.8208 0 23.0606 0C16.5513 0 10.9406 4.97461 10.0094 11.5708C9.93185 12.1153 10.3456 12.6 10.8788 12.6H16.2578C16.6539 12.6 17.0201 12.2689 17.1211 11.8768C17.831 9.1208 20.2672 7.20008 23.0607 7.20008C24.5965 7.20008 26.0718 7.78826 27.198 8.83298C27.8643 9.4511 28.9048 9.38114 29.577 8.76968L32.8375 5.80351C33.1995 5.47285 33.2337 4.90375 32.9104 4.53253Z'
                    fill='url(#paint0_linear_6527_40103)'
                />
                <path
                    d='M35.5144 2.12042C35.1977 1.7585 34.6419 1.74146 34.2874 2.0645L27.0303 8.67946C28.4278 9.8926 29.2132 11.6556 29.2132 13.5C29.2132 15.058 28.6527 16.558 27.6363 17.7175C27.321 18.0771 27.3801 18.6393 27.7327 18.9607L34.2884 24.9364C34.6481 25.2651 35.2038 25.2354 35.5286 24.8634C38.2571 21.7363 40.0001 17.7003 40.0001 13.5C40.0001 9.29242 38.2519 5.24979 35.5144 2.12042Z'
                    fill='url(#paint1_linear_6527_40103)'
                />
            </g>
            <defs>
                <filter
                    id='filter0_d_6527_40103'
                    x='0'
                    y='0'
                    width='50'
                    height='47'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dy='10' />
                    <feGaussianBlur stdDeviation='5' />
                    <feComposite in2='hardAlpha' operator='out' />
                    <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.305882 0 0 0 0 0.67451 0 0 0 0 0.976471 0 0 0 0.2 0'
                    />
                    <feBlend
                        mode='normal'
                        in2='BackgroundImageFix'
                        result='effect1_dropShadow_6527_40103'
                    />
                    <feBlend
                        mode='normal'
                        in='SourceGraphic'
                        in2='effect1_dropShadow_6527_40103'
                        result='shape'
                    />
                </filter>
                <linearGradient
                    id='paint0_linear_6527_40103'
                    x1='21.5663'
                    y1='27.0001'
                    x2='21.5663'
                    y2='0'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#53AFF7' />
                    <stop offset='1' stopColor='#A9D4FF' />
                </linearGradient>
                <linearGradient
                    id='paint1_linear_6527_40103'
                    x1='33.5152'
                    y1='25.1641'
                    x2='33.5152'
                    y2='1.83487'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#3C9FFF' />
                    <stop offset='1' stopColor='#76C0FF' />
                </linearGradient>
            </defs>
        </svg>
    )
}

export const IconCalendarLarge = () => {
    return (
        <svg
            width='50'
            height='50'
            viewBox='0 0 50 50'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g filter='url(#filter0_d_6527_40110)'>
                <path
                    d='M33.4961 2.28516H33.2987L32.9102 1.75781V0.878906C32.9102 0.393516 32.5166 0 32.0312 0C31.5459 0 31.1523 0.393516 31.1523 0.878906V1.75781L30.5873 2.28516H24.4902L24.1211 1.75781V0.878906C24.1211 0.393516 23.7276 0 23.2422 0C22.7568 0 22.3633 0.393516 22.3633 0.878906V1.75781L21.898 2.28516H15.7077L15.2734 1.75781V0.878906C15.2734 0.393516 14.8799 0 14.3945 0C13.9091 0 13.5156 0.393516 13.5156 0.878906V1.75781L13.0503 2.28516H12.4023L10 7.08984V25.5469C10 26.0323 10.3935 26.4258 10.8789 26.4258H35.5469C36.0323 26.4258 36.4258 26.0323 36.4258 25.5469V7.08984L33.4961 2.28516Z'
                    fill='url(#paint0_linear_6527_40110)'
                />
                <path
                    d='M36.4258 2.63672C36.4258 2.15133 36.0323 1.75781 35.5469 1.75781H32.9102V4.39453C32.9102 4.87992 32.5166 5.27344 32.0312 5.27344C31.5459 5.27344 31.1523 4.87992 31.1523 4.39453V1.75781H24.1211V4.39453C24.1211 4.87992 23.7276 5.27344 23.2422 5.27344C22.7568 5.27344 22.3633 4.87992 22.3633 4.39453V1.75781H15.2734V4.39453C15.2734 4.87992 14.8799 5.27344 14.3945 5.27344C13.9091 5.27344 13.5156 4.87992 13.5156 4.39453V1.75781H10.8789C10.3935 1.75781 10 2.15133 10 2.63672V7.08984H36.4258V2.63672ZM17.9102 10.6055H14.3945C13.9091 10.6055 13.5156 10.999 13.5156 11.4844V15C13.5156 15.4854 13.9091 15.8789 14.3945 15.8789H17.9102C18.3955 15.8789 18.7891 15.4854 18.7891 15V11.4844C18.7891 10.999 18.3955 10.6055 17.9102 10.6055ZM25 10.6055H21.4844C20.999 10.6055 20.6055 10.999 20.6055 11.4844V15C20.6055 15.4854 20.999 15.8789 21.4844 15.8789H25C25.4854 15.8789 25.8789 15.4854 25.8789 15V11.4844C25.8789 10.999 25.4854 10.6055 25 10.6055ZM28.5156 10.6055C28.0302 10.6055 27.6367 10.999 27.6367 11.4844V15C27.6367 15.4854 28.0302 15.8789 28.5156 15.8789H32.0312C32.5166 15.8789 32.9102 15.4854 32.9102 15V11.4844C32.9102 10.999 32.5166 10.6055 32.0312 10.6055H28.5156ZM25 17.6367H21.4844C20.999 17.6367 20.6055 18.0302 20.6055 18.5156V22.0312C20.6055 22.5166 20.999 22.9102 21.4844 22.9102H25C25.4854 22.9102 25.8789 22.5166 25.8789 22.0312V18.5156C25.8789 18.0302 25.4854 17.6367 25 17.6367ZM17.9102 17.6367H14.3945C13.9091 17.6367 13.5156 18.0302 13.5156 18.5156V22.0312C13.5156 22.5166 13.9091 22.9102 14.3945 22.9102H17.9102C18.3955 22.9102 18.7891 22.5166 18.7891 22.0312V18.5156C18.7891 18.0302 18.3955 17.6367 17.9102 17.6367ZM33.7891 17.6367C30.3967 17.6367 27.6367 20.3967 27.6367 23.7891C27.6367 27.2138 30.3967 30 33.7891 30C37.1966 30 40 27.1835 40 23.7891C40 20.3967 37.2138 17.6367 33.7891 17.6367ZM35.5469 24.668H33.7891C33.3037 24.668 32.9102 24.2745 32.9102 23.7891V22.0312C32.9102 21.5459 33.3037 21.1523 33.7891 21.1523C34.2745 21.1523 34.668 21.5459 34.668 22.0312V22.9102H35.5469C36.0323 22.9102 36.4258 23.3037 36.4258 23.7891C36.4258 24.2745 36.0323 24.668 35.5469 24.668Z'
                    fill='#EDF7FF'
                />
            </g>
            <defs>
                <filter
                    id='filter0_d_6527_40110'
                    x='0'
                    y='0'
                    width='50'
                    height='50'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dy='10' />
                    <feGaussianBlur stdDeviation='5' />
                    <feComposite in2='hardAlpha' operator='out' />
                    <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.305882 0 0 0 0 0.67451 0 0 0 0 0.976471 0 0 0 0.2 0'
                    />
                    <feBlend
                        mode='normal'
                        in2='BackgroundImageFix'
                        result='effect1_dropShadow_6527_40110'
                    />
                    <feBlend
                        mode='normal'
                        in='SourceGraphic'
                        in2='effect1_dropShadow_6527_40110'
                        result='shape'
                    />
                </filter>
                <linearGradient
                    id='paint0_linear_6527_40110'
                    x1='8.01185'
                    y1='-26.9543'
                    x2='42.2538'
                    y2='-25.1892'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#93CFFF' />
                    <stop offset='1' stopColor='#2894FF' />
                </linearGradient>
            </defs>
        </svg>
    )
}

export const IconThreePeople = () => {
    return (
        <svg
            width='50'
            height='44'
            viewBox='0 0 50 44'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g filter='url(#filter0_d_6527_40117)'>
                <path
                    d='M25.0322 15.7688C20.3175 15.7688 16.3408 16.6281 16.3408 19.8993C16.3408 23.1705 20.3449 23.9997 25.0322 23.9997C29.7195 23.9997 33.7236 23.1554 33.7236 19.8691C33.7236 16.5828 29.7195 15.7688 25.0322 15.7688Z'
                    fill='url(#paint0_linear_6527_40117)'
                />
                <path
                    d='M25.0325 12.6475C26.556 12.6476 28.0173 11.981 29.0958 10.794C30.1744 9.60709 30.7822 7.9967 30.7858 6.31613C30.7804 5.06414 30.4393 3.84192 29.8057 2.80322C29.172 1.76451 28.274 0.955736 27.2247 0.478698C26.1753 0.0016603 25.0215 -0.122284 23.9084 0.122347C22.7953 0.366978 21.7727 0.96925 20.9692 1.8535C20.1657 2.73775 19.6173 3.86438 19.3929 5.09167C19.1685 6.31895 19.2781 7.5921 19.7081 8.75078C20.1381 9.90945 20.8691 10.9019 21.8092 11.6033C22.7494 12.3048 23.8565 12.6839 24.9915 12.6928'
                    fill='url(#paint1_linear_6527_40117)'
                />
                <path
                    d='M37.4546 7.74892C37.646 6.95261 37.67 6.11864 37.525 5.31049C37.3799 4.50235 37.0695 3.74136 36.6174 3.08562C36.1653 2.42988 35.5835 1.89669 34.9163 1.52662C34.249 1.15655 33.5139 0.959372 32.7671 0.95018C32.4417 0.956191 32.1172 0.991494 31.7969 1.05571L31.6876 1.13107C31.6744 1.15628 31.6675 1.18486 31.6675 1.21397C31.6675 1.24308 31.6744 1.27175 31.6876 1.29696C32.6408 2.78211 33.1518 4.55746 33.1498 6.37715C33.1514 8.12003 32.675 9.82266 31.7833 11.2614C31.7626 11.2825 31.746 11.3082 31.7347 11.3367C31.7234 11.3653 31.7176 11.396 31.7176 11.4272C31.7176 11.4583 31.7234 11.4891 31.7347 11.5176C31.746 11.5461 31.7626 11.5718 31.7833 11.593C31.8098 11.6033 31.8387 11.6033 31.8652 11.593C32.0837 11.6078 32.3027 11.6078 32.5212 11.593C33.6146 11.6382 34.6892 11.2697 35.5666 10.5486C36.444 9.82744 37.0717 8.79698 37.3452 7.62829'
                    fill='url(#paint2_linear_6527_40117)'
                />
                <path
                    d='M39.8052 16.1909C39.4945 15.6342 39.0688 15.1665 38.5629 14.8259C38.057 14.4853 37.4853 14.2815 36.8944 14.2312C35.4366 13.9132 33.9525 13.7667 32.4667 13.794C32.4607 13.8055 32.4575 13.8185 32.4575 13.8318C32.4575 13.845 32.4607 13.8579 32.4667 13.8694C33.6144 14.4243 34.5792 15.3559 35.2297 16.5374C35.8802 17.7189 36.1846 19.0929 36.1017 20.4722C36.0959 20.507 36.0967 20.5428 36.1041 20.5772C36.1114 20.6117 36.1251 20.6441 36.1444 20.6725C36.1636 20.7008 36.188 20.7244 36.2159 20.7418C36.2439 20.7593 36.2748 20.7701 36.3068 20.7737C37.0857 20.6531 39.1219 20.1706 39.7506 18.6632C39.915 18.2683 40.0001 17.839 40.0001 17.4045C40.0001 16.97 39.915 16.5405 39.7506 16.1457'
                    fill='url(#paint3_linear_6527_40117)'
                />
                <path
                    d='M10.1948 16.1909C10.5055 15.6342 10.9312 15.1665 11.4371 14.8259C11.943 14.4853 12.5147 14.2815 13.1056 14.2312C14.5634 13.9132 16.0475 13.7667 17.5333 13.794C17.5393 13.8055 17.5425 13.8185 17.5425 13.8318C17.5425 13.845 17.5393 13.8579 17.5333 13.8694C16.3856 14.4243 15.4208 15.3559 14.7703 16.5374C14.1198 17.7189 13.8154 19.0929 13.8983 20.4722C13.9041 20.507 13.9033 20.5428 13.8959 20.5772C13.8886 20.6117 13.8749 20.6441 13.8556 20.6725C13.8364 20.7008 13.812 20.7244 13.7841 20.7418C13.7561 20.7593 13.7252 20.7701 13.6932 20.7737C12.9143 20.6531 10.8781 20.1706 10.2494 18.6632C10.085 18.2683 9.99989 17.839 9.99989 17.4045C9.99989 16.97 10.085 16.5405 10.2494 16.1457'
                    fill='url(#paint4_linear_6527_40117)'
                />
                <path
                    d='M18.1998 1.05571C17.8843 0.990737 17.5642 0.955424 17.2432 0.95018C16.6009 0.952126 15.9652 1.09438 15.3729 1.36873C14.7807 1.64308 14.2436 2.04411 13.7926 2.54865C13.3416 3.0532 12.9855 3.65123 12.7451 4.30833C12.5047 4.96543 12.3847 5.66861 12.3919 6.37715C12.3908 6.84045 12.4459 7.30178 12.5559 7.74892C12.8295 8.9176 13.457 9.94797 14.3344 10.6691C15.2119 11.3902 16.2865 11.7588 17.3799 11.7136C17.5984 11.7284 17.8174 11.7284 18.0359 11.7136C18.0643 11.7101 18.0917 11.7 18.1164 11.6841C18.141 11.6683 18.1623 11.6469 18.1791 11.6213C18.1958 11.5958 18.2075 11.5666 18.2134 11.5357C18.2194 11.5049 18.2194 11.4731 18.2135 11.4423C18.2194 11.4074 18.2194 11.3716 18.2135 11.3367C17.3188 9.85733 16.8505 8.11411 16.87 6.33584C16.8895 4.55758 17.396 2.82739 18.3229 1.37232C18.3361 1.34711 18.343 1.31853 18.343 1.28942C18.343 1.26031 18.3361 1.23173 18.3229 1.20652C18.2889 1.16939 18.2463 1.14323 18.1998 1.13107'
                    fill='url(#paint5_linear_6527_40117)'
                />
            </g>
            <defs>
                <filter
                    id='filter0_d_6527_40117'
                    x='0'
                    y='0'
                    width='50'
                    height='43.9997'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dy='10' />
                    <feGaussianBlur stdDeviation='5' />
                    <feComposite in2='hardAlpha' operator='out' />
                    <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.305882 0 0 0 0 0.67451 0 0 0 0 0.976471 0 0 0 0.2 0'
                    />
                    <feBlend
                        mode='normal'
                        in2='BackgroundImageFix'
                        result='effect1_dropShadow_6527_40117'
                    />
                    <feBlend
                        mode='normal'
                        in='SourceGraphic'
                        in2='effect1_dropShadow_6527_40117'
                        result='shape'
                    />
                </filter>
                <linearGradient
                    id='paint0_linear_6527_40117'
                    x1='25.0322'
                    y1='23.9997'
                    x2='25.0322'
                    y2='15.7688'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#3C9FFF' />
                    <stop offset='1' stopColor='#76C0FF' />
                </linearGradient>
                <linearGradient
                    id='paint1_linear_6527_40117'
                    x1='25.0325'
                    y1='12.6928'
                    x2='25.0325'
                    y2='0'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#3C9FFF' />
                    <stop offset='1' stopColor='#76C0FF' />
                </linearGradient>
                <linearGradient
                    id='paint2_linear_6527_40117'
                    x1='34.643'
                    y1='11.6041'
                    x2='34.643'
                    y2='0.95018'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#3C9FFF' />
                    <stop offset='1' stopColor='#76C0FF' />
                </linearGradient>
                <linearGradient
                    id='paint3_linear_6527_40117'
                    x1='36.2288'
                    y1='20.7737'
                    x2='36.2288'
                    y2='13.7908'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#3C9FFF' />
                    <stop offset='1' stopColor='#76C0FF' />
                </linearGradient>
                <linearGradient
                    id='paint4_linear_6527_40117'
                    x1='13.7712'
                    y1='20.7737'
                    x2='13.7712'
                    y2='13.7908'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#3C9FFF' />
                    <stop offset='1' stopColor='#76C0FF' />
                </linearGradient>
                <linearGradient
                    id='paint5_linear_6527_40117'
                    x1='15.3673'
                    y1='11.7247'
                    x2='15.3673'
                    y2='0.95018'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#3C9FFF' />
                    <stop offset='1' stopColor='#76C0FF' />
                </linearGradient>
            </defs>
        </svg>
    )
}

export const IconPeopleHeart = () => {
    return (
        <svg
            width='50'
            height='48'
            viewBox='0 0 50 48'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g filter='url(#filter0_d_6527_40126)'>
                <path
                    d='M32.0312 0C28.4418 0 26.1047 2.07356 25 3.35963C23.8953 2.07356 21.5573 0 17.9688 0C13.533 0 10 4.23646 10 9.64413C10 12.2209 10.9288 16.4425 15.332 21.0436L17.3189 20.6634L22.542 24.5709L24.1211 27.6189C24.2843 27.7109 24.4288 27.8034 24.5958 27.8952C24.7228 27.9653 24.861 28 25 28C25.139 28 25.2772 27.9653 25.4042 27.8952C25.5712 27.8034 25.7157 27.7108 25.8789 27.6189L27.6092 24.4578L32.5203 20.7837L34.668 21.0436C39.0712 16.4425 40 12.2209 40 9.64413C40 4.23646 36.467 0 32.0312 0Z'
                    fill='url(#paint0_linear_6527_40126)'
                />
                <path
                    d='M19.7266 14.9333C17.3035 14.9333 15.332 17.0268 15.332 19.5999V21.0435C17.3917 23.1957 20.232 25.4289 24.1211 27.6188V19.5999C24.1211 17.0268 22.1496 14.9333 19.7266 14.9333ZM22.3633 12.1333C22.3633 10.5893 21.1805 9.33325 19.7266 9.33325C18.2726 9.33325 17.0898 10.5893 17.0898 12.1333C17.0898 13.6772 18.2726 14.9333 19.7266 14.9333C21.1805 14.9333 22.3633 13.6772 22.3633 12.1333ZM30.2734 14.9333C27.8504 14.9333 25.8789 17.0268 25.8789 19.5999V27.6188C29.768 25.4289 32.6083 23.1957 34.668 21.0435V19.5999C34.668 17.0268 32.6965 14.9333 30.2734 14.9333ZM32.9102 12.1333C32.9102 10.5893 31.7274 9.33325 30.2734 9.33325C28.8195 9.33325 27.6367 10.5893 27.6367 12.1333C27.6367 13.6772 28.8195 14.9333 30.2734 14.9333C31.7274 14.9333 32.9102 13.6772 32.9102 12.1333Z'
                    fill='#EDF7FF'
                />
            </g>
            <defs>
                <filter
                    id='filter0_d_6527_40126'
                    x='0'
                    y='0'
                    width='50'
                    height='48'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dy='10' />
                    <feGaussianBlur stdDeviation='5' />
                    <feComposite in2='hardAlpha' operator='out' />
                    <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.305882 0 0 0 0 0.67451 0 0 0 0 0.976471 0 0 0 0.2 0'
                    />
                    <feBlend
                        mode='normal'
                        in2='BackgroundImageFix'
                        result='effect1_dropShadow_6527_40126'
                    />
                    <feBlend
                        mode='normal'
                        in='SourceGraphic'
                        in2='effect1_dropShadow_6527_40126'
                        result='shape'
                    />
                </filter>
                <linearGradient
                    id='paint0_linear_6527_40126'
                    x1='25'
                    y1='28'
                    x2='25'
                    y2='0'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#3C9FFF' />
                    <stop offset='1' stopColor='#76C0FF' />
                </linearGradient>
            </defs>
        </svg>
    )
}

export const IconPictureSymbol = () => {
    return (
        <svg
            width='48'
            height='48'
            viewBox='0 0 48 48'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g filter='url(#filter0_d_6527_40133)'>
                <path
                    d='M37.9998 17.7889V19.7298C37.9998 20.0556 37.9998 20.3767 37.9998 20.6932C37.9343 22.6945 37.078 24.5879 35.6192 25.9573C34.1605 27.3266 32.2185 28.0598 30.2201 27.9958H18.0628C16.0393 28.0674 14.0697 27.3346 12.5836 25.9573C12.0263 25.4668 11.5551 24.8863 11.1895 24.2398C11.6495 23.6812 12.1654 23.0669 12.6673 22.4386C13.5178 21.4332 14.3542 20.414 14.8701 19.7577C15.6369 18.7943 17.6584 16.2949 20.4468 17.4678C20.9833 17.709 21.4967 17.9988 21.9805 18.3335C23.1237 19.0875 23.5977 19.3109 24.3924 18.878C25.2698 18.2725 25.9759 17.45 26.4419 16.4903C26.7626 15.9737 27.0832 15.471 27.4318 15.0103C28.037 14.0711 28.9805 13.4018 30.066 13.1417C31.1515 12.8816 32.2954 13.0508 33.2595 13.614C34.2031 14.2081 35.0776 14.9059 35.8666 15.6944L36.3546 16.1692C36.5638 16.3787 37.2608 17.0908 37.9579 17.761'
                    fill='url(#paint0_linear_6527_40133)'
                />
                <path
                    d='M30.1101 0.0419297H18.0224C13.2961 0.0419297 10.1174 3.36508 10.1174 8.30796V19.7296C10.0875 21.2943 10.4672 22.8396 11.2187 24.2118L12.6966 22.4245C13.561 21.4052 14.3696 20.3999 14.8994 19.7436C15.6662 18.7802 17.6878 16.2808 20.4762 17.4537C21.0095 17.701 21.5224 17.9905 22.0099 18.3194C23.1392 19.0734 23.6131 19.2968 24.4078 18.8639C25.2891 18.2628 25.9961 17.4391 26.4573 16.4762C26.7779 15.9596 27.0986 15.457 27.4472 14.9962C28.0524 14.057 28.9959 13.3877 30.0814 13.1277C31.1669 12.8676 32.3108 13.0367 33.2749 13.5999C34.2239 14.1865 35.0992 14.8849 35.882 15.6803L36.37 16.1551L37.9733 17.7469V8.26603C37.9733 3.32315 34.8085 0 30.0822 0'
                    fill='#EDF7FF'
                />
                <path
                    d='M23.2917 9.53662C23.2917 10.2491 23.0807 10.9456 22.6855 11.538C22.2902 12.1304 21.7284 12.5922 21.0711 12.8648C20.4139 13.1375 19.6906 13.2088 18.9929 13.0698C18.2951 12.9308 17.6542 12.5877 17.1512 12.0839C16.6481 11.5801 16.3056 10.9382 16.1668 10.2394C16.028 9.54056 16.0992 8.81623 16.3714 8.15797C16.6437 7.49971 17.1048 6.93713 17.6963 6.54129C18.2878 6.14545 18.9832 5.93416 19.6946 5.93416C20.6464 5.94146 21.557 6.32339 22.23 6.9974C22.903 7.67141 23.2844 8.58345 23.2917 9.53662Z'
                    fill='url(#paint1_linear_6527_40133)'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M30.0766 1.78817H17.8077C15.4238 1.78817 13.3575 3.20747 12.3422 5.28066L15.8557 5.28066C16.3177 5.28066 16.6922 5.67157 16.6922 6.15378C16.6922 6.63599 16.3177 7.0269 15.8557 7.0269L10.8366 7.0269C10.7788 7.0269 10.7224 7.02079 10.668 7.00915C10.6016 6.99498 10.5381 6.97261 10.4785 6.9431C10.1956 6.80306 10 6.50226 10 6.15377V0.915053C10 0.432842 10.3746 0.0419332 10.8366 0.0419332C11.2985 0.0419332 11.6731 0.432842 11.6731 0.915053V3.14984C13.1028 1.25706 15.3193 0.0419312 17.8077 0.0419312H30.0766C34.3886 0.0419312 37.8841 3.69042 37.8841 8.19105V19.8326C37.8841 24.3333 34.3886 27.9818 30.0766 27.9818H17.8077C13.6495 27.9818 10.2505 24.5887 10.0135 20.3105C10.0046 20.2617 10 20.2115 10 20.1602V13.6841C10 13.2221 10.3745 12.8476 10.8365 12.8476C11.2985 12.8476 11.673 13.2221 11.673 13.6841V19.8326H11.6733V19.8326C11.6733 23.3689 14.4198 26.2355 17.8077 26.2355H30.0766C33.4646 26.2355 36.2111 23.3689 36.2111 19.8326V8.19105C36.2111 4.65484 33.4646 1.78817 30.0766 1.78817Z'
                    fill='url(#paint2_linear_6527_40133)'
                />
            </g>
            <defs>
                <filter
                    id='filter0_d_6527_40133'
                    x='0'
                    y='0'
                    width='48'
                    height='48.0006'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dy='10' />
                    <feGaussianBlur stdDeviation='5' />
                    <feComposite in2='hardAlpha' operator='out' />
                    <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.305882 0 0 0 0 0.67451 0 0 0 0 0.976471 0 0 0 0.2 0'
                    />
                    <feBlend
                        mode='normal'
                        in2='BackgroundImageFix'
                        result='effect1_dropShadow_6527_40133'
                    />
                    <feBlend
                        mode='normal'
                        in='SourceGraphic'
                        in2='effect1_dropShadow_6527_40133'
                        result='shape'
                    />
                </filter>
                <linearGradient
                    id='paint0_linear_6527_40133'
                    x1='24.5946'
                    y1='28.0006'
                    x2='24.5946'
                    y2='13.0225'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#3C9FFF' />
                    <stop offset='1' stopColor='#76C0FF' />
                </linearGradient>
                <linearGradient
                    id='paint1_linear_6527_40133'
                    x1='19.6947'
                    y1='13.139'
                    x2='19.6947'
                    y2='5.93416'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#3C9FFF' />
                    <stop offset='1' stopColor='#76C0FF' />
                </linearGradient>
                <linearGradient
                    id='paint2_linear_6527_40133'
                    x1='23.9421'
                    y1='27.9818'
                    x2='23.9421'
                    y2='0.0419312'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#3C9FFF' />
                    <stop offset='1' stopColor='#76C0FF' />
                </linearGradient>
            </defs>
        </svg>
    )
}

export const IconMediaFolder = () => {
    return (
        <svg
            width='50'
            height='50'
            viewBox='0 0 50 50'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g filter='url(#filter0_d_6527_39896)'>
                <path
                    d='M35.3125 14.375H23.0125C22.6937 14.375 22.3675 14.2412 22.1412 14.0175L20.3625 12.2375C20.1287 12.0037 19.8175 11.875 19.4875 11.875H14.6875C14.17 11.875 13.75 11.455 13.75 10.9375V3.4375C13.75 1.54125 15.2912 0 17.1875 0H32.8125C34.7087 0 36.25 1.54125 36.25 3.4375V13.4375C36.25 13.955 35.83 14.375 35.3125 14.375Z'
                    fill='#D6EBFF'
                />
                <path
                    d='M36.5625 11.25H23.0125C22.9375 11.25 22.85 11.2125 22.8 11.1625L21.025 9.3875C20.6125 8.975 20.0625 8.75 19.4875 8.75H13.4375C11.5375 8.75 10 10.2875 10 12.1875V26.5625C10 28.4625 11.5375 30 13.4375 30H36.5625C38.4625 30 40 28.4625 40 26.5625V14.6875C40 12.7875 38.4625 11.25 36.5625 11.25Z'
                    fill='url(#paint0_linear_6527_39896)'
                />
                <path
                    d='M29.3889 18.9629L23.6664 16.1286C23.5028 16.0456 23.3166 16.0012 23.1265 16C22.8277 16 22.5412 16.1017 22.3299 16.2829C22.1187 16.464 22 16.7096 22 16.9657V23.0487C22 23.2187 22.0532 23.3856 22.1539 23.532C22.2546 23.6784 22.3993 23.7989 22.5728 23.8812C22.7463 23.9634 22.9423 24.0043 23.1405 23.9996C23.3387 23.9949 23.5318 23.9448 23.6997 23.8545L29.4289 20.7515C29.607 20.656 29.7532 20.5225 29.8533 20.364C29.9533 20.2056 30.0038 20.0276 29.9998 19.8475C29.9957 19.6674 29.9374 19.4912 29.8303 19.3362C29.7232 19.1812 29.5712 19.0526 29.3889 18.9629Z'
                    fill='#EDF7FF'
                />
            </g>
            <defs>
                <filter
                    id='filter0_d_6527_39896'
                    x='0'
                    y='0'
                    width='50'
                    height='50'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dy='10' />
                    <feGaussianBlur stdDeviation='5' />
                    <feComposite in2='hardAlpha' operator='out' />
                    <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.305882 0 0 0 0 0.67451 0 0 0 0 0.976471 0 0 0 0.2 0'
                    />
                    <feBlend
                        mode='normal'
                        in2='BackgroundImageFix'
                        result='effect1_dropShadow_6527_39896'
                    />
                    <feBlend
                        mode='normal'
                        in='SourceGraphic'
                        in2='effect1_dropShadow_6527_39896'
                        result='shape'
                    />
                </filter>
                <linearGradient
                    id='paint0_linear_6527_39896'
                    x1='25'
                    y1='30'
                    x2='25'
                    y2='8.75'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#3C9FFF' />
                    <stop offset='1' stopColor='#76C0FF' />
                </linearGradient>
            </defs>
        </svg>
    )
}

export const IconMediaFolder2 = () => {
    return (
        <svg
            width='50'
            height='50'
            viewBox='0 0 50 50'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M32.9337 10.1648V11.2739C32.9337 11.46 32.9337 11.6436 32.9337 11.8244C32.8963 12.968 32.407 14.0499 31.5734 14.8324C30.7398 15.6149 29.6302 16.0338 28.4883 15.9972H21.5413C20.3851 16.0382 19.2596 15.6194 18.4104 14.8324C18.092 14.5522 17.8227 14.2204 17.6138 13.851C17.8767 13.5318 18.1714 13.1808 18.4582 12.8217C18.9442 12.2473 19.4222 11.6648 19.7169 11.2898C20.1551 10.7393 21.3103 9.31112 22.9036 9.98133C23.2101 10.1192 23.5035 10.2848 23.78 10.476C24.4332 10.9069 24.7041 11.0345 25.1582 10.7872C25.6595 10.4412 26.063 9.97116 26.3293 9.42282C26.5126 9.1276 26.6958 8.84037 26.8949 8.57708C27.2408 8.0404 27.7799 7.65794 28.4002 7.50932C29.0205 7.36071 29.6741 7.45739 30.225 7.77921C30.7642 8.11872 31.2639 8.51745 31.7148 8.96803L31.9936 9.23932C32.1131 9.359 32.5114 9.76593 32.9098 10.1489'
                fill='url(#paint0_linear_6527_39911)'
            />
            <path
                d='M28.4252 0.0239594H21.518C18.8173 0.0239594 17.0009 1.92287 17.0009 4.74733V11.2739C16.9839 12.168 17.2009 13.051 17.6303 13.8351L18.4747 12.8138C18.9687 12.2313 19.4308 11.6569 19.7335 11.2819C20.1717 10.7313 21.3268 9.30314 22.9202 9.97335C23.2249 10.1147 23.518 10.2801 23.7965 10.468C24.4418 10.8989 24.7127 11.0265 25.1668 10.7792C25.6704 10.4357 26.0743 9.96502 26.3379 9.41484C26.5211 9.11962 26.7043 8.83239 26.9035 8.5691C27.2493 8.03242 27.7885 7.65001 28.4088 7.50139C29.0291 7.35278 29.6827 7.44941 30.2336 7.77123C30.7759 8.10641 31.276 8.50553 31.7233 8.96004L32.0022 9.23134L32.9183 10.1409V4.72337C32.9183 1.89891 31.1099 0 28.4092 0'
                fill='#D6EBFF'
            />
            <path
                d='M24.5293 5.44944C24.5293 5.85658 24.4087 6.25455 24.1829 6.59307C23.957 6.93159 23.636 7.19544 23.2604 7.35125C22.8848 7.50705 22.4715 7.54779 22.0728 7.46837C21.6741 7.38894 21.3079 7.19291 21.0204 6.90503C20.733 6.61714 20.5373 6.25032 20.458 5.85101C20.3786 5.4517 20.4193 5.0378 20.5749 4.66166C20.7305 4.28551 20.9939 3.96405 21.3319 3.73785C21.6699 3.51166 22.0673 3.39093 22.4738 3.39093C23.0177 3.3951 23.5381 3.61334 23.9226 3.99849C24.3072 4.38363 24.5251 4.90479 24.5293 5.44944Z'
                fill='url(#paint1_linear_6527_39911)'
            />
            <g filter='url(#filter0_d_6527_39911)'>
                <path
                    d='M36.5625 11.25H23.0125C22.9375 11.25 22.85 11.2125 22.8 11.1625L21.025 9.3875C20.6125 8.975 20.0625 8.75 19.4875 8.75H13.4375C11.5375 8.75 10 10.2875 10 12.1875V26.5625C10 28.4625 11.5375 30 13.4375 30H36.5625C38.4625 30 40 28.4625 40 26.5625V14.6875C40 12.7875 38.4625 11.25 36.5625 11.25Z'
                    fill='url(#paint2_linear_6527_39911)'
                />
                <path
                    d='M29.3889 18.9629L23.6664 16.1286C23.5028 16.0456 23.3166 16.0012 23.1265 16C22.8277 16 22.5412 16.1017 22.3299 16.2829C22.1187 16.464 22 16.7096 22 16.9657V23.0487C22 23.2187 22.0532 23.3856 22.1539 23.532C22.2546 23.6784 22.3993 23.7989 22.5728 23.8812C22.7463 23.9634 22.9423 24.0043 23.1405 23.9996C23.3387 23.9949 23.5318 23.9448 23.6997 23.8545L29.4289 20.7515C29.607 20.656 29.7532 20.5225 29.8533 20.364C29.9533 20.2056 30.0038 20.0276 29.9998 19.8475C29.9957 19.6674 29.9374 19.4912 29.8303 19.3362C29.7232 19.1812 29.5712 19.0526 29.3889 18.9629Z'
                    fill='#EDF7FF'
                />
            </g>
            <defs>
                <filter
                    id='filter0_d_6527_39911'
                    x='0'
                    y='8.75'
                    width='50'
                    height='41.25'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dy='10' />
                    <feGaussianBlur stdDeviation='5' />
                    <feComposite in2='hardAlpha' operator='out' />
                    <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.305882 0 0 0 0 0.67451 0 0 0 0 0.976471 0 0 0 0.2 0'
                    />
                    <feBlend
                        mode='normal'
                        in2='BackgroundImageFix'
                        result='effect1_dropShadow_6527_39911'
                    />
                    <feBlend
                        mode='normal'
                        in='SourceGraphic'
                        in2='effect1_dropShadow_6527_39911'
                        result='shape'
                    />
                </filter>
                <linearGradient
                    id='paint0_linear_6527_39911'
                    x1='25.2737'
                    y1='16'
                    x2='25.2737'
                    y2='7.44122'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#3C9FFF' />
                    <stop offset='1' stopColor='#76C0FF' />
                </linearGradient>
                <linearGradient
                    id='paint1_linear_6527_39911'
                    x1='22.4739'
                    y1='7.50793'
                    x2='22.4739'
                    y2='3.39093'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#3C9FFF' />
                    <stop offset='1' stopColor='#76C0FF' />
                </linearGradient>
                <linearGradient
                    id='paint2_linear_6527_39911'
                    x1='25'
                    y1='30'
                    x2='25'
                    y2='8.75'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#3C9FFF' />
                    <stop offset='1' stopColor='#76C0FF' />
                </linearGradient>
            </defs>
        </svg>
    )
}

export const IconSettings = () => {
    return (
        <svg
            width='50'
            height='50'
            viewBox='0 0 50 50'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g filter='url(#filter0_d_6527_40147)'>
                <path
                    d='M39.1211 12.3633H37.0049C36.694 10.9515 36.1315 9.59561 35.3513 8.37744L36.8081 6.92068C37.1513 6.5775 37.1511 6.02068 36.8081 5.67773L34.3223 3.19189C33.9791 2.84865 33.4226 2.84865 33.0793 3.19189L31.6226 4.64865C30.4043 3.86848 29.0485 3.30598 27.6367 2.99502V0.878906C27.6367 0.393516 27.2432 0 26.7578 0H23.2422C22.7568 0 22.3633 0.393516 22.3633 0.878906V2.99502C20.9515 3.30598 19.5957 3.86848 18.3775 4.64859L16.9207 3.19184C16.5776 2.84859 16.021 2.84859 15.6778 3.19184L13.1919 5.67773C12.8487 6.02092 12.8489 6.57773 13.1919 6.92068L14.6487 8.37744C13.8685 9.59561 13.306 10.9515 12.9951 12.3633H10.8789C10.3935 12.3633 10 12.7568 10 13.2422V16.7578C10 17.2432 10.3935 17.6367 10.8789 17.6367H12.9951C13.306 19.0484 13.8685 20.4042 14.6487 21.6225L13.1919 23.0791C12.8487 23.4223 12.8489 23.9791 13.1919 24.3221L15.6777 26.8081C16.0209 27.1513 16.5777 27.1512 16.9207 26.8081L18.3774 25.3513C19.5955 26.1315 20.9515 26.694 22.3632 27.0049V29.1211C22.3632 29.6065 22.7567 30 23.2421 30H26.7578C27.2431 30 27.6367 29.6065 27.6367 29.1211V27.0049C29.0484 26.694 30.4043 26.1315 31.6224 25.3513L33.0792 26.8081C33.4223 27.1513 33.9791 27.1511 34.3221 26.8081L36.808 24.3221C37.1513 23.979 37.1511 23.4221 36.808 23.0792L35.3513 21.6226C36.1314 20.4043 36.6939 19.0484 37.0049 17.6368H39.1211C39.6065 17.6368 40 17.2433 40 16.7579V13.2422C40 12.7568 39.6065 12.3633 39.1211 12.3633Z'
                    fill='url(#paint0_linear_6527_40147)'
                />
                <path
                    d='M25.0023 5.58984C19.8123 5.58984 15.5898 9.81229 15.5898 15.0023C15.5898 20.1924 19.8123 24.4148 25.0023 24.4148C30.1924 24.4148 34.4148 20.1924 34.4148 15.0023C34.4148 9.81229 30.1924 5.58984 25.0023 5.58984ZM26.0482 19.1857C26.0482 19.7633 25.5799 20.2315 25.0023 20.2315C24.4248 20.2315 23.9565 19.7633 23.9565 19.1857V15.0023C23.9565 14.4248 24.4248 13.9565 25.0023 13.9565C25.5799 13.9565 26.0482 14.4248 26.0482 15.0023V19.1857ZM25.0023 11.8648C24.4248 11.8648 23.9565 11.3966 23.9565 10.819C23.9565 10.2414 24.4248 9.77318 25.0023 9.77318C25.5799 9.77318 26.0482 10.2414 26.0482 10.819C26.0482 11.3966 25.5799 11.8648 25.0023 11.8648Z'
                    fill='#EDF7FF'
                />
            </g>
            <defs>
                <filter
                    id='filter0_d_6527_40147'
                    x='0'
                    y='0'
                    width='50'
                    height='50'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dy='10' />
                    <feGaussianBlur stdDeviation='5' />
                    <feComposite in2='hardAlpha' operator='out' />
                    <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.305882 0 0 0 0 0.67451 0 0 0 0 0.976471 0 0 0 0.2 0'
                    />
                    <feBlend
                        mode='normal'
                        in2='BackgroundImageFix'
                        result='effect1_dropShadow_6527_40147'
                    />
                    <feBlend
                        mode='normal'
                        in='SourceGraphic'
                        in2='effect1_dropShadow_6527_40147'
                        result='shape'
                    />
                </filter>
                <linearGradient
                    id='paint0_linear_6527_40147'
                    x1='25'
                    y1='30'
                    x2='25'
                    y2='0'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#3C9FFF' />
                    <stop offset='1' stopColor='#76C0FF' />
                </linearGradient>
            </defs>
        </svg>
    )
}

export const IconThreeDotsCircle = () => {
    return (
        <svg
            width='30'
            height='30'
            viewBox='0 0 30 30'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M15 1.12503C17.7442 1.12503 20.4268 1.93877 22.7086 3.46338C24.9903 4.98798 26.7687 7.15492 27.8188 9.69025C28.869 12.2256 29.1438 15.0154 28.6084 17.7069C28.073 20.3984 26.7515 22.8706 24.8111 24.8111C22.8706 26.7516 20.3983 28.0731 17.7068 28.6084C15.0154 29.1438 12.2256 28.869 9.69031 27.8188C7.15498 26.7686 4.98795 24.9902 3.46335 22.7085C1.93874 20.4268 1.125 17.7442 1.125 15C1.125 11.3202 2.58687 7.79094 5.18893 5.18887C7.791 2.58681 11.3201 1.12503 15 1.12503V1.12503Z'
                stroke='#0D1444'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M8.28 16.8C7.92399 16.8 7.57598 16.6944 7.27997 16.4966C6.98396 16.2989 6.75318 16.0177 6.61694 15.6888C6.48071 15.3599 6.44513 14.998 6.51459 14.6488C6.58404 14.2997 6.75541 13.9789 7.00714 13.7272C7.25888 13.4754 7.57964 13.3041 7.9288 13.2346C8.27797 13.1652 8.63993 13.2007 8.96884 13.337C9.29775 13.4732 9.57882 13.704 9.77661 14C9.9744 14.296 10.0799 14.644 10.0799 15V15C10.0799 15.2364 10.0334 15.4704 9.94296 15.6888C9.8525 15.9072 9.71991 16.1057 9.55276 16.2728C9.38562 16.4399 9.18723 16.5725 8.96884 16.663C8.75046 16.7535 8.51638 16.8 8.28 16.8V16.8Z'
                fill='#0D1444'
            />
            <path
                d='M15.0002 16.8C14.6442 16.8 14.2962 16.6944 14.0002 16.4966C13.7042 16.2989 13.4735 16.0177 13.3372 15.6888C13.201 15.3599 13.1653 14.998 13.2348 14.6488C13.3042 14.2997 13.4757 13.9789 13.7274 13.7272C13.9792 13.4754 14.2998 13.3041 14.649 13.2346C14.9982 13.1652 15.3601 13.2007 15.689 13.337C16.0179 13.4732 16.299 13.704 16.4968 14C16.6946 14.296 16.8002 14.644 16.8002 15V15C16.8002 15.2364 16.7536 15.4704 16.6632 15.6888C16.5727 15.9072 16.4401 16.1057 16.273 16.2728C16.1058 16.4399 15.9074 16.5725 15.689 16.663C15.4706 16.7535 15.2366 16.8 15.0002 16.8V16.8Z'
                fill='#0D1444'
            />
            <path
                d='M21.7199 16.8C21.3639 16.8 21.0159 16.6944 20.7199 16.4966C20.4239 16.2989 20.1932 16.0177 20.057 15.6888C19.9207 15.3599 19.8851 14.998 19.9545 14.6488C20.024 14.2997 20.1954 13.9789 20.4472 13.7272C20.6989 13.4754 21.0196 13.3041 21.3688 13.2346C21.718 13.1652 22.0799 13.2007 22.4088 13.337C22.7377 13.4732 23.0188 13.704 23.2166 14C23.4144 14.296 23.5199 14.644 23.5199 15V15C23.5199 15.2364 23.4734 15.4704 23.383 15.6888C23.2925 15.9072 23.1599 16.1057 22.9928 16.2728C22.8256 16.4399 22.6271 16.5725 22.4088 16.663C22.1904 16.7535 21.9563 16.8 21.7199 16.8V16.8Z'
                fill='#0D1444'
            />
        </svg>
    )
}
export const IconThreeDotsCircleSmall = () => {
    return (
        <svg
            width='20'
            height='20'
            viewBox='0 0 30 30'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M15 1.12503C17.7442 1.12503 20.4268 1.93877 22.7086 3.46338C24.9903 4.98798 26.7687 7.15492 27.8188 9.69025C28.869 12.2256 29.1438 15.0154 28.6084 17.7069C28.073 20.3984 26.7515 22.8706 24.8111 24.8111C22.8706 26.7516 20.3983 28.0731 17.7068 28.6084C15.0154 29.1438 12.2256 28.869 9.69031 27.8188C7.15498 26.7686 4.98795 24.9902 3.46335 22.7085C1.93874 20.4268 1.125 17.7442 1.125 15C1.125 11.3202 2.58687 7.79094 5.18893 5.18887C7.791 2.58681 11.3201 1.12503 15 1.12503V1.12503Z'
                stroke='currentColor'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M8.28 16.8C7.92399 16.8 7.57598 16.6944 7.27997 16.4966C6.98396 16.2989 6.75318 16.0177 6.61694 15.6888C6.48071 15.3599 6.44513 14.998 6.51459 14.6488C6.58404 14.2997 6.75541 13.9789 7.00714 13.7272C7.25888 13.4754 7.57964 13.3041 7.9288 13.2346C8.27797 13.1652 8.63993 13.2007 8.96884 13.337C9.29775 13.4732 9.57882 13.704 9.77661 14C9.9744 14.296 10.0799 14.644 10.0799 15V15C10.0799 15.2364 10.0334 15.4704 9.94296 15.6888C9.8525 15.9072 9.71991 16.1057 9.55276 16.2728C9.38562 16.4399 9.18723 16.5725 8.96884 16.663C8.75046 16.7535 8.51638 16.8 8.28 16.8V16.8Z'
                fill='currentColor'
            />
            <path
                d='M15.0002 16.8C14.6442 16.8 14.2962 16.6944 14.0002 16.4966C13.7042 16.2989 13.4735 16.0177 13.3372 15.6888C13.201 15.3599 13.1653 14.998 13.2348 14.6488C13.3042 14.2997 13.4757 13.9789 13.7274 13.7272C13.9792 13.4754 14.2998 13.3041 14.649 13.2346C14.9982 13.1652 15.3601 13.2007 15.689 13.337C16.0179 13.4732 16.299 13.704 16.4968 14C16.6946 14.296 16.8002 14.644 16.8002 15V15C16.8002 15.2364 16.7536 15.4704 16.6632 15.6888C16.5727 15.9072 16.4401 16.1057 16.273 16.2728C16.1058 16.4399 15.9074 16.5725 15.689 16.663C15.4706 16.7535 15.2366 16.8 15.0002 16.8V16.8Z'
                fill='currentColor'
            />
            <path
                d='M21.7199 16.8C21.3639 16.8 21.0159 16.6944 20.7199 16.4966C20.4239 16.2989 20.1932 16.0177 20.057 15.6888C19.9207 15.3599 19.8851 14.998 19.9545 14.6488C20.024 14.2997 20.1954 13.9789 20.4472 13.7272C20.6989 13.4754 21.0196 13.3041 21.3688 13.2346C21.718 13.1652 22.0799 13.2007 22.4088 13.337C22.7377 13.4732 23.0188 13.704 23.2166 14C23.4144 14.296 23.5199 14.644 23.5199 15V15C23.5199 15.2364 23.4734 15.4704 23.383 15.6888C23.2925 15.9072 23.1599 16.1057 22.9928 16.2728C22.8256 16.4399 22.6271 16.5725 22.4088 16.663C22.1904 16.7535 21.9563 16.8 21.7199 16.8V16.8Z'
                fill='currentColor'
            />
        </svg>
    )
}

export const IconLiveStream = () => {
    const id = useId()

    const filterId = `livestream_filter_${id}`
    const paint0Id = `livestream_paint0_${id}`
    const paint1Id = `livestream_paint1_${id}`
    const paint2Id = `livestream_paint2_${id}`
    const paint3Id = `livestream_paint3_${id}`
    const paint4Id = `livestream_paint4_${id}`

    return (
        <svg
            width='50'
            height='40'
            viewBox='0 0 50 40'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g filter={`url(#${filterId})`}>
                <path
                    d='M12.9872 18.565C9.00426 13.2598 9.00426 5.85114 12.9872 0.545898C13.4404 -0.0565965 14.2989 -0.176531 14.8961 0.273997C15.5012 0.727165 15.6212 1.58163 15.168 2.18549C11.9129 6.52434 11.9129 12.5867 15.168 16.9254C15.6212 17.5293 15.5012 18.3837 14.8961 18.8369C14.2917 19.2902 13.4356 19.1658 12.9872 18.565Z'
                    fill={`url(#${paint0Id})`}
                />
                <path
                    d='M35.104 18.8368C34.4989 18.3837 34.3788 17.5292 34.8321 16.9254C38.0872 12.5865 38.0872 6.52415 34.8321 2.18539C34.3789 1.58153 34.4989 0.727157 35.104 0.273898C35.7039 -0.177995 36.5622 -0.0593346 37.0129 0.545799C40.9958 5.85104 40.9958 13.2597 37.0129 18.5649C36.5646 19.1655 35.7085 19.2903 35.104 18.8368Z'
                    fill={`url(#${paint1Id})`}
                />
                <path
                    d='M17.8798 15.9257C14.6273 12.2947 14.6273 6.81618 17.8798 3.18511C18.3836 2.62256 19.2474 2.57861 19.8073 3.07846C20.3671 3.58095 20.4151 4.44478 19.9113 5.00597C17.5892 7.59994 17.5892 11.5108 19.9113 14.1048C20.4151 14.666 20.3672 15.5297 19.8073 16.0323C19.2464 16.5331 18.3837 16.4895 17.8798 15.9257Z'
                    fill={`url(#${paint2Id})`}
                />
                <path
                    d='M30.1932 16.0323C29.6334 15.5298 29.5853 14.666 30.0892 14.1048C32.4113 11.5108 32.4113 7.59993 30.0892 5.00596C29.5853 4.44478 29.6333 3.58103 30.1932 3.07845C30.7531 2.57587 31.6168 2.61991 32.1207 3.1851C35.3731 6.81608 35.3731 12.2946 32.1207 15.9257C31.6177 16.4885 30.7551 16.534 30.1932 16.0323Z'
                    fill={`url(#${paint3Id})`}
                />
                <path
                    d='M25.0002 13.6502C22.7421 13.6502 20.9053 11.8133 20.9053 9.55528C20.9053 7.29726 22.7421 5.46039 25.0002 5.46039C27.2582 5.46039 29.095 7.29726 29.095 9.55528C29.095 11.8133 27.2582 13.6502 25.0002 13.6502Z'
                    fill={`url(#${paint4Id})`}
                />
            </g>
            <defs>
                <filter
                    id={filterId}
                    x='0'
                    y='0'
                    width='50'
                    height='39.1101'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dy='10' />
                    <feGaussianBlur stdDeviation='5' />
                    <feComposite in2='hardAlpha' operator='out' />
                    <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.305882 0 0 0 0 0.67451 0 0 0 0 0.976471 0 0 0 0.2 0'
                    />
                    <feBlend
                        mode='normal'
                        in2='BackgroundImageFix'
                        result={`effect1_dropShadow_${id}`}
                    />
                    <feBlend
                        mode='normal'
                        in='SourceGraphic'
                        in2={`effect1_dropShadow_${id}`}
                        result='shape'
                    />
                </filter>
                <linearGradient
                    id={paint0Id}
                    x1='12.7212'
                    y1='19.1101'
                    x2='12.7212'
                    y2='0.00146484'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#3C9FFF' />
                    <stop offset='1' stopColor='#76C0FF' />
                </linearGradient>
                <linearGradient
                    id={paint1Id}
                    x1='37.2789'
                    y1='19.1101'
                    x2='37.2789'
                    y2='0'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#3C9FFF' />
                    <stop offset='1' stopColor='#76C0FF' />
                </linearGradient>
                <linearGradient
                    id={paint2Id}
                    x1='17.8503'
                    y1='16.3802'
                    x2='17.8503'
                    y2='2.73138'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#3C9FFF' />
                    <stop offset='1' stopColor='#76C0FF' />
                </linearGradient>
                <linearGradient
                    id={paint3Id}
                    x1='32.1501'
                    y1='16.3802'
                    x2='32.1501'
                    y2='2.72937'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#3C9FFF' />
                    <stop offset='1' stopColor='#76C0FF' />
                </linearGradient>
                <linearGradient
                    id={paint4Id}
                    x1='25.0002'
                    y1='13.6502'
                    x2='25.0002'
                    y2='5.46039'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#3C9FFF' />
                    <stop offset='1' stopColor='#76C0FF' />
                </linearGradient>
            </defs>
        </svg>
    )
}
export const IconManCircleDots = () => {
    return (
        <svg
            width='50'
            height='50'
            viewBox='-8 0 50 50'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g filter='url(#filter0_i_6527_40166)'>
                <path
                    d='M3 6C4.65685 6 6 4.65685 6 3C6 1.34315 4.65685 0 3 0C1.34315 0 0 1.34315 0 3C0 4.65685 1.34315 6 3 6Z'
                    fill='url(#paint0_linear_6527_40166)'
                />
            </g>
            <g filter='url(#filter1_i_6527_40166)'>
                <path
                    d='M27 6C28.6569 6 30 4.65685 30 3C30 1.34315 28.6569 0 27 0C25.3431 0 24 1.34315 24 3C24 4.65685 25.3431 6 27 6Z'
                    fill='url(#paint1_linear_6527_40166)'
                />
            </g>
            <g filter='url(#filter2_i_6527_40166)'>
                <path
                    d='M3 30C4.65685 30 6 28.6569 6 27C6 25.3431 4.65685 24 3 24C1.34315 24 0 25.3431 0 27C0 28.6569 1.34315 30 3 30Z'
                    fill='url(#paint2_linear_6527_40166)'
                />
            </g>
            <g filter='url(#filter3_i_6527_40166)'>
                <path
                    d='M27 30C28.6569 30 30 28.6569 30 27C30 25.3431 28.6569 24 27 24C25.3431 24 24 25.3431 24 27C24 28.6569 25.3431 30 27 30Z'
                    fill='url(#paint3_linear_6527_40166)'
                />
            </g>
            <path
                d='M14.9975 3.50006C8.65816 3.50006 3.5 8.65766 3.5 14.9976C3.5 21.3375 8.65816 26.4951 14.9975 26.4951C21.3368 26.4951 26.495 21.3375 26.495 14.9976C26.495 8.65766 21.3368 3.50006 14.9975 3.50006Z'
                fill='url(#paint4_linear_6527_40166)'
            />
            <path
                d='M15 14C16.6569 14 18 12.6569 18 11C18 9.34315 16.6569 8 15 8C13.3431 8 12 9.34315 12 11C12 12.6569 13.3431 14 15 14Z'
                fill='white'
            />
            <path
                d='M15 15C12.7939 15 11 16.7944 11 19V20.1899C11 20.5435 11.1865 20.8711 11.4912 21.0508C12.542 21.6719 13.7549 22 15 22C16.2451 22 17.458 21.6719 18.5088 21.0508C18.8135 20.8711 19 20.5435 19 20.1899V19C19 16.7944 17.2061 15 15 15Z'
                fill='#EDF7FF'
            />
            <defs>
                <filter
                    id='filter0_i_6527_40166'
                    x='0'
                    y='0'
                    width='6'
                    height='8'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feBlend
                        mode='normal'
                        in='SourceGraphic'
                        in2='BackgroundImageFix'
                        result='shape'
                    />
                    <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dy='2' />
                    <feGaussianBlur stdDeviation='2' />
                    <feComposite
                        in2='hardAlpha'
                        operator='arithmetic'
                        k2='-1'
                        k3='1'
                    />
                    <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.279167 0 0 0 0 0.655653 0 0 0 0 1 0 0 0 1 0'
                    />
                    <feBlend
                        mode='normal'
                        in2='shape'
                        result='effect1_innerShadow_6527_40166'
                    />
                </filter>
                <filter
                    id='filter1_i_6527_40166'
                    x='24'
                    y='0'
                    width='6'
                    height='8'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feBlend
                        mode='normal'
                        in='SourceGraphic'
                        in2='BackgroundImageFix'
                        result='shape'
                    />
                    <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dy='2' />
                    <feGaussianBlur stdDeviation='2' />
                    <feComposite
                        in2='hardAlpha'
                        operator='arithmetic'
                        k2='-1'
                        k3='1'
                    />
                    <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.279167 0 0 0 0 0.655653 0 0 0 0 1 0 0 0 1 0'
                    />
                    <feBlend
                        mode='normal'
                        in2='shape'
                        result='effect1_innerShadow_6527_40166'
                    />
                </filter>
                <filter
                    id='filter2_i_6527_40166'
                    x='0'
                    y='24'
                    width='6'
                    height='8'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feBlend
                        mode='normal'
                        in='SourceGraphic'
                        in2='BackgroundImageFix'
                        result='shape'
                    />
                    <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dy='2' />
                    <feGaussianBlur stdDeviation='2' />
                    <feComposite
                        in2='hardAlpha'
                        operator='arithmetic'
                        k2='-1'
                        k3='1'
                    />
                    <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.279167 0 0 0 0 0.655653 0 0 0 0 1 0 0 0 1 0'
                    />
                    <feBlend
                        mode='normal'
                        in2='shape'
                        result='effect1_innerShadow_6527_40166'
                    />
                </filter>
                <filter
                    id='filter3_i_6527_40166'
                    x='24'
                    y='24'
                    width='6'
                    height='8'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feBlend
                        mode='normal'
                        in='SourceGraphic'
                        in2='BackgroundImageFix'
                        result='shape'
                    />
                    <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dy='2' />
                    <feGaussianBlur stdDeviation='2' />
                    <feComposite
                        in2='hardAlpha'
                        operator='arithmetic'
                        k2='-1'
                        k3='1'
                    />
                    <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.279167 0 0 0 0 0.655653 0 0 0 0 1 0 0 0 1 0'
                    />
                    <feBlend
                        mode='normal'
                        in2='shape'
                        result='effect1_innerShadow_6527_40166'
                    />
                </filter>
                <linearGradient
                    id='paint0_linear_6527_40166'
                    x1='-0.451411'
                    y1='-6.11999'
                    x2='7.32326'
                    y2='-5.71922'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#93CFFF' />
                    <stop offset='1' stopColor='#2894FF' />
                </linearGradient>
                <linearGradient
                    id='paint1_linear_6527_40166'
                    x1='23.5486'
                    y1='-6.11999'
                    x2='31.3233'
                    y2='-5.71922'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#93CFFF' />
                    <stop offset='1' stopColor='#2894FF' />
                </linearGradient>
                <linearGradient
                    id='paint2_linear_6527_40166'
                    x1='-0.451411'
                    y1='17.88'
                    x2='7.32326'
                    y2='18.2808'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#93CFFF' />
                    <stop offset='1' stopColor='#2894FF' />
                </linearGradient>
                <linearGradient
                    id='paint3_linear_6527_40166'
                    x1='23.5486'
                    y1='17.88'
                    x2='31.3233'
                    y2='18.2808'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#93CFFF' />
                    <stop offset='1' stopColor='#2894FF' />
                </linearGradient>
                <linearGradient
                    id='paint4_linear_6527_40166'
                    x1='1.76997'
                    y1='-19.9548'
                    x2='31.5664'
                    y2='-18.4189'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#93CFFF' />
                    <stop offset='1' stopColor='#2894FF' />
                </linearGradient>
            </defs>
        </svg>
    )
}

export const IconCreditCards = () => {
    return (
        <svg
            width='50'
            height='46'
            viewBox='0 0 50 46'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g filter='url(#filter0_d_6527_39699)'>
                <path
                    d='M38.0629 17.9165L17.4304 21.6343C16.1556 21.864 14.9401 20.9942 14.7153 19.6915L12.4442 6.52926C12.2194 5.22655 13.0706 3.98432 14.3453 3.75462L34.9778 0.0367851C36.2526 -0.192908 37.4682 0.676943 37.693 1.97959L39.964 15.1418C40.1889 16.4445 39.3377 17.6868 38.0629 17.9165Z'
                    fill='#D6EBFF'
                />
                <path
                    d='M32.8516 26H12.3438C11.0494 26 10 24.9277 10 23.6049V10.5683C10 9.24558 11.0494 8.17322 12.3438 8.17322H32.8516C34.146 8.17322 35.1953 9.24558 35.1953 10.5683V23.6049C35.1953 24.9277 34.146 26 32.8516 26Z'
                    fill='url(#paint0_linear_6527_39699)'
                />
                <path
                    d='M10 12.2479H35.1953V16.3226H10V12.2479Z'
                    fill='#EDF7FF'
                />
                <path
                    d='M16.9775 22.0458H12.9902C12.5048 22.0458 12.1113 22.4479 12.1113 22.9439C12.1113 23.44 12.5048 23.8421 12.9902 23.8421H16.9775C17.4629 23.8421 17.8564 23.44 17.8564 22.9439C17.8564 22.4479 17.4629 22.0458 16.9775 22.0458Z'
                    fill='url(#paint1_linear_6527_39699)'
                />
            </g>
            <defs>
                <filter
                    id='filter0_d_6527_39699'
                    x='0'
                    y='0'
                    width='50'
                    height='46'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dy='10' />
                    <feGaussianBlur stdDeviation='5' />
                    <feComposite in2='hardAlpha' operator='out' />
                    <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.305882 0 0 0 0 0.67451 0 0 0 0 0.976471 0 0 0 0.2 0'
                    />
                    <feBlend
                        mode='normal'
                        in2='BackgroundImageFix'
                        result='effect1_dropShadow_6527_39699'
                    />
                    <feBlend
                        mode='normal'
                        in='SourceGraphic'
                        in2='effect1_dropShadow_6527_39699'
                        result='shape'
                    />
                </filter>
                <linearGradient
                    id='paint0_linear_6527_39699'
                    x1='22.5977'
                    y1='26'
                    x2='22.5977'
                    y2='8.17322'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#3C9FFF' />
                    <stop offset='1' stopColor='#76C0FF' />
                </linearGradient>
                <linearGradient
                    id='paint1_linear_6527_39699'
                    x1='14.9839'
                    y1='23.8421'
                    x2='14.9839'
                    y2='22.0458'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#ADDCFF' />
                    <stop offset='0.5028' stopColor='#EAF6FF' />
                    <stop offset='1' stopColor='#EAF6FF' />
                </linearGradient>
            </defs>
        </svg>
    )
}

export const IconHowToBook = () => {
    return (
        <svg
            width='45'
            height='50'
            viewBox='0 0 45 50'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g filter='url(#filter0_d_6527_40175)'>
                <path
                    d='M33.7305 0H14.3945C11.9707 0 10 1.9715 10 4.39453V26.4844C10 26.9702 10.3931 27.3633 10.8789 27.3633C11.3647 27.3633 11.7578 26.9702 11.7578 26.4844C11.7578 25.5154 12.5457 24.7266 13.5156 24.7266L34.6094 23.8477V0.878906C34.6094 0.393105 34.2163 0 33.7305 0Z'
                    fill='url(#paint0_linear_6527_40175)'
                />
                <path
                    d='M22.3047 21.2109C27.1562 21.2109 31.0938 17.2734 31.0938 12.4219C31.0938 7.57031 27.1562 3.63281 22.3047 3.63281C17.4531 3.63281 13.5156 7.57031 13.5156 12.4219C13.5156 17.2734 17.4531 21.2109 22.3047 21.2109ZM22.3047 17.6953C21.8124 17.6953 21.4258 17.3085 21.4258 16.8164C21.4258 16.3242 21.8124 15.9375 22.3047 15.9375C22.7969 15.9375 23.1836 16.3242 23.1836 16.8164C23.1836 17.3085 22.7969 17.6953 22.3047 17.6953ZM22.3047 7.14844C23.7637 7.14844 24.9414 8.32617 24.9414 9.78516C24.9414 10.7167 24.4317 11.5956 23.623 12.0703C23.3593 12.2286 23.1836 12.5098 23.1836 12.8262V13.3008C23.1836 13.7929 22.7969 14.1797 22.3047 14.1797C21.8124 14.1797 21.4258 13.7929 21.4258 13.3008V12.8261C21.4258 11.8945 21.9355 11.0156 22.7441 10.541C23.0079 10.3827 23.1836 10.1015 23.1836 9.7851C23.1836 9.29285 22.7969 8.90619 22.3047 8.90619C21.8124 8.90619 21.4258 9.29285 21.4258 9.7851C21.4258 10.2772 21.0391 10.664 20.5469 10.664C20.0546 10.664 19.668 10.2772 19.668 9.7851C19.668 8.32617 20.8457 7.14844 22.3047 7.14844ZM33.7305 28.2422C32.7606 28.2422 31.9727 27.4534 31.9727 26.4844C31.9727 25.5154 32.7606 24.7266 33.7305 24.7266C34.2163 24.7266 34.6094 24.3335 34.6094 23.8477C34.6094 23.3619 34.2163 22.9688 33.7305 22.9688H13.5156C11.5776 22.9688 10 24.5454 10 26.4844C10 28.4233 11.5776 30 13.5156 30H33.7305C34.2163 30 34.6094 29.6069 34.6094 29.1211C34.6094 28.6353 34.2163 28.2422 33.7305 28.2422Z'
                    fill='#EDF7FF'
                />
            </g>
            <defs>
                <filter
                    id='filter0_d_6527_40175'
                    x='0'
                    y='0'
                    width='44.6094'
                    height='50'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dy='10' />
                    <feGaussianBlur stdDeviation='5' />
                    <feComposite in2='hardAlpha' operator='out' />
                    <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.305882 0 0 0 0 0.67451 0 0 0 0 0.976471 0 0 0 0.2 0'
                    />
                    <feBlend
                        mode='normal'
                        in2='BackgroundImageFix'
                        result='effect1_dropShadow_6527_40175'
                    />
                    <feBlend
                        mode='normal'
                        in='SourceGraphic'
                        in2='effect1_dropShadow_6527_40175'
                        result='shape'
                    />
                </filter>
                <linearGradient
                    id='paint0_linear_6527_40175'
                    x1='8.14851'
                    y1='-27.9105'
                    x2='40.053'
                    y2='-26.4314'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#93CFFF' />
                    <stop offset='1' stopColor='#2894FF' />
                </linearGradient>
            </defs>
        </svg>
    )
}

export const IconHowToBookLarge = () => {
    return (
        <svg
            width='80'
            viewBox='0 0 45 50'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g filter='url(#filter0_d_6527_40175)'>
                <path
                    d='M33.7305 0H14.3945C11.9707 0 10 1.9715 10 4.39453V26.4844C10 26.9702 10.3931 27.3633 10.8789 27.3633C11.3647 27.3633 11.7578 26.9702 11.7578 26.4844C11.7578 25.5154 12.5457 24.7266 13.5156 24.7266L34.6094 23.8477V0.878906C34.6094 0.393105 34.2163 0 33.7305 0Z'
                    fill='url(#paint0_linear_6527_40175)'
                />
                <path
                    d='M22.3047 21.2109C27.1562 21.2109 31.0938 17.2734 31.0938 12.4219C31.0938 7.57031 27.1562 3.63281 22.3047 3.63281C17.4531 3.63281 13.5156 7.57031 13.5156 12.4219C13.5156 17.2734 17.4531 21.2109 22.3047 21.2109ZM22.3047 17.6953C21.8124 17.6953 21.4258 17.3085 21.4258 16.8164C21.4258 16.3242 21.8124 15.9375 22.3047 15.9375C22.7969 15.9375 23.1836 16.3242 23.1836 16.8164C23.1836 17.3085 22.7969 17.6953 22.3047 17.6953ZM22.3047 7.14844C23.7637 7.14844 24.9414 8.32617 24.9414 9.78516C24.9414 10.7167 24.4317 11.5956 23.623 12.0703C23.3593 12.2286 23.1836 12.5098 23.1836 12.8262V13.3008C23.1836 13.7929 22.7969 14.1797 22.3047 14.1797C21.8124 14.1797 21.4258 13.7929 21.4258 13.3008V12.8261C21.4258 11.8945 21.9355 11.0156 22.7441 10.541C23.0079 10.3827 23.1836 10.1015 23.1836 9.7851C23.1836 9.29285 22.7969 8.90619 22.3047 8.90619C21.8124 8.90619 21.4258 9.29285 21.4258 9.7851C21.4258 10.2772 21.0391 10.664 20.5469 10.664C20.0546 10.664 19.668 10.2772 19.668 9.7851C19.668 8.32617 20.8457 7.14844 22.3047 7.14844ZM33.7305 28.2422C32.7606 28.2422 31.9727 27.4534 31.9727 26.4844C31.9727 25.5154 32.7606 24.7266 33.7305 24.7266C34.2163 24.7266 34.6094 24.3335 34.6094 23.8477C34.6094 23.3619 34.2163 22.9688 33.7305 22.9688H13.5156C11.5776 22.9688 10 24.5454 10 26.4844C10 28.4233 11.5776 30 13.5156 30H33.7305C34.2163 30 34.6094 29.6069 34.6094 29.1211C34.6094 28.6353 34.2163 28.2422 33.7305 28.2422Z'
                    fill='#EDF7FF'
                />
            </g>
            <defs>
                <filter
                    id='filter0_d_6527_40175'
                    x='0'
                    y='0'
                    width='44.6094'
                    height='50'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dy='10' />
                    <feGaussianBlur stdDeviation='5' />
                    <feComposite in2='hardAlpha' operator='out' />
                    <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.305882 0 0 0 0 0.67451 0 0 0 0 0.976471 0 0 0 0.2 0'
                    />
                    <feBlend
                        mode='normal'
                        in2='BackgroundImageFix'
                        result='effect1_dropShadow_6527_40175'
                    />
                    <feBlend
                        mode='normal'
                        in='SourceGraphic'
                        in2='effect1_dropShadow_6527_40175'
                        result='shape'
                    />
                </filter>
                <linearGradient
                    id='paint0_linear_6527_40175'
                    x1='8.14851'
                    y1='-27.9105'
                    x2='40.053'
                    y2='-26.4314'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#93CFFF' />
                    <stop offset='1' stopColor='#2894FF' />
                </linearGradient>
            </defs>
        </svg>
    )
}

export const IconManHeadphones = () => {
    return (
        <svg
            width='47'
            height='50'
            viewBox='0 0 47 50'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g filter='url(#filter0_d_6527_40182)'>
                <path
                    d='M16.1524 15.8789C17.6062 15.8789 18.7891 14.6961 18.7891 13.2422V9.66797C18.7891 8.21408 17.6062 7.03125 16.1524 7.03125C16.0025 7.03125 15.8558 7.04449 15.7127 7.06863C16.7904 3.97998 19.7321 1.75781 23.1836 1.75781C26.6351 1.75781 29.5768 3.97998 30.6545 7.06863C30.5115 7.04449 30.3647 7.03125 30.2149 7.03125C28.761 7.03125 27.5781 8.21408 27.5781 9.66797V13.2422C27.5781 14.6961 28.761 15.8789 30.2149 15.8789C31.6687 15.8789 32.8516 14.6961 32.8516 13.2422V9.66797C32.8516 4.33705 28.5145 0 23.1836 0C17.8527 0 13.5156 4.33705 13.5156 9.66797V13.2422C13.5156 14.6961 14.6985 15.8789 16.1524 15.8789ZM36.3554 28.9777L35.087 21.3088C34.7324 19.1811 32.9094 17.6367 30.7523 17.6367H15.6149C13.4578 17.6367 11.6348 19.1811 11.28 21.3098L10.0118 28.9777C9.96966 29.2324 10.0417 29.4927 10.2086 29.6896C10.3757 29.8865 10.6208 30 10.8789 30H15.2734L17.6758 29.1211H28.75L31.0938 30H35.4883C35.7465 30 35.9916 29.8865 36.1585 29.6896C36.3255 29.4928 36.3975 29.2324 36.3554 28.9777Z'
                    fill='url(#paint0_linear_6527_40182)'
                />
                <path
                    d='M23.1836 17.6367C26.576 17.6367 29.3359 14.8505 29.3359 11.4258C29.3359 8.03338 26.576 5.27344 23.1836 5.27344C19.7912 5.27344 17.0312 8.03338 17.0312 11.4258C17.0312 14.8505 19.7912 17.6367 23.1836 17.6367ZM30.2148 21.1523H16.1523C15.667 21.1523 15.2734 21.5459 15.2734 22.0312V30H31.0938V22.0312C31.0938 21.5459 30.7002 21.1523 30.2148 21.1523ZM23.1836 26.4258C22.6982 26.4258 22.3047 26.0323 22.3047 25.5469C22.3047 25.0615 22.6982 24.668 23.1836 24.668C23.669 24.668 24.0625 25.0615 24.0625 25.5469C24.0625 26.0323 23.669 26.4258 23.1836 26.4258Z'
                    fill='#EDF7FF'
                />
            </g>
            <defs>
                <filter
                    id='filter0_d_6527_40182'
                    x='0'
                    y='0'
                    width='46.3672'
                    height='50'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dy='10' />
                    <feGaussianBlur stdDeviation='5' />
                    <feComposite in2='hardAlpha' operator='out' />
                    <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.305882 0 0 0 0 0.67451 0 0 0 0 0.976471 0 0 0 0.2 0'
                    />
                    <feBlend
                        mode='normal'
                        in2='BackgroundImageFix'
                        result='effect1_dropShadow_6527_40182'
                    />
                    <feBlend
                        mode='normal'
                        in='SourceGraphic'
                        in2='effect1_dropShadow_6527_40182'
                        result='shape'
                    />
                </filter>
                <linearGradient
                    id='paint0_linear_6527_40182'
                    x1='8.01626'
                    y1='-30.6'
                    x2='42.2029'
                    y2='-29.0511'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#93CFFF' />
                    <stop offset='1' stopColor='#2894FF' />
                </linearGradient>
            </defs>
        </svg>
    )
}

export const IconWallet = () => {
    return (
        <svg
            width='50'
            height='50'
            viewBox='0 0 50 50'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g filter='url(#filter0_d_4945_12808)'>
                <path
                    d='M31.0938 11.543V4.27148L29.4875 1.604L26.8048 0H21.3026L18.6353 1.60623L17.0312 4.28906V11.543C17.0312 12.0351 17.4179 12.4219 17.9102 12.4219H30.2148C30.7071 12.4219 31.0938 12.0351 31.0938 11.543ZM39.1211 15.9375H38.125L31.9727 14.1797L25.8203 20.332L31.9727 26.4844L38.125 24.7266H39.1211C39.6133 24.7266 40 24.3398 40 23.8477V16.8164C40 16.3242 39.6133 15.9375 39.1211 15.9375Z'
                    fill='#D6EBFF'
                />
                <path
                    d='M31.0938 4.27148V0.878906C31.0938 0.38666 30.7071 0 30.2148 0H26.8048C26.1718 2.61914 28.4746 4.92188 31.0938 4.27148ZM38.125 13.3008C38.125 11.8418 36.9474 10.6641 35.4883 10.6641H14.3945C11.9687 10.6641 10 12.6328 10 15.0586V25.6055C10 28.0312 11.9687 30 14.3945 30H35.4883C36.9474 30 38.125 28.8221 38.125 27.3633V24.7266H33.7305C31.3047 24.7266 29.3359 22.7578 29.3359 20.332C29.3359 17.8815 31.3275 15.9375 33.7305 15.9375H38.125V13.3008ZM32.8516 20.332C32.8516 20.8174 33.2451 21.2109 33.7305 21.2109C34.2159 21.2109 34.6094 20.8174 34.6094 20.332C34.6094 19.8466 34.2159 19.4531 33.7305 19.4531C33.2451 19.4531 32.8516 19.8466 32.8516 20.332ZM21.3026 0H17.9102C17.4179 0 17.0312 0.38666 17.0312 0.878906V4.28906C19.6504 4.92188 21.9532 2.61914 21.3026 0Z'
                    fill='url(#paint0_linear_4945_12808)'
                />
            </g>
            <defs>
                <filter
                    id='filter0_d_4945_12808'
                    x='0'
                    y='0'
                    width='50'
                    height='50'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dy='10' />
                    <feGaussianBlur stdDeviation='5' />
                    <feComposite in2='hardAlpha' operator='out' />
                    <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.305882 0 0 0 0 0.67451 0 0 0 0 0.976471 0 0 0 0.2 0'
                    />
                    <feBlend
                        mode='normal'
                        in2='BackgroundImageFix'
                        result='effect1_dropShadow_4945_12808'
                    />
                    <feBlend
                        mode='normal'
                        in='SourceGraphic'
                        in2='effect1_dropShadow_4945_12808'
                        result='shape'
                    />
                </filter>
                <linearGradient
                    id='paint0_linear_4945_12808'
                    x1='24.0625'
                    y1='30'
                    x2='24.0625'
                    y2='0'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#3C9FFF' />
                    <stop offset='1' stopColor='#76C0FF' />
                </linearGradient>
            </defs>
        </svg>
    )
}

export const IconNotePencil = () => {
    return (
        <svg
            width='49'
            height='50'
            viewBox='0 0 49 50'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g filter='url(#filter0_d_4945_12791)'>
                <path
                    d='M30.1875 7.03125V1.75781H12.6875V7.03125C11.721 7.03125 10.9375 7.81828 10.9375 8.78906V29.1211C10.9375 29.6065 11.3293 30 11.8125 30H31.0625C31.5457 30 31.9375 29.6065 31.9375 29.1211V8.78906C31.9375 7.81828 31.154 7.03125 30.1875 7.03125ZM37.1875 3.79471V2.75391C37.1875 2.26811 36.7961 1.875 36.3125 1.875C35.8289 1.875 35.4375 2.26811 35.4375 2.75391V3.79471C34.4212 4.15875 33.6875 5.1252 33.6875 6.26953V17.6953C33.6875 18.6661 34.471 19.4531 35.4375 19.4531H37.1875C38.154 19.4531 38.9375 18.6661 38.9375 17.6953V6.26953C38.9375 5.1252 38.2038 4.15875 37.1875 3.79471Z'
                    fill='url(#paint0_linear_4945_12791)'
                />
                <path
                    d='M31.0625 0H11.8125C11.3224 0 10.9375 0.38666 10.9375 0.878906V8.78906H31.9375V0.878906C31.9375 0.38666 31.5526 0 31.0625 0ZM15.3125 5.27344C14.8224 5.27344 14.4375 4.88666 14.4375 4.39453C14.4375 3.90229 14.8224 3.51562 15.3125 3.51562C15.8026 3.51562 16.1875 3.90229 16.1875 4.39453C16.1875 4.88666 15.8026 5.27344 15.3125 5.27344ZM24.0625 5.27344H18.8125C18.3224 5.27344 17.9375 4.88666 17.9375 4.39453C17.9375 3.90229 18.3224 3.51562 18.8125 3.51562H24.0625C24.5526 3.51562 24.9375 3.90229 24.9375 4.39453C24.9375 4.88666 24.5526 5.27344 24.0625 5.27344ZM27.5625 5.27344C27.0724 5.27344 26.6875 4.88666 26.6875 4.39453C26.6875 3.90229 27.0724 3.51562 27.5625 3.51562C28.0526 3.51562 28.4375 3.90229 28.4375 4.39453C28.4375 4.88666 28.0526 5.27344 27.5625 5.27344ZM27.5625 12.4219H18.8125C18.3289 12.4219 17.9375 12.815 17.9375 13.3008C17.9375 13.7866 18.3289 14.1797 18.8125 14.1797H27.5625C28.0461 14.1797 28.4375 13.7866 28.4375 13.3008C28.4375 12.815 28.0461 12.4219 27.5625 12.4219ZM27.5625 15.9375H15.3125C14.8289 15.9375 14.4375 16.3306 14.4375 16.8164C14.4375 17.3022 14.8289 17.6953 15.3125 17.6953H27.5625C28.0461 17.6953 28.4375 17.3022 28.4375 16.8164C28.4375 16.3306 28.0461 15.9375 27.5625 15.9375ZM27.5625 19.4531H15.3125C14.8289 19.4531 14.4375 19.8462 14.4375 20.332C14.4375 20.8178 14.8289 21.2109 15.3125 21.2109H27.5625C28.0461 21.2109 28.4375 20.8178 28.4375 20.332C28.4375 19.8462 28.0461 19.4531 27.5625 19.4531ZM27.5625 22.9688H15.3125C14.8289 22.9688 14.4375 23.3619 14.4375 23.8477C14.4375 24.3335 14.8289 24.7266 15.3125 24.7266H27.5625C28.0461 24.7266 28.4375 24.3335 28.4375 23.8477C28.4375 23.3619 28.0461 22.9688 27.5625 22.9688ZM33.6875 17.6953V23.1267C33.6875 24.9325 34.4189 26.7032 35.6939 27.9847C35.8579 28.1495 36.0801 28.2422 36.3125 28.2422C36.5449 28.2422 36.7671 28.1495 36.9311 27.9847C38.206 26.7032 38.9375 24.9325 38.9375 23.1267V17.6953H33.6875Z'
                    fill='#D6EBFF'
                />
            </g>
            <defs>
                <filter
                    id='filter0_d_4945_12791'
                    x='0.9375'
                    y='0'
                    width='48'
                    height='50'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dy='10' />
                    <feGaussianBlur stdDeviation='5' />
                    <feComposite in2='hardAlpha' operator='out' />
                    <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.305882 0 0 0 0 0.67451 0 0 0 0 0.976471 0 0 0 0.2 0'
                    />
                    <feBlend
                        mode='normal'
                        in2='BackgroundImageFix'
                        result='effect1_dropShadow_4945_12791'
                    />
                    <feBlend
                        mode='normal'
                        in='SourceGraphic'
                        in2='effect1_dropShadow_4945_12791'
                        result='shape'
                    />
                </filter>
                <linearGradient
                    id='paint0_linear_4945_12791'
                    x1='24.9375'
                    y1='30'
                    x2='24.9375'
                    y2='1.75781'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#3C9FFF' />
                    <stop offset='1' stopColor='#76C0FF' />
                </linearGradient>
            </defs>
        </svg>
    )
}

export const IconManCircleBlue = () => {
    return (
        <svg
            width='50'
            height='50'
            viewBox='0 0 50 50'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g filter='url(#filter0_d_4945_12774)'>
                <path
                    d='M25 30C33.2843 30 40 23.2843 40 15C40 6.71573 33.2843 0 25 0C16.7157 0 10 6.71573 10 15C10 23.2843 16.7157 30 25 30Z'
                    fill='url(#paint0_linear_4945_12774)'
                />
                <path
                    d='M29.3945 9.72656C29.3945 7.30342 27.4231 5.33203 25 5.33203C22.5769 5.33203 20.6055 7.30342 20.6055 9.72656C20.6055 12.1497 22.5769 14.1211 25 14.1211C27.4231 14.1211 29.3945 12.1497 29.3945 9.72656ZM25 14.1211C20.6383 14.1211 17.0898 17.6696 17.0898 22.0312V22.855C17.0898 23.1048 17.1961 23.3428 17.3822 23.5095C19.5231 25.4279 22.2285 26.4844 25 26.4844C27.7715 26.4844 30.4769 25.4279 32.6178 23.5095C32.8039 23.3428 32.9102 23.1047 32.9102 22.855V22.0312C32.9102 17.6696 29.3617 14.1211 25 14.1211Z'
                    fill='#EDF7FF'
                />
            </g>
            <defs>
                <filter
                    id='filter0_d_4945_12774'
                    x='0'
                    y='0'
                    width='50'
                    height='50'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dy='10' />
                    <feGaussianBlur stdDeviation='5' />
                    <feComposite in2='hardAlpha' operator='out' />
                    <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.305882 0 0 0 0 0.67451 0 0 0 0 0.976471 0 0 0 0.2 0'
                    />
                    <feBlend
                        mode='normal'
                        in2='BackgroundImageFix'
                        result='effect1_dropShadow_4945_12774'
                    />
                    <feBlend
                        mode='normal'
                        in='SourceGraphic'
                        in2='effect1_dropShadow_4945_12774'
                        result='shape'
                    />
                </filter>
                <linearGradient
                    id='paint0_linear_4945_12774'
                    x1='25'
                    y1='30'
                    x2='25'
                    y2='0'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#3C9FFF' />
                    <stop offset='1' stopColor='#76C0FF' />
                </linearGradient>
            </defs>
        </svg>
    )
}

export const IconChatBubble2 = ({ bubbleColor, dotsColor }: SVGProps) => {
    const id = useId()

    const filterId = `chatBubbleFilter${id}`
    const gradientId = `chatBubbleGradient${id}`

    return (
        <svg
            width='51'
            height='51'
            viewBox='0 0 51 51'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g filter={`url(#${filterId})`}>
                <path
                    d='M25 4.94558e-06C21.0218 4.94558e-06 17.2065 1.58188 14.3934 4.39775C11.5804 7.21361 10 11.0328 10 15.015C10.0382 17.6475 10.7343 20.2285 12.025 22.5225C12.1408 22.7262 12.2102 22.9528 12.2284 23.1864C12.2465 23.42 12.2129 23.6547 12.13 23.8738L11.125 27.2372C11.0483 27.4722 11.0666 27.728 11.1759 27.9497C11.2852 28.1714 11.477 28.3415 11.71 28.4234C11.9171 28.5062 12.148 28.5062 12.355 28.4234L15.355 27.5225C15.7439 27.4323 16.1484 27.4342 16.5364 27.5281C16.9244 27.6219 17.2852 27.8051 17.59 28.0631C19.5866 29.2011 21.8176 29.8647 24.111 30.0029C26.4044 30.1411 28.6988 29.75 30.8174 28.8599C32.9359 27.9699 34.8218 26.6046 36.3297 24.8694C37.8375 23.1341 38.927 21.0754 39.5141 18.8519C40.1012 16.6284 40.1702 14.2996 39.7158 12.0452C39.2614 9.79079 38.2957 7.67103 36.8932 5.84939C35.4908 4.02776 33.6889 2.5529 31.6269 1.53871C29.5648 0.524528 27.2975 -0.00186139 25 4.94558e-06Z'
                    fill={bubbleColor ?? `url(#${gradientId})`}
                />
                <path
                    d='M29.9652 15.03C29.9652 14.6499 30.0778 14.2783 30.2888 13.9622C30.4997 13.6462 30.7996 13.3998 31.1505 13.2544C31.5013 13.1089 31.8874 13.0709 32.2598 13.145C32.6322 13.2192 32.9744 13.4022 33.2429 13.671C33.5114 13.9398 33.6942 14.2822 33.7683 14.6551C33.8424 15.0279 33.8044 15.4143 33.6591 15.7655C33.5138 16.1167 33.2677 16.4169 32.9519 16.6281C32.6362 16.8393 32.265 16.9519 31.8853 16.9519C31.6338 16.9539 31.3844 16.906 31.1515 16.8111C30.9187 16.7161 30.7069 16.576 30.5284 16.3988C30.35 16.2215 30.2083 16.0106 30.1116 15.7782C30.0149 15.5459 29.9652 15.2967 29.9652 15.045V15.03ZM23.0502 15.03C23.0532 14.6505 23.1683 14.2804 23.3811 13.9663C23.5939 13.6523 23.8947 13.4083 24.2458 13.2651C24.5969 13.1219 24.9824 13.0861 25.3539 13.1619C25.7253 13.2377 26.066 13.422 26.333 13.6913C26.6001 13.9607 26.7815 14.3032 26.8543 14.6756C26.9272 15.048 26.8883 15.4336 26.7426 15.7839C26.5968 16.1342 26.3507 16.4336 26.0353 16.6441C25.7199 16.8546 25.3493 16.967 24.9702 16.967C24.7162 16.969 24.4645 16.9202 24.2296 16.8234C23.9948 16.7266 23.7816 16.5837 23.6027 16.4033C23.4238 16.2228 23.2828 16.0083 23.1879 15.7725C23.093 15.5366 23.0462 15.2842 23.0502 15.03ZM16.1353 15.03C16.1353 14.6499 16.2478 14.2783 16.4588 13.9622C16.6698 13.6462 16.9697 13.3998 17.3205 13.2544C17.6713 13.1089 18.0573 13.0709 18.4297 13.145C18.8022 13.2192 19.1443 13.4022 19.4128 13.671C19.6814 13.9398 19.8643 14.2822 19.9384 14.6551C20.0124 15.0279 19.9744 15.4143 19.829 15.7655C19.6837 16.1167 19.4376 16.4169 19.1219 16.6281C18.8061 16.8393 18.4349 16.9519 18.0552 16.9519C17.546 16.9519 17.0576 16.7495 16.6976 16.3891C16.3375 16.0286 16.1353 15.5397 16.1353 15.03Z'
                    fill={dotsColor ?? '#EDF7FF'}
                />
            </g>

            <defs>
                <filter
                    id={filterId}
                    x='0'
                    y='0'
                    width='50.0122'
                    height='50.03'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feFlood
                        floodOpacity='0'
                        result='BackgroundImageFix'
                    />
                    <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dy='10' />
                    <feGaussianBlur stdDeviation='5' />
                    <feComposite
                        in2='hardAlpha'
                        operator='out'
                    />
                    <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.305882 0 0 0 0 0.67451 0 0 0 0 0.976471 0 0 0 0.2 0'
                    />
                    <feBlend
                        mode='normal'
                        in2='BackgroundImageFix'
                        result='effect1_dropShadow_4945_12731'
                    />
                    <feBlend
                        mode='normal'
                        in='SourceGraphic'
                        in2='effect1_dropShadow_4945_12731'
                        result='shape'
                    />
                </filter>

                <linearGradient
                    id={gradientId}
                    x1='25.0061'
                    y1='30.03'
                    x2='25.0061'
                    y2='0'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#3C9FFF' />
                    <stop offset='1' stopColor='#76C0FF' />
                </linearGradient>
            </defs>
        </svg>
    )
}
export const IconChatBubble = ({ bubbleColor, dotsColor }: SVGProps) => {
    const id = useId()

    const filterId = `${id}-chat-filter`
    const gradientId = `${id}-chat-gradient`

    return (
        <svg
            width={'51'}
            height={'51'}
            viewBox='0 0 51 51'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g filter={`url(#${filterId})`}>
                <path
                    d='M25 4.94558e-06C21.0218 4.94558e-06 17.2065 1.58188 14.3934 4.39775C11.5804 7.21361 10 11.0328 10 15.015C10.0382 17.6475 10.7343 20.2285 12.025 22.5225C12.1408 22.7262 12.2102 22.9528 12.2284 23.1864C12.2465 23.42 12.2129 23.6547 12.13 23.8738L11.125 27.2372C11.0483 27.4722 11.0666 27.728 11.1759 27.9497C11.2852 28.1714 11.477 28.3415 11.71 28.4234C11.9171 28.5062 12.148 28.5062 12.355 28.4234L15.355 27.5225C15.7439 27.4323 16.1484 27.4342 16.5364 27.5281C16.9244 27.6219 17.2852 27.8051 17.59 28.0631C19.5866 29.2011 21.8176 29.8647 24.111 30.0029C26.4044 30.1411 28.6988 29.75 30.8174 28.8599C32.9359 27.9699 34.8218 26.6046 36.3297 24.8694C37.8375 23.1341 38.927 21.0754 39.5141 18.8519C40.1012 16.6284 40.1702 14.2996 39.7158 12.0452C39.2614 9.79079 38.2957 7.67103 36.8932 5.84939C35.4908 4.02776 33.6889 2.5529 31.6269 1.53871C29.5648 0.524528 27.2975 -0.00186139 25 4.94558e-06Z'
                    fill={bubbleColor ?? `url(#${gradientId})`}
                />
                <path
                    d='M29.9652 15.03C29.9652 14.6499 30.0778 14.2783 30.2888 13.9622C30.4997 13.6462 30.7996 13.3998 31.1505 13.2544C31.5013 13.1089 31.8874 13.0709 32.2598 13.145C32.6322 13.2192 32.9744 13.4022 33.2429 13.671C33.5114 13.9398 33.6942 14.2822 33.7683 14.6551C33.8424 15.0279 33.8044 15.4143 33.6591 15.7655C33.5138 16.1167 33.2677 16.4169 32.9519 16.6281C32.6362 16.8393 32.265 16.9519 31.8853 16.9519C31.6338 16.9539 31.3844 16.906 31.1515 16.8111C30.9187 16.7161 30.7069 16.576 30.5284 16.3988C30.35 16.2215 30.2083 16.0106 30.1116 15.7782C30.0149 15.5459 29.9652 15.2967 29.9652 15.045V15.03ZM23.0502 15.03C23.0532 14.6505 23.1683 14.2804 23.3811 13.9663C23.5939 13.6523 23.8947 13.4083 24.2458 13.2651C24.5969 13.1219 24.9824 13.0861 25.3539 13.1619C25.7253 13.2377 26.066 13.422 26.333 13.6913C26.6001 13.9607 26.7815 14.3032 26.8543 14.6756C26.9272 15.048 26.8883 15.4336 26.7426 15.7839C26.5968 16.1342 26.3507 16.4336 26.0353 16.6441C25.7199 16.8546 25.3493 16.967 24.9702 16.967C24.7162 16.969 24.4645 16.9202 24.2296 16.8234C23.9948 16.7266 23.7816 16.5837 23.6027 16.4033C23.4238 16.2228 23.2828 16.0083 23.1879 15.7725C23.093 15.5366 23.0462 15.2842 23.0502 15.03ZM16.1353 15.03C16.1353 14.6499 16.2478 14.2783 16.4588 13.9622C16.6698 13.6462 16.9697 13.3998 17.3205 13.2544C17.6713 13.1089 18.0573 13.0709 18.4297 13.145C18.8022 13.2192 19.1443 13.4022 19.4128 13.671C19.6814 13.9398 19.8643 14.2822 19.9384 14.6551C20.0124 15.0279 19.9744 15.4143 19.829 15.7655C19.6837 16.1167 19.4376 16.4169 19.1219 16.6281C18.8061 16.8393 18.4349 16.9519 18.0552 16.9519C17.546 16.9519 17.0576 16.7495 16.6976 16.3891C16.3375 16.0286 16.1353 15.5397 16.1353 15.03Z'
                    fill={dotsColor ?? '#EDF7FF'}
                />
            </g>
            <defs>
                <filter
                    id={filterId}
                    x='0'
                    y='0'
                    width='50.0122'
                    height='50.03'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dy='10' />
                    <feGaussianBlur stdDeviation='5' />
                    <feComposite in2='hardAlpha' operator='out' />
                    <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.305882 0 0 0 0 0.67451 0 0 0 0 0.976471 0 0 0 0.2 0'
                    />
                    <feBlend
                        mode='normal'
                        in2='BackgroundImageFix'
                        result='effect1_dropShadow_4945_12731'
                    />
                    <feBlend
                        mode='normal'
                        in='SourceGraphic'
                        in2='effect1_dropShadow_4945_12731'
                        result='shape'
                    />
                </filter>
                <linearGradient
                    id={gradientId}
                    x1='25.0061'
                    y1='30.03'
                    x2='25.0061'
                    y2='0'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#3C9FFF' />
                    <stop offset='1' stopColor='#76C0FF' />
                </linearGradient>
            </defs>
        </svg>
    )
}

export const IconPlusInCircle = () => {
    return (
        <svg
            width='48'
            height='48'
            viewBox='0 0 48 48'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g filter='url(#filter0_d_5322_55590)'>
                <path
                    d='M23.9852 24.8387C29.9713 24.8387 34.824 19.9861 34.824 14C34.824 8.01392 29.9713 3.16125 23.9852 3.16125C17.9992 3.16125 13.1465 8.01392 13.1465 14C13.1465 19.9861 17.9992 24.8387 23.9852 24.8387Z'
                    fill='#D6EBFF'
                />
                <path
                    d='M29.2805 13.2803L24.6137 13.2945V8.71952C24.6137 8.3209 24.2928 8 23.8942 8C23.4957 8 23.1747 8.3209 23.1747 8.71952L23.1888 13.2805H18.7195C18.3209 13.2805 18 13.6014 18 14C18 14.3985 18.3209 14.7194 18.7195 14.7194H23.1817V19.2805C23.1817 19.6788 23.5026 20 23.9012 20C24.2999 20 24.6208 19.6788 24.6208 19.2805V14.7195H29.2805C29.6791 14.7195 30 14.3984 30 14C30 13.6012 29.6755 13.2803 29.2805 13.2803Z'
                    fill='url(#paint0_linear_5322_55590)'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M36.1788 14C36.1788 14.4988 36.5832 14.9032 37.082 14.9032C37.5808 14.9032 37.9852 14.4988 37.9852 14C37.9852 6.28048 31.705 0 23.9852 0C23.4864 0 23.082 0.404414 23.082 0.903219C23.082 1.40202 23.4864 1.80644 23.9852 1.80644C30.7087 1.80644 36.1788 7.2765 36.1788 14ZM19.9183 2.4475C19.5903 2.4475 19.2748 2.26867 19.1158 1.95597L19.113 1.95066C19.0464 1.81947 19.0146 1.67985 19.0146 1.54204C19.0144 1.21282 19.1948 0.895467 19.5082 0.735835C19.9525 0.508936 20.4967 0.686452 20.723 1.13101C20.7898 1.26264 20.8217 1.40313 20.8217 1.5416C20.8217 1.87104 20.6423 2.18905 20.3291 2.34846C20.1972 2.41573 20.0565 2.4475 19.9183 2.4475ZM14.9528 5.41936C14.7142 5.41936 14.476 5.32541 14.2985 5.13909C13.9545 4.77788 13.9684 4.20612 14.3296 3.86208C14.8855 3.33265 15.4889 2.8455 16.123 2.41439C16.5356 2.13324 17.0975 2.24087 17.3778 2.65343C17.6583 3.066 17.5513 3.62769 17.1387 3.90818C16.5861 4.28394 16.0602 4.70843 15.5755 5.17021C15.4006 5.33668 15.1765 5.41936 14.9528 5.41936ZM10.9831 12.1741C11.0457 12.1874 11.1083 12.1938 11.1699 12.1938C11.5879 12.1938 11.9633 11.9018 12.0528 11.4762C12.3119 10.2442 12.7602 9.06402 13.3854 7.96808C13.6325 7.53479 13.4815 6.98327 13.0482 6.73608C12.6151 6.48933 12.0636 6.63972 11.8162 7.07323C11.098 8.33214 10.5829 9.68855 10.2852 11.1045C10.1824 11.5927 10.4949 12.0716 10.9831 12.1741ZM13.0613 22.129C12.7684 22.129 12.4813 21.987 12.3075 21.7248C10.9738 19.7126 10.182 17.375 10.0177 14.9645C9.98399 14.467 10.36 14.0359 10.8577 14.002C11.3565 13.9718 11.7863 14.3442 11.8202 14.8419C11.9631 16.9401 12.6522 18.9752 13.8133 20.7268C14.0889 21.1427 13.9751 21.703 13.5595 21.9786C13.4059 22.0805 13.2326 22.129 13.0613 22.129ZM15.2949 24.9769C17.7898 26.9545 20.7947 28 23.9851 28C24.4839 28 24.8883 27.5955 24.8884 27.0967C24.8884 26.5979 24.484 26.1935 23.9852 26.1935C21.2065 26.1935 18.5894 25.2833 16.4169 23.5613C16.0263 23.2514 15.4583 23.3171 15.148 23.7081C14.8382 24.0989 14.9039 24.6671 15.2949 24.9769ZM27.5973 27.4955C27.2044 27.4955 26.843 27.2373 26.7294 26.8408C26.5922 26.3612 26.8697 25.861 27.3491 25.7237C31.3575 24.5759 34.5607 21.3727 35.7085 17.3642C35.8461 16.8848 36.346 16.6076 36.8256 16.7445C37.305 16.8819 37.5824 17.382 37.4453 17.8616C36.1273 22.4642 32.4491 26.1424 27.8466 27.4604C27.7634 27.4843 27.6796 27.4955 27.5973 27.4955Z'
                    fill='url(#paint1_linear_5322_55590)'
                />
            </g>
            <defs>
                <filter
                    id='filter0_d_5322_55590'
                    x='0.015625'
                    y='0'
                    width='47.9697'
                    height='48'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dy='10' />
                    <feGaussianBlur stdDeviation='5' />
                    <feComposite in2='hardAlpha' operator='out' />
                    <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.305882 0 0 0 0 0.67451 0 0 0 0 0.976471 0 0 0 0.2 0'
                    />
                    <feBlend
                        mode='normal'
                        in2='BackgroundImageFix'
                        result='effect1_dropShadow_5322_55590'
                    />
                    <feBlend
                        mode='normal'
                        in='SourceGraphic'
                        in2='effect1_dropShadow_5322_55590'
                        result='shape'
                    />
                </filter>
                <linearGradient
                    id='paint0_linear_5322_55590'
                    x1='24'
                    y1='20'
                    x2='24'
                    y2='8'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#3C9FFF' />
                    <stop offset='1' stopColor='#76C0FF' />
                </linearGradient>
                <linearGradient
                    id='paint1_linear_5322_55590'
                    x1='24.0004'
                    y1='28'
                    x2='24.0004'
                    y2='0'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#3C9FFF' />
                    <stop offset='1' stopColor='#76C0FF' />
                </linearGradient>
            </defs>
        </svg>
    )
}

export const IconPlusInCircleDashed = ({ color = 'white' }: SVGProps) => {
    return (
        <svg
            width='22'
            height='22'
            viewBox='0 0 22 22'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M7.2354 1.6251C6.83005 1.78691 6.63258 2.2467 6.79438 2.65204C6.95617 3.05742 7.41598 3.25492 7.82134 3.09311L7.82318 3.09237L20.9989 11.0001M7.2354 1.6251C7.23541 1.62509 7.23543 1.62508 7.23545 1.62508L7.27252 1.71794L7.23534 1.62512C7.23536 1.62511 7.23538 1.62511 7.2354 1.6251ZM7.2354 1.6251C10.99 0.121331 15.2795 0.999818 18.1407 3.85847C20.0411 5.74847 21.1063 8.32021 21.0989 11.0004M21.0989 11.0004L20.9989 11.0001M21.0989 11.0004C21.0989 11.0003 21.0989 11.0002 21.0989 11.0001L20.9989 11.0001M21.0989 11.0004C21.1003 14.5975 19.1876 17.9236 16.078 19.7318M20.9989 11.0001C21.0004 14.5617 19.1067 17.855 16.0278 19.6454M16.078 19.7318L16.0795 19.7309L16.0278 19.6454M16.078 19.7318L16.0727 19.7349M16.078 19.7318L16.0278 19.6454M16.0278 19.6454L16.0727 19.7349M16.0727 19.7349L16.0227 19.6483L16.0721 19.7353L16.0727 19.7349ZM16.0727 19.7349C15.6946 19.9531 15.2113 19.8235 14.9931 19.4455C14.775 19.0676 14.9044 18.5845 15.2821 18.3662C17.8997 16.835 19.5113 14.0327 19.5183 11.0001L16.0727 19.7349Z'
                fill={color}
                stroke='white'
                strokeWidth='0.2'
            />
            <path
                d='M6.17627 3.00067L6.17627 3.00066C5.921 2.64661 5.42707 2.56652 5.07298 2.82178L5.0703 2.82371L5.06865 2.82492L5.06831 2.82516C3.8424 3.71828 2.83117 4.87366 2.10835 6.20711L2.10826 6.20727C1.90095 6.59139 2.04421 7.0708 2.42831 7.27818C2.81204 7.48566 3.29131 7.34277 3.49875 6.95902L3.49873 6.95902L3.4995 6.95763C3.49967 6.9573 3.49985 6.95697 3.50002 6.95662C4.11013 5.83186 4.96335 4.85729 5.99761 4.1038C6.35148 3.84849 6.43148 3.35468 6.17627 3.00067Z'
                fill={color}
                stroke='white'
                strokeWidth='0.2'
            />
            <path
                d='M2.80386 13.3332L2.80381 13.3332C2.42259 11.9828 2.37787 10.5596 2.67354 9.188L2.67363 9.18758C2.76379 8.76051 2.49069 8.34121 2.06364 8.25105C1.63965 8.16152 1.22267 8.43011 1.12881 8.85312L1.12881 8.85312L1.12868 8.8537C0.77817 10.4788 0.831269 12.1651 1.28332 13.765L1.28336 13.7651C1.40263 14.185 1.83968 14.4287 2.25956 14.3094C2.67944 14.1901 2.92313 13.7531 2.80386 13.3332Z'
                fill={color}
                stroke='white'
                strokeWidth='0.2'
            />
            <path
                d='M6.26256 18.0817C5.1564 17.3386 4.23808 16.3485 3.5801 15.1896C3.36978 14.8075 2.88962 14.668 2.50725 14.878C2.12467 15.0881 1.98487 15.5686 2.19501 15.9512L2.19502 15.9512L2.20433 15.9677L2.20433 15.9677C2.98372 17.3408 4.07157 18.514 5.38212 19.3946L5.38221 19.3946C5.74476 19.6377 6.2357 19.5408 6.47875 19.1782C6.67062 18.892 6.65064 18.5259 6.4554 18.2647H6.53494L6.26256 18.0817Z'
                fill={color}
                stroke='white'
                strokeWidth='0.2'
            />
            <path
                d='M6.79701 19.3472L6.79701 19.3472C6.63428 19.7523 6.83068 20.2125 7.23567 20.3753L7.23584 20.3753C9.37971 21.2324 11.7518 21.3324 13.9603 20.6589L13.9604 20.6589C14.3777 20.5311 14.6125 20.0892 14.4847 19.6718C14.3569 19.2545 13.915 19.0197 13.4977 19.1475C11.6346 19.7153 9.63365 19.631 7.82494 18.9085C7.41994 18.7459 6.95974 18.9423 6.79701 19.3472Z'
                fill={color}
                stroke='white'
                strokeWidth='0.2'
            />
            <path
                d='M10.4266 13.2452L10.4264 13.1565L10.3942 11.1112L8.32668 11.1011C8.17088 11.1006 8.02133 11.0383 7.91092 10.9279C7.80051 10.8175 7.73824 10.668 7.7378 10.5122C7.73681 10.3676 7.78848 10.2279 7.88308 10.119C7.97768 10.0101 8.10879 9.93942 8.25201 9.92026L8.33508 9.9149L10.4026 9.92502L10.398 7.852C10.3977 7.6962 10.4594 7.54699 10.5693 7.43707C10.6793 7.32715 10.8285 7.26547 10.9843 7.26572C11.129 7.26383 11.2696 7.31474 11.38 7.40882C11.4904 7.5029 11.5629 7.63376 11.584 7.77701L11.5843 7.86571L11.5888 9.93874L13.6619 9.94332C13.8184 9.93411 13.9725 9.98749 14.0902 10.0917C14.2078 10.1959 14.2795 10.3424 14.2894 10.499C14.2993 10.6556 14.2466 10.8094 14.1429 10.9266C14.0392 11.0439 13.8931 11.1149 13.7365 11.1241L13.6534 11.1294L11.5804 11.1248L11.5904 13.1924C11.5957 13.2703 11.5856 13.3484 11.5607 13.4223C11.5357 13.4961 11.4965 13.5643 11.4452 13.6229C11.3938 13.6814 11.3314 13.7292 11.2615 13.7635C11.1916 13.7979 11.1155 13.8181 11.0376 13.8231C10.9597 13.828 10.8816 13.8175 10.8076 13.7922C10.7337 13.767 10.6653 13.7274 10.6065 13.6758C10.5478 13.6242 10.4996 13.5616 10.4649 13.4915C10.4303 13.4214 10.4097 13.3452 10.4045 13.2673L10.4266 13.2452Z'
                fill={color}
            />
        </svg>
    )
}

export const IconGlobeMagnified = () => {
    return (
        <svg
            width='50'
            height='50'
            viewBox='0 0 50 50'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g filter='url(#filter0_d_4945_12840)'>
                <g filter='url(#filter1_i_4945_12840)'>
                    <path
                        d='M38.5067 21.8022C39.487 19.7591 40.0263 17.4627 39.999 15.0371C39.9049 6.67829 33.1704 0 24.84 0C18.4453 0 12.9753 3.97302 10.7478 9.59341C10.0588 11.3318 10 13.2278 10 15.2126C10 23.6113 16.4704 29.9616 24.84 29.9999C27.0273 30.0098 29.0006 29.467 30.8815 28.64C31.2052 28.4977 31.5646 28.4583 31.9129 28.5186L38.3898 29.8905C39.1299 30.0186 39.9594 29.9754 39.9982 29.2713C40.0041 29.1625 39.9956 29.0502 39.9706 28.9365L38.3669 22.9969C38.2783 22.5941 38.3284 22.1737 38.5067 21.8022Z'
                        fill='url(#paint0_linear_4945_12840)'
                    />
                </g>
                <circle cx='25' cy='15' r='13' fill='#EDF7FF' />
                <g filter='url(#filter2_i_4945_12840)'>
                    <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M26.1575 8.86076C25.7282 7.53411 26.1476 5.93143 27.7741 5.7704C29.0437 5.62041 29.597 4.08691 29.5049 2.95622L29.3719 2C30.4962 2.3318 31.5931 2.8295 32.6284 3.49983C34.7287 4.86033 36.2871 6.74565 37.243 8.87407L37.2429 8.87425C37.3862 9.19254 37.5155 9.51635 37.6314 9.84505C37.6009 9.84933 37.5832 9.85178 37.582 9.85178C37.4597 9.86262 37.3316 9.87558 37.1995 9.88895C36.4138 9.96847 35.4875 10.0622 34.8075 9.80648C34.4309 9.69444 34.0821 9.47584 33.7432 9.26352C32.9637 8.77512 32.2373 8.31993 31.349 9.27144C31.1489 9.56467 30.9403 9.83158 30.7256 10.0673C30.4858 10.3299 30.1972 10.5374 29.88 10.6813C29.5622 10.8251 29.2163 10.9066 28.8612 10.917C27.8833 10.9445 26.9712 10.4285 26.4875 9.57508C26.4747 9.55304 26.4625 9.531 26.4503 9.50835C26.3289 9.30633 26.2306 9.08717 26.1574 8.86067C26.1575 8.8607 26.1575 8.86073 26.1575 8.86076Z'
                        fill='url(#paint1_linear_4945_12840)'
                    />
                </g>
                <g filter='url(#filter3_i_4945_12840)'>
                    <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M23.1793 27.9446C23.1794 27.9447 23.1794 27.9447 23.1795 27.9447C23.1673 27.81 23.1593 27.7144 23.1563 27.6781C23.1557 27.6709 23.1553 27.666 23.1551 27.6637C23.1322 27.3116 23.0897 26.9405 23.0462 26.5605C23.0098 26.2427 22.9728 25.9188 22.9458 25.5945C22.9457 25.5945 22.9455 25.5944 22.9454 25.5944C22.849 24.4388 22.8799 23.2791 23.5246 22.3818C23.8955 21.8658 24.1749 21.2866 24.3293 20.6696C24.3317 20.661 24.3335 20.653 24.3354 20.6445C24.411 20.3378 24.4293 20.0207 24.3988 19.706C24.3773 19.4812 24.3613 19.1724 24.3436 18.829C24.2928 17.8473 24.2275 16.5836 23.9767 16.1976C23.4392 15.0369 21.9372 14.6458 20.847 15.2494C20.5629 15.4495 20.2817 15.688 19.9962 15.9301C18.9377 16.8278 17.8201 17.7755 16.2716 17.0051C15.8012 16.6537 15.3205 16.1982 15.2742 15.5732C15.21 14.7069 14.6863 14.3603 14.0329 14.247C14.0329 14.2469 14.0329 14.2467 14.0329 14.2466C13.6574 14.1816 13.2391 14.1936 12.8405 14.2282C12.6277 14.2467 12.4205 14.2715 12.2284 14.2946C12.198 14.2983 12.168 14.3019 12.1384 14.3054C12.1187 14.3081 12.099 14.3104 12.0798 14.3126C12.0776 14.3128 12.0754 14.3131 12.0732 14.3133H12.0726L12.0518 14.3152L12.052 14.3155C11.8045 16.9991 12.4463 19.7542 13.8578 22.0476C13.8578 22.0476 13.8578 22.0478 13.8579 22.0479C13.8579 22.0481 13.8581 22.0482 13.8584 22.0482C13.9255 22.1584 13.995 22.268 14.0658 22.3763C14.0658 22.3763 14.0664 22.3763 14.0664 22.3769C14.8288 23.538 15.7867 24.5695 16.8873 25.4152C16.8879 25.4152 16.8879 25.4158 16.8879 25.4158C18.7016 26.8152 20.9028 27.7059 23.1793 27.9446L23.1793 27.9447C23.1793 27.9447 23.1793 27.9447 23.1793 27.9446Z'
                        fill='url(#paint2_linear_4945_12840)'
                    />
                </g>
                <g filter='url(#filter4_i_4945_12840)'>
                    <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M33.6674 15.4262C33.472 14.8254 33.0906 14.3756 32.2942 14.5129C31.8306 14.6673 31.5715 15.0152 31.2802 15.4064C30.8515 15.982 30.3531 16.6513 29.0309 16.9358C28.6345 17.0251 28.2851 17.2727 28.0781 17.6243C28.0778 17.6241 28.0778 17.6239 28.0778 17.6237C28.0778 17.6235 28.0778 17.6233 28.0776 17.6231C27.9301 17.884 27.8641 18.1783 27.8658 18.477C27.8659 18.4963 27.8664 18.5155 27.8674 18.5344C27.8909 19.2259 28.2712 19.9314 28.8381 20.2924C30.0133 20.9645 30.8654 20.5349 31.7894 20.0692C31.8223 20.0526 31.8553 20.036 31.8884 20.0193C32.2855 19.8161 33.0634 19.2731 33.3348 18.8036C33.8479 17.9943 34.0193 17.013 33.8119 16.077C33.7796 15.8541 33.7345 15.6311 33.6674 15.4262Z'
                        fill='url(#paint3_linear_4945_12840)'
                    />
                </g>
            </g>
            <defs>
                <filter
                    id='filter0_d_4945_12840'
                    x='0'
                    y='0'
                    width='50'
                    height='50'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dy='10' />
                    <feGaussianBlur stdDeviation='5' />
                    <feComposite in2='hardAlpha' operator='out' />
                    <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.305882 0 0 0 0 0.67451 0 0 0 0 0.976471 0 0 0 0.2 0'
                    />
                    <feBlend
                        mode='normal'
                        in2='BackgroundImageFix'
                        result='effect1_dropShadow_4945_12840'
                    />
                    <feBlend
                        mode='normal'
                        in='SourceGraphic'
                        in2='effect1_dropShadow_4945_12840'
                        result='shape'
                    />
                </filter>
                <filter
                    id='filter1_i_4945_12840'
                    x='10'
                    y='0'
                    width='30'
                    height='32'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feBlend
                        mode='normal'
                        in='SourceGraphic'
                        in2='BackgroundImageFix'
                        result='shape'
                    />
                    <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dy='2' />
                    <feGaussianBlur stdDeviation='2' />
                    <feComposite
                        in2='hardAlpha'
                        operator='arithmetic'
                        k2='-1'
                        k3='1'
                    />
                    <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.279167 0 0 0 0 0.655653 0 0 0 0 1 0 0 0 1 0'
                    />
                    <feBlend
                        mode='normal'
                        in2='shape'
                        result='effect1_innerShadow_4945_12840'
                    />
                </filter>
                <filter
                    id='filter2_i_4945_12840'
                    x='26'
                    y='2'
                    width='11.6313'
                    height='10.918'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feBlend
                        mode='normal'
                        in='SourceGraphic'
                        in2='BackgroundImageFix'
                        result='shape'
                    />
                    <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dy='2' />
                    <feGaussianBlur stdDeviation='2' />
                    <feComposite
                        in2='hardAlpha'
                        operator='arithmetic'
                        k2='-1'
                        k3='1'
                    />
                    <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.279167 0 0 0 0 0.655653 0 0 0 0 1 0 0 0 1 0'
                    />
                    <feBlend
                        mode='normal'
                        in2='shape'
                        result='effect1_innerShadow_4945_12840'
                    />
                </filter>
                <filter
                    id='filter3_i_4945_12840'
                    x='12'
                    y='14.2'
                    width='12.4131'
                    height='15.7447'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feBlend
                        mode='normal'
                        in='SourceGraphic'
                        in2='BackgroundImageFix'
                        result='shape'
                    />
                    <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dy='2' />
                    <feGaussianBlur stdDeviation='2' />
                    <feComposite
                        in2='hardAlpha'
                        operator='arithmetic'
                        k2='-1'
                        k3='1'
                    />
                    <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.279167 0 0 0 0 0.655653 0 0 0 0 1 0 0 0 1 0'
                    />
                    <feBlend
                        mode='normal'
                        in2='shape'
                        result='effect1_innerShadow_4945_12840'
                    />
                </filter>
                <filter
                    id='filter4_i_4945_12840'
                    x='27.8657'
                    y='14.4881'
                    width='6.03223'
                    height='8.15186'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feBlend
                        mode='normal'
                        in='SourceGraphic'
                        in2='BackgroundImageFix'
                        result='shape'
                    />
                    <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dy='2' />
                    <feGaussianBlur stdDeviation='2' />
                    <feComposite
                        in2='hardAlpha'
                        operator='arithmetic'
                        k2='-1'
                        k3='1'
                    />
                    <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.279167 0 0 0 0 0.655653 0 0 0 0 1 0 0 0 1 0'
                    />
                    <feBlend
                        mode='normal'
                        in2='shape'
                        result='effect1_innerShadow_4945_12840'
                    />
                </filter>
                <linearGradient
                    id='paint0_linear_4945_12840'
                    x1='7.74294'
                    y1='-30.6'
                    x2='46.6163'
                    y2='-28.5961'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#93CFFF' />
                    <stop offset='1' stopColor='#2894FF' />
                </linearGradient>
                <linearGradient
                    id='paint1_linear_4945_12840'
                    x1='25.1249'
                    y1='-7.09637'
                    x2='40.1687'
                    y2='-6.08494'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#93CFFF' />
                    <stop offset='1' stopColor='#2894FF' />
                </linearGradient>
                <linearGradient
                    id='paint2_linear_4945_12840'
                    x1='11.0661'
                    y1='0.180482'
                    x2='27.1583'
                    y2='0.929628'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#93CFFF' />
                    <stop offset='1' stopColor='#2894FF' />
                </linearGradient>
                <linearGradient
                    id='paint3_linear_4945_12840'
                    x1='27.4119'
                    y1='8.21317'
                    x2='35.229'
                    y2='8.60829'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#93CFFF' />
                    <stop offset='1' stopColor='#2894FF' />
                </linearGradient>
            </defs>
        </svg>
    )
}

export const IconMagnifyingGlass = ({
    width = '20',
    height = '20'
}: {
    width?: string
    height?: string
}) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox='0 0 22 22'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M10.5812 19.7055C15.8727 19.7055 20.1623 15.5182 20.1623 10.3528C20.1623 5.18738 15.8727 1 10.5812 1C5.28963 1 1 5.18738 1 10.3528C1 15.5182 5.28963 19.7055 10.5812 19.7055Z'
                stroke='#778797'
                strokeWidth='1.5'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                opacity='0.4'
                d='M17.2437 17.3427L20.9998 21'
                stroke='#778797'
                strokeWidth='1.5'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}

export const IconLockFill = () => {
    return (
        <svg
            width='8'
            height='10'
            viewBox='0 0 8 10'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M5.99058 10H2.00942C1.74863 10.0033 1.48977 9.95199 1.24764 9.849C1.00552 9.746 0.784826 9.59336 0.598231 9.39975C0.411636 9.20613 0.262805 8.97536 0.160156 8.72061C0.057508 8.46586 0.00307168 8.1921 0 7.91501V5.445C0.00307168 5.16791 0.057508 4.89418 0.160156 4.63943C0.262805 4.38468 0.411636 4.15391 0.598231 3.96029C0.784826 3.76668 1.00552 3.61401 1.24764 3.51101C1.48977 3.40802 1.74863 3.35671 2.00942 3.36001H5.99058C6.51691 3.35467 7.02382 3.57105 7.40039 3.96179C7.77696 4.35253 7.99256 4.88581 8 5.445V7.91501C7.99693 8.1921 7.94249 8.46586 7.83984 8.72061C7.7372 8.97536 7.58836 9.20613 7.40177 9.39975C7.21517 9.59336 6.99448 9.746 6.75236 9.849C6.51023 9.95199 6.25137 10.0033 5.99058 10ZM4 5.695C3.94607 5.69367 3.89245 5.70381 3.84226 5.72482C3.79206 5.74583 3.7463 5.77732 3.70772 5.81738C3.66914 5.85744 3.63851 5.90529 3.61759 5.95813C3.59667 6.01096 3.58587 6.06771 3.58588 6.12503V7.23001C3.57966 7.29207 3.58582 7.35484 3.60392 7.41421C3.62201 7.47359 3.65167 7.52826 3.69095 7.57467C3.73022 7.62108 3.7782 7.65819 3.83186 7.68359C3.88551 7.70899 3.94361 7.7221 4.00236 7.7221C4.0611 7.7221 4.1192 7.70899 4.17285 7.68359C4.22651 7.65819 4.27449 7.62108 4.31376 7.57467C4.35304 7.52826 4.3827 7.47359 4.40079 7.41421C4.41889 7.35484 4.42505 7.29207 4.41883 7.23001V6.12503C4.41822 6.06747 4.40684 6.01062 4.3854 5.95776C4.36396 5.9049 4.3329 5.85707 4.29395 5.81708C4.25499 5.77708 4.20895 5.74571 4.15849 5.72476C4.10804 5.70381 4.05416 5.69368 4 5.695Z'
                fill='white'
            />
            <path
                d='M6.59783 2.70001V3.43503C6.42612 3.38492 6.24883 3.35968 6.07077 3.36002H5.76017V2.70001C5.7552 2.21023 5.56762 1.74253 5.23857 1.39948C4.90952 1.05642 4.46587 0.866026 4.00488 0.870026C3.54461 0.865969 3.10136 1.05466 2.77108 1.39529C2.4408 1.73592 2.25006 2.20109 2.24018 2.69003V3.36002H1.93428C1.75584 3.35889 1.57823 3.38586 1.40723 3.44003V2.70001C1.46257 2.01115 1.75923 1.36944 2.23851 0.901825C2.71779 0.434208 3.34477 0.174744 3.99546 0.174744C4.64616 0.174744 5.27313 0.434208 5.75241 0.901825C6.23169 1.36944 6.52836 2.01115 6.5837 2.70001'
                fill='white'
            />
        </svg>
    )
}

export const IconIdCard = () => {
    return (
        <svg
            width='203'
            height='180'
            viewBox='0 0 203 180'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g filter='url(#filter0_d_5928_26069)'>
                <g filter='url(#filter1_i_5928_26069)'>
                    <path
                        d='M15.3333 21.3335C12.3463 21.3335 10 23.6798 10 26.6668V154.667C10 157.654 12.3463 160 15.3333 160H186.711C189.698 160 192.044 157.654 192.044 154.667V26.6668C192.044 23.6798 189.698 21.3335 186.711 21.3335H15.3333Z'
                        fill='url(#paint0_linear_5928_26069)'
                    />
                </g>
                <path
                    d='M85.0277 85.3333C85.0277 73.5676 75.46 64 63.6943 64C51.9286 64 42.361 73.5676 42.361 85.3333C42.361 97.099 51.9286 106.667 63.6943 106.667C75.46 106.667 85.0277 97.099 85.0277 85.3333ZM106.361 80C106.361 82.9479 108.746 85.3333 111.694 85.3333H165.028C167.976 85.3333 170.361 82.9479 170.361 80C170.361 77.0521 167.976 74.6667 165.028 74.6667H111.694C108.746 74.6667 106.361 77.0521 106.361 80ZM165.028 96H111.694C108.746 96 106.361 98.3854 106.361 101.333C106.361 104.281 108.746 106.667 111.694 106.667H165.028C167.976 106.667 170.361 104.281 170.361 101.333C170.361 98.3854 167.976 96 165.028 96ZM154.361 117.333H122.361C119.413 117.333 117.028 119.719 117.028 122.667C117.028 125.615 119.413 128 122.361 128H154.361C157.309 128 159.694 125.615 159.694 122.667C159.694 119.719 157.309 117.333 154.361 117.333ZM69.0277 106.667H63.6943H58.361C43.6577 106.667 31.6943 118.63 31.6943 133.333C31.6943 136.281 34.0798 138.667 37.0277 138.667H90.361C93.3089 138.667 95.6943 136.281 95.6943 133.333C95.6943 118.63 83.731 106.667 69.0277 106.667ZM79.6943 53.3333H122.361C125.348 53.3333 127.694 50.987 127.694 48C127.694 45.013 125.348 42.6667 122.361 42.6667H117.028V5.33333C117.028 2.34631 114.681 0 111.694 0H90.361C87.374 0 85.0277 2.34631 85.0277 5.33333V42.6667H79.6943C76.7073 42.6667 74.361 45.013 74.361 48C74.361 50.987 76.7073 53.3333 79.6943 53.3333Z'
                    fill='url(#paint1_linear_5928_26069)'
                />
            </g>
            <defs>
                <filter
                    id='filter0_d_5928_26069'
                    x='0'
                    y='0'
                    width='202.044'
                    height='180'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dy='10' />
                    <feGaussianBlur stdDeviation='5' />
                    <feComposite in2='hardAlpha' operator='out' />
                    <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.305882 0 0 0 0 0.67451 0 0 0 0 0.976471 0 0 0 0.2 0'
                    />
                    <feBlend
                        mode='normal'
                        in2='BackgroundImageFix'
                        result='effect1_dropShadow_5928_26069'
                    />
                    <feBlend
                        mode='normal'
                        in='SourceGraphic'
                        in2='effect1_dropShadow_5928_26069'
                        result='shape'
                    />
                </filter>
                <filter
                    id='filter1_i_5928_26069'
                    x='10'
                    y='21.3335'
                    width='182.044'
                    height='140.667'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feBlend
                        mode='normal'
                        in='SourceGraphic'
                        in2='BackgroundImageFix'
                        result='shape'
                    />
                    <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dy='2' />
                    <feGaussianBlur stdDeviation='2' />
                    <feComposite
                        in2='hardAlpha'
                        operator='arithmetic'
                        k2='-1'
                        k3='1'
                    />
                    <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.279167 0 0 0 0 0.655653 0 0 0 0 1 0 0 0 1 0'
                    />
                    <feBlend
                        mode='normal'
                        in2='shape'
                        result='effect1_innerShadow_5928_26069'
                    />
                </filter>
                <linearGradient
                    id='paint0_linear_5928_26069'
                    x1='-3.69615'
                    y1='-120.106'
                    x2='231.742'
                    y2='-104.173'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#93CFFF' />
                    <stop offset='1' stopColor='#2894FF' />
                </linearGradient>
                <linearGradient
                    id='paint1_linear_5928_26069'
                    x1='101.028'
                    y1='138.667'
                    x2='101.028'
                    y2='0'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#ADDCFF' />
                    <stop offset='0.5028' stopColor='#EAF6FF' />
                    <stop offset='1' stopColor='#EAF6FF' />
                </linearGradient>
            </defs>
        </svg>
    )
}

export const IconLockBlue = () => {
    return (
        <svg
            width='40'
            height='50'
            viewBox='0 0 40 50'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g filter='url(#filter0_d_4945_13465)'>
                <path
                    d='M20 0C15.6383 0 12.0898 3.54844 12.0898 7.91016V14.1797L14.9023 15.9375L17.3633 14.1797V7.91016C17.3633 6.45645 18.5463 5.27344 20 5.27344C21.4537 5.27344 22.6367 6.45645 22.6367 7.91016V11.543C22.6367 12.0281 23.0305 12.4219 23.5156 12.4219H27.0312C27.5164 12.4219 27.9102 12.0281 27.9102 11.543V7.91016C27.9102 3.54844 24.3617 0 20 0ZM20 16.8164C18.0615 16.8164 16.4844 18.3935 16.4844 20.332C16.4844 21.5994 17.1702 22.7551 18.2422 23.3757V25.6055C18.2422 26.5747 19.0307 27.3633 20 27.3633C20.9693 27.3633 21.7578 26.5747 21.7578 25.6055V23.3757C22.8298 22.7551 23.5156 21.5994 23.5156 20.332C23.5156 18.3935 21.9385 16.8164 20 16.8164Z'
                    fill='#BBDFFF'
                />
                <path
                    d='M28.7891 14.1797H11.2109C10.7258 14.1797 10.332 14.5734 10.332 15.0586V20.332C10.332 25.6629 14.6691 30 20 30C25.3309 30 29.668 25.6629 29.668 20.332V15.0586C29.668 14.5734 29.2742 14.1797 28.7891 14.1797ZM20.8789 22.8176V25.6055C20.8789 26.0909 20.4854 26.4844 20 26.4844C19.5146 26.4844 19.1211 26.0909 19.1211 25.6055V22.8176C18.0981 22.4548 17.3633 21.4778 17.3633 20.332C17.3633 18.8781 18.5461 17.6953 20 17.6953C21.4539 17.6953 22.6367 18.8781 22.6367 20.332C22.6367 21.4778 21.9019 22.4548 20.8789 22.8176Z'
                    fill='url(#paint0_linear_4945_13465)'
                />
            </g>
            <defs>
                <filter
                    id='filter0_d_4945_13465'
                    x='0.332031'
                    y='0'
                    width='39.3359'
                    height='50'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dy='10' />
                    <feGaussianBlur stdDeviation='5' />
                    <feComposite in2='hardAlpha' operator='out' />
                    <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.305882 0 0 0 0 0.67451 0 0 0 0 0.976471 0 0 0 0.2 0'
                    />
                    <feBlend
                        mode='normal'
                        in2='BackgroundImageFix'
                        result='effect1_dropShadow_4945_13465'
                    />
                    <feBlend
                        mode='normal'
                        in='SourceGraphic'
                        in2='effect1_dropShadow_4945_13465'
                        result='shape'
                    />
                </filter>
                <linearGradient
                    id='paint0_linear_4945_13465'
                    x1='20'
                    y1='30'
                    x2='20'
                    y2='14.1797'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#3C9FFF' />
                    <stop offset='1' stopColor='#76C0FF' />
                </linearGradient>
            </defs>
        </svg>
    )
}

export const IconPhoneBlue = () => {
    return (
        <svg
            width='42'
            height='50'
            viewBox='0 0 42 50'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g filter='url(#filter0_d_4945_13482)'>
                <path
                    d='M28.6992 0H12.6367C11.1828 0 10 1.18283 10 2.63672V27.3633C10 28.8172 11.1828 30 12.6367 30H28.6992C30.1531 30 31.3359 28.8172 31.3359 27.3633V2.63672C31.3359 1.18283 30.1531 0 28.6992 0Z'
                    fill='url(#paint0_linear_4945_13482)'
                />
                <rect x='12' y='5' width='17' height='20' fill='#EDF7FF' />
                <path
                    d='M21.5469 26.7266H19.7891C19.3037 26.7266 18.9102 27.1201 18.9102 27.6055C18.9102 28.0909 19.3037 28.4844 19.7891 28.4844H21.5469C22.0323 28.4844 22.4258 28.0909 22.4258 27.6055C22.4258 27.1201 22.0323 26.7266 21.5469 26.7266ZM20.7891 3.27344C21.2745 3.27344 21.668 2.87992 21.668 2.39453C21.668 1.90914 21.2745 1.51562 20.7891 1.51562C20.3037 1.51562 19.9102 1.90914 19.9102 2.39453C19.9102 2.87992 20.3037 3.27344 20.7891 3.27344Z'
                    fill='url(#paint1_linear_4945_13482)'
                />
            </g>
            <defs>
                <filter
                    id='filter0_d_4945_13482'
                    x='0'
                    y='0'
                    width='41.3359'
                    height='50'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dy='10' />
                    <feGaussianBlur stdDeviation='5' />
                    <feComposite in2='hardAlpha' operator='out' />
                    <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.305882 0 0 0 0 0.67451 0 0 0 0 0.976471 0 0 0 0.2 0'
                    />
                    <feBlend
                        mode='normal'
                        in2='BackgroundImageFix'
                        result='effect1_dropShadow_4945_13482'
                    />
                    <feBlend
                        mode='normal'
                        in='SourceGraphic'
                        in2='effect1_dropShadow_4945_13482'
                        result='shape'
                    />
                </filter>
                <linearGradient
                    id='paint0_linear_4945_13482'
                    x1='20.668'
                    y1='30'
                    x2='20.668'
                    y2='0'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#3C9FFF' />
                    <stop offset='1' stopColor='#76C0FF' />
                </linearGradient>
                <linearGradient
                    id='paint1_linear_4945_13482'
                    x1='20.668'
                    y1='26.4844'
                    x2='20.668'
                    y2='3.51562'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#ADDCFF' />
                    <stop offset='0.5028' stopColor='#EAF6FF' />
                    <stop offset='1' stopColor='#EAF6FF' />
                </linearGradient>
            </defs>
        </svg>
    )
}

export const IconMail = () => {
    return (
        <svg
            width='50'
            height='48'
            viewBox='0 0 50 48'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g filter='url(#filter0_d_4945_13528)'>
                <path
                    d='M39.6086 9.75313L34.2766 6.2375H33.7891V1.69531H16.2109V6.2375H15.7234L10.3914 9.75313C10.1477 9.91619 10 10.1908 10 10.4844V26.3047C10 26.7905 10.3931 27.1836 10.8789 27.1836H39.1211C39.6069 27.1836 40 26.7905 40 26.3047V10.4844C40 10.1908 39.8523 9.91619 39.6086 9.75313Z'
                    fill='url(#paint0_linear_4945_13528)'
                />
                <path
                    d='M36.2505 12.5941C35.9569 12.2027 35.4076 12.1289 35.0197 12.4181L34.6678 12.6821V1.69531C34.6678 1.20951 34.2747 0.816406 33.7889 0.816406H16.2107C15.7249 0.816406 15.3318 1.20951 15.3318 1.69531V12.6821L14.9799 12.4181C14.5937 12.1297 14.0426 12.2045 13.7491 12.5941C13.459 12.9821 13.5379 13.5331 13.9259 13.824L24.4728 21.7342C24.629 21.8518 24.8144 21.9102 24.9998 21.9102C25.1852 21.9102 25.3706 21.8518 25.5268 21.7342L36.0737 13.824C36.4616 13.5331 36.5406 12.9821 36.2505 12.5941ZM28.5154 13.1211H21.4842C20.9984 13.1211 20.6053 12.728 20.6053 12.2422C20.6053 11.7564 20.9984 11.3633 21.4842 11.3633H28.5154C29.0012 11.3633 29.3943 11.7564 29.3943 12.2422C29.3943 12.728 29.0012 13.1211 28.5154 13.1211ZM28.5154 9.60547H21.4842C20.9984 9.60547 20.6053 9.21236 20.6053 8.72656C20.6053 8.24076 20.9984 7.84766 21.4842 7.84766H28.5154C29.0012 7.84766 29.3943 8.24076 29.3943 8.72656C29.3943 9.21236 29.0012 9.60547 28.5154 9.60547ZM28.5154 6.08984H21.4842C20.9984 6.08984 20.6053 5.69674 20.6053 5.21094C20.6053 4.72514 20.9984 4.33203 21.4842 4.33203H28.5154C29.0012 4.33203 29.3943 4.72514 29.3943 5.21094C29.3943 5.69674 29.0012 6.08984 28.5154 6.08984Z'
                    fill='#EDF7FF'
                />
            </g>
            <defs>
                <filter
                    id='filter0_d_4945_13528'
                    x='0'
                    y='0.816406'
                    width='50'
                    height='46.3672'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dy='10' />
                    <feGaussianBlur stdDeviation='5' />
                    <feComposite in2='hardAlpha' operator='out' />
                    <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.305882 0 0 0 0 0.67451 0 0 0 0 0.976471 0 0 0 0.2 0'
                    />
                    <feBlend
                        mode='normal'
                        in2='BackgroundImageFix'
                        result='effect1_dropShadow_4945_13528'
                    />
                    <feBlend
                        mode='normal'
                        in='SourceGraphic'
                        in2='effect1_dropShadow_4945_13528'
                        result='shape'
                    />
                </filter>
                <linearGradient
                    id='paint0_linear_4945_13528'
                    x1='25'
                    y1='27.1836'
                    x2='25'
                    y2='1.69531'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#3C9FFF' />
                    <stop offset='1' stopColor='#76C0FF' />
                </linearGradient>
            </defs>
        </svg>
    )
}

export const IconChatBubbles = () => {
    return (
        <svg
            width='50'
            height='50'
            viewBox='0 0 50 50'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g filter='url(#filter0_d_4945_13573)'>
                <path
                    d='M19.668 14.1797H17.9102C13.5483 14.1797 10 17.7279 10 22.0898C10 23.9077 10.6094 25.6312 11.7303 27.0285L10.2575 28.4997C10.0069 28.7512 9.93139 29.1288 10.067 29.4576C10.2026 29.7854 10.5236 30 10.8789 30H19.668C24.0299 30 27.5781 26.4517 27.5781 22.0898C27.5781 17.7279 24.0299 14.1797 19.668 14.1797Z'
                    fill='url(#paint0_linear_4945_13573)'
                />
                <path
                    d='M38.2697 12.8488C39.3906 11.4515 40 9.72803 40 7.91016C40 3.54826 36.4517 0 32.0898 0H30.332C25.9701 0 22.4219 3.54826 22.4219 7.91016C22.4219 12.2721 25.9701 15.8203 30.332 15.8203H39.1211C39.4764 15.8203 39.7974 15.6057 39.933 15.2779C40.0686 14.9491 39.9931 14.5714 39.7425 14.32L38.2697 12.8488Z'
                    fill='#BBDFFF'
                />
            </g>
            <defs>
                <filter
                    id='filter0_d_4945_13573'
                    x='0'
                    y='0'
                    width='50'
                    height='50'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dy='10' />
                    <feGaussianBlur stdDeviation='5' />
                    <feComposite in2='hardAlpha' operator='out' />
                    <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.305882 0 0 0 0 0.67451 0 0 0 0 0.976471 0 0 0 0.2 0'
                    />
                    <feBlend
                        mode='normal'
                        in2='BackgroundImageFix'
                        result='effect1_dropShadow_4945_13573'
                    />
                    <feBlend
                        mode='normal'
                        in='SourceGraphic'
                        in2='effect1_dropShadow_4945_13573'
                        result='shape'
                    />
                </filter>
                <linearGradient
                    id='paint0_linear_4945_13573'
                    x1='18.7891'
                    y1='30'
                    x2='18.7891'
                    y2='14.1797'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#3C9FFF' />
                    <stop offset='1' stopColor='#76C0FF' />
                </linearGradient>
            </defs>
        </svg>
    )
}

export const IconPrivacyShield = () => {
    return (
        <svg
            width='26'
            height='30'
            viewBox='0 0 26 30'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M23.7147 4.55873C24.0382 4.66421 24.3198 4.86187 24.5214 5.12492C24.723 5.38797 24.8349 5.7037 24.8418 6.02932V16C24.8713 18.0633 24.2941 20.0934 23.1754 21.8606C22.0567 23.6278 20.4412 25.0615 18.5116 25.9998L13.0152 28.8234L7.5033 25.9851C6.21601 25.3628 5.06364 24.5147 4.10665 23.4852C2.20471 21.4066 1.15717 18.7425 1.15772 15.9852V6.02932C1.16461 5.7037 1.27646 5.38797 1.47807 5.12492C1.67967 4.86187 1.96131 4.66421 2.28481 4.55873L12.4439 1.14704C12.8042 1.0294 13.1953 1.0294 13.5556 1.14704L23.7147 4.55873Z'
                stroke='#0D1444'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M8.98584 14.5881L11.9039 17.3823L17.9252 11.647'
                stroke='#0D1444'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}

export const IconWhiteMan = () => {
    return (
        <svg
            width='35'
            height='42'
            viewBox='0 0 35 42'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M17.2335 20.8393C23.2317 20.8393 28.0942 16.1743 28.0942 10.4197C28.0942 4.66504 23.2317 0 17.2335 0C11.2353 0 6.3728 4.66504 6.3728 10.4197C6.3728 16.1743 11.2353 20.8393 17.2335 20.8393Z'
                fill='white'
            />
            <path
                d='M0.00995712 35.3132C-0.0027418 34.5591 0.168365 33.8127 0.509755 33.1333C1.26052 32.1709 2.20789 31.3654 3.29386 30.7658C4.37984 30.1661 5.58173 29.7849 6.82628 29.6456C8.57911 29.2928 10.3559 29.0597 12.1431 28.9481C15.4614 28.6647 18.7992 28.6647 22.1175 28.9481C23.9063 29.0578 25.6837 29.2983 27.4343 29.6675C29.8655 30.147 32.7965 31.1061 33.8417 33.1988C34.1854 33.8781 34.364 34.6235 34.364 35.3786C34.364 36.1338 34.1854 36.8791 33.8417 37.5585C32.7965 39.7383 29.8655 40.6102 27.4343 41.068C25.6846 41.4458 23.907 41.6937 22.1175 41.8092C19.4193 42.0198 16.7094 42.0562 14.0061 41.9182C13.3819 41.9397 12.7573 41.8958 12.1431 41.7874C10.3601 41.6811 8.58933 41.4331 6.84903 41.0462C5.57658 40.9514 4.34121 40.59 3.23021 39.9874C2.11921 39.3848 1.15958 38.5556 0.41892 37.5585C0.0998837 36.8515 -0.040244 36.0821 0.00995712 35.3132Z'
                fill='white'
            />
        </svg>
    )
}

export const IconGPSPoint = () => {
    return (
        <svg
            width='50'
            height='50'
            viewBox='0 0 50 50'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g filter='url(#filter0_d_4945_15084)'>
                <path
                    d='M40 15C40 17.9668 39.1203 20.8668 37.472 23.3335C35.8238 25.8003 33.4811 27.7229 30.7402 28.8582C27.9994 29.9935 24.9834 30.2905 22.0737 29.7117C19.1639 29.133 16.4912 27.7044 14.3934 25.6066C12.2956 23.5088 10.867 20.836 10.2882 17.9263C9.70945 15.0166 10.0065 12.0007 11.1418 9.25977C12.2771 6.51887 14.1997 4.17621 16.6664 2.52798C19.1332 0.879763 22.0333 3.05176e-05 25 3.05176e-05C28.9782 3.05176e-05 32.7936 1.58033 35.6066 4.39337C38.4197 7.20642 40 11.0218 40 15Z'
                    fill='url(#paint0_linear_4945_15084)'
                />
                <path
                    d='M24.1847 20.7736H24.1353L23.7976 20.5494C22.3806 19.5899 21.1226 18.4255 20.067 17.0966L19.8035 16.7681C18.6893 15.3457 18.0588 13.6208 18 11.8334V11.6091C18.0597 9.84006 18.8227 8.16254 20.1284 6.9298C21.434 5.69706 23.1805 5.00527 25 5H25.2306C27.0533 5.06447 28.7788 5.81599 30.0421 7.09575C31.3054 8.37551 32.0076 10.0831 31.9999 11.8574V11.9376C31.9588 14.0525 30.8964 16.2394 28.9364 18.2581C28.0089 19.1967 26.9726 20.0275 25.8482 20.7336H25.807C25.5693 20.9065 25.2804 21 24.9835 21C24.6866 21 24.3977 20.9065 24.16 20.7336L24.1847 20.7736ZM24.8188 6.22571C23.323 6.27354 21.9049 6.88535 20.8644 7.93186C19.824 8.97837 19.2427 10.3775 19.2435 11.8334V12.1218C19.3513 13.5535 19.8865 14.9233 20.7835 16.0631C21.8969 17.5114 23.2627 18.7587 24.8188 19.7483L24.8847 19.7963C24.9119 19.8199 24.947 19.8331 24.9835 19.8331C25.02 19.8331 25.0551 19.8199 25.0823 19.7963L25.1482 19.7403C26.1941 19.0842 27.1585 18.3127 28.0223 17.4411C29.5908 15.9991 30.5583 14.0454 30.7399 11.9535V11.6811C30.695 10.2232 30.0678 8.83973 28.9916 7.82419C27.9153 6.80866 26.4747 6.24099 24.9753 6.24165L24.8188 6.22571ZM22.3482 11.9295C22.3498 11.4165 22.5077 10.9155 22.8019 10.4897C23.0961 10.0639 23.5134 9.73241 24.001 9.53719C24.4887 9.34196 25.025 9.2917 25.542 9.39275C26.059 9.4938 26.5337 9.74165 26.906 10.105C27.2784 10.4683 27.5317 10.9308 27.634 11.434C27.7363 11.9373 27.6829 12.4589 27.4808 12.9327C27.2786 13.4065 26.9366 13.8113 26.498 14.0962C26.0594 14.381 25.5438 14.5331 25.0164 14.5331C24.6643 14.5352 24.3153 14.4693 23.9896 14.3392C23.6639 14.2091 23.368 14.0174 23.119 13.7752C22.87 13.533 22.673 13.2452 22.5393 12.9284C22.4055 12.6115 22.3378 12.272 22.34 11.9295H22.3482ZM23.5917 11.9295C23.5917 12.2036 23.6753 12.4715 23.8318 12.6994C23.9884 12.9274 24.2109 13.105 24.4712 13.2099C24.7316 13.3148 25.018 13.3422 25.2944 13.2887C25.5707 13.2353 25.8246 13.1033 26.0238 12.9095C26.2231 12.7157 26.3588 12.4687 26.4138 12.1998C26.4687 11.931 26.4405 11.6524 26.3327 11.3991C26.2248 11.1459 26.0422 10.9295 25.808 10.7772C25.5737 10.6249 25.2982 10.5436 25.0164 10.5436C24.8283 10.5414 24.6417 10.5758 24.4674 10.6446C24.2931 10.7134 24.1346 10.8153 24.0012 10.9443C23.8678 11.0733 23.7622 11.2268 23.6905 11.396C23.6188 11.5651 23.5824 11.7466 23.5835 11.9295H23.5917Z'
                    fill='#EDF7FF'
                />
                <path
                    d='M26.4152 24.8468L26.5099 24.8884L26.4981 24.8943C26.6699 24.9631 26.887 24.997 27.1064 24.9893C27.3258 24.9816 27.5314 24.9328 27.6824 24.8527C27.8487 24.7693 27.9421 24.6563 27.9421 24.5383C27.9421 24.4204 27.8487 24.3073 27.6824 24.2239L26.2612 23.5118L27.6824 22.7999L27.7771 22.7465C27.9342 22.6568 28.0136 22.5395 27.9981 22.4205C27.9825 22.3014 27.8732 22.1903 27.6942 22.1116C27.5152 22.0329 27.2811 21.9932 27.0435 22.001C26.8058 22.0088 26.5841 22.0635 26.427 22.1532L25.0059 22.8651L23.5848 22.1532L23.4901 22.1116C23.3183 22.0428 23.1011 22.009 22.8817 22.0167C22.6624 22.0244 22.4568 22.0731 22.3058 22.1532C22.1395 22.2366 22.046 22.3497 22.046 22.4676C22.046 22.5855 22.1395 22.6986 22.3058 22.7821L23.7269 23.4941L22.3058 24.206L22.2229 24.2535C22.1451 24.2979 22.0856 24.3496 22.0477 24.4055C22.0098 24.4614 21.9942 24.5206 22.0019 24.5795C22.0096 24.6385 22.0403 24.6961 22.0925 24.7491C22.1446 24.8021 22.2171 24.8494 22.3058 24.8884C22.3944 24.9273 22.4975 24.9572 22.6092 24.9762C22.7208 24.9951 22.8389 25.0029 22.9565 24.999C23.0742 24.9952 23.1892 24.9797 23.295 24.9536C23.4007 24.9275 23.4952 24.8912 23.573 24.8468L24.994 24.1348L26.4152 24.8468Z'
                    fill='#EDF7FF'
                />
            </g>
            <defs>
                <filter
                    id='filter0_d_4945_15084'
                    x='0'
                    y='3.05176e-05'
                    width='50'
                    height='49.9999'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dy='10' />
                    <feGaussianBlur stdDeviation='5' />
                    <feComposite in2='hardAlpha' operator='out' />
                    <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.305882 0 0 0 0 0.67451 0 0 0 0 0.976471 0 0 0 0.2 0'
                    />
                    <feBlend
                        mode='normal'
                        in2='BackgroundImageFix'
                        result='effect1_dropShadow_4945_15084'
                    />
                    <feBlend
                        mode='normal'
                        in='SourceGraphic'
                        in2='effect1_dropShadow_4945_15084'
                        result='shape'
                    />
                </filter>
                <linearGradient
                    id='paint0_linear_4945_15084'
                    x1='25'
                    y1='30'
                    x2='25'
                    y2='3.05176e-05'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#3C9FFF' />
                    <stop offset='1' stopColor='#76C0FF' />
                </linearGradient>
            </defs>
        </svg>
    )
}

export const IconManLineThrough = () => {
    return (
        <svg
            width='50'
            height='50'
            viewBox='0 0 50 50'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g filter='url(#filter0_d_4945_15049)'>
                <path
                    d='M25 30C33.2843 30 40 23.2843 40 15C40 6.71573 33.2843 0 25 0C16.7157 0 10 6.71573 10 15C10 23.2843 16.7157 30 25 30Z'
                    fill='url(#paint0_linear_4945_15049)'
                />
                <path
                    d='M29.3945 9.72656C29.3945 7.30342 27.4231 5.33203 25 5.33203C22.5769 5.33203 20.6055 7.30342 20.6055 9.72656C20.6055 12.1497 22.5769 14.1211 25 14.1211C27.4231 14.1211 29.3945 12.1497 29.3945 9.72656ZM25 14.1211C20.6383 14.1211 17.0898 17.6696 17.0898 22.0312V22.855C17.0898 23.1048 17.1961 23.3428 17.3822 23.5095C19.5231 25.4279 22.2285 26.4844 25 26.4844C27.7715 26.4844 30.4769 25.4279 32.6178 23.5095C32.8039 23.3428 32.9102 23.1047 32.9102 22.855V22.0312C32.9102 17.6696 29.3617 14.1211 25 14.1211Z'
                    fill='#EDF7FF'
                />
                <path
                    d='M34.3802 6.36994L25.0004 16.0194L16.4804 24.7489C16.4039 24.8281 16.3123 24.891 16.2109 24.9339C16.1096 24.9769 16.0006 24.999 15.8905 24.9989C15.7789 24.9992 15.6683 24.9772 15.5653 24.9343C15.4623 24.8913 15.3688 24.8284 15.2905 24.7489C15.1599 24.6085 15.077 24.4303 15.0536 24.24C15.0303 24.0496 15.0677 23.8568 15.1605 23.689L15.2305 23.599L33.1802 5.17C33.257 5.08763 33.3498 5.02193 33.4531 4.97702C33.5563 4.9321 33.6677 4.90891 33.7803 4.90891C33.8928 4.90891 34.0042 4.9321 34.1074 4.97702C34.2106 5.02193 34.3035 5.08763 34.3802 5.17C34.5385 5.3356 34.6269 5.55586 34.6269 5.78495C34.6269 6.01405 34.5385 6.23431 34.3802 6.39991'
                    fill='#EDF7FF'
                />
            </g>
            <defs>
                <filter
                    id='filter0_d_4945_15049'
                    x='0'
                    y='0'
                    width='50'
                    height='50'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dy='10' />
                    <feGaussianBlur stdDeviation='5' />
                    <feComposite in2='hardAlpha' operator='out' />
                    <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.305882 0 0 0 0 0.67451 0 0 0 0 0.976471 0 0 0 0.2 0'
                    />
                    <feBlend
                        mode='normal'
                        in2='BackgroundImageFix'
                        result='effect1_dropShadow_4945_15049'
                    />
                    <feBlend
                        mode='normal'
                        in='SourceGraphic'
                        in2='effect1_dropShadow_4945_15049'
                        result='shape'
                    />
                </filter>
                <linearGradient
                    id='paint0_linear_4945_15049'
                    x1='25'
                    y1='30'
                    x2='25'
                    y2='0'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#3C9FFF' />
                    <stop offset='1' stopColor='#76C0FF' />
                </linearGradient>
            </defs>
        </svg>
    )
}

export const IconMagnifyingGlassChecked = () => {
    return (
        <svg
            width='50'
            height='50'
            viewBox='0 0 50 50'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g filter='url(#filter0_d_4945_15100)'>
                <path
                    d='M34.3279 7.44581C33.6089 6.72868 32.4735 6.7762 31.8389 7.44581L26.8143 12.4532L24.5519 10.2053C23.8641 9.47725 22.7023 9.51165 22.0817 10.1726C21.3596 10.855 21.3732 12.0095 22.0645 12.6626L25.5475 16.1439C25.8651 16.4967 26.3268 16.6992 26.816 16.6992C27.3053 16.6992 27.767 16.4967 28.052 16.1791L34.3279 9.92116C35.0082 9.2427 35.0038 8.1235 34.3279 7.44581ZM20.4955 18.2622L18.0905 20.6663C17.7472 21.0096 17.7472 21.5658 18.0905 21.9091C18.4338 22.2525 18.99 22.2524 19.3333 21.9091L21.7383 19.505C22.0816 19.1617 22.0816 18.6055 21.7383 18.2622C21.395 17.9189 20.8388 17.9189 20.4955 18.2622Z'
                    fill='url(#paint0_linear_4945_15100)'
                />
                <path
                    d='M28.5751 0C22.2821 0 17.1494 5.13275 17.1494 11.4258C17.1494 17.7188 22.2821 22.8516 28.5751 22.8516C34.8682 22.8516 40.0009 17.7188 40.0009 11.4258C40.0009 5.13275 34.8682 0 28.5751 0ZM33.7078 9.29877L27.4326 15.5566C27.2744 15.7324 27.0458 15.8203 26.8173 15.8203C26.5888 15.8203 26.3603 15.7324 26.2021 15.5566L22.6865 12.041C22.3348 11.707 22.3348 11.1446 22.6865 10.8105C23.0206 10.459 23.5828 10.459 23.9169 10.8105L26.8173 13.6933L32.4598 8.06836C32.7939 7.7168 33.3563 7.7168 33.7078 8.06836C34.0419 8.4024 34.0419 8.96479 33.7078 9.29877ZM18.0918 19.4235C17.7485 19.0802 17.1923 19.0802 16.849 19.4235L10.2585 26.014C9.91515 26.3573 9.91515 26.9136 10.2585 27.2569L12.7441 29.7425C13.0875 30.0858 13.6436 30.0858 13.9869 29.7425L20.5775 23.152C20.9208 22.8087 20.9208 22.2524 20.5775 21.9091L18.0918 19.4235Z'
                    fill='url(#paint1_linear_4945_15100)'
                />
            </g>
            <defs>
                <filter
                    id='filter0_d_4945_15100'
                    x='0.000976562'
                    y='0'
                    width='50'
                    height='50'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dy='10' />
                    <feGaussianBlur stdDeviation='5' />
                    <feComposite in2='hardAlpha' operator='out' />
                    <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.305882 0 0 0 0 0.67451 0 0 0 0 0.976471 0 0 0 0.2 0'
                    />
                    <feBlend
                        mode='normal'
                        in2='BackgroundImageFix'
                        result='effect1_dropShadow_4945_15100'
                    />
                    <feBlend
                        mode='normal'
                        in='SourceGraphic'
                        in2='effect1_dropShadow_4945_15100'
                        result='shape'
                    />
                </filter>
                <linearGradient
                    id='paint0_linear_4945_15100'
                    x1='26.3347'
                    y1='22.1667'
                    x2='26.3347'
                    y2='6.92567'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#ADDCFF' />
                    <stop offset='0.5028' stopColor='#EAF6FF' />
                    <stop offset='1' stopColor='#EAF6FF' />
                </linearGradient>
                <linearGradient
                    id='paint1_linear_4945_15100'
                    x1='25.0009'
                    y1='30'
                    x2='25.0009'
                    y2='0'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#3C9FFF' />
                    <stop offset='1' stopColor='#76C0FF' />
                </linearGradient>
            </defs>
        </svg>
    )
}

export const IconScanSquare = () => {
    return (
        <svg
            width='50'
            height='46'
            viewBox='0 0 50 46'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g filter='url(#filter0_d_4945_15069)'>
                <path
                    d='M18.4755 10.876C18.3792 10.8724 18.2877 10.8301 18.2195 10.7577C18.1513 10.6854 18.1115 10.5882 18.1082 10.486V8.68051C18.1118 7.81345 18.4387 6.98326 19.0175 6.37151C19.5963 5.75976 20.3799 5.41633 21.1966 5.41634H28.7068C29.5163 5.42015 30.2915 5.76423 30.8626 6.37327C31.4338 6.98232 31.7544 7.80673 31.7544 8.66614V10.4716C31.751 10.5739 31.7113 10.6709 31.6431 10.7433C31.5749 10.8156 31.4834 10.8579 31.3871 10.8615L18.4755 10.876ZM35.3735 8.33387V5.64739C35.3681 5.18457 35.277 4.72737 35.1052 4.30195C34.9334 3.87653 34.6844 3.49123 34.3723 3.16799C34.0603 2.84475 33.6913 2.58997 33.2865 2.41813C32.8816 2.24629 32.4489 2.16081 32.0129 2.16653H29.8497C29.579 2.16653 29.3195 2.05241 29.1281 1.84926C28.9368 1.64611 28.8293 1.37057 28.8293 1.08327C28.8293 0.795967 28.9368 0.520427 29.1281 0.317275C29.3195 0.114124 29.579 2.82579e-07 29.8497 2.82579e-07H32.0129C33.4353 -0.000381986 34.8013 0.590361 35.8185 1.64588C36.8356 2.7014 37.4231 4.13777 37.4551 5.64739V8.33387C37.4551 8.625 37.3462 8.90423 37.1523 9.11009C36.9583 9.31595 36.6953 9.4316 36.4211 9.4316C36.1468 9.4316 35.8838 9.31595 35.6899 9.11009C35.496 8.90423 35.3871 8.625 35.3871 8.33387H35.3735ZM12.4619 8.33387V5.63294C12.4974 4.12584 13.0864 2.6932 14.1032 1.64077C15.12 0.588335 16.484 -0.000470904 17.9041 2.82579e-07H20.1082C20.3788 2.82579e-07 20.6383 0.114124 20.8297 0.317275C21.0211 0.520427 21.1286 0.795967 21.1286 1.08327C21.1286 1.37057 21.0211 1.64611 20.8297 1.84926C20.6383 2.05241 20.3788 2.16653 20.1082 2.16653H17.8769C17.4434 2.16081 17.013 2.24605 16.6106 2.41734C16.2082 2.58863 15.8416 2.84256 15.5319 3.16464C15.2222 3.48672 14.9754 3.87061 14.8058 4.29419C14.6362 4.71777 14.5471 5.17269 14.5435 5.63294V8.33387C14.5143 8.60515 14.392 8.85551 14.2001 9.03727C14.0081 9.21904 13.7599 9.31955 13.5027 9.31955C13.2455 9.31955 12.9973 9.21904 12.8054 9.03727C12.6134 8.85551 12.4912 8.60515 12.4619 8.33387Z'
                    fill='#BBDFFF'
                />
                <path
                    d='M38.8844 13.0569H11.0204C10.7498 13.0569 10.4902 13.1711 10.2989 13.3742C10.1075 13.5774 10 13.8529 10 14.1402C10 14.4275 10.1075 14.7031 10.2989 14.9062C10.4902 15.1094 10.7498 15.2235 11.0204 15.2235H12.4626V20.3654C12.4981 21.8725 13.0871 23.3051 14.1039 24.3576C15.1207 25.41 16.4847 25.9989 17.9048 25.9984H20.1225C20.2562 26.0062 20.3901 25.9852 20.5161 25.9366C20.642 25.888 20.7574 25.8128 20.8553 25.7157C20.9532 25.6185 21.0315 25.5014 21.0856 25.3713C21.1397 25.2411 21.1684 25.1007 21.1701 24.9584C21.1774 24.6735 21.0787 24.397 20.8954 24.1888C20.712 23.9806 20.4587 23.8575 20.1905 23.8462H17.8776C17.4434 23.8501 17.0128 23.7631 16.6103 23.5902C16.2078 23.4174 15.8413 23.162 15.5318 22.8388C15.2222 22.5156 14.9757 22.1307 14.8063 21.7063C14.6368 21.2819 14.5478 20.8263 14.5442 20.3654V15.2235H18.1497V16.6678C18.1533 17.5349 18.4802 18.3652 19.059 18.9769C19.6379 19.5887 20.4214 19.9321 21.2381 19.9321H28.7483C29.1532 19.934 29.5545 19.8509 29.9292 19.6877C30.3038 19.5245 30.6444 19.2845 30.9313 18.9812C31.2183 18.6778 31.446 18.3173 31.6014 17.9204C31.7568 17.5234 31.8367 17.0977 31.8367 16.6678V15.2235H35.4014V20.3654C35.3978 20.8275 35.3083 21.2843 35.138 21.7097C34.9677 22.135 34.72 22.5205 34.409 22.8439C34.098 23.1673 33.73 23.4224 33.3259 23.5944C32.9218 23.7664 32.4897 23.852 32.0544 23.8462H29.8504C29.6018 23.8769 29.3724 24.0035 29.206 24.2019C29.0395 24.4003 28.9476 24.6567 28.9476 24.9224C28.9476 25.188 29.0395 25.4444 29.206 25.6428C29.3724 25.8412 29.6018 25.9678 29.8504 25.9984H32.0816C33.5017 25.9989 34.8657 25.41 35.8825 24.3576C36.8993 23.3051 37.4883 21.8725 37.5238 20.3654V15.2235H38.966C39.2379 15.2235 39.4988 15.1098 39.6924 14.9071C39.8859 14.7043 39.9964 14.4288 40 14.1402C39.9964 13.8516 39.8859 13.5761 39.6924 13.3733C39.4988 13.1706 39.2379 13.0569 38.966 13.0569'
                    fill='url(#paint0_linear_4945_15069)'
                />
            </g>
            <defs>
                <filter
                    id='filter0_d_4945_15069'
                    x='0'
                    y='0'
                    width='50'
                    height='46'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dy='10' />
                    <feGaussianBlur stdDeviation='5' />
                    <feComposite in2='hardAlpha' operator='out' />
                    <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.305882 0 0 0 0 0.67451 0 0 0 0 0.976471 0 0 0 0.2 0'
                    />
                    <feBlend
                        mode='normal'
                        in2='BackgroundImageFix'
                        result='effect1_dropShadow_4945_15069'
                    />
                    <feBlend
                        mode='normal'
                        in='SourceGraphic'
                        in2='effect1_dropShadow_4945_15069'
                        result='shape'
                    />
                </filter>
                <linearGradient
                    id='paint0_linear_4945_15069'
                    x1='25'
                    y1='26'
                    x2='25'
                    y2='13.0569'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#3C9FFF' />
                    <stop offset='1' stopColor='#76C0FF' />
                </linearGradient>
            </defs>
        </svg>
    )
}

export const IconNote = () => {
    return (
        <svg
            width='46'
            height='50'
            viewBox='0 0 46 50'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g filter='url(#filter0_d_4945_15118)'>
                <path
                    d='M29.0522 0H16.9478C12.6144 0 10 2.66993 10 7.24493V22.74C10 27.39 12.5567 30 16.9478 30H29.0522C33.5156 30 36 27.39 36 22.74V7.24493C36 2.66993 33.5156 0 29.0522 0Z'
                    fill='url(#paint0_linear_4945_15118)'
                />
                <path
                    d='M16.2547 22.425C16.1406 22.2362 16.0801 22.0179 16.0801 21.795C16.0801 21.5721 16.1406 21.3538 16.2547 21.165C16.3684 20.9777 16.5298 20.8267 16.721 20.7288C16.9122 20.6308 17.1257 20.5897 17.338 20.61H28.6625C28.9412 20.6427 29.1985 20.7808 29.3853 20.998C29.5721 21.2152 29.6754 21.4962 29.6754 21.7875C29.6754 22.0787 29.5721 22.3597 29.3853 22.5769C29.1985 22.7941 28.9412 22.9323 28.6625 22.965H17.2225C17.03 22.9697 16.8396 22.9224 16.6699 22.8278C16.5003 22.7331 16.3572 22.5943 16.2547 22.425ZM17.338 16.11C17.0392 16.11 16.7526 15.9868 16.5413 15.7673C16.3301 15.5479 16.2114 15.2503 16.2114 14.94C16.2114 14.6297 16.3301 14.3321 16.5413 14.1127C16.7526 13.8933 17.0392 13.77 17.338 13.77H28.6625C28.9613 13.77 29.2479 13.8933 29.4592 14.1127C29.6705 14.3321 29.7892 14.6297 29.7892 14.94C29.7892 15.2503 29.6705 15.5479 29.4592 15.7673C29.2479 15.9868 28.9613 16.11 28.6625 16.11H17.338ZM17.338 9.32999C17.0392 9.34192 16.7481 9.23014 16.5287 9.01917C16.3093 8.80819 16.1795 8.51529 16.168 8.20499C16.1565 7.89468 16.2642 7.59239 16.4674 7.36453C16.6705 7.13668 16.9525 7.00192 17.2514 6.98999H21.6569C21.9571 6.99394 22.2436 7.12057 22.4545 7.34238C22.6654 7.56418 22.7836 7.86326 22.7836 8.17496C22.7836 8.48526 22.6649 8.7829 22.4536 9.00232C22.2423 9.22174 21.9557 9.345 21.6569 9.345L17.338 9.32999Z'
                    fill='#EDF7FF'
                />
            </g>
            <defs>
                <filter
                    id='filter0_d_4945_15118'
                    x='0'
                    y='0'
                    width='46'
                    height='50'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dy='10' />
                    <feGaussianBlur stdDeviation='5' />
                    <feComposite in2='hardAlpha' operator='out' />
                    <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.305882 0 0 0 0 0.67451 0 0 0 0 0.976471 0 0 0 0.2 0'
                    />
                    <feBlend
                        mode='normal'
                        in2='BackgroundImageFix'
                        result='effect1_dropShadow_4945_15118'
                    />
                    <feBlend
                        mode='normal'
                        in='SourceGraphic'
                        in2='effect1_dropShadow_4945_15118'
                        result='shape'
                    />
                </filter>
                <linearGradient
                    id='paint0_linear_4945_15118'
                    x1='23'
                    y1='30'
                    x2='23'
                    y2='0'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#3C9FFF' />
                    <stop offset='1' stopColor='#76C0FF' />
                </linearGradient>
            </defs>
        </svg>
    )
}

export const IconManCancel = () => {
    return (
        <svg
            width='26'
            height='32'
            viewBox='0 0 26 32'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M11.704 1.49761C8.30979 1.49761 5.55257 4.25284 5.55257 7.65863C5.55257 11.0644 8.30979 13.8196 11.704 13.8196C15.0981 13.8196 17.8554 11.0644 17.8554 7.65863C17.8554 4.25284 15.0981 1.49761 11.704 1.49761ZM4.0498 7.65863C4.0498 3.43203 7.47354 0 11.704 0C15.9344 0 19.3581 3.43203 19.3581 7.65863C19.3581 11.8852 15.9344 15.3173 11.704 15.3173C7.47354 15.3173 4.0498 11.8852 4.0498 7.65863Z'
                fill='#200E32'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M14.7418 20.6918C12.6773 20.5079 10.6006 20.5079 8.53613 20.6918L8.51826 20.6932C7.41796 20.7649 6.32409 20.9147 5.24495 21.1413C5.22263 21.146 5.20011 21.1497 5.17746 21.1523C4.48832 21.2328 3.82262 21.453 3.22094 21.7997C2.64085 22.1339 2.13197 22.5788 1.7232 23.1092C1.57645 23.4375 1.50318 23.7945 1.50899 24.155C1.50931 24.1746 1.50886 24.1941 1.50763 24.2136C1.48467 24.5806 1.54311 24.9477 1.67827 25.2887C2.07865 25.8314 2.58877 26.2836 3.17547 26.6156C3.78576 26.961 4.4642 27.1681 5.16287 27.2224C5.20057 27.2253 5.23799 27.231 5.27481 27.2396C6.34032 27.4868 7.42446 27.6452 8.51604 27.7131C8.54616 27.715 8.57614 27.7186 8.60582 27.7241C8.94226 27.7861 9.28435 27.8111 9.62619 27.7988C9.6486 27.798 9.67104 27.7982 9.69343 27.7994C11.3778 27.8892 13.0663 27.8655 14.7475 27.7286L14.7581 27.7277L14.7581 27.7278C15.8567 27.6538 16.948 27.495 18.0223 27.253L18.0426 27.2487C18.7913 27.1016 19.5684 26.8964 20.2232 26.5758C20.8783 26.2551 21.3436 25.8525 21.5772 25.3442L21.5838 25.3302C21.7529 24.9814 21.8409 24.5985 21.8409 24.2105C21.8409 23.8224 21.7529 23.4395 21.5838 23.0907L21.5822 23.0873C21.3495 22.6013 20.88 22.1945 20.2166 21.8617C19.5579 21.5312 18.7777 21.309 18.036 21.1564L18.026 21.1543L18.026 21.1543C16.9508 20.9177 15.8591 20.7636 14.7606 20.6933L14.7418 20.6918ZM14.8663 19.1993C12.7188 19.0086 10.5587 19.0086 8.41123 19.1994C7.25386 19.2752 6.1032 19.4322 4.96779 19.669C4.0873 19.7766 3.23748 20.0603 2.46882 20.5031C1.69009 20.9518 1.01094 21.5543 0.472838 22.2741C0.443963 22.3127 0.418894 22.354 0.39798 22.3974C0.134717 22.944 0.000772055 23.5436 0.00606072 24.1497C-0.0280196 24.7672 0.08196 25.3844 0.327621 25.9524C0.348466 26.0006 0.374339 26.0465 0.404812 26.0893C0.939055 26.8398 1.63144 27.464 2.43338 27.9179C3.21849 28.3622 4.08979 28.6325 4.98815 28.7107C6.10306 28.9663 7.23677 29.1316 8.37825 29.205C8.79655 29.2788 9.22127 29.3095 9.64587 29.2966C11.3852 29.3878 13.1287 29.3628 14.8647 29.2216C16.0356 29.1425 17.1986 28.9734 18.3435 28.716C19.1377 28.5595 20.0603 28.3242 20.8858 27.92C21.7124 27.5154 22.5087 26.9082 22.9402 25.9749C23.2058 25.4245 23.3437 24.8214 23.3437 24.2105C23.3437 23.5975 23.2049 22.9924 22.9376 22.4406C22.5057 21.5398 21.7123 20.9354 20.8924 20.524C20.069 20.1109 19.1473 19.8562 18.345 19.6908C17.1996 19.439 16.0366 19.2747 14.8663 19.1993Z'
                fill='#200E32'
            />
            <mask
                id='path-3-outside-1_4945_15151'
                maskUnits='userSpaceOnUse'
                x='12.9014'
                y='18.8461'
                width='9'
                height='9'
                fill='black'
            >
                <rect
                    fill='white'
                    x='12.9014'
                    y='18.8461'
                    width='9'
                    height='9'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M16.1079 21.0542C15.8319 20.7767 15.3844 20.7767 15.1084 21.0542C14.8324 21.3317 14.8324 21.7816 15.1084 22.0591L16.1885 23.145L15.1084 24.2309C14.8324 24.5084 14.8324 24.9583 15.1084 25.2358C15.3844 25.5133 15.8319 25.5133 16.1079 25.2358L17.188 24.1499L18.2747 25.2424C18.5508 25.5199 18.9983 25.5199 19.2743 25.2424C19.5503 24.9649 19.5503 24.515 19.2743 24.2375L18.1876 23.145L19.2677 22.0591C19.5437 21.7816 19.5437 21.3317 19.2677 21.0542C18.9917 20.7767 18.5442 20.7767 18.2681 21.0542L17.188 22.1401L16.1079 21.0542Z'
                />
            </mask>
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M16.1079 21.0542C15.8319 20.7767 15.3844 20.7767 15.1084 21.0542C14.8324 21.3317 14.8324 21.7816 15.1084 22.0591L16.1885 23.145L15.1084 24.2309C14.8324 24.5084 14.8324 24.9583 15.1084 25.2358C15.3844 25.5133 15.8319 25.5133 16.1079 25.2358L17.188 24.1499L18.2747 25.2424C18.5508 25.5199 18.9983 25.5199 19.2743 25.2424C19.5503 24.9649 19.5503 24.515 19.2743 24.2375L18.1876 23.145L19.2677 22.0591C19.5437 21.7816 19.5437 21.3317 19.2677 21.0542C18.9917 20.7767 18.5442 20.7767 18.2681 21.0542L17.188 22.1401L16.1079 21.0542Z'
                fill='#200E32'
            />
            <path
                d='M15.1084 21.0542L16.5264 22.4646L16.5264 22.4646L15.1084 21.0542ZM16.1079 21.0542L14.6899 22.4646L14.6899 22.4646L16.1079 21.0542ZM15.1084 22.0591L16.5264 20.6486L15.1084 22.0591ZM16.1885 23.145L17.6065 24.5554C18.3825 23.7752 18.3825 22.5147 17.6065 21.7345L16.1885 23.145ZM15.1084 24.2309L13.6904 22.8204L13.6904 22.8204L15.1084 24.2309ZM15.1084 25.2358L13.6904 26.6462H13.6904L15.1084 25.2358ZM16.1079 25.2358L17.5259 26.6462L17.5259 26.6462L16.1079 25.2358ZM17.188 24.1499L18.606 22.7394C18.2306 22.362 17.7203 22.1499 17.188 22.1499C16.6557 22.1499 16.1454 22.362 15.77 22.7394L17.188 24.1499ZM18.2747 25.2424L19.6927 23.832V23.832L18.2747 25.2424ZM19.2743 24.2375L20.6922 22.8271V22.8271L19.2743 24.2375ZM18.1876 23.145L16.7696 21.7345C15.9935 22.5147 15.9935 23.7752 16.7696 24.5554L18.1876 23.145ZM19.2677 22.0591L20.6856 23.4695L19.2677 22.0591ZM19.2677 21.0542L20.6857 19.6438L20.6857 19.6438L19.2677 21.0542ZM18.2681 21.0542L19.6861 22.4646V22.4646L18.2681 21.0542ZM17.188 22.1401L15.77 23.5505C16.1454 23.9279 16.6557 24.1401 17.188 24.1401C17.7203 24.1401 18.2306 23.9279 18.606 23.5505L17.188 22.1401ZM16.5264 22.4646C16.0205 22.9732 15.1958 22.9732 14.6899 22.4646L17.5259 19.6438C16.468 18.5802 14.7483 18.5802 13.6904 19.6438L16.5264 22.4646ZM16.5264 20.6486C17.0264 21.1513 17.0264 21.9619 16.5264 22.4646L13.6904 19.6438C12.6384 20.7014 12.6384 22.4119 13.6904 23.4695L16.5264 20.6486ZM17.6065 21.7345L16.5264 20.6486L13.6904 23.4695L14.7705 24.5554L17.6065 21.7345ZM16.5264 25.6413L17.6065 24.5554L14.7705 21.7345L13.6904 22.8204L16.5264 25.6413ZM16.5264 23.8253C17.0264 24.328 17.0264 25.1386 16.5264 25.6413L13.6904 22.8204C12.6384 23.8781 12.6384 25.5885 13.6904 26.6462L16.5264 23.8253ZM14.6899 23.8253C15.1958 23.3167 16.0205 23.3167 16.5264 23.8253L13.6904 26.6462C14.7483 27.7098 16.468 27.7098 17.5259 26.6462L14.6899 23.8253ZM15.77 22.7394L14.6899 23.8253L17.5259 26.6462L18.606 25.5603L15.77 22.7394ZM19.6927 23.832L18.606 22.7394L15.77 25.5603L16.8568 26.6528L19.6927 23.832ZM17.8563 23.832C18.3622 23.3234 19.1868 23.3234 19.6927 23.832L16.8568 26.6528C17.9147 27.7164 19.6344 27.7164 20.6923 26.6528L17.8563 23.832ZM17.8563 25.6479C17.3563 25.1453 17.3563 24.3347 17.8563 23.832L20.6923 26.6528C21.7443 25.5951 21.7443 23.8847 20.6922 22.8271L17.8563 25.6479ZM16.7696 24.5554L17.8563 25.6479L20.6922 22.8271L19.6055 21.7345L16.7696 24.5554ZM17.8497 20.6486L16.7696 21.7345L19.6055 24.5554L20.6856 23.4695L17.8497 20.6486ZM17.8497 22.4646C17.3497 21.9619 17.3497 21.1513 17.8497 20.6486L20.6856 23.4695C21.7377 22.4119 21.7377 20.7014 20.6857 19.6438L17.8497 22.4646ZM19.6861 22.4646C19.1802 22.9732 18.3556 22.9732 17.8497 22.4646L20.6857 19.6438C19.6278 18.5802 17.9081 18.5802 16.8502 19.6438L19.6861 22.4646ZM18.606 23.5505L19.6861 22.4646L16.8502 19.6438L15.77 20.7297L18.606 23.5505ZM14.6899 22.4646L15.77 23.5505L18.606 20.7297L17.5259 19.6438L14.6899 22.4646Z'
                fill='#F6F6F6'
                mask='url(#path-3-outside-1_4945_15151)'
            />
            <path
                d='M14.3351 15.3032C12.9187 15.3032 11.6393 15.8224 10.7222 16.8078C9.81658 17.7808 9.38281 19.0787 9.38281 20.4425V25.8674C9.38281 27.2178 9.80948 28.5131 10.7114 29.4877C11.6266 30.4767 12.9079 31 14.3351 31H20.0476C21.4639 31 22.7429 30.481 23.6598 29.4971C24.5653 28.5255 24.9999 27.2293 24.9999 25.8674V20.4491C24.9999 19.0929 24.5792 17.7921 23.6747 16.8131C22.7564 15.8193 21.4723 15.3032 20.0476 15.3032H14.3351ZM12.7964 20.4425C12.7964 19.7978 12.9953 19.381 13.2183 19.1414C13.4297 18.9142 13.7734 18.7244 14.3351 18.7244H20.0476C20.6273 18.7244 20.9664 18.9172 21.1701 19.1377C21.3876 19.3731 21.5864 19.7903 21.5864 20.4491V25.8674C21.5864 26.5074 21.3883 26.9225 21.1652 27.1618C20.9536 27.3889 20.6095 27.5789 20.0476 27.5789H14.3351C13.7645 27.5789 13.4227 27.3866 13.2142 27.1613C12.9925 26.9217 12.7964 26.5056 12.7964 25.8674V20.4425Z'
                fill='#200E32'
                stroke='#F6F6F6'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}

export const IconLogOut = () => {
    return (
        <svg
            width='30'
            height='30'
            viewBox='0 0 30 30'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M18.9583 8.05496V6.65997C18.9583 5.93311 18.8189 5.21335 18.5481 4.54181C18.2772 3.87027 17.8803 3.26016 17.3798 2.74619C16.8794 2.23221 16.2852 1.82445 15.6313 1.5463C14.9774 1.26814 14.2766 1.12497 13.5688 1.12497H6.45589C5.0277 1.12893 3.65908 1.71333 2.64919 2.75049C1.6393 3.78765 1.07026 5.19322 1.06641 6.65997V23.355C1.07027 24.8204 1.63978 26.2244 2.65008 27.2592C3.66039 28.2939 5.02904 28.875 6.45589 28.875H13.5835C14.2886 28.8769 14.9872 28.736 15.6392 28.4602C16.2913 28.1845 16.8839 27.7793 17.3832 27.2679C17.8825 26.7566 18.2786 26.149 18.5489 25.4801C18.8192 24.8112 18.9583 24.0942 18.9583 23.37V21.96'
                stroke='#200E32'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M28.9047 15H11.3779'
                stroke='#200E32'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M24.625 10.62L28.9044 14.985L24.625 19.365'
                stroke='#200E32'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}

export const IconCalendarOutline = () => {
    return (
        <svg
            width='30'
            height='30'
            viewBox='0 0 30 30'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <rect
                x='0.7'
                y='4.7'
                width='28.6'
                height='24.6'
                rx='6.3'
                stroke='#0D1444'
                strokeWidth='1.4'
            />
            <rect
                x='16.7'
                y='16.7'
                width='12.6'
                height='12.6'
                rx='6.3'
                stroke='#0D1444'
                strokeWidth='1.4'
            />
            <path
                d='M23.5131 22.6073C22.6746 22.2572 22.125 22.0025 22.125 21.6667C22.125 21.1765 22.6297 20.7778 23.25 20.7778C23.8703 20.7778 24.375 21.1765 24.375 21.6667C24.375 21.9121 24.6268 22.1111 24.9375 22.1111C25.2482 22.1111 25.5 21.9121 25.5 21.6667C25.5 20.8398 24.7819 20.143 23.8125 19.9452V19.4444C23.8125 19.199 23.5607 19 23.25 19C22.9393 19 22.6875 19.199 22.6875 19.4444V19.9452C21.7181 20.143 21 20.8398 21 21.6667C21 22.5632 22.0558 23.0041 22.9874 23.3932C23.8256 23.7433 24.375 23.9978 24.375 24.3333C24.375 24.8235 23.8703 25.2222 23.25 25.2222C22.6297 25.2222 22.125 24.8235 22.125 24.3333C22.125 24.0879 21.8732 23.8889 21.5625 23.8889C21.2518 23.8889 21 24.0879 21 24.3333C21 25.1602 21.7181 25.857 22.6875 26.0548V26.5556C22.6875 26.801 22.9393 27 23.25 27C23.5607 27 23.8125 26.801 23.8125 26.5556V26.0548C24.7819 25.857 25.5 25.1602 25.5 24.3333C25.5 23.4372 24.4444 22.9963 23.5131 22.6073Z'
                fill='#0D1444'
            />
            <rect
                x='5.59316'
                y='10.3026'
                width='3.7934'
                height='3.55671'
                rx='1.4'
                stroke='#0D1444'
                strokeWidth='1.2'
            />
            <path
                d='M5.09316 2.08109C5.09316 1.64827 5.46294 1.28921 5.92943 1.28921C6.39591 1.28921 6.76569 1.64827 6.76569 2.08109V6.24321C6.76569 6.67603 6.39591 7.03509 5.92943 7.03509C5.46294 7.03509 5.09316 6.67603 5.09316 6.24321V2.08109Z'
                fill='#0D1444'
                stroke='#F6F6F6'
                strokeWidth='0.2'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M8.11434 2.08106V6.24318C8.11434 7.39252 7.13626 8.32424 5.92973 8.32424C4.7232 8.32424 3.74512 7.39251 3.74512 6.24318V2.08106C3.74512 0.931722 4.7232 0 5.92973 0C7.13626 0 8.11434 0.931722 8.11434 2.08106ZM5.92973 1.18918C5.41265 1.18918 4.99347 1.58849 4.99347 2.08106V6.24318C4.99347 6.73575 5.41265 7.13506 5.92973 7.13506C6.44681 7.13506 6.86599 6.73575 6.86599 6.24318V2.08106C6.86599 1.58849 6.44681 1.18918 5.92973 1.18918Z'
                fill='#F6F6F6'
            />
            <path
                d='M23.1938 2.08109C23.1938 1.64827 23.5635 1.28921 24.03 1.28921C24.4965 1.28921 24.8663 1.64827 24.8663 2.08109V6.24321C24.8663 6.67603 24.4965 7.03509 24.03 7.03509C23.5635 7.03509 23.1938 6.67603 23.1938 6.24321V2.08109Z'
                fill='#0D1444'
                stroke='#F6F6F6'
                strokeWidth='0.2'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M26.2149 2.08106V6.24318C26.2149 7.39252 25.2368 8.32424 24.0303 8.32424C22.8238 8.32424 21.8457 7.39251 21.8457 6.24318V2.08106C21.8457 0.931722 22.8238 0 24.0303 0C25.2368 0 26.2149 0.931722 26.2149 2.08106ZM24.0303 1.18918C23.5132 1.18918 23.0941 1.58849 23.0941 2.08106V6.24318C23.0941 6.73575 23.5132 7.13506 24.0303 7.13506C24.5474 7.13506 24.9666 6.73575 24.9666 6.24318V2.08106C24.9666 1.58849 24.5474 1.18918 24.0303 1.18918Z'
                fill='#F6F6F6'
            />
            <path
                d='M14.4555 2.08109C14.4555 1.64827 14.8252 1.28921 15.2917 1.28921C15.7582 1.28921 16.128 1.64827 16.128 2.08109V6.24321C16.128 6.67603 15.7582 7.03509 15.2917 7.03509C14.8252 7.03509 14.4555 6.67603 14.4555 6.24321V2.08109Z'
                fill='#0D1444'
                stroke='#F6F6F6'
                strokeWidth='0.2'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M17.4766 2.08106V6.24318C17.4766 7.39252 16.4986 8.32424 15.292 8.32424C14.0855 8.32424 13.1074 7.39251 13.1074 6.24318V2.08106C13.1074 0.931722 14.0855 0 15.292 0C16.4986 0 17.4766 0.931722 17.4766 2.08106ZM15.292 1.18918C14.775 1.18918 14.3558 1.58849 14.3558 2.08106V6.24318C14.3558 6.73575 14.775 7.13506 15.292 7.13506C15.8091 7.13506 16.2283 6.73575 16.2283 6.24318V2.08106C16.2283 1.58849 15.8091 1.18918 15.292 1.18918Z'
                fill='#F6F6F6'
            />
            <rect
                x='5.59316'
                y='19.6269'
                width='3.7934'
                height='3.55671'
                rx='1.4'
                stroke='#0D1444'
                strokeWidth='1.2'
            />
            <rect
                x='13.0834'
                y='10.3026'
                width='3.7934'
                height='3.55671'
                rx='1.4'
                stroke='#0D1444'
                strokeWidth='1.2'
            />
            <rect
                x='20.5736'
                y='10.3026'
                width='3.7934'
                height='3.55671'
                rx='1.4'
                stroke='#0D1444'
                strokeWidth='1.2'
            />
        </svg>
    )
}

export const IconWalletOutline = ({
    width = '30',
    height = '30'
}: SVGProps) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox='0 0 30 30'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g clipPath='url(#clip0_4945_13255)'>
                <path
                    d='M28.6364 15.1258V10.9094C28.6364 9.47963 27.5274 8.31687 26.1263 8.20412L22.2106 1.36474C21.8477 0.732193 21.2617 0.280091 20.5606 0.0923594C19.8628 -0.0940935 19.1331 0.00383102 18.5085 0.367341L5.08528 8.18213H2.72774C1.22365 8.18213 0.000488281 9.40523 0.000488281 10.9094V27.2727C0.000488281 28.7768 1.22359 30 2.72774 30H25.9092C27.4133 30 28.6364 28.7769 28.6364 27.2727V23.0563C29.4283 22.7739 30 22.0242 30 21.1365V17.0456C30 16.1579 29.4283 15.4082 28.6364 15.1258ZM24.5418 8.18213H18.5991L23.0562 5.58726L24.5418 8.18213ZM22.3787 4.40392L15.889 8.18213H13.1972L21.7056 3.22837L22.3787 4.40392ZM19.195 1.54582C19.5033 1.36538 19.8634 1.31744 20.2077 1.40935C20.5559 1.50255 20.8463 1.72761 21.0267 2.04254L21.0281 2.04503L10.4872 8.18213H7.79546L19.195 1.54582ZM27.2728 27.2727C27.2728 28.0244 26.6609 28.6363 25.9092 28.6363H2.72774C1.97605 28.6363 1.36414 28.0244 1.36414 27.2727V10.9094C1.36414 10.1577 1.97605 9.54578 2.72774 9.54578H25.9092C26.6609 9.54578 27.2728 10.1577 27.2728 10.9094V15.0002H23.1819C20.9261 15.0002 19.0911 16.8352 19.0911 19.0911C19.0911 21.3469 20.9261 23.1819 23.1819 23.1819H27.2728V27.2727ZM28.6364 21.1365C28.6364 21.5126 28.3309 21.8183 27.9546 21.8183H23.1819C21.6779 21.8183 20.4547 20.5952 20.4547 19.0911C20.4547 17.587 21.6778 16.3638 23.1819 16.3638H27.9546C28.3308 16.3638 28.6364 16.6694 28.6364 17.0456V21.1365Z'
                    fill='#0D1444'
                />
                <path
                    d='M23.182 17.7274C22.4303 17.7274 21.8184 18.3393 21.8184 19.091C21.8184 19.8427 22.4303 20.4546 23.182 20.4546C23.9336 20.4546 24.5455 19.8427 24.5455 19.091C24.5456 18.3393 23.9337 17.7274 23.182 17.7274Z'
                    fill='#0D1444'
                />
            </g>
            <defs>
                <clipPath id='clip0_4945_13255'>
                    <rect width='30' height='30' fill='white' />
                </clipPath>
            </defs>
        </svg>
    )
}

export const IconNoteOutline = () => {
    return (
        <svg
            width='30'
            height='30'
            viewBox='0 0 30 30'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M20.9836 21.42H9.08252'
                stroke='#0D1444'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M20.9836 15.1129H9.08252'
                stroke='#0D1444'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M13.6155 8.82092H9.08252'
                stroke='#0D1444'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M21.2969 1.12897H8.62108C6.77001 1.04248 4.9563 1.62619 3.57371 2.75349C2.19112 3.88079 1.35123 5.46068 1.23645 7.15004C1.21189 7.44565 1.21189 7.74249 1.23645 8.0381V21.8866C1.08118 23.5789 1.66739 25.2583 2.86639 26.5564C4.06539 27.8545 5.77927 28.6652 7.63206 28.8108C7.97777 28.8333 8.32482 28.8333 8.67053 28.8108H21.4453C22.3621 28.8575 23.28 28.7389 24.1465 28.4616C25.0131 28.1842 25.8113 27.7537 26.4955 27.1945C27.1798 26.6354 27.7367 25.9585 28.1344 25.2027C28.5321 24.4469 28.7628 23.627 28.8134 22.7897C28.8381 22.4941 28.8381 22.1973 28.8134 21.9017V8.05316C28.9687 6.36088 28.3825 4.68148 27.1835 3.38338C25.9845 2.08527 24.2706 1.27452 22.4178 1.12897C22.0447 1.10268 21.67 1.10268 21.2969 1.12897V1.12897Z'
                stroke='#0D1444'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}

export const IconGraph = ({ color }: SVGProps) => {
    return (
        <svg
            width='20'
            height='16'
            viewBox='0 0 20 16'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <rect
                y='8'
                width='2'
                height='8'
                rx='1'
                fill={`${color ?? 'white'}`}
            />
            <rect
                x='6'
                y='4'
                width='2'
                height='12'
                rx='1'
                fill={`${color ?? 'white'}`}
            />
            <rect
                x='12'
                width='2'
                height='16'
                rx='1'
                fill={`${color ?? 'white'}`}
            />
            <rect
                x='18'
                y='6'
                width='2'
                height='10'
                rx='1'
                fill={`${color ?? 'white'}`}
            />
        </svg>
    )
}

export const IconCogWheel = () => {
    return (
        <svg
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g clipPath='url(#clip0_4945_27601)'>
                <path
                    d='M18.953 5.88516L18.3101 4.84318C18.1802 4.63342 18.0071 4.44955 17.8007 4.30207C17.5944 4.1546 17.3588 4.0464 17.1075 3.98368C16.8562 3.92096 16.5941 3.90492 16.3361 3.93651C16.0781 3.96811 15.8294 4.04672 15.6041 4.16781V4.16781C15.1521 4.41226 14.615 4.48149 14.1087 4.36055C13.6024 4.2396 13.1675 3.9382 12.898 3.52143V3.52143C12.7227 3.25757 12.6294 2.95364 12.6284 2.64344V2.64344C12.6395 2.39935 12.5986 2.15565 12.5081 1.92633C12.4176 1.697 12.2792 1.48661 12.1009 1.30726C11.9226 1.12791 11.708 0.983115 11.4693 0.88128C11.2307 0.779444 10.9727 0.722556 10.7103 0.713867H9.34177C8.81931 0.713867 8.31824 0.907017 7.94881 1.25079C7.57938 1.59456 7.37184 2.06082 7.37184 2.54698C7.36638 3.03236 7.15531 3.49611 6.78452 3.83752C6.41373 4.17894 5.91317 4.37047 5.39154 4.37044C5.05633 4.36942 4.72732 4.28623 4.43766 4.12924V4.12924C4.2127 4.00686 3.96388 3.92722 3.70562 3.89494C3.44736 3.86266 3.18479 3.87835 2.93311 3.94116C2.68142 4.00398 2.44562 4.11265 2.23938 4.26085C2.03314 4.40906 1.86056 4.59384 1.73161 4.80455L1.04731 5.86585C0.916031 6.07444 0.830607 6.30522 0.796053 6.5448C0.7615 6.78438 0.778511 7.02796 0.846046 7.26138C0.913581 7.4948 1.03029 7.71342 1.18944 7.90447C1.34859 8.09553 1.54698 8.2552 1.77306 8.37426V8.37426C2.07263 8.53857 2.32102 8.77267 2.49374 9.05351C2.66646 9.33435 2.75755 9.65226 2.75804 9.97584C2.75964 10.2998 2.66942 10.6184 2.49649 10.8996C2.32357 11.1808 2.07404 11.4145 1.77306 11.5774V11.5774C1.54749 11.6956 1.34935 11.8543 1.19008 12.0443C1.0308 12.2342 0.913545 12.4516 0.845097 12.6839C0.776648 12.9163 0.758381 13.159 0.791307 13.3979C0.824233 13.6369 0.907708 13.8674 1.03693 14.0762V14.0762L1.69013 15.1278C1.94579 15.5551 2.37269 15.871 2.8777 16.0066C3.38272 16.1421 3.92486 16.0863 4.38583 15.8514V15.8514C4.8371 15.6095 5.3729 15.5438 5.87611 15.6685C6.37933 15.7933 6.80901 16.0983 7.07116 16.5171V16.5171C7.23986 16.7866 7.32926 17.0927 7.33036 17.4046V17.4046C7.3331 17.8943 7.54405 18.3629 7.91707 18.7083C8.2901 19.0536 8.79484 19.2474 9.32101 19.2474H10.617C11.1404 19.2474 11.6426 19.0546 12.0137 18.7111C12.3848 18.3676 12.5946 17.9013 12.5973 17.4143V17.4143C12.5946 17.1732 12.6432 16.9341 12.7405 16.7106C12.8377 16.4871 12.9816 16.2838 13.1639 16.1125C13.3461 15.9411 13.5631 15.805 13.8022 15.7122C14.0413 15.6194 14.2978 15.5716 14.5569 15.5716V15.5716C14.8911 15.5793 15.2183 15.662 15.5107 15.8128V15.8128C15.7357 15.9352 15.9845 16.0148 16.2428 16.0471C16.501 16.0794 16.7636 16.0636 17.0153 16.0008C17.267 15.938 17.5028 15.8293 17.709 15.6811C17.9153 15.5329 18.0879 15.3481 18.2168 15.1374V15.1374L18.9011 14.0762C19.0314 13.8678 19.1163 13.6376 19.1509 13.3987C19.1855 13.1598 19.169 12.9168 19.1026 12.6838C19.0361 12.4508 18.9209 12.2323 18.7636 12.0408C18.6063 11.8493 18.4099 11.6885 18.1857 11.5677V11.5677C17.7322 11.327 17.4 10.9286 17.2619 10.4601C17.1239 9.99152 17.1914 9.4912 17.4496 9.06894V9.06894C17.6223 8.78753 17.8729 8.55432 18.1753 8.39358V8.39358C18.6278 8.1494 18.9581 7.74854 19.094 7.27858C19.23 6.80861 19.1607 6.30772 18.9011 5.88516H18.953Z'
                    stroke='white'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M10.0057 12.5421C11.5174 12.5421 12.7429 11.4017 12.7429 9.99503C12.7429 8.58834 11.5174 7.448 10.0057 7.448C8.49403 7.448 7.26855 8.58834 7.26855 9.99503C7.26855 11.4017 8.49403 12.5421 10.0057 12.5421Z'
                    stroke='white'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </g>
            <defs>
                <clipPath id='clip0_4945_27601'>
                    <rect width='20' height='20' fill='white' />
                </clipPath>
            </defs>
        </svg>
    )
}

export const IconDollar = ({ color, width, height }: SVGProps) => {
    return (
        <svg
            width={width ?? '21'}
            height={height ?? '38'}
            viewBox='0 0 21 38'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M20.945 25.8C20.945 27.1067 20.5983 28.3067 19.905 29.4C19.2383 30.4667 18.2117 31.3467 16.825 32.04C15.4383 32.7333 13.7183 33.12 11.665 33.2V37.8H10.185V33.2C8.23833 33.12 6.39833 32.7333 4.665 32.04C2.95833 31.3467 1.625 30.4667 0.665 29.4L1.585 27.88C2.51833 28.84 3.75833 29.6533 5.305 30.32C6.85167 30.96 8.47833 31.32 10.185 31.4V19.8C8.345 19.3467 6.825 18.8667 5.625 18.36C4.425 17.8533 3.425 17.1067 2.625 16.12C1.825 15.1333 1.425 13.84 1.425 12.24C1.425 10.24 2.15833 8.54667 3.625 7.16C5.11833 5.77333 7.305 5 10.185 4.84V0.199998H11.665V4.8C13.185 4.85333 14.6517 5.10667 16.065 5.56C17.505 5.98667 18.745 6.57333 19.785 7.32L19.025 8.96C17.9317 8.21333 16.745 7.65333 15.465 7.28C14.185 6.88 12.9183 6.65333 11.665 6.6V18.2C13.6917 18.7067 15.3183 19.2 16.545 19.68C17.7717 20.16 18.8117 20.8933 19.665 21.88C20.5183 22.84 20.945 24.1467 20.945 25.8ZM3.465 12.2C3.465 13.8267 4.03833 15.04 5.185 15.84C6.33167 16.6133 7.99833 17.28 10.185 17.84V6.64C7.97167 6.8 6.29167 7.4 5.145 8.44C4.025 9.45333 3.465 10.7067 3.465 12.2ZM11.665 31.4C14.065 31.2933 15.865 30.7333 17.065 29.72C18.2917 28.7067 18.905 27.44 18.905 25.92C18.905 24.7467 18.585 23.8 17.945 23.08C17.305 22.3333 16.4917 21.76 15.505 21.36C14.5183 20.96 13.2383 20.56 11.665 20.16V31.4Z'
                fill={color ?? 'white'}
                fillOpacity='0.8'
            />
        </svg>
    )
}

export const IconRightChevron = ({ color }: SVGProps) => {
    return (
        <svg
            width='6'
            height='10'
            viewBox='0 0 6 10'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M1 0.999999L5 5L1 9'
                stroke={color ?? '#767676'}
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}

export const IconDownChevron = ({ color, width, height }: SVGProps) => {
    return (
        <svg
            width={width ?? '10'}
            height={height ?? '6'}
            viewBox='0 0 10 6'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M9 1L5 5L1 1'
                stroke={color ?? '#767676'}
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}

export const IconHamburgerLinesWhite = () => {
    return (
        <svg
            width='12'
            height='12'
            viewBox='0 0 14 14'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <rect
                x='4.13672'
                width='9.86399'
                height='1.68837'
                rx='0.844186'
                fill='white'
            />
            <rect width='2.33342' height='1.68837' rx='0.844186' fill='white' />
            <rect
                x='4.13672'
                y='6.15601'
                width='9.86399'
                height='1.68837'
                rx='0.844186'
                fill='white'
            />
            <rect
                y='6.15601'
                width='2.33342'
                height='1.68837'
                rx='0.844186'
                fill='white'
            />
            <rect
                x='4.13672'
                y='12.3118'
                width='9.86399'
                height='1.68837'
                rx='0.844186'
                fill='white'
            />
            <rect
                y='12.3118'
                width='2.33342'
                height='1.68837'
                rx='0.844186'
                fill='white'
            />
        </svg>
    )
}

export const IconCalendarLinesWhite = ({
    width = '14',
    height = '14',
    color = 'white'
}: SVGProps) => {
    return (
        <svg
            width={width.toString()}
            height={height.toString()}
            viewBox='0 0 14 14'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g clipPath='url(#clip0_7074_24636)'>
                <path
                    d='M3.97215 13.9931C3.4402 14.0334 2.90485 13.9689 2.40349 13.8039C1.90213 13.6389 1.44683 13.3776 1.06935 13.038C0.691866 12.6984 0.401307 12.2888 0.21794 11.8378C0.0345731 11.3868 -0.0371821 10.9052 0.00768541 10.4266V4.5455C-0.0354122 4.10133 0.0246046 3.65395 0.183921 3.23175C0.343238 2.80956 0.598385 2.42178 0.933156 2.093C1.26793 1.76422 1.67502 1.50163 2.12859 1.32191C2.58217 1.14219 3.0723 1.04925 3.56792 1.049V0.496525C3.5679 0.367901 3.62417 0.244453 3.72454 0.15285C3.82491 0.0612475 3.96133 0.00888612 4.10429 0.00704864C4.23521 0.00604297 4.36204 0.0481616 4.46084 0.125448C4.55964 0.202735 4.62359 0.309835 4.64066 0.426612V1.042H9.33584V0.496525C9.32553 0.368553 9.37216 0.242129 9.46546 0.145082C9.55876 0.0480352 9.6911 -0.0116774 9.83335 -0.0209507C9.9756 -0.030224 10.1161 0.011724 10.224 0.0956563C10.3319 0.179589 10.3983 0.29864 10.4086 0.426612V1.049C10.9035 1.05022 11.3928 1.14389 11.8455 1.32404C12.2981 1.50419 12.7043 1.76689 13.0382 2.09556C13.3721 2.42423 13.6266 2.81166 13.7854 3.23338C13.9443 3.65509 14.0041 4.10192 13.9611 4.5455V10.4826C13.9868 10.9551 13.9057 11.4275 13.7227 11.871C13.5396 12.3145 13.2584 12.72 12.8961 13.0629C12.1046 13.7062 11.0619 14.0407 9.99659 13.9931H3.97215ZM1.08043 10.4266C1.00164 11.0432 1.19806 11.6627 1.62655 12.1491C2.05503 12.6355 2.68057 12.9491 3.36583 13.021C3.56726 13.042 3.77072 13.042 3.97215 13.021H10.0354C11.8933 13.021 12.9194 12.1259 12.9194 10.4826V5.81119H1.08043V10.4266ZM12.9194 4.83224V4.5525C12.9465 4.21503 12.8971 3.87607 12.7742 3.55631C12.6513 3.23654 12.4574 2.94262 12.2042 2.69234C11.7264 2.28907 11.1022 2.05554 10.4474 2.03504V2.65043C10.4485 2.71379 10.4356 2.77668 10.4096 2.83558C10.3836 2.89448 10.3449 2.94822 10.2958 2.99367C10.2468 3.03913 10.1882 3.07537 10.1235 3.10046C10.0588 3.12556 9.98929 3.13899 9.91885 3.1399C9.78494 3.14408 9.65427 3.10231 9.55326 3.02312C9.45224 2.94393 9.38841 2.83324 9.37469 2.71334V2.01404H4.67176V2.64343C4.67176 2.7714 4.61526 2.89414 4.51467 2.98462C4.41408 3.07511 4.27764 3.1259 4.13539 3.1259C4.00401 3.12846 3.87627 3.08687 3.77711 3.00929C3.67794 2.93172 3.61445 2.82374 3.59902 2.70634V2.00704C2.93239 2.01074 2.29458 2.25206 1.82539 2.67808C1.3562 3.1041 1.09389 3.68006 1.09596 4.27977C1.09596 4.36368 1.09596 4.44059 1.09596 4.5245V4.80424L12.9194 4.83224ZM9.65455 10.4266C9.65343 10.3089 9.70023 10.1947 9.78614 10.1058C9.87205 10.017 9.99115 9.95944 10.121 9.94408H10.1987C10.2702 9.94678 10.3404 9.96211 10.4052 9.98924C10.4701 10.0164 10.5284 10.0548 10.5768 10.1022C10.6251 10.1496 10.6627 10.2051 10.6872 10.2656C10.7116 10.326 10.7226 10.3903 10.7195 10.4546C10.7157 10.5666 10.6686 10.6741 10.5863 10.7583C10.504 10.8425 10.3917 10.8983 10.2687 10.9161H10.1987C10.1231 10.9164 10.0484 10.9025 9.9791 10.8753C9.90985 10.8481 9.84763 10.8083 9.79644 10.7583C9.74525 10.7083 9.70622 10.6492 9.68179 10.5849C9.65736 10.5206 9.64808 10.4524 9.65455 10.3846V10.4266ZM6.46743 10.4266C6.46631 10.3089 6.51313 10.1947 6.59904 10.1058C6.68495 10.017 6.80403 9.95944 6.93384 9.94408H7.01158C7.08306 9.94678 7.15323 9.96211 7.21811 9.98924C7.28299 10.0164 7.3413 10.0548 7.38967 10.1022C7.43805 10.1496 7.47554 10.2051 7.50003 10.2656C7.52452 10.326 7.53552 10.3903 7.53239 10.4546C7.52855 10.5666 7.48146 10.6741 7.39919 10.7583C7.31691 10.8425 7.20459 10.8983 7.08154 10.9161H7.0038C6.86011 10.9143 6.72286 10.8622 6.62125 10.7707C6.51963 10.6793 6.46166 10.5559 6.45965 10.4266H6.46743ZM3.28031 10.4266C3.27919 10.3089 3.32601 10.1947 3.41192 10.1058C3.49783 10.017 3.61691 9.95944 3.74672 9.94408H3.82446C3.96744 9.95132 4.10148 10.009 4.19752 10.1046C4.29356 10.2001 4.34387 10.3259 4.33751 10.4546C4.33401 10.5656 4.28802 10.6722 4.20729 10.7563C4.12657 10.8404 4.01605 10.8968 3.89442 10.9161H3.81668C3.67435 10.9125 3.53906 10.8596 3.43911 10.7684C3.33915 10.6771 3.28225 10.5547 3.28031 10.4266ZM9.65455 7.89518C9.65508 7.77781 9.70245 7.66449 9.78806 7.57592C9.87368 7.48735 9.99183 7.42938 10.121 7.41262H10.1987C10.3278 7.42324 10.4484 7.47498 10.5389 7.5585C10.6293 7.64203 10.6837 7.75183 10.6921 7.8682C10.7006 7.98458 10.6625 8.09988 10.5849 8.19327C10.5073 8.28666 10.3951 8.35204 10.2687 8.37766H10.1987C10.1238 8.37783 10.0498 8.36412 9.98107 8.33736C9.91238 8.31061 9.85057 8.27135 9.7995 8.22212C9.74843 8.1729 9.70919 8.11471 9.68425 8.05122C9.65931 7.98774 9.64921 7.92034 9.65455 7.85318V7.89518ZM6.46743 7.89518C6.46795 7.77781 6.51535 7.66449 6.60096 7.57592C6.68658 7.48735 6.80471 7.42938 6.93384 7.41262H7.01158C7.08271 7.41441 7.15271 7.42893 7.21754 7.4553C7.28237 7.48167 7.34073 7.51941 7.3892 7.56627C7.43767 7.61313 7.47531 7.66814 7.49989 7.72821C7.52447 7.78827 7.53551 7.85215 7.53239 7.91609C7.52886 8.02899 7.48205 8.13733 7.39987 8.22272C7.3177 8.30811 7.20524 8.36534 7.08154 8.38466H7.0038C6.93234 8.38466 6.86158 8.37195 6.79556 8.34735C6.72954 8.32275 6.66957 8.2867 6.61904 8.24124C6.56851 8.19579 6.52841 8.14186 6.50107 8.08247C6.47372 8.02308 6.45965 7.95946 6.45965 7.89518H6.46743ZM3.28031 7.89518C3.28083 7.77781 3.32823 7.66449 3.41384 7.57592C3.49945 7.48735 3.61758 7.42938 3.74672 7.41262H3.82446C3.95355 7.42324 4.07418 7.47498 4.16464 7.5585C4.2551 7.64203 4.30945 7.75183 4.31789 7.8682C4.32633 7.98458 4.2883 8.09988 4.21066 8.19327C4.13303 8.28666 4.02088 8.35204 3.89442 8.37766H3.81668C3.74558 8.37766 3.67519 8.36495 3.6096 8.34027C3.54401 8.31558 3.48455 8.27945 3.43465 8.2339C3.38474 8.18835 3.34537 8.13431 3.31888 8.07496C3.29239 8.0156 3.27927 7.95213 3.28031 7.88818V7.89518Z'
                    fill={color}
                />
            </g>
            <defs>
                <clipPath id='clip0_7074_24636'>
                    <rect width='14' height='14' fill={color} />
                </clipPath>
            </defs>
        </svg>
    )
}

export const IconWallet2 = () => {
    return (
        <svg
            width='40'
            height='40'
            viewBox='0 0 40 40'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M5 5.00171H25C26.385 5.00171 27.5 6.11659 27.5 7.5016V10.0016H5C3.615 10.0016 2.5 8.88661 2.5 7.5016C2.5 6.11659 3.615 5.00171 5 5.00171Z'
                fill='#BBDFFF'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M2.50391 7.51172V32.5511C2.50391 33.9383 3.62066 35.055 5.00784 35.055H32.5511C33.9383 35.055 35.0551 33.9383 35.0551 32.5511V12.5196C35.0551 11.1324 33.9383 10.0157 32.5511 10.0157H5.00784C3.62066 10.0157 2.50391 8.89891 2.50391 7.51172Z'
                fill='url(#paint0_linear_7190_24065)'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M30 17.5015H35C36.385 17.5015 37.5 18.6165 37.5 20.0015V25.0014C37.5 26.3864 36.385 27.5015 35 27.5015H30C28.615 27.5015 27.5 26.3864 27.5 25.0014V20.0015C27.5 18.6165 28.615 17.5015 30 17.5015Z'
                fill='#BBDFFF'
            />
            <defs>
                <linearGradient
                    id='paint0_linear_7190_24065'
                    x1='18.7795'
                    y1='35.055'
                    x2='18.7795'
                    y2='7.51172'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#3C9FFF' />
                    <stop offset='1' stopColor='#76C0FF' />
                </linearGradient>
            </defs>
        </svg>
    )
}

export const IconUpArrow = ({ color }: SVGProps) => {
    return (
        <svg
            width='10'
            height='10'
            viewBox='0 0 10 10'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M5 2L5.6585 1.24742L5 0.671232L4.3415 1.24742L5 2ZM4 8.99999C4 9.55227 4.44771 9.99999 5 9.99999C5.55228 9.99999 6 9.55227 6 8.99999L4 8.99999ZM9.6585 4.74742L5.6585 1.24742L4.3415 2.75258L8.3415 6.25257L9.6585 4.74742ZM4.3415 1.24742L0.341495 4.74742L1.6585 6.25257L5.6585 2.75258L4.3415 1.24742ZM4 2L4 8.99999L6 8.99999L6 2L4 2Z'
                fill={`${color ?? '#27AE60'}`}
            />
        </svg>
    )
}

export const IconDownArrow = ({ color }: SVGProps) => {
    return (
        <svg
            width='10'
            height='10'
            viewBox='0 0 10 10'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M5 8L4.3415 8.75258L5 9.32877L5.6585 8.75258L5 8ZM6 1.00001C6 0.447726 5.55228 1.04914e-05 5 1.04913e-05C4.44772 1.04912e-05 4 0.447726 4 1.00001L6 1.00001ZM0.341496 5.25258L4.3415 8.75258L5.6585 7.24742L1.6585 3.74743L0.341496 5.25258ZM5.6585 8.75258L9.6585 5.25258L8.3415 3.74743L4.3415 7.24742L5.6585 8.75258ZM6 8L6 1.00001L4 1.00001L4 8L6 8Z'
                fill={`${color ?? '#EB5757'}`}
            />
        </svg>
    )
}

export const IconChartBlue = () => {
    return (
        <svg
            width='60'
            height='54'
            viewBox='0 0 60 54'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g filter='url(#filter0_d_5983_25466)'>
                <g filter='url(#filter1_i_5983_25466)'>
                    <path
                        d='M19.377 32.5913V9.86197C19.377 9.07292 18.937 8.45312 18.377 8.45312H14.377C13.8169 8.45312 13.377 9.07292 13.377 9.86197V32.5913H19.377Z'
                        fill='url(#paint0_linear_5983_25466)'
                    />
                </g>
                <g opacity='0.5' filter='url(#filter2_i_5983_25466)'>
                    <path
                        d='M28.5078 32.5911V18.3148C28.5078 17.5258 28.0679 16.906 27.5078 16.906H23.5078C22.9477 16.906 22.5078 17.5258 22.5078 18.3148V32.5911H28.5078Z'
                        fill='url(#paint1_linear_5983_25466)'
                    />
                </g>
                <g filter='url(#filter3_i_5983_25466)'>
                    <path
                        d='M37.6367 32.5913V9.86197C37.6367 9.07292 37.1968 8.45312 36.6367 8.45312H32.6367C32.0767 8.45312 31.6367 9.07292 31.6367 9.86197V32.5913H37.6367Z'
                        fill='url(#paint2_linear_5983_25466)'
                    />
                </g>
                <g opacity='0.8' filter='url(#filter4_i_5983_25466)'>
                    <path
                        d='M46.7676 32.5912V1.40884C46.7676 0.619796 46.3276 0 45.7676 0H41.7676C41.2075 0 40.7676 0.619796 40.7676 1.40884V32.5912H46.7676Z'
                        fill='url(#paint3_linear_5983_25466)'
                    />
                </g>
                <g filter='url(#filter5_i_5983_25466)'>
                    <path
                        d='M48.8281 31.1821H11.1719C10.5155 31.1821 10 31.8019 10 32.591C10 33.3798 10.5155 33.9998 11.1719 33.9998H48.8281C49.4845 33.9998 50 33.3798 50 32.591C50 31.8019 49.4845 31.1821 48.8281 31.1821Z'
                        fill='url(#paint4_linear_5983_25466)'
                    />
                </g>
            </g>
            <defs>
                <filter
                    id='filter0_d_5983_25466'
                    x='0'
                    y='0'
                    width='60'
                    height='53.9998'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dy='10' />
                    <feGaussianBlur stdDeviation='5' />
                    <feComposite in2='hardAlpha' operator='out' />
                    <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.305882 0 0 0 0 0.67451 0 0 0 0 0.976471 0 0 0 0.2 0'
                    />
                    <feBlend
                        mode='normal'
                        in2='BackgroundImageFix'
                        result='effect1_dropShadow_5983_25466'
                    />
                    <feBlend
                        mode='normal'
                        in='SourceGraphic'
                        in2='effect1_dropShadow_5983_25466'
                        result='shape'
                    />
                </filter>
                <filter
                    id='filter1_i_5983_25466'
                    x='13.377'
                    y='8.45312'
                    width='6'
                    height='26.1382'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feBlend
                        mode='normal'
                        in='SourceGraphic'
                        in2='BackgroundImageFix'
                        result='shape'
                    />
                    <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dy='2' />
                    <feGaussianBlur stdDeviation='2' />
                    <feComposite
                        in2='hardAlpha'
                        operator='arithmetic'
                        k2='-1'
                        k3='1'
                    />
                    <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.279167 0 0 0 0 0.655653 0 0 0 0 1 0 0 0 1 0'
                    />
                    <feBlend
                        mode='normal'
                        in2='shape'
                        result='effect1_innerShadow_5983_25466'
                    />
                </filter>
                <filter
                    id='filter2_i_5983_25466'
                    x='22.5078'
                    y='16.906'
                    width='6'
                    height='17.6851'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feBlend
                        mode='normal'
                        in='SourceGraphic'
                        in2='BackgroundImageFix'
                        result='shape'
                    />
                    <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dy='2' />
                    <feGaussianBlur stdDeviation='2' />
                    <feComposite
                        in2='hardAlpha'
                        operator='arithmetic'
                        k2='-1'
                        k3='1'
                    />
                    <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.279167 0 0 0 0 0.655653 0 0 0 0 1 0 0 0 1 0'
                    />
                    <feBlend
                        mode='normal'
                        in2='shape'
                        result='effect1_innerShadow_5983_25466'
                    />
                </filter>
                <filter
                    id='filter3_i_5983_25466'
                    x='31.6367'
                    y='8.45312'
                    width='6'
                    height='26.1382'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feBlend
                        mode='normal'
                        in='SourceGraphic'
                        in2='BackgroundImageFix'
                        result='shape'
                    />
                    <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dy='2' />
                    <feGaussianBlur stdDeviation='2' />
                    <feComposite
                        in2='hardAlpha'
                        operator='arithmetic'
                        k2='-1'
                        k3='1'
                    />
                    <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.279167 0 0 0 0 0.655653 0 0 0 0 1 0 0 0 1 0'
                    />
                    <feBlend
                        mode='normal'
                        in2='shape'
                        result='effect1_innerShadow_5983_25466'
                    />
                </filter>
                <filter
                    id='filter4_i_5983_25466'
                    x='40.7676'
                    y='0'
                    width='6'
                    height='34.5911'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feBlend
                        mode='normal'
                        in='SourceGraphic'
                        in2='BackgroundImageFix'
                        result='shape'
                    />
                    <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dy='2' />
                    <feGaussianBlur stdDeviation='2' />
                    <feComposite
                        in2='hardAlpha'
                        operator='arithmetic'
                        k2='-1'
                        k3='1'
                    />
                    <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.279167 0 0 0 0 0.655653 0 0 0 0 1 0 0 0 1 0'
                    />
                    <feBlend
                        mode='normal'
                        in2='shape'
                        result='effect1_innerShadow_5983_25466'
                    />
                </filter>
                <filter
                    id='filter5_i_5983_25466'
                    x='10'
                    y='31.1821'
                    width='40'
                    height='4.81763'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feBlend
                        mode='normal'
                        in='SourceGraphic'
                        in2='BackgroundImageFix'
                        result='shape'
                    />
                    <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dy='2' />
                    <feGaussianBlur stdDeviation='2' />
                    <feComposite
                        in2='hardAlpha'
                        operator='arithmetic'
                        k2='-1'
                        k3='1'
                    />
                    <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.279167 0 0 0 0 0.655653 0 0 0 0 1 0 0 0 1 0'
                    />
                    <feBlend
                        mode='normal'
                        in2='shape'
                        result='effect1_innerShadow_5983_25466'
                    />
                </filter>
                <linearGradient
                    id='paint0_linear_5983_25466'
                    x1='13.2491'
                    y1='-16.1677'
                    x2='20.3127'
                    y2='-16.0857'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#93CFFF' />
                    <stop offset='1' stopColor='#2894FF' />
                </linearGradient>
                <linearGradient
                    id='paint1_linear_5983_25466'
                    x1='22.3799'
                    y1='0.907236'
                    x2='29.4423'
                    y2='1.03344'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#93CFFF' />
                    <stop offset='1' stopColor='#2894FF' />
                </linearGradient>
                <linearGradient
                    id='paint2_linear_5983_25466'
                    x1='31.5088'
                    y1='-16.1677'
                    x2='38.5725'
                    y2='-16.0857'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#93CFFF' />
                    <stop offset='1' stopColor='#2894FF' />
                </linearGradient>
                <linearGradient
                    id='paint3_linear_5983_25466'
                    x1='40.6397'
                    y1='-33.243'
                    x2='47.7038'
                    y2='-33.1822'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#93CFFF' />
                    <stop offset='1' stopColor='#2894FF' />
                </linearGradient>
                <linearGradient
                    id='paint4_linear_5983_25466'
                    x1='9.14746'
                    y1='28.3081'
                    x2='41.8582'
                    y2='50.0014'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#E8F5FF' />
                    <stop offset='1' stopColor='white' />
                </linearGradient>
            </defs>
        </svg>
    )
}

export const IconCogWheelBlue = () => {
    return (
        <svg
            width='50'
            height='50'
            viewBox='0 0 50 50'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g filter='url(#filter0_d_7190_23748)'>
                <path
                    d='M39.1211 12.3633H37.0049C36.694 10.9515 36.1315 9.59561 35.3513 8.37744L36.8081 6.92068C37.1513 6.5775 37.1511 6.02068 36.8081 5.67773L34.3223 3.19189C33.9791 2.84865 33.4226 2.84865 33.0793 3.19189L31.6226 4.64865C30.4043 3.86848 29.0485 3.30598 27.6367 2.99502V0.878906C27.6367 0.393516 27.2432 0 26.7578 0H23.2422C22.7568 0 22.3633 0.393516 22.3633 0.878906V2.99502C20.9515 3.30598 19.5957 3.86848 18.3775 4.64859L16.9207 3.19184C16.5776 2.84859 16.021 2.84859 15.6778 3.19184L13.1919 5.67773C12.8487 6.02092 12.8489 6.57773 13.1919 6.92068L14.6487 8.37744C13.8685 9.59561 13.306 10.9515 12.9951 12.3633H10.8789C10.3935 12.3633 10 12.7568 10 13.2422V16.7578C10 17.2432 10.3935 17.6367 10.8789 17.6367H12.9951C13.306 19.0484 13.8685 20.4042 14.6487 21.6225L13.1919 23.0791C12.8487 23.4223 12.8489 23.9791 13.1919 24.3221L15.6777 26.8081C16.0209 27.1513 16.5777 27.1512 16.9207 26.8081L18.3774 25.3513C19.5955 26.1315 20.9515 26.694 22.3632 27.0049V29.1211C22.3632 29.6065 22.7567 30 23.2421 30H26.7578C27.2431 30 27.6367 29.6065 27.6367 29.1211V27.0049C29.0484 26.694 30.4043 26.1315 31.6224 25.3513L33.0792 26.8081C33.4223 27.1513 33.9791 27.1511 34.3221 26.8081L36.808 24.3221C37.1513 23.979 37.1511 23.4221 36.808 23.0792L35.3513 21.6226C36.1314 20.4043 36.6939 19.0484 37.0049 17.6368H39.1211C39.6065 17.6368 40 17.2433 40 16.7579V13.2422C40 12.7568 39.6065 12.3633 39.1211 12.3633Z'
                    fill='url(#paint0_linear_7190_23748)'
                />
                <path
                    d='M25.0023 5.58984C19.8123 5.58984 15.5898 9.81229 15.5898 15.0023C15.5898 20.1924 19.8123 24.4148 25.0023 24.4148C30.1924 24.4148 34.4148 20.1924 34.4148 15.0023C34.4148 9.81229 30.1924 5.58984 25.0023 5.58984Z'
                    fill='#EDF7FF'
                />
                <path
                    d='M26.6667 12.662C26.6667 11.7456 25.919 11 25 11C24.081 11 23.3333 11.7456 23.3333 12.662C23.3333 13.5785 24.081 14.3241 25 14.3241C25.919 14.3241 26.6667 13.5785 26.6667 12.662ZM25 14.3241C23.3458 14.3241 22 15.6662 22 17.3158V17.6273C22 17.7218 22.0403 17.8118 22.1109 17.8749C22.9228 18.6004 23.9489 19 25 19C26.0511 19 27.0772 18.6004 27.8891 17.8749C27.9597 17.8118 28 17.7218 28 17.6273V17.3158C28 15.6662 26.6542 14.3241 25 14.3241Z'
                    fill='url(#paint1_linear_7190_23748)'
                />
            </g>
            <defs>
                <filter
                    id='filter0_d_7190_23748'
                    x='0'
                    y='0'
                    width='50'
                    height='50'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dy='10' />
                    <feGaussianBlur stdDeviation='5' />
                    <feComposite in2='hardAlpha' operator='out' />
                    <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.305882 0 0 0 0 0.67451 0 0 0 0 0.976471 0 0 0 0.2 0'
                    />
                    <feBlend
                        mode='normal'
                        in2='BackgroundImageFix'
                        result='effect1_dropShadow_7190_23748'
                    />
                    <feBlend
                        mode='normal'
                        in='SourceGraphic'
                        in2='effect1_dropShadow_7190_23748'
                        result='shape'
                    />
                </filter>
                <linearGradient
                    id='paint0_linear_7190_23748'
                    x1='25'
                    y1='30'
                    x2='25'
                    y2='0'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#3C9FFF' />
                    <stop offset='1' stopColor='#76C0FF' />
                </linearGradient>
                <linearGradient
                    id='paint1_linear_7190_23748'
                    x1='25'
                    y1='19'
                    x2='25'
                    y2='11'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#3C9FFF' />
                    <stop offset='1' stopColor='#76C0FF' />
                </linearGradient>
            </defs>
        </svg>
    )
}

export const IconHeartHole = () => {
    return (
        <svg
            fill='none'
            version='1.1'
            viewBox='0 0 50 50'
            id='svg56'
            xmlns='http://www.w3.org/2000/svg'
            width={'50px'}
        >
            <g filter='url(#filter0_d_5720_25483)' id='g4'>
                <path
                    d='m25.013 29.947 0.0818 0.0526-0.0904-0.0472zm-0.3098-0.1991 0.3098 0.1991 0.3679-0.2306c0.887-0.5835 1.7581-1.1922 2.6121-1.8251-1.2329-1.2619-1.9928-2.9881-1.9928-4.8917 0-3.866 3.134-7 7-7 1.8673 0 3.5639 0.7312 4.819 1.9228 0.6503-1.1498 1.1908-2.3684 1.6112-3.6386 0.8308-2.7097 0.7511-5.6345-0.2259-8.2904-0.4983-1.2979-1.2639-2.4654-2.2424-3.4196-0.9785-0.95426-2.1459-1.6719-3.4196-2.1022-0.9033-0.3133-1.849-0.47268-2.8008-0.47197-2.0749 0.0090054-4.0899 0.7273-5.7373 2.0451-0.1249-0.09303-0.2557-0.17713-0.3915-0.25171-0.078-0.0401-0.1493-0.09324-0.2109-0.15733l-0.4366-0.2989-0.5723-0.25171c-0.3022-0.17349-0.6199-0.31573-0.9486-0.42473l-0.1355-0.094385h-0.0904c-0.8892-0.31338-1.8177-0.48833-2.7557-0.51917h-0.1656c-0.4233 1.065e-4 -0.846 0.031693-1.265 0.094433h-0.1807c-0.4561 0.063344-0.9051 0.174-1.3402 0.33035-1.283 0.43609-2.459 1.1607-3.445 2.1229-0.9861 0.96216-1.7582 2.1385-2.2621 3.4461-0.9942 2.6531-1.0688 5.586-0.2108 8.2905 0.9535 2.8347 2.4963 5.4136 4.5175 7.5511 2.9178 2.9741 6.1338 5.6113 9.5922 7.8658z'
                    clipRule='evenodd'
                    fill='url(#paint0_linear_5720_25483)'
                    fillRule='evenodd'
                    id='path2'
                />
            </g>
            <defs id='defs50'>
                <filter
                    id='filter0_d_5720_25483'
                    x='0'
                    y='0'
                    width='50'
                    height='50'
                    colorInterpolationFilters='sRGB'
                    filterUnits='userSpaceOnUse'
                >
                    <feFlood
                        floodOpacity='0'
                        result='BackgroundImageFix'
                        id='feFlood6'
                    />
                    <feColorMatrix
                        in='SourceAlpha'
                        result='hardAlpha'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        id='feColorMatrix8'
                    />
                    <feOffset dy='10' id='feOffset10' />
                    <feGaussianBlur stdDeviation='5' id='feGaussianBlur12' />
                    <feComposite
                        in2='hardAlpha'
                        operator='out'
                        id='feComposite14'
                    />
                    <feColorMatrix
                        values='0 0 0 0 0.305882 0 0 0 0 0.67451 0 0 0 0 0.976471 0 0 0 0.2 0'
                        id='feColorMatrix16'
                    />
                    <feBlend
                        in2='BackgroundImageFix'
                        result='effect1_dropShadow_5720_25483'
                        id='feBlend18'
                    />
                    <feBlend
                        in='SourceGraphic'
                        in2='effect1_dropShadow_5720_25483'
                        result='shape'
                        id='feBlend20'
                    />
                </filter>
                <linearGradient
                    id='paint0_linear_5720_25483'
                    x1='25'
                    x2='25'
                    y1='30'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#3C9FFF' offset='0' id='stop23' />
                    <stop stopColor='#76C0FF' offset='1' id='stop25' />
                </linearGradient>
                <filter
                    id='filter0_i_5720_25484'
                    x='0'
                    y='0'
                    width='8'
                    height='10'
                    colorInterpolationFilters='sRGB'
                    filterUnits='userSpaceOnUse'
                >
                    <feFlood
                        floodOpacity='0'
                        result='BackgroundImageFix'
                        id='feFlood28'
                    />
                    <feBlend
                        in='SourceGraphic'
                        in2='BackgroundImageFix'
                        result='shape'
                        id='feBlend30'
                    />
                    <feColorMatrix
                        in='SourceAlpha'
                        result='hardAlpha'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        id='feColorMatrix32'
                    />
                    <feOffset dy='2' id='feOffset34' />
                    <feGaussianBlur stdDeviation='2' id='feGaussianBlur36' />
                    <feComposite
                        in2='hardAlpha'
                        k2='-1'
                        k3='1'
                        operator='arithmetic'
                        id='feComposite38'
                    />
                    <feColorMatrix
                        values='0 0 0 0 0.279167 0 0 0 0 0.655653 0 0 0 0 1 0 0 0 1 0'
                        id='feColorMatrix40'
                    />
                    <feBlend
                        in2='shape'
                        result='effect1_innerShadow_5720_25484'
                        id='feBlend42'
                    />
                </filter>
                <linearGradient
                    id='paint0_linear_5720_25484'
                    x1='4'
                    x2='4'
                    y1='8'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#3C9FFF' offset='0' id='stop45' />
                    <stop stopColor='#76C0FF' offset='1' id='stop47' />
                </linearGradient>
            </defs>
            <g transform='translate(28.809 18.668)' fill='none' id='g54'>
                <path
                    d='m4 8c0.79112 0 1.5645-0.2346 2.2223-0.67412 0.65779-0.43953 1.1705-1.0642 1.4732-1.7952 0.30275-0.7309 0.38196-1.5352 0.22762-2.3111s-0.53531-1.4887-1.0947-2.0481c-0.55941-0.55941-1.2721-0.94037-2.0481-1.0947-0.77592-0.15434-1.5802-0.075128-2.3111 0.22762-0.73091 0.30275-1.3556 0.81544-1.7951 1.4732-0.43952 0.6578-0.67412 1.4312-0.67412 2.2223 0.0015987 1.0604 0.42354 2.0769 1.1733 2.8267 0.7498 0.7498 1.7663 1.1717 2.8267 1.1733zm-0.44445-5.3333c0-0.11788 0.04683-0.23092 0.13018-0.31427s0.19639-0.13018 0.31427-0.13018c0.11787 0 0.23092 0.04683 0.31427 0.13018s0.13017 0.19639 0.13017 0.31427v1.1467l0.81334 0.81334c0.08312 0.0838 0.12966 0.19713 0.12942 0.31517-2.4e-4 0.11805-0.04724 0.23118-0.13071 0.31465s-0.19661 0.13047-0.31465 0.13071-0.23137-0.0463-0.31517-0.12942l-0.94223-0.94222c-0.08154-0.08496-0.12763-0.19781-0.12889-0.31556z'
                    fill='url(#paint0_linear_5720_25484)'
                    filter='url(#filter0_i_5720_25484)'
                    id='path52'
                />
            </g>
        </svg>
    )
}

export const IconPlayButtonClock = () => {
    return (
        <svg
            width='50'
            height='50'
            viewBox='0 0 50 50'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g filter='url(#filter0_d_5720_25464)'>
                <g filter='url(#filter1_d_5720_25464)'>
                    <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M39.3265 19.4579C39.7642 18.0496 40 16.5523 40 15C40 6.71573 33.2843 0 25 0C16.7157 0 10 6.71573 10 15C10 23.2843 16.7157 30 25 30C26.5523 30 28.0496 29.7642 29.4579 29.3265C27.9537 28.0425 27 26.1326 27 24C27 20.134 30.134 17 34 17C36.1326 17 38.0425 17.9537 39.3265 19.4579Z'
                        fill='url(#paint0_linear_5720_25464)'
                    />
                </g>
                <g filter='url(#filter2_i_5720_25464)'>
                    <path
                        d='M34 28C34.7911 28 35.5645 27.7654 36.2223 27.3259C36.8801 26.8864 37.3928 26.2616 37.6955 25.5307C37.9983 24.7998 38.0775 23.9956 37.9231 23.2196C37.7688 22.4437 37.3878 21.731 36.8284 21.1716C36.269 20.6122 35.5563 20.2312 34.7804 20.0769C34.0044 19.9225 33.2002 20.0017 32.4693 20.3045C31.7384 20.6072 31.1136 21.1199 30.6741 21.7777C30.2346 22.4355 30 23.2089 30 24C30.0016 25.0604 30.4235 26.0769 31.1733 26.8267C31.9231 27.5765 32.9396 27.9984 34 28ZM33.5556 22.6667C33.5556 22.5488 33.6024 22.4357 33.6857 22.3524C33.7691 22.269 33.8821 22.2222 34 22.2222C34.1179 22.2222 34.2309 22.269 34.3143 22.3524C34.3976 22.4357 34.4444 22.5488 34.4444 22.6667V23.8133L35.2578 24.6267C35.3409 24.7105 35.3874 24.8238 35.3872 24.9418C35.387 25.0599 35.34 25.173 35.2565 25.2565C35.173 25.34 35.0599 25.387 34.9418 25.3872C34.8238 25.3874 34.7105 25.3409 34.6267 25.2578L33.6844 24.3156C33.6029 24.2306 33.5568 24.1178 33.5556 24V22.6667Z'
                        fill='url(#paint1_linear_5720_25464)'
                    />
                </g>
                <path
                    d='M29.3889 13.9629L23.6664 11.1286C23.5028 11.0456 23.3166 11.0012 23.1265 11C22.8277 11 22.5412 11.1017 22.3299 11.2829C22.1187 11.464 22 11.7096 22 11.9657V18.0487C22 18.2187 22.0532 18.3856 22.1539 18.532C22.2546 18.6784 22.3993 18.7989 22.5728 18.8812C22.7463 18.9634 22.9423 19.0043 23.1405 18.9996C23.3387 18.9949 23.5318 18.9448 23.6997 18.8545L29.4289 15.7515C29.607 15.656 29.7532 15.5225 29.8533 15.364C29.9533 15.2056 30.0038 15.0276 29.9998 14.8475C29.9957 14.6674 29.9374 14.4912 29.830,3 14.3362C29.7232 14.1812 29.5712 14.0526 29.3889 13.9629Z'
                    fill='#EDF7FF'
                />
            </g>
            <defs>
                <filter
                    id='filter0_d_5720_25464'
                    x='0'
                    y='0'
                    width='50'
                    height='50'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dy='10' />
                    <feGaussianBlur stdDeviation='5' />
                    <feComposite in2='hardAlpha' operator='out' />
                    <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.305882 0 0 0 0 0.67451 0 0 0 0 0.976471 0 0 0 0.2 0'
                    />
                    <feBlend
                        mode='normal'
                        in2='BackgroundImageFix'
                        result='effect1_dropShadow_5720_25464'
                    />
                    <feBlend
                        mode='normal'
                        in='SourceGraphic'
                        in2='effect1_dropShadow_5720_25464'
                        result='shape'
                    />
                </filter>
                <filter
                    id='filter1_d_5720_25464'
                    x='0'
                    y='0'
                    width='50'
                    height='50'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dy='10' />
                    <feGaussianBlur stdDeviation='5' />
                    <feComposite in2='hardAlpha' operator='out' />
                    <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.305882 0 0 0 0 0.67451 0 0 0 0 0.976471 0 0 0 0.2 0'
                    />
                    <feBlend
                        mode='normal'
                        in2='BackgroundImageFix'
                        result='effect1_dropShadow_5720_25464'
                    />
                    <feBlend
                        mode='normal'
                        in='SourceGraphic'
                        in2='effect1_dropShadow_5720_25464'
                        result='shape'
                    />
                </filter>
                <filter
                    id='filter2_i_5720_25464'
                    x='30'
                    y='20'
                    width='8'
                    height='10'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feBlend
                        mode='normal'
                        in='SourceGraphic'
                        in2='BackgroundImageFix'
                        result='shape'
                    />
                    <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dy='2' />
                    <feGaussianBlur stdDeviation='2' />
                    <feComposite
                        in2='hardAlpha'
                        operator='arithmetic'
                        k2='-1'
                        k3='1'
                    />
                    <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.279167 0 0 0 0 0.655653 0 0 0 0 1 0 0 0 1 0'
                    />
                    <feBlend
                        mode='normal'
                        in2='shape'
                        result='effect1_innerShadow_5720_25464'
                    />
                </filter>
                <linearGradient
                    id='paint0_linear_5720_25464'
                    x1='25'
                    y1='30'
                    x2='25'
                    y2='0'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#3C9FFF' />
                    <stop offset='1' stopColor='#76C0FF' />
                </linearGradient>
                <linearGradient
                    id='paint1_linear_5720_25464'
                    x1='34'
                    y1='28'
                    x2='34'
                    y2='20'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#3C9FFF' />
                    <stop offset='1' stopColor='#76C0FF' />
                </linearGradient>
            </defs>
        </svg>
    )
}

export const IconPlayFill = ({ color }: SVGProps) => {
    return (
        <svg
            width='17'
            height='22'
            viewBox='0 0 17 22'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M15.6279 11.8416C16.2409 11.448 16.2409 10.5521 15.6279 10.1586L1.54024 1.11439C0.874703 0.687119 0 1.16501 0 1.9559V20.0442C0 20.8351 0.874702 21.313 1.54024 20.8858L15.6279 11.8416Z'
                fill={color ?? 'white'}
            />
        </svg>
    )
}

export const IconPlayOutline = ({ color }: SVGProps) => {
    return (
        <svg
            width='20'
            height='22'
            viewBox='0 0 20 22'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M0.0110167 3.07005L0.0110167 2.938C0.0218829 2.68024 0.0662688 2.42499 0.143066 2.17869L0.231052 1.92561C0.537231 1.17914 1.12216 0.581278 1.86171 0.25875C2.60126 -0.0637778 3.43727 -0.0856196 4.19264 0.197898L4.37977 0.263922L18.3885 8.26421C18.7472 8.46184 19.0634 8.72829 19.319 9.04831C19.5746 9.36833 19.7646 9.7356 19.8781 10.1291C19.9915 10.5227 20.0263 10.9348 19.9803 11.3418C19.9343 11.7487 19.8084 12.1426 19.6099 12.5009C19.3633 12.949 19.0075 13.3275 18.5756 13.6014L18.3995 13.7004L4.29164 21.7557C3.76377 21.9723 3.18635 22.0386 2.62311 21.9473C2.05986 21.8561 1.53289 21.6107 1.10045 21.2385C0.484374 20.7182 0.0906554 19.9819 -8.38413e-07 19.1806L-1.34196e-07 3.07005L0.0110167 3.07005ZM1.66169 18.9605C1.68444 19.3459 1.85728 19.7069 2.14327 19.9661C2.42926 20.2254 2.80549 20.3622 3.1912 20.3471L3.46631 20.3471L3.57646 20.3471L17.5962 12.3249C17.9336 12.137 18.1831 11.8233 18.2903 11.4523C18.3975 11.0813 18.3537 10.6829 18.1684 10.344C18.0582 10.1498 17.9082 9.98106 17.7282 9.84886L17.5852 9.7608L3.66445 1.80458C3.3054 1.65933 2.90338 1.66233 2.54654 1.81291C2.18969 1.96348 1.90715 2.24933 1.76069 2.60788L1.67257 2.92699L1.67257 19.0155L1.66169 18.9605Z'
                fill={color ?? '#2894FF'}
            />
        </svg>
    )
}

export const IconForward10 = ({ color = '#fff'}: SVGProps) => {
    return (
      <svg
       width='22'
       height='22'
        viewBox="0 0 512 512"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M386.3 160L336 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 51.2L414.4 97.6c-87.5-87.5-229.3-87.5-316.8 0s-87.5 229.3 0 316.8 229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3 163.8-62.5 226.3 0L386.3 160z"
          fill={color}
        />
      </svg>
    )
  }
  export const IconPictureInPicture = ({ color = '#fff' }: SVGProps) => {
    return (
      <svg
        width="28"
        height="28"
        viewBox="0 0 512 512"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="64" y="64" width="384" height="384" rx="48" stroke={color} strokeWidth="32" fill="none"/>
        <rect x="288" y="288" width="144" height="112" rx="16" fill={color}/>
      </svg>
    );
  };
  export const IconFullscreen = ({ color = '#fff' }: SVGProps) => {
    return (
      <svg
        width="28"
        height="28"
        viewBox="0 0 512 512"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M96 192V96h96" stroke={color} strokeWidth="32" strokeLinecap="round" strokeLinejoin="round" />
       
        <path d="M416 192V96h-96" stroke={color} strokeWidth="32" strokeLinecap="round" strokeLinejoin="round" />
       
        <path d="M96 320v96h96" stroke={color} strokeWidth="32" strokeLinecap="round" strokeLinejoin="round" />
       
        <path d="M416 320v96h-96" stroke={color} strokeWidth="32" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    );
  };
  export const IconBackward10 = ({ color = '#fff' }: SVGProps) => {
    return (
      <svg
        width='22'
        height='22'
        viewBox="0 0 512 512"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g transform="scale(-1,1) translate(-512, 0)">
          <path
            d="M386.3 160L336 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 51.2L414.4 97.6c-87.5-87.5-229.3-87.5-316.8 0s-87.5 229.3 0 316.8 229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3 163.8-62.5 226.3 0L386.3 160z"
            fill={color}
          />
        </g>
      </svg>
    );
  };
export const IconPostPlayOutline = ({ color = '#fff' }: SVGProps) => {
    return (
        <svg
            width='26'
            height='29'
            viewBox='0 0 26 29'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M0.0143202 3.99107L0.0143202 3.81941C0.028446 3.48431 0.0861491 3.15249 0.185985 2.8323L0.300369 2.50329C0.698402 1.53288 1.4588 0.755661 2.42022 0.336375C3.38164 -0.0829111 4.46846 -0.111306 5.45044 0.257267L5.6937 0.343098L23.905 10.7435C24.3714 11.0004 24.7824 11.3468 25.1147 11.7628C25.447 12.1788 25.694 12.6563 25.8415 13.1679C25.989 13.6795 26.0342 14.2152 25.9744 14.7443C25.9146 15.2734 25.7509 15.7854 25.4929 16.2512C25.1723 16.8337 24.7098 17.3257 24.1483 17.6818L23.9193 17.8106L5.57914 28.2824C4.8929 28.564 4.14225 28.6502 3.41003 28.5316C2.67782 28.4129 1.99275 28.0939 1.43058 27.61C0.629687 26.9336 0.117852 25.9765 -1.08994e-06 24.9348L-1.74455e-07 3.99107L0.0143202 3.99107ZM2.1602 24.6487C2.18977 25.1496 2.41446 25.619 2.78625 25.956C3.15804 26.293 3.64713 26.4708 4.14855 26.4513L4.5062 26.4513L4.6494 26.4513L22.875 16.0223C23.3137 15.7781 23.638 15.3704 23.7773 14.888C23.9167 14.4057 23.8598 13.8877 23.619 13.4472C23.4757 13.1947 23.2807 12.9754 23.0467 12.8035L22.8607 12.689L4.76378 2.34595C4.29702 2.15713 3.77439 2.16103 3.3105 2.35678C2.8466 2.55252 2.4793 2.92413 2.2889 3.39025L2.17434 3.80509L2.17434 24.7202L2.1602 24.6487Z'
                fill={color}
            />
        </svg>
    )
}

export const IconPauseFill = ({ color }: SVGProps) => {
    return (
        <svg
            width='18'
            height='21'
            viewBox='0 0 18 21'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M0 2.27264C0 1.0175 1.00731 0 2.24988 0H4.49976C5.74233 0 6.74964 1.0175 6.74964 2.27264V18.1811C6.74964 19.4363 5.74233 20.4537 4.49976 20.4537H2.24988C1.00731 20.4537 0 19.4363 0 18.1811V2.27264Z'
                fill={color ?? 'white'}
            />
            <path
                d='M11.25 2.27264C11.25 1.0175 12.2573 0 13.4999 0H15.7498C16.9923 0 17.9996 1.0175 17.9996 2.27264V18.1811C17.9996 19.4363 16.9923 20.4537 15.7498 20.4537H13.4999C12.2573 20.4537 11.25 19.4363 11.25 18.1811V2.27264Z'
                fill={color ?? 'white'}
            />
        </svg>
    )
}

export const IconPostPauseOutline = ({ color = '#fff' }: SVGProps) => {
    return (
        <svg
            width='26'
            height='26'
            viewBox='0 0 26 26'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <rect
                x='1'
                y='1'
                width='7.75'
                height='24'
                rx='3.875'
                stroke={color}
                strokeWidth='2'
            />
            <rect
                x='17.25'
                y='1'
                width='7.75'
                height='24'
                rx='3.875'
                stroke={color}
                strokeWidth='2'
            />
        </svg>
    )
}

export const IconVolumeFill = ({ color }: SVGProps) => {
    return (
        <svg
            width='24'
            height='21'
            viewBox='0 0 24 21'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M11.559 1.09773C12.2205 0.625711 13.1434 1.09416 13.1434 1.90194V19.9164C13.1434 20.7242 12.2205 21.1926 11.559 20.7206L5.47641 16.3802H2C0.89543 16.3802 0 15.4928 0 14.3982V7.42018C0 6.32555 0.895431 5.43818 2 5.43818H5.47641L11.559 1.09773Z'
                fill={color ?? 'white'}
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M15.7061 4.81685C16.1004 4.43363 16.7335 4.43974 17.1202 4.8305C18.6661 6.39261 19.6208 8.54122 19.6208 10.9092C19.6208 13.2672 18.6741 15.4078 17.1396 16.9682C16.7541 17.3602 16.121 17.3683 15.7255 16.9863C15.33 16.6043 15.3218 15.9769 15.7072 15.5849C16.8909 14.3813 17.6208 12.7321 17.6208 10.9092C17.6208 9.07865 16.8848 7.42325 15.6923 6.21827C15.3056 5.82752 15.3118 5.20008 15.7061 4.81685Z'
                fill={color ?? 'white'}
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M18.7664 1.69479C19.1585 1.30934 19.7917 1.31187 20.1807 1.70043C22.54 4.05744 23.9995 7.31475 23.9995 10.9092C23.9995 14.5037 22.54 17.761 20.1807 20.118C19.7917 20.5066 19.1585 20.5091 18.7664 20.1237C18.3744 19.7382 18.3718 19.1108 18.7608 18.7222C20.762 16.723 21.9995 13.9622 21.9995 10.9092C21.9995 7.8563 20.762 5.0955 18.7608 3.09627C18.3718 2.7077 18.3744 2.08024 18.7664 1.69479Z'
                fill={color ?? 'white'}
            />
        </svg>
    )
}

export const IconVolumeMutedFill = () => {
    return (
        <svg
            width='22'
            height='20'
            viewBox='0 0 22 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M21.7682 1.43437C22.1412 1.9248 22.0548 2.63161 21.5753 3.01306L1.77538 18.763C1.29584 19.1444 0.604737 19.0561 0.231762 18.5656C-0.141213 18.0752 -0.0548258 17.3684 0.424714 16.9869L20.2246 1.23703C20.7042 0.855577 21.3953 0.943928 21.7682 1.43437Z'
                fill='white'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M17.1434 0.992758C17.1434 0.184975 16.2205 -0.283469 15.559 0.188549L9.47641 4.529H6C4.89543 4.529 4 5.41637 4 6.511V13.489C4 14.2654 4.45049 14.9376 5.10657 15.2627L17.1434 5.68802V0.992758ZM17.1434 8.53844L8.42815 15.471H9.47641L15.559 19.8114C16.2205 20.2835 17.1434 19.815 17.1434 19.0072V8.53844Z'
                fill='white'
            />
        </svg>
    )
}


export const IconReplayGraphRounded = ({
    color = '#fff',
    width = '16',
    height = '16'
  }: SVGProps) => {
    return (
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Left vertical line with rounded corner */}
        <path
          d="M4 3V20C4 20.5523 4.44772 21 5 21H21"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
  
        {/* Zigzag graph line */}
        <path
          d="M7 15L12 10L15 13L20 8"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  };



export const IconReverseExclamationCircle = () => {
    return (
        <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="12" cy="12" r="11" fill="white" stroke="rgba(0, 0, 0, 0.4)" strokeWidth="2" />
            <text
                x="12"
                y="16"
                textAnchor="middle"
                fontSize="14"
                fontWeight="bold"
                fill="rgba(0, 0, 0, 0.4)"
                fontFamily="Arial, sans-serif"
            >
                ¡
            </text>
        </svg>
    );
};

export const IconSettingsOutline = ({ color = 'white' }: SVGProps) => {
    return (
        <svg
            width='22'
            height='22'
            viewBox='0 0 19 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M18.005 5.88522L17.3943 4.84324C17.2709 4.63348 17.1064 4.44961 16.9104 4.30214C16.7144 4.15466 16.4906 4.04646 16.2518 3.98374C16.0131 3.92102 15.7641 3.90498 15.519 3.93657C15.2739 3.96817 15.0376 4.04678 14.8236 4.16788V4.16788C14.3942 4.41232 13.884 4.48155 13.403 4.36061C12.922 4.23966 12.5089 3.93827 12.2528 3.52149V3.52149C12.0863 3.25763 11.9976 2.95371 11.9967 2.6435V2.6435C12.0073 2.39941 11.9684 2.15571 11.8824 1.92639C11.7964 1.69706 11.6649 1.48667 11.4956 1.30732C11.3262 1.12797 11.1223 0.983176 10.8956 0.881341C10.6688 0.779505 10.4238 0.722617 10.1745 0.713928H8.87438C8.37805 0.713928 7.90204 0.907078 7.55108 1.25085C7.20011 1.59462 7.00296 2.06088 7.00296 2.54704C6.99777 3.03242 6.79725 3.49617 6.445 3.83759C6.09276 4.179 5.61722 4.37053 5.12167 4.3705C4.80322 4.36948 4.49066 4.28629 4.21548 4.12931V4.12931C4.00178 4.00692 3.76539 3.92728 3.52004 3.895C3.2747 3.86272 3.02526 3.87841 2.78616 3.94122C2.54706 4.00404 2.32305 4.11271 2.12712 4.26092C1.93119 4.40912 1.76724 4.5939 1.64474 4.80461L0.994655 5.86591C0.869936 6.0745 0.788783 6.30528 0.755958 6.54486C0.723132 6.78444 0.739293 7.02802 0.803451 7.26144C0.867609 7.49486 0.978487 7.71348 1.12968 7.90453C1.28087 8.09559 1.46934 8.25527 1.68411 8.37433V8.37433C1.9687 8.53863 2.20468 8.77273 2.36876 9.05357C2.53285 9.33441 2.61938 9.65233 2.61984 9.9759C2.62136 10.2999 2.53566 10.6185 2.37138 10.8996C2.2071 11.1808 1.97004 11.4146 1.68411 11.5774V11.5774C1.46983 11.6957 1.28159 11.8544 1.13028 12.0443C0.978967 12.2343 0.867575 12.4517 0.802549 12.684C0.737523 12.9163 0.720169 13.159 0.751449 13.398C0.782729 13.637 0.862029 13.8675 0.984795 14.0762V14.0762L1.60533 15.1278C1.8482 15.5552 2.25376 15.8711 2.73353 16.0066C3.21329 16.1422 3.72832 16.0864 4.16625 15.8514V15.8514C4.59495 15.6096 5.10396 15.5438 5.58202 15.6686C6.06007 15.7933 6.46827 16.0984 6.71731 16.5171V16.5171C6.87757 16.7867 6.9625 17.0928 6.96355 17.4047V17.4047C6.96615 17.8943 7.16655 18.363 7.52093 18.7083C7.8753 19.0536 8.35481 19.2475 8.85467 19.2475H10.0859C10.5831 19.2475 11.0602 19.0546 11.4127 18.7111C11.7652 18.3676 11.9646 17.9014 11.9672 17.4144V17.4144C11.9646 17.1733 12.0108 16.9341 12.1032 16.7107C12.1956 16.4872 12.3323 16.2839 12.5054 16.1125C12.6785 15.9411 12.8846 15.8051 13.1118 15.7123C13.3389 15.6194 13.5826 15.5716 13.8288 15.5716V15.5716C14.1463 15.5793 14.4571 15.6621 14.7349 15.8128V15.8128C14.9486 15.9352 15.185 16.0149 15.4304 16.0471C15.6757 16.0794 15.9251 16.0637 16.1642 16.0009C16.4033 15.9381 16.6273 15.8294 16.8233 15.6812C17.0192 15.533 17.1832 15.3482 17.3057 15.1375V15.1375L17.9558 14.0762C18.0796 13.8679 18.1602 13.6377 18.1931 13.3988C18.2259 13.1598 18.2103 12.9169 18.1472 12.6839C18.084 12.4509 17.9746 12.2324 17.8251 12.0409C17.6757 11.8493 17.4891 11.6886 17.2761 11.5678V11.5678C16.8453 11.3271 16.5297 10.9287 16.3985 10.4601C16.2674 9.99158 16.3315 9.49126 16.5768 9.069V9.069C16.7409 8.78759 16.979 8.55438 17.2663 8.39364V8.39364C17.6961 8.14946 18.0099 7.74861 18.139 7.27864C18.2682 6.80867 18.2023 6.30778 17.9558 5.88522H18.005Z'
                stroke={color}
                strokeWidth='1.2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M9.50461 12.5422C10.9407 12.5422 12.1049 11.4019 12.1049 9.99518C12.1049 8.5885 10.9407 7.44815 9.50461 7.44815C8.06849 7.44815 6.9043 8.5885 6.9043 9.99518C6.9043 11.4019 8.06849 12.5422 9.50461 12.5422Z'
                stroke={color}
                strokeWidth='1.2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}

export const IconSettingsOutlineLiveStream = ({
    color = 'white'
}: SVGProps) => {
    return (
        <svg
            width='22'
            height='22'
            viewBox='0 0 22 22'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M20.8488 6.47376L20.1417 5.32758C19.9988 5.09685 19.8084 4.89459 19.5814 4.73237C19.3544 4.57014 19.0953 4.45112 18.8188 4.38213C18.5424 4.31314 18.2541 4.29549 17.9703 4.33025C17.6865 4.365 17.4129 4.45148 17.165 4.58468V4.58468C16.6679 4.85357 16.0771 4.92973 15.5202 4.79669C14.9632 4.66365 14.4849 4.33211 14.1884 3.87365V3.87365C13.9956 3.58341 13.8929 3.24909 13.8919 2.90787V2.90787C13.9041 2.63937 13.8591 2.3713 13.7595 2.11904C13.6599 1.86679 13.5077 1.63535 13.3116 1.43807C13.1155 1.24079 12.8794 1.08151 12.6168 0.969493C12.3543 0.857474 12.0706 0.794897 11.7819 0.785339H10.2765C9.70182 0.785339 9.15065 0.997804 8.74428 1.37595C8.3379 1.7541 8.10961 2.26698 8.10961 2.80177C8.1036 3.33568 7.87143 3.8458 7.46356 4.22136C7.05569 4.59692 6.50507 4.8076 5.93127 4.80757C5.56255 4.80645 5.20064 4.71494 4.88201 4.54225V4.54225C4.63456 4.40763 4.36085 4.32002 4.07676 4.28452C3.79268 4.24901 3.50386 4.26627 3.227 4.33537C2.95015 4.40446 2.69077 4.524 2.46391 4.68703C2.23704 4.85005 2.0472 5.05331 1.90536 5.28509L1.15263 6.45252C1.00822 6.68197 0.914253 6.93582 0.876245 7.19937C0.838236 7.46291 0.856948 7.73084 0.931236 7.98761C1.00552 8.24437 1.13391 8.48485 1.30897 8.69501C1.48404 8.90517 1.70226 9.08081 1.95095 9.21178V9.21178C2.28048 9.39251 2.55371 9.65003 2.7437 9.95895C2.93369 10.2679 3.0339 10.6176 3.03443 10.9735C3.03619 11.3299 2.93695 11.6803 2.74673 11.9896C2.55651 12.2989 2.28203 12.5561 1.95095 12.7352V12.7352C1.70283 12.8653 1.48487 13.0398 1.30967 13.2488C1.13447 13.4577 1.00549 13.6968 0.930192 13.9524C0.854899 14.208 0.834805 14.475 0.871024 14.7378C0.907242 15.0007 0.999064 15.2542 1.14121 15.4839V15.4839L1.85973 16.6406C2.14095 17.1107 2.61054 17.4582 3.16606 17.6073C3.72157 17.7564 4.31793 17.695 4.825 17.4366V17.4366C5.3214 17.1705 5.91078 17.0982 6.46431 17.2354C7.01785 17.3727 7.4905 17.7083 7.77886 18.1688V18.1688C7.96443 18.4653 8.06277 18.8021 8.06398 19.1452V19.1452C8.06699 19.6838 8.29904 20.1993 8.70937 20.5792C9.1197 20.959 9.67491 21.1722 10.2537 21.1722H11.6793C12.2551 21.1722 12.8074 20.9601 13.2156 20.5823C13.6238 20.2044 13.8546 19.6916 13.8576 19.1558V19.1558C13.8546 18.8906 13.9082 18.6276 14.0151 18.3818C14.1221 18.136 14.2804 17.9123 14.4809 17.7238C14.6813 17.5353 14.92 17.3856 15.183 17.2835C15.446 17.1814 15.7282 17.1288 16.0132 17.1288V17.1288C16.3808 17.1373 16.7408 17.2283 17.0624 17.3941V17.3941C17.3099 17.5288 17.5836 17.6164 17.8677 17.6519C18.1517 17.6874 18.4406 17.6701 18.7174 17.601C18.9943 17.5319 19.2536 17.4123 19.4805 17.2493C19.7074 17.0863 19.8972 16.883 20.0391 16.6512V16.6512L20.7918 15.4839C20.9352 15.2547 21.0285 15.0015 21.0666 14.7387C21.1046 14.4758 21.0865 14.2086 21.0134 13.9523C20.9403 13.696 20.8136 13.4556 20.6406 13.245C20.4675 13.0343 20.2515 12.8574 20.0049 12.7246V12.7246C19.506 12.4598 19.1405 12.0215 18.9887 11.5062C18.8369 10.9908 18.9111 10.4404 19.1951 9.97592V9.97592C19.3851 9.66637 19.6608 9.40984 19.9935 9.23302V9.23302C20.4912 8.96442 20.8545 8.52348 21.004 8.00652C21.1536 7.48955 21.0773 6.93857 20.7918 6.47376H20.8488Z'
                stroke={color}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M11.007 13.7965C12.6698 13.7965 14.0179 12.5421 14.0179 10.9947C14.0179 9.44737 12.6698 8.19299 11.007 8.19299C9.34411 8.19299 7.99609 9.44737 7.99609 10.9947C7.99609 12.5421 9.34411 13.7965 11.007 13.7965Z'
                stroke={color}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}

export const IconReplyOutline = () => {
    return (
        <svg
            width='20'
            height='18'
            viewBox='0 0 20 18'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M10.0046 12.5174V14.7146C10.0046 14.9511 9.86847 15.1664 9.65486 15.2679L9.65485 15.2679C9.44121 15.3693 9.18833 15.3387 9.00505 15.1893L9.00504 15.1893L1.17547 8.8062C1.03521 8.69185 0.952672 8.52131 0.950065 8.34032L10.0046 12.5174ZM10.0046 12.5174C13.1905 12.5393 16.1483 14.1466 17.9272 16.8271C18.0428 17.0013 18.2361 17.101 18.4376 17.101C18.4964 17.101 18.556 17.0924 18.6144 17.0748C18.873 16.9968 19.05 16.7585 19.05 16.4884V14.5222C19.05 11.8597 18.0632 9.29732 16.2716 7.30725C14.6181 5.47055 12.4095 4.26008 10.0046 3.86159V1.56249C10.0046 1.32282 9.8648 1.10518 9.64678 1.0055V1.0055C9.42892 0.905815 9.17278 0.942417 8.99149 1.09917C8.99149 1.09917 8.99149 1.09918 8.99149 1.09918L1.16192 7.86811L1.16191 7.86812L1.19461 7.90594C1.06886 8.01464 0.997634 8.17341 1.00006 8.33959L0.950065 8.34031L10.0046 12.5174ZM8.77956 11.9046V13.425L2.51493 8.31773L8.77956 2.90169V4.3944C8.77956 4.70597 9.01346 4.96789 9.32304 5.00299C14.17 5.55261 17.825 9.64493 17.825 14.5222V14.7272C15.7938 12.5508 12.9546 11.2921 9.93878 11.2921H9.39206C9.05377 11.2921 8.77956 11.5664 8.77956 11.9046Z'
                fill='#767676'
                stroke='#767676'
                strokeWidth='0.1'
            />
        </svg>
    )
}

export const IconLikeOutline = () => {
    return (
        <svg
            width='18'
            height='18'
            viewBox='0 0 18 18'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M8.78959 17.1785C6.88894 15.9411 5.12239 14.4895 3.5213 12.8492C2.3897 11.6606 1.52825 10.2186 1.0013 8.63077C0.06179 5.53846 1.15936 2.00308 4.25009 0.960002C5.05089 0.689764 5.90155 0.625012 6.73102 0.77115C7.56049 0.917288 8.34466 1.27004 9.01789 1.79998C9.69012 1.27152 10.4727 0.919573 11.3005 0.77346C12.1283 0.627347 12.9774 0.691323 13.7769 0.960002C16.8676 2.00308 17.974 5.57538 17.0345 8.63077C16.5117 10.2207 15.6497 11.6637 14.5145 12.8492C12.9134 14.4895 11.1468 15.9411 9.24619 17.1785L9.04421 17.3077L8.78959 17.1785Z'
                stroke='#767676'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}

export const IconSwipeUp = ({ color = 'white', opacity = 0.5 }: SVGProps) => {
    return (
        <svg
            width='36'
            height='40'
            viewBox='0 0 36 40'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M32.6552 15.7618H32.5974C31.8264 15.7559 31.0793 16.0216 30.4935 16.5101C29.9968 15.2525 28.7956 14.3525 27.3929 14.3525C26.5403 14.361 25.7257 14.6957 25.1243 15.2849C24.567 14.2033 23.4355 13.5177 22.1942 13.5092H22.1328C21.4456 13.5092 20.7735 13.6827 20.3115 14.0506V6.423C20.3115 4.52834 18.7955 2.98706 16.9539 2.98706C15.1145 2.98706 13.6076 4.52693 13.6061 6.42053L13.5906 21.6105L12.7915 20.6644C12.0024 19.7067 10.8409 19.1119 9.58445 19.0221C8.35398 18.9401 7.14336 19.3572 6.23955 20.1756L5.46676 20.8007C5.19857 21.0171 5.12205 21.387 5.28267 21.688L12.8084 35.7907C14.1934 38.3851 16.829 40 19.687 40H28.1278C32.4588 40 35.9864 36.3391 35.9907 31.8434C35.9925 29.8533 35.9947 28.3673 35.9961 27.1622C36.0004 23.9244 36.0019 22.7333 35.9936 19.1679C35.9889 17.2785 34.4913 15.7618 32.6552 15.7618ZM34.5177 27.1586C34.5162 28.3638 34.514 29.8516 34.5122 31.842C34.5086 35.5436 31.6445 38.5583 28.1278 38.5583H19.687C17.3824 38.5583 15.2495 37.2409 14.1201 35.1252L6.8694 21.5401L7.19642 21.2748C7.2058 21.267 7.21555 21.2586 7.22457 21.2505C7.83169 20.6937 8.64851 20.4075 9.48014 20.4606C10.3302 20.524 11.1149 20.9295 11.6465 21.5796L13.7527 24.0796C13.9508 24.3147 14.2789 24.4031 14.5728 24.3006C14.8666 24.1982 15.0629 23.9265 15.0629 23.6224L15.0756 6.42124C15.0763 5.32239 15.9292 4.42873 16.9546 4.42873C17.9801 4.42873 18.833 5.32309 18.833 6.423V16.7931C18.833 16.8297 18.8312 16.8663 18.8312 16.9029C18.8312 16.9195 18.833 16.936 18.833 16.9522V21.3842C18.833 21.7823 19.164 22.1051 19.5722 22.1051C19.9805 22.1051 20.3115 21.7823 20.3115 21.3842V16.8177C20.3115 15.758 21.1337 14.9509 22.1328 14.9509H22.1942C23.22 14.9509 24.1 15.8041 24.1 16.904V20.9615C24.1 21.3596 24.431 21.6823 24.8392 21.6823C25.2474 21.6823 25.5784 21.3596 25.5784 20.9615V17.7779C25.5784 16.6784 26.3978 15.7837 27.4294 15.7837C28.4552 15.7837 29.2745 16.678 29.2745 17.7779V20.7813C29.2745 21.1794 29.6055 21.5021 30.0138 21.5021C30.422 21.5021 30.753 21.1794 30.753 20.7813V19.1548C30.753 18.0556 31.5716 17.2035 32.5974 17.2035H32.6552C33.6781 17.2035 34.5122 18.0739 34.5151 19.1703C34.5234 22.7333 34.522 23.9226 34.5177 27.1586Z'
                fill={color}
                fillOpacity={opacity}
            />
            <path
                d='M5.41891 4.36528C5.70767 4.64686 6.17582 4.64686 6.46422 4.36528C6.75298 4.08371 6.75298 3.6272 6.46422 3.34563L4.03107 0.973343C3.90402 0.779759 3.69647 0.649881 3.46294 0.618556C3.2294 0.586879 2.9937 0.656921 2.81756 0.809676L0.216569 3.34563C-0.0721896 3.6272 -0.0721896 4.08371 0.216569 4.36528C0.504966 4.64686 0.973116 4.64686 1.26187 4.36528L2.65947 3.00245V18.9158C2.65947 19.3138 2.99046 19.6366 3.39869 19.6366C3.80692 19.6366 4.13791 19.3138 4.13791 18.9158V3.11649L5.41891 4.36528Z'
                fill={color}
                fillOpacity={opacity}
            />
            <path
                d='M11.4677 6.76241C11.876 6.76241 12.207 6.43966 12.207 6.04158C12.207 3.50105 14.3189 1.44167 16.9242 1.44167C19.5295 1.44167 21.6414 3.50105 21.6414 6.04158C21.6414 6.43966 21.9724 6.76241 22.3806 6.76241C22.7888 6.76241 23.1198 6.43966 23.1198 6.04158C23.1198 2.70489 20.346 0 16.9242 0C13.5024 0 10.7285 2.70489 10.7285 6.04158C10.7285 6.43966 11.0595 6.76241 11.4677 6.76241Z'
                fill={color}
                fillOpacity={opacity}
            />
        </svg>
    )
}

export const IconViewers = ({ color = '#C0C0C1' }: SVGProps) => {
    return (
        <svg
            width='12'
            height='14'
            viewBox='0 0 12 14'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M6.00364 6.96623C7.90628 6.96623 9.44868 5.52024 9.44868 3.7365C9.44868 1.95277 7.90628 0.506775 6.00364 0.506775C4.10099 0.506775 2.55859 1.95277 2.55859 3.7365C2.55859 5.52024 4.10099 6.96623 6.00364 6.96623Z'
                stroke={color}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M0.540268 11.4527C0.53624 11.219 0.590515 10.9876 0.698805 10.777C0.93695 10.4787 1.23746 10.229 1.58193 10.0432C1.92641 9.8573 2.30765 9.73915 2.70243 9.69597C3.25843 9.58661 3.82203 9.51435 4.38894 9.47975C5.44151 9.39192 6.50029 9.39192 7.55287 9.47975C8.12026 9.51376 8.68408 9.58831 9.23937 9.70273C10.0105 9.85138 10.9403 10.1487 11.2718 10.7973C11.3808 11.0079 11.4375 11.2389 11.4375 11.473C11.4375 11.7071 11.3808 11.9381 11.2718 12.1487C10.9403 12.8244 10.0105 13.0946 9.23937 13.2365C8.68435 13.3536 8.12049 13.4304 7.55287 13.4663C6.69698 13.5315 5.83738 13.5428 4.97989 13.5C4.7819 13.5067 4.58377 13.4931 4.38894 13.4595C3.82337 13.4265 3.26167 13.3497 2.70964 13.2297C2.30602 13.2004 1.91416 13.0883 1.56174 12.9016C1.20933 12.7148 0.904934 12.4578 0.669992 12.1487C0.568793 11.9295 0.524344 11.691 0.540268 11.4527Z'
                stroke={color}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}
export const IconViewersSize = ({ color = '#fff' }: SVGProps) => {
    return (
        <svg
            width='20'
            height='25'
            viewBox='0 0 12 14'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M6.00364 6.96623C7.90628 6.96623 9.44868 5.52024 9.44868 3.7365C9.44868 1.95277 7.90628 0.506775 6.00364 0.506775C4.10099 0.506775 2.55859 1.95277 2.55859 3.7365C2.55859 5.52024 4.10099 6.96623 6.00364 6.96623Z'
                stroke={color}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M0.540268 11.4527C0.53624 11.219 0.590515 10.9876 0.698805 10.777C0.93695 10.4787 1.23746 10.229 1.58193 10.0432C1.92641 9.8573 2.30765 9.73915 2.70243 9.69597C3.25843 9.58661 3.82203 9.51435 4.38894 9.47975C5.44151 9.39192 6.50029 9.39192 7.55287 9.47975C8.12026 9.51376 8.68408 9.58831 9.23937 9.70273C10.0105 9.85138 10.9403 10.1487 11.2718 10.7973C11.3808 11.0079 11.4375 11.2389 11.4375 11.473C11.4375 11.7071 11.3808 11.9381 11.2718 12.1487C10.9403 12.8244 10.0105 13.0946 9.23937 13.2365C8.68435 13.3536 8.12049 13.4304 7.55287 13.4663C6.69698 13.5315 5.83738 13.5428 4.97989 13.5C4.7819 13.5067 4.58377 13.4931 4.38894 13.4595C3.82337 13.4265 3.26167 13.3497 2.70964 13.2297C2.30602 13.2004 1.91416 13.0883 1.56174 12.9016C1.20933 12.7148 0.904934 12.4578 0.669992 12.1487C0.568793 11.9295 0.524344 11.691 0.540268 11.4527Z'
                stroke={color}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}
export const IconActionTip = ({ color = 'white' }: SVGProps) => {
    return (
        <svg
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M13.1536 22.538C12.7747 22.579 12.3898 22.6 12 22.6C6.14578 22.6 1.4 17.8542 1.4 12C1.4 6.14578 6.14578 1.4 12 1.4C17.8542 1.4 22.6 6.14578 22.6 12C22.6 12.9524 22.4744 13.8755 22.2388 14.7536C22.645 15.159 22.9933 15.6223 23.2704 16.13C23.7424 14.8423 24 13.4513 24 12C24 5.37258 18.6274 2.2213e-07 12 1.43099e-07C5.37258 6.40674e-08 2.2213e-07 5.37258 1.43099e-07 12C6.40674e-08 18.6274 5.37258 24 12 24C12.807 24 13.5954 23.9203 14.3578 23.7684C13.9 23.4182 13.494 23.0035 13.1536 22.538ZM19.8941 13.3051C19.9638 12.8804 20 12.4444 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C12.0277 20 12.0553 19.9999 12.0829 19.9996C12.0284 19.6745 12 19.3406 12 19C12 18.8656 12.0044 18.7322 12.0131 18.6C12.0088 18.6 12.0044 18.6 12 18.6C8.35492 18.6 5.4 15.6451 5.4 12C5.4 8.35492 8.35492 5.4 12 5.4C15.6451 5.4 18.6 8.35492 18.6 12C18.6 12.3477 18.5731 12.6891 18.5213 13.0223C18.9969 13.0633 19.4567 13.1597 19.8941 13.3051ZM12 14.6C13.4359 14.6 14.6 13.4359 14.6 12C14.6 10.5641 13.4359 9.4 12 9.4C10.5641 9.4 9.4 10.5641 9.4 12C9.4 13.4359 10.5641 14.6 12 14.6Z'
                fill={color}
            />
            <circle cx='12' cy='12' r='3' fill={color} />
            <path
                d='M18.5131 18.6073C17.6746 18.2572 17.125 18.0025 17.125 17.6667C17.125 17.1765 17.6297 16.7778 18.25 16.7778C18.8703 16.7778 19.375 17.1765 19.375 17.6667C19.375 17.9121 19.6268 18.1111 19.9375 18.1111C20.2482 18.1111 20.5 17.9121 20.5 17.6667C20.5 16.8398 19.7819 16.143 18.8125 15.9452V15.4444C18.8125 15.199 18.5607 15 18.25 15C17.9393 15 17.6875 15.199 17.6875 15.4444V15.9452C16.7181 16.143 16 16.8398 16 17.6667C16 18.5632 17.0558 19.0041 17.9874 19.3932C18.8256 19.7433 19.375 19.9978 19.375 20.3333C19.375 20.8235 18.8703 21.2222 18.25 21.2222C17.6297 21.2222 17.125 20.8235 17.125 20.3333C17.125 20.0879 16.8732 19.8889 16.5625 19.8889C16.2518 19.8889 16 20.0879 16 20.3333C16 21.1602 16.7181 21.857 17.6875 22.0548V22.5556C17.6875 22.801 17.9393 23 18.25 23C18.5607 23 18.8125 22.801 18.8125 22.5556V22.0548C19.7819 21.857 20.5 21.1602 20.5 20.3333C20.5 19.4372 19.4444 18.9963 18.5131 18.6073Z'
                fill={color}
            />
        </svg>
    )
}

export const IconActionDollar = ({
    color = 'white',
    width = '18',
    height = '18'
}: SVGProps) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox='0 0 18 18'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g clipPath='url(#clip0_4945_30366)'>
                <path
                    d='M8.1943 6.31852C8.90945 5.60341 10.1369 6.11619 10.1369 7.12316C10.1369 7.53135 10.4678 7.86224 10.876 7.86224C11.2841 7.86224 11.615 7.53135 11.615 7.12316C11.615 5.9373 10.8217 4.93384 9.73803 4.61406V4.11994C9.73803 3.71176 9.40713 3.38086 8.99894 3.38086C8.59076 3.38086 8.25986 3.71176 8.25986 4.11994V4.61287C7.00111 4.98156 6.18882 6.24271 6.47594 7.56862C6.65265 8.38477 7.2178 9.0624 7.98767 9.38129L9.44457 9.98473C10.1184 10.2639 10.3201 11.1287 9.83256 11.6518C9.13314 12.4014 7.86097 11.9104 7.86097 10.8772C7.86097 10.469 7.53008 10.1381 7.12189 10.1381C6.71371 10.1381 6.38281 10.469 6.38281 10.8772C6.38281 12.0319 7.14604 13.0613 8.25983 13.3858V13.8804C8.25983 14.2886 8.59073 14.6195 8.99891 14.6195C9.40709 14.6195 9.73799 14.2886 9.73799 13.8804V13.3847C10.1503 13.2646 10.5281 13.0445 10.8391 12.7367C12.1238 11.4659 11.6639 9.30408 10.0102 8.61909L8.55328 8.01565C7.87188 7.7334 7.66723 6.84654 8.1943 6.31852Z'
                    fill={color}
                />
                <path
                    d='M15.3625 2.63745C11.8462 -0.878905 6.15432 -0.879397 2.63747 2.63745C-0.878891 6.15381 -0.879419 11.8457 2.63747 15.3625C6.15382 18.8789 11.8456 18.8794 15.3625 15.3625C18.8789 11.8462 18.8795 6.15434 15.3625 2.63745ZM9.00001 16.5198C4.85357 16.5198 1.48018 13.1464 1.48018 9.00004C1.48018 4.85363 4.85357 1.4802 9.00001 1.4802C13.1465 1.4802 16.5199 4.8536 16.5199 9.00004C16.5199 13.1465 13.1465 16.5198 9.00001 16.5198Z'
                    fill={color}
                />
            </g>
            <defs>
                <clipPath id='clip0_4945_30366'>
                    <rect width='18' height='18' fill={color} />
                </clipPath>
            </defs>
        </svg>
    )
}

export const IconCameraOutline = ({
    color = 'white',
    width = '24',
    height = '18'
}: SVGProps) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox='0 0 24 18'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M16.3644 13.045C16.3862 13.5415 16.3096 14.0375 16.1392 14.5045C15.9687 14.9714 15.7077 15.4003 15.371 15.7664C15.0343 16.1326 14.6286 16.4289 14.1771 16.6384C13.7256 16.8478 13.2372 16.9663 12.7397 16.9871C12.5856 16.9988 12.4307 16.9988 12.2765 16.9871H5.07344C4.57797 17.0282 4.07926 16.9708 3.60612 16.8184C3.13298 16.6659 2.69476 16.4214 2.31682 16.0989C1.93888 15.7764 1.6287 15.3824 1.40417 14.9396C1.17964 14.4968 1.04521 14.0139 1.00867 13.5189C0.99711 13.3612 0.99711 13.2028 1.00867 13.045V4.95253C0.986919 4.45598 1.06347 3.95997 1.23393 3.49299C1.4044 3.026 1.66543 2.59717 2.0021 2.23101C2.33878 1.86485 2.74449 1.56856 3.19599 1.35909C3.6475 1.14963 4.13594 1.03112 4.63338 1.01031H12.2881C13.288 0.936682 14.2766 1.25953 15.0397 1.90876C15.8028 2.55799 16.2788 3.48127 16.3644 4.47851C16.3644 4.62879 16.3644 4.7791 16.3644 4.92939V13.045Z'
                stroke={color}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M16.3633 8.02765L21.1113 4.15487C21.347 3.96187 21.6493 3.8694 21.9528 3.89753C22.2563 3.92567 22.5365 4.07215 22.7326 4.30516C22.9052 4.51315 22.9994 4.77487 22.9989 5.04499V12.9871C22.9996 13.2059 22.9382 13.4205 22.8217 13.6057C22.7052 13.791 22.5384 13.9395 22.3407 14.0339C22.1431 14.1283 21.9226 14.1649 21.705 14.1392C21.4873 14.1135 21.2815 14.0267 21.1113 13.8889L16.3633 10.0161'
                stroke={color}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}

export const IconCameraOutlineOnline = ({
    width = '24',
    height = '18',
    circleColor = '#0FE465',
    color = '#200E32'
}: SVGProps) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox='0 0 24 18'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M17.0399 13.6469C17.0601 14.0964 16.9892 14.5453 16.8313 14.968C16.6734 15.3907 16.4316 15.7788 16.1198 16.1103C15.8079 16.4417 15.4321 16.7099 15.0139 16.8995C14.5957 17.0891 14.1433 17.1964 13.6826 17.2152C13.5397 17.2258 13.3963 17.2258 13.2535 17.2152H6.58163C6.1227 17.2524 5.66077 17.2004 5.22252 17.0624C4.78427 16.9245 4.37837 16.7031 4.0283 16.4112C3.67823 16.1193 3.39093 15.7627 3.18296 15.3619C2.97499 14.961 2.85047 14.524 2.81663 14.0759C2.80592 13.9331 2.80592 13.7897 2.81663 13.6469V6.32186C2.79648 5.87239 2.86738 5.42342 3.02528 5.00072C3.18317 4.57802 3.42495 4.18985 3.7368 3.85842C4.04864 3.52698 4.42443 3.25878 4.84264 3.06918C5.26084 2.87958 5.71326 2.77231 6.17402 2.75348H13.2642C14.1904 2.68683 15.1061 2.97906 15.8129 3.56672C16.5197 4.15439 16.9606 4.99012 17.0399 5.89278C17.0399 6.02882 17.0399 6.16487 17.0399 6.30091V13.6469Z'
                stroke={color}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M17.0391 9.10525L21.4369 5.59972C21.6552 5.42503 21.9353 5.34132 22.2164 5.36679C22.4975 5.39226 22.757 5.52484 22.9386 5.73576C23.0985 5.92403 23.1858 6.16093 23.1853 6.40543V13.5944C23.186 13.7925 23.1291 13.9867 23.0212 14.1544C22.9133 14.3221 22.7588 14.4565 22.5757 14.5419C22.3926 14.6274 22.1884 14.6605 21.9868 14.6372C21.7852 14.614 21.5946 14.5354 21.4369 14.4107L17.0391 10.9052'
                stroke={color}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <circle cx='4' cy='4' r='3.5' fill={circleColor} stroke='white' />
        </svg>
    )
}

export const IconChatDashed = ({ color = '#CFCFCF' }: SVGProps) => {
    return (
        <svg
            width='26'
            height='26'
            viewBox='0 0 26 26'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M17.3491 13.2781C17.3467 12.9977 17.4276 12.723 17.5815 12.4888C17.7353 12.2545 17.9553 12.0712 18.2134 11.9623C18.4714 11.8533 18.756 11.8236 19.031 11.8768C19.306 11.93 19.559 12.0638 19.7579 12.2612C19.9568 12.4586 20.0927 12.7107 20.1482 12.9855C20.2037 13.2603 20.1764 13.5454 20.0698 13.8046C19.9632 14.0639 19.782 14.2855 19.5493 14.4416C19.3165 14.5976 19.0428 14.6808 18.7627 14.6808C18.3899 14.6809 18.0321 14.5335 17.7674 14.2708C17.5026 14.008 17.3523 13.6512 17.3491 13.2781ZM11.864 13.2781C11.864 12.9028 12.0129 12.5429 12.278 12.2776C12.5431 12.0123 12.9027 11.8632 13.2776 11.8632C13.6525 11.8632 14.012 12.0123 14.2771 12.2776C14.5422 12.5429 14.6911 12.9028 14.6911 13.2781C14.688 13.6524 14.5381 14.0104 14.2737 14.275C14.0092 14.5397 13.6515 14.6898 13.2776 14.693C12.9027 14.693 12.5431 14.5439 12.278 14.2786C12.0129 14.0132 11.864 13.6533 11.864 13.2781ZM6.37891 13.2781C6.37892 12.9977 6.46211 12.7237 6.61798 12.4908C6.77384 12.2578 6.99529 12.0765 7.25429 11.9698C7.51329 11.8631 7.79814 11.8358 8.07267 11.8913C8.3472 11.9469 8.59909 12.0829 8.7963 12.2819C8.9935 12.481 9.12717 12.7343 9.18034 13.0096C9.23351 13.2848 9.20372 13.5697 9.09487 13.828C8.98603 14.0863 8.803 14.3064 8.56895 14.4604C8.33491 14.6145 8.06044 14.6953 7.78036 14.693C7.40756 14.6898 7.0511 14.5393 6.78861 14.2743C6.52613 14.0093 6.37889 13.6513 6.37891 13.2781Z'
                fill={color}
            />
            <path
                d='M12.988 0.906986C9.78374 0.906986 6.71072 2.18102 4.44495 4.44891C2.17918 6.71679 0.90625 9.79274 0.90625 13C0.94057 15.1197 1.50105 17.1976 2.53726 19.0465C2.63133 19.2102 2.68774 19.3928 2.70237 19.5811C2.717 19.7694 2.68949 19.9586 2.62184 20.1349L1.81238 22.8437C1.75061 23.033 1.76532 23.239 1.85338 23.4175C1.94145 23.5961 2.09589 23.7331 2.28359 23.7991C2.45158 23.859 2.63511 23.859 2.8031 23.7991L5.21945 23.0734C5.53267 23.0008 5.85849 23.0024 6.17101 23.0779C6.48353 23.1535 6.7741 23.3011 7.01963 23.5089C8.62776 24.4254 10.4248 24.9599 12.272 25.0712C14.1192 25.1825 15.9673 24.8675 17.6736 24.1506C19.38 23.4338 20.899 22.3342 22.1135 20.9366C23.328 19.5391 24.2056 17.881 24.6785 16.0902C25.1514 14.2994 25.2069 12.4238 24.8409 10.6081C24.4749 8.79243 23.6971 7.08519 22.5675 5.61805C21.4378 4.15092 19.9866 2.96308 18.3256 2.14626C16.6647 1.32944 14.8386 0.905483 12.988 0.906986V0.906986Z'
                stroke={color}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeDasharray='3 3'
            />
        </svg>
    )
}

export const IconSendOutline = ({ color = 'white' }: SVGProps) => {
    return (
        <svg
            width='22'
            height='22'
            viewBox='0 0 22 22'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M15.3445 6.58871L8.95885 13.0195L1.47884 8.41639C1.32901 8.32615 1.19862 8.20704 1.09522 8.06596C0.991824 7.92488 0.917464 7.76467 0.876524 7.59462C0.835585 7.42456 0.828827 7.24802 0.856692 7.07534C0.884558 6.90266 0.946476 6.73725 1.03883 6.58871C1.21825 6.30961 1.48964 6.10205 1.806 6.00202L19.4624 0.947681C19.6299 0.899584 19.8052 0.885097 19.9782 0.905057C20.1512 0.925017 20.3186 0.979037 20.4707 1.06399C20.6228 1.14894 20.7565 1.26314 20.8642 1.40002C20.972 1.53691 21.0515 1.69375 21.0983 1.86152C21.1662 2.10509 21.1662 2.36254 21.0983 2.60611L15.8522 20.2513C15.8041 20.418 15.7237 20.5737 15.6155 20.7093C15.5073 20.845 15.3734 20.9579 15.2214 21.0418C15.0695 21.1256 14.9025 21.1786 14.73 21.1979C14.5576 21.2171 14.3829 21.2021 14.2163 21.1538C13.9013 21.0568 13.6325 20.8482 13.4604 20.5672L8.94756 13.1098'
                stroke={color}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}

export const IconSortAsc = ({ color = 'white' }: SVGProps) => {
    return (
        <svg
            width='18'
            height='18'
            viewBox='0 0 20 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M14.8168 6.03391C15.2021 6.034 15.5144 6.34643 15.5143 6.73175L15.5113 19.3024C15.5113 19.6877 15.1988 20 14.8135 19.9999C14.4282 19.9998 14.1159 19.6874 14.116 19.302L14.119 6.73142C14.1191 6.34611 14.4315 6.03383 14.8168 6.03391Z'
                fill={color}
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M9.85117 14.7791C10.109 14.4928 10.5502 14.4698 10.8365 14.7276L14.8354 18.3296L18.8344 14.7276C19.1207 14.4698 19.5618 14.4928 19.8197 14.7791C20.0776 15.0654 20.0545 15.5065 19.7682 15.7644L15.3024 19.787C15.037 20.026 14.6339 20.026 14.3685 19.787L9.90262 15.7644C9.61633 15.5065 9.59329 15.0654 9.85117 14.7791Z'
                fill={color}
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M0 0.697669C0 0.312357 0.312357 0 0.69767 0H18.8515C19.2368 0 19.5491 0.312357 19.5491 0.697669C19.5491 1.08298 19.2368 1.39534 18.8515 1.39534H0.69767C0.312357 1.39534 0 1.08298 0 0.697669Z'
                fill={color}
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M0 6.73154C0 6.34623 0.312357 6.03387 0.69767 6.03387H9.77457C10.1599 6.03387 10.4722 6.34623 10.4722 6.73154C10.4722 7.11686 10.1599 7.42921 9.77457 7.42921H0.69767C0.312357 7.42921 0 7.11686 0 6.73154Z'
                fill={color}
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M0 13.7711C0 13.3858 0.312357 13.0734 0.69767 13.0734H5.74039C6.1257 13.0734 6.43806 13.3858 6.43806 13.7711C6.43806 14.1564 6.1257 14.4688 5.74039 14.4688H0.69767C0.312357 14.4688 0 14.1564 0 13.7711Z'
                fill={color}
            />
        </svg>
    )
}

export const IconSortDesc = ({ color = 'white' }: SVGProps) => {
    return (
        <svg
            width='23'
            height='18'
            viewBox='0 0 23 18'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M17.145 17.9998C17.5304 17.9997 17.8426 17.6866 17.8425 17.3003L17.8387 4.69936C17.8386 4.31312 17.5262 4.00007 17.1408 4.00014C16.7555 4.00021 16.4432 4.31338 16.4433 4.69962L16.4471 17.3006C16.4472 17.6868 16.7597 17.9999 17.145 17.9998Z'
                fill={color}
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M12.1793 9.23348C12.4372 9.52046 12.8784 9.54356 13.1647 9.28506L17.1641 5.67434L21.1634 9.28506C21.4497 9.54356 21.8909 9.52046 22.1488 9.23348C22.4067 8.94649 22.3837 8.50429 22.0974 8.24579L17.631 4.21348C17.3656 3.97385 16.9625 3.97385 16.6971 4.21348L12.2308 8.24579C11.9444 8.50429 11.9214 8.94649 12.1793 9.23348Z'
                fill={color}
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M0 0.69773C0 0.312418 0.312357 6.10352e-05 0.69767 6.10352e-05H18.8515C19.2368 6.10352e-05 19.5491 0.312418 19.5491 0.69773C19.5491 1.08304 19.2368 1.3954 18.8515 1.3954H0.69767C0.312357 1.3954 0 1.08304 0 0.69773Z'
                fill={color}
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M0 6.7316C0 6.34629 0.312357 6.03394 0.69767 6.03394H9.77457C10.1599 6.03394 10.4722 6.34629 10.4722 6.7316C10.4722 7.11692 10.1599 7.42927 9.77457 7.42927H0.69767C0.312357 7.42927 0 7.11692 0 6.7316Z'
                fill={color}
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M0 13.7712C0 13.3858 0.312357 13.0735 0.69767 13.0735H5.74039C6.1257 13.0735 6.43806 13.3858 6.43806 13.7712C6.43806 14.1565 6.1257 14.4688 5.74039 14.4688H0.69767C0.312357 14.4688 0 14.1565 0 13.7712Z'
                fill={color}
            />
        </svg>
    )
}

export const Crown = ({ color = '#F6C334' }: SVGProps) => {
    return (
        <svg
            width='40'
            height='18'
            viewBox='0 0 40 18'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M40 6.26944C40 4.31827 38.2925 2.73084 36.1938 2.73084C34.0952 2.73084 32.388 4.31827 32.388 6.26944C32.388 7.20743 32.7832 8.06087 33.4265 8.69471C32.2824 9.88465 30.621 10.6357 28.7735 10.6357C25.7828 10.6357 23.2779 8.67003 22.6718 6.0558C23.3716 5.41373 23.8062 4.52256 23.8062 3.5386C23.8062 1.58743 22.0987 0 20 0C17.9013 0 16.1938 1.58743 16.1938 3.5386C16.1938 4.52256 16.6287 5.41373 17.3282 6.0558C16.7221 8.67003 14.2172 10.6357 11.2265 10.6357C9.37897 10.6357 7.71759 9.88465 6.57349 8.69471C7.2168 8.06087 7.6123 7.20743 7.6123 6.26944C7.6123 4.31827 5.90485 2.73084 3.80615 2.73084C1.70746 2.73084 0 4.31827 0 6.26944C0 7.96044 1.28265 9.37735 2.99072 9.7252C3.32855 12.3173 3.98132 15.4754 5.2417 18L34.7583 18C36.0187 15.4754 36.6714 12.3173 37.0093 9.7252C38.7173 9.37707 40 7.96044 40 6.26944Z'
                fill={color}
            />
        </svg>
    )
}

export const CrownTilted = ({ color = '#F6C334' }: SVGProps) => {
    return (
        <svg
            width='16'
            height='13'
            viewBox='0 0 16 13'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M14.2496 1.41311C13.816 0.662105 12.8718 0.392593 12.1448 0.812332C11.4178 1.23207 11.1791 2.1845 11.6127 2.93551C11.8212 3.29654 12.1477 3.54599 12.5114 3.66129C12.3795 4.34812 11.9709 4.96946 11.3309 5.33897C10.2949 5.93712 8.99037 5.68152 8.19948 4.79652C8.29921 4.40943 8.25171 3.9795 8.03305 3.60078C7.59946 2.84977 6.65521 2.58026 5.9282 3C5.20119 3.41974 4.96248 4.37223 5.39607 5.12324C5.61473 5.50196 5.96341 5.758 6.34839 5.86524C6.71938 6.99267 6.28847 8.25023 5.25246 8.84837C4.61245 9.21788 3.87004 9.26109 3.20928 9.0319C3.29128 8.65927 3.23863 8.25168 3.03019 7.89065C2.5966 7.13964 1.65235 6.87013 0.925343 7.28987C0.198335 7.70961 -0.0403833 8.6621 0.39321 9.41311C0.768986 10.064 1.52818 10.3528 2.19717 10.1451C2.89022 11.0752 3.81815 12.1602 4.81578 12.8799L15.0406 6.97654C14.9162 5.75276 14.4405 4.40664 13.9815 3.34138C14.4959 2.86577 14.6254 2.06397 14.2496 1.41311Z'
                fill={color}
            />
        </svg>
    )
}

export const IconStartLiveViewers = ({ color = '#696B73' }: SVGProps) => {
    return (
        <svg
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M23.8475 11.5332C23.6331 11.2399 18.5245 4.35168 11.9999 4.35168C5.47529 4.35168 0.366469 11.2399 0.152297 11.5329C-0.0507657 11.8112 -0.0507657 12.1886 0.152297 12.4668C0.366469 12.7601 5.47529 19.6484 11.9999 19.6484C18.5245 19.6484 23.6331 12.7601 23.8475 12.4671C24.0508 12.1889 24.0508 11.8112 23.8475 11.5332ZM11.9999 18.066C7.19383 18.066 3.03127 13.4941 1.79907 11.9995C3.02968 10.5036 7.18351 5.93409 11.9999 5.93409C16.8057 5.93409 20.968 10.5052 22.2007 12.0006C20.9701 13.4965 16.8163 18.066 11.9999 18.066Z'
                fill={color}
            />
            <path
                d='M11.9992 7.25275C9.38162 7.25275 7.25195 9.38242 7.25195 12C7.25195 14.6176 9.38162 16.7473 11.9992 16.7473C14.6168 16.7473 16.7465 14.6176 16.7465 12C16.7465 9.38242 14.6168 7.25275 11.9992 7.25275ZM11.9992 15.1648C10.2541 15.1648 8.83441 13.7451 8.83441 12C8.83441 10.2549 10.2541 8.8352 11.9992 8.8352C13.7443 8.8352 15.164 10.2549 15.164 12C15.164 13.7451 13.7444 15.1648 11.9992 15.1648Z'
                fill={color}
            />
        </svg>
    )
}

export const IconStartLiveCarret = ({ color = '#767676' }: SVGProps) => {
    return (
        <svg
            width='6'
            height='10'
            viewBox='0 0 6 10'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M1 0.999999L5 5L1 9'
                stroke={color}
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}

export const IconGoLive = () => {
    return (
        <svg
            width='24'
            height='16'
            viewBox='0 0 24 16'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M2.51204 15.4565L2.5118 15.4561C-0.63724 11.0667 -0.637266 4.9343 2.51172 0.544829C2.82564 0.108068 3.41513 0.0244796 3.82414 0.347374L3.82456 0.347703C4.24385 0.676289 4.32972 1.30065 4.01274 1.74258L4.01271 1.74261C1.37105 5.4275 1.37105 10.5734 4.01271 14.2582L4.01273 14.2582C4.32965 14.7002 4.24385 15.3245 3.82455 15.6531L3.82448 15.6532C3.40957 15.9788 2.82207 15.8912 2.51204 15.4565Z'
                fill='#349BFD'
            />
            <path
                d='M2.51204 15.4565L2.5118 15.4561C-0.63724 11.0667 -0.637266 4.9343 2.51172 0.544829C2.82564 0.108068 3.41513 0.0244796 3.82414 0.347374L3.82456 0.347703C4.24385 0.676289 4.32972 1.30065 4.01274 1.74258L4.01271 1.74261C1.37105 5.4275 1.37105 10.5734 4.01271 14.2582L4.01273 14.2582C4.32965 14.7002 4.24385 15.3245 3.82455 15.6531L3.82448 15.6532C3.40957 15.9788 2.82207 15.8912 2.51204 15.4565Z'
                fill='white'
            />
            <path
                d='M2.51204 15.4565L2.5118 15.4561C-0.63724 11.0667 -0.637266 4.9343 2.51172 0.544829C2.82564 0.108068 3.41513 0.0244796 3.82414 0.347374L3.82456 0.347703C4.24385 0.676289 4.32972 1.30065 4.01274 1.74258L4.01271 1.74261C1.37105 5.4275 1.37105 10.5734 4.01271 14.2582L4.01273 14.2582C4.32965 14.7002 4.24385 15.3245 3.82455 15.6531L3.82448 15.6532C3.40957 15.9788 2.82207 15.8912 2.51204 15.4565Z'
                stroke='#141419'
                strokeWidth='0.3'
            />
            <path
                d='M20.1762 15.6529L20.1761 15.6528C19.7569 15.3242 19.671 14.6999 19.988 14.2579L19.988 14.2579C22.6297 10.573 22.6297 5.42711 19.988 1.74229L19.988 1.74228C19.6711 1.30033 19.7569 0.676031 20.1762 0.347373L20.1762 0.347373L20.1765 0.347114C20.5881 0.0226169 21.177 0.106134 21.4886 0.54393L21.4886 0.54393L21.4889 0.5444C24.638 4.93388 24.638 11.0663 21.4889 15.4558L21.4887 15.4561C21.1787 15.8908 20.5912 15.9786 20.1762 15.6529Z'
                fill='#349BFD'
            />
            <path
                d='M20.1762 15.6529L20.1761 15.6528C19.7569 15.3242 19.671 14.6999 19.988 14.2579L19.988 14.2579C22.6297 10.573 22.6297 5.42711 19.988 1.74229L19.988 1.74228C19.6711 1.30033 19.7569 0.676031 20.1762 0.347373L20.1762 0.347373L20.1765 0.347114C20.5881 0.0226169 21.177 0.106134 21.4886 0.54393L21.4886 0.54393L21.4889 0.5444C24.638 4.93388 24.638 11.0663 21.4889 15.4558L21.4887 15.4561C21.1787 15.8908 20.5912 15.9786 20.1762 15.6529Z'
                fill='white'
            />
            <path
                d='M20.1762 15.6529L20.1761 15.6528C19.7569 15.3242 19.671 14.6999 19.988 14.2579L19.988 14.2579C22.6297 10.573 22.6297 5.42711 19.988 1.74229L19.988 1.74228C19.6711 1.30033 19.7569 0.676031 20.1762 0.347373L20.1762 0.347373L20.1765 0.347114C20.5881 0.0226169 21.177 0.106134 21.4886 0.54393L21.4886 0.54393L21.4889 0.5444C24.638 4.93388 24.638 11.0663 21.4889 15.4558L21.4887 15.4561C21.1787 15.8908 20.5912 15.9786 20.1762 15.6529Z'
                stroke='#141419'
                strokeWidth='0.3'
            />
            <path
                d='M6.41719 13.236L6.41709 13.2359C3.86305 10.2521 3.86305 5.74807 6.41709 2.76416L6.41709 2.76415C6.76475 2.35795 7.35729 2.32688 7.7427 2.68682C8.13159 3.05228 8.16574 3.68416 7.8146 4.09343L7.81445 4.0936C5.90867 6.3215 5.90867 9.67858 7.81445 11.9065L7.8146 11.9067C8.16573 12.3159 8.13166 12.9477 7.74273 13.3132C7.35644 13.674 6.76484 13.6431 6.41719 13.236Z'
                fill='#349BFD'
            />
            <path
                d='M6.41719 13.236L6.41709 13.2359C3.86305 10.2521 3.86305 5.74807 6.41709 2.76416L6.41709 2.76415C6.76475 2.35795 7.35729 2.32688 7.7427 2.68682C8.13159 3.05228 8.16574 3.68416 7.8146 4.09343L7.81445 4.0936C5.90867 6.3215 5.90867 9.67858 7.81445 11.9065L7.8146 11.9067C8.16573 12.3159 8.13166 12.9477 7.74273 13.3132C7.35644 13.674 6.76484 13.6431 6.41719 13.236Z'
                fill='white'
            />
            <path
                d='M6.41719 13.236L6.41709 13.2359C3.86305 10.2521 3.86305 5.74807 6.41709 2.76416L6.41709 2.76415C6.76475 2.35795 7.35729 2.32688 7.7427 2.68682C8.13159 3.05228 8.16574 3.68416 7.8146 4.09343L7.81445 4.0936C5.90867 6.3215 5.90867 9.67858 7.81445 11.9065L7.8146 11.9067C8.16573 12.3159 8.13166 12.9477 7.74273 13.3132C7.35644 13.674 6.76484 13.6431 6.41719 13.236Z'
                stroke='#141419'
                strokeWidth='0.3'
            />
            <path
                d='M16.1879 11.9069L16.1881 11.9067C18.0939 9.6788 18.0939 6.32172 16.1881 4.09382L16.1879 4.09365C15.8367 3.68431 15.8709 3.05239 16.26 2.68687C16.6453 2.32495 17.2375 2.35595 17.5852 2.7641L17.5854 2.76437C20.1395 5.74821 20.1395 10.2522 17.5854 13.2362L17.5853 13.2363C17.2383 13.6426 16.6468 13.6749 16.2598 13.3135C15.8709 12.948 15.8368 12.3161 16.1879 11.9069Z'
                fill='#349BFD'
            />
            <path
                d='M16.1879 11.9069L16.1881 11.9067C18.0939 9.6788 18.0939 6.32172 16.1881 4.09382L16.1879 4.09365C15.8367 3.68431 15.8709 3.05239 16.26 2.68687C16.6453 2.32495 17.2375 2.35595 17.5852 2.7641L17.5854 2.76437C20.1395 5.74821 20.1395 10.2522 17.5854 13.2362L17.5853 13.2363C17.2383 13.6426 16.6468 13.6749 16.2598 13.3135C15.8709 12.948 15.8368 12.3161 16.1879 11.9069Z'
                fill='white'
            />
            <path
                d='M16.1879 11.9069L16.1881 11.9067C18.0939 9.6788 18.0939 6.32172 16.1881 4.09382L16.1879 4.09365C15.8367 3.68431 15.8709 3.05239 16.26 2.68687C16.6453 2.32495 17.2375 2.35595 17.5852 2.7641L17.5854 2.76437C20.1395 5.74821 20.1395 10.2522 17.5854 13.2362L17.5853 13.2363C17.2383 13.6426 16.6468 13.6749 16.2598 13.3135C15.8709 12.948 15.8368 12.3161 16.1879 11.9069Z'
                stroke='#141419'
                strokeWidth='0.3'
            />
            <path
                d='M12.0027 11.2786C10.2853 11.2786 8.87656 9.81431 8.87656 8.00017C8.87656 6.18602 10.2853 4.72178 12.0027 4.72178C13.72 4.72178 15.1288 6.18602 15.1288 8.00017C15.1288 9.81431 13.72 11.2786 12.0027 11.2786Z'
                fill='#349BFD'
            />
            <path
                d='M12.0027 11.2786C10.2853 11.2786 8.87656 9.81431 8.87656 8.00017C8.87656 6.18602 10.2853 4.72178 12.0027 4.72178C13.72 4.72178 15.1288 6.18602 15.1288 8.00017C15.1288 9.81431 13.72 11.2786 12.0027 11.2786Z'
                fill='white'
            />
            <path
                d='M12.0027 11.2786C10.2853 11.2786 8.87656 9.81431 8.87656 8.00017C8.87656 6.18602 10.2853 4.72178 12.0027 4.72178C13.72 4.72178 15.1288 6.18602 15.1288 8.00017C15.1288 9.81431 13.72 11.2786 12.0027 11.2786Z'
                stroke='#141419'
                strokeWidth='0.3'
            />
        </svg>
    )
}
export const IconGoLiveSidebar = () => {
    return (
        <svg
            width="25"
            height="16"
            viewBox="0 0 24 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            {/* outer left */}
            <path
                d="M2.5 15.4C-0.6 11.1 -0.6 4.9 2.5 0.5"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
            />

            {/* outer right */}
            <path
                d="M21.5 0.5C24.6 4.9 24.6 11.1 21.5 15.4"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
            />

            {/* inner left */}
            <path
                d="M6.5 13.2C3.9 10.2 3.9 5.8 6.5 2.8"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
            />

            {/* inner right */}
            <path
                d="M17.5 2.8C20.1 5.8 20.1 10.2 17.5 13.2"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
            />

            {/* center dot */}
            <circle cx="12" cy="8" r="1.8" fill="currentColor" />
        </svg>
    )
}
export const IconLiveCamera = ({ color = '#696B73' }: SVGProps) => {
    return (
        <svg
            width='24'
            height='18'
            viewBox='0 0 24 18'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M16.3644 13.045C16.3862 13.5415 16.3096 14.0375 16.1392 14.5045C15.9687 14.9714 15.7077 15.4003 15.371 15.7664C15.0343 16.1326 14.6286 16.4289 14.1771 16.6384C13.7256 16.8478 13.2372 16.9663 12.7397 16.9871C12.5856 16.9988 12.4307 16.9988 12.2765 16.9871H5.07344C4.57797 17.0282 4.07926 16.9708 3.60612 16.8184C3.13298 16.6659 2.69476 16.4214 2.31682 16.0989C1.93888 15.7764 1.6287 15.3824 1.40417 14.9396C1.17964 14.4968 1.04521 14.0139 1.00867 13.5189C0.99711 13.3612 0.99711 13.2028 1.00867 13.045V4.95253C0.986919 4.45598 1.06347 3.95997 1.23393 3.49299C1.4044 3.026 1.66543 2.59717 2.0021 2.23101C2.33878 1.86485 2.74449 1.56856 3.19599 1.35909C3.6475 1.14963 4.13594 1.03112 4.63338 1.01031H12.2881C13.288 0.936682 14.2766 1.25953 15.0397 1.90876C15.8028 2.55799 16.2788 3.48127 16.3644 4.47851C16.3644 4.62879 16.3644 4.7791 16.3644 4.92939V13.045Z'
                stroke={color}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M16.3633 8.02765L21.1113 4.15487C21.347 3.96187 21.6493 3.8694 21.9528 3.89753C22.2563 3.92567 22.5365 4.07215 22.7326 4.30516C22.9052 4.51315 22.9994 4.77487 22.9989 5.04499V12.9871C22.9996 13.2059 22.9382 13.4205 22.8217 13.6057C22.7052 13.791 22.5384 13.9395 22.3407 14.0339C22.1431 14.1283 21.9226 14.1649 21.705 14.1392C21.4873 14.1135 21.2815 14.0267 21.1113 13.8889L16.3633 10.0161'
                stroke={color}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}

export const IconLiveMicrophone = ({ color = '#696B73' }: SVGProps) => {
    return (
        <svg
            width='22'
            height='24'
            viewBox='0 0 22 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g clipPath='url(#clip0)'>
                <path
                    d='M0.993164 10.8018C1.08647 13.11 2.1605 15.2955 3.98942 16.8985C5.81834 18.5016 8.25965 19.3972 10.7999 19.3972C13.3402 19.3972 15.7814 18.5016 17.6104 16.8985C19.4393 15.2955 20.5133 13.11 20.6067 10.8018'
                    stroke={color}
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M10.8066 23.0969V19.713'
                    stroke={color}
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M10.9657 15.1972H10.6479C9.36235 15.1972 8.12947 14.7328 7.22046 13.9062C6.31146 13.0797 5.80078 11.9586 5.80078 10.7897V5.3106C5.80078 4.14168 6.31146 3.02063 7.22046 2.19408C8.12947 1.36753 9.36235 0.903137 10.6479 0.903137H10.979C12.2645 0.903137 13.4974 1.36753 14.4064 2.19408C15.3154 3.02063 15.826 4.14168 15.826 5.3106V10.7897C15.826 11.9586 15.3154 13.0797 14.4064 13.9062C13.4974 14.7328 12.2645 15.1972 10.979 15.1972H10.9657Z'
                    stroke={color}
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </g>
            <defs>
                <clipPath id='clip0'>
                    <rect width='21.6' height='24' fill='white' />
                </clipPath>
            </defs>
        </svg>
    )
}

export const IconLiveConnection = ({ color = '#696B73' }: SVGProps) => {
    return (
        <svg
            width='22'
            height='22'
            viewBox='0 0 22 22'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M21.6476 15.8294C21.5014 15.2849 21.1974 14.8098 20.7751 14.453C21.2563 12.6086 21.2001 10.6837 20.605 8.84576C19.9359 6.77922 18.6482 5.02107 16.8812 3.7614C16.4942 3.48554 15.9564 3.57496 15.6801 3.96116C15.4037 4.34732 15.4933 4.884 15.8802 5.15982C17.3445 6.20361 18.4116 7.66094 18.9664 9.37415C19.4367 10.8267 19.5013 12.3442 19.1613 13.8062C18.1567 13.7474 17.1551 14.242 16.6185 15.1682C16.2518 15.8012 16.1542 16.5387 16.3438 17.2448C16.5336 17.9514 16.988 18.542 17.6236 18.9076C18.9288 19.6585 20.613 19.2175 21.3729 17.906C21.7397 17.2731 21.8372 16.5356 21.6476 15.8294ZM19.8821 17.0458C19.6 17.5328 18.9726 17.7001 18.4837 17.4188C18.4837 17.4188 18.4837 17.4188 18.4836 17.4188C18.2469 17.2826 18.0778 17.0629 18.0072 16.8001C17.9368 16.5377 17.973 16.2637 18.1093 16.0285C18.5619 15.2474 19.7481 15.3951 19.9843 16.2743C20.0546 16.5366 20.0184 16.8106 19.8821 17.0458ZM1.72808 11.887C1.75661 11.8898 1.78488 11.8911 1.81294 11.8911C2.25071 11.8911 2.62531 11.5593 2.66884 11.1155C2.84385 9.33023 3.57677 7.68075 4.78835 6.34545C5.81625 5.21262 7.1036 4.39772 8.54524 3.96009C8.99658 4.85663 9.92707 5.4737 11 5.4737C12.5137 5.4737 13.7452 4.24596 13.7452 2.73685C13.7452 1.22775 12.5137 0 11 0C9.65585 0 8.53506 0.968301 8.30058 2.24177C6.45687 2.74837 4.81182 3.75934 3.51188 5.19196C2.05039 6.80264 1.16626 8.79308 0.954984 10.9481C0.908663 11.4204 1.25482 11.8408 1.72808 11.887ZM11 1.71858C11.5641 1.71858 12.0231 2.17538 12.0231 2.73689C12.0231 3.29841 11.5641 3.75517 11 3.75517C10.4355 3.75517 9.97674 3.29815 9.97674 2.73685C9.97674 2.17534 10.4358 1.71858 11 1.71858ZM14.4517 19.5361C12.812 20.2781 11.0114 20.4703 9.24456 20.0923C7.74718 19.7719 6.39625 19.0694 5.29564 18.0455C5.456 17.8029 5.57851 17.5338 5.65611 17.2449C5.84573 16.5387 5.74815 15.8012 5.38141 15.1682C4.62456 13.862 2.94263 13.4127 1.63209 14.1667C0.996578 14.5323 0.542054 15.1228 0.352347 15.8294C0.162769 16.5356 0.260308 17.2731 0.627089 17.9061C1.30054 19.0684 2.70291 19.5499 3.92546 19.1152C5.28761 20.4531 6.9887 21.3672 8.88362 21.7727C10.9728 22.2197 13.1469 22.0134 15.1628 21.1014C15.5959 20.9054 15.7878 20.3962 15.5915 19.9639C15.3951 19.5317 14.8848 19.3402 14.4517 19.5361ZM3.9927 16.8001C3.75968 17.6679 2.57482 17.8347 2.1178 17.0459C1.98151 16.8106 1.94524 16.5366 2.01567 16.2743C2.08622 16.0114 2.25543 15.7917 2.49211 15.6556C2.98075 15.3744 3.60822 15.5412 3.89057 16.0285C4.02686 16.2637 4.06317 16.5377 3.9927 16.8001Z'
                fill={color}
            />
        </svg>
    )
}

export const IconLiveCircleTip = ({ color = 'white' }: SVGProps) => {
    return (
        <svg
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M12 0C5.3835 0 0 5.3835 0 12C0 18.6165 5.3835 24 12 24C18.6165 24 24 18.6165 24 12C24 5.3835 18.6165 0 12 0ZM12 22.5C6.21 22.5 1.5 17.79 1.5 12C1.5 6.21 6.21 1.5 12 1.5C17.79 1.5 22.5 6.21 22.5 12C22.5 17.79 17.79 22.5 12 22.5Z'
                fill={color}
            />
            <path
                d='M12.3508 11.4601C11.2328 10.9786 10.5 10.6284 10.5 10.1667C10.5 9.49273 11.1729 8.94444 12 8.94444C12.8271 8.94444 13.5 9.49273 13.5 10.1667C13.5 10.5042 13.8358 10.7778 14.25 10.7778C14.6642 10.7778 15 10.5042 15 10.1667C15 9.02976 14.0425 8.07166 12.75 7.79959V7.11111C12.75 6.77359 12.4142 6.5 12 6.5C11.5858 6.5 11.25 6.77359 11.25 7.11111V7.79959C9.95753 8.07166 9 9.02976 9 10.1667C9 11.3993 10.4078 12.0057 11.6498 12.5406C12.7674 13.022 13.5 13.372 13.5 13.8333C13.5 14.5073 12.827 15.0556 12 15.0556C11.1729 15.0556 10.5 14.5073 10.5 13.8333C10.5 13.4958 10.1642 13.2222 9.75 13.2222C9.33578 13.2222 9 13.4958 9 13.8333C9 14.9702 9.95753 15.9283 11.25 16.2004V16.8889C11.25 17.2264 11.5858 17.5 12 17.5C12.4142 17.5 12.75 17.2264 12.75 16.8889V16.2004C14.0425 15.9283 15 14.9702 15 13.8333C15 12.6011 13.5926 11.9949 12.3508 11.4601Z'
                fill={color}
            />
        </svg>
    )
}

export const IconLiveEndStreamLarge = () => {
    return (
        <svg
            width='103'
            height='73'
            viewBox='0 0 103 73'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g
                style={{ mixBlendMode: 'luminosity' }}
                filter='url(#filter0_d_7548_24303)'
            >
                <path
                    d='M18.2441 51.2357C7.25197 36.5943 7.25197 16.148 18.2441 1.50667C19.4948 -0.156087 21.8639 -0.487081 23.5121 0.756282C25.1822 2.00693 25.5134 4.36507 24.2625 6.0316C15.2792 18.0059 15.2792 34.7367 24.2625 46.7107C25.5132 48.3773 25.1822 50.7351 23.5121 51.986C21.8441 53.2369 19.4814 52.8936 18.2441 51.2357Z'
                    fill='url(#paint0_linear_7548_24303)'
                />
                <path
                    d='M79.2774 51.9857C77.6074 50.735 77.2761 48.3769 78.527 46.7104C87.5104 34.7361 87.5104 18.0053 78.527 6.03122C77.2764 4.36469 77.6074 2.0068 79.2774 0.755901C80.9329 -0.491229 83.3019 -0.163751 84.5455 1.50629C95.5376 16.1476 95.5376 36.5939 84.5455 51.2353C83.3084 52.8928 80.9457 53.2371 79.2774 51.9857Z'
                    fill='url(#paint1_linear_7548_24303)'
                />
                <path
                    d='M31.7437 43.9515C22.7677 33.9307 22.7677 18.8112 31.7437 8.79026C33.1343 7.23776 35.518 7.11646 37.0632 8.49594C38.6082 9.8827 38.7408 12.2667 37.3503 13.8154C30.9419 20.9743 30.9419 31.7675 37.3503 38.9263C38.7408 40.475 38.6085 42.8588 37.0632 44.2458C35.5153 45.6278 33.1345 45.5075 31.7437 43.9515Z'
                    fill='url(#paint2_linear_7548_24303)'
                />
                <path
                    d='M65.7305 44.2458C64.1855 42.859 64.0529 40.475 65.4435 38.9262C71.8519 31.7674 71.8519 20.9742 65.4435 13.8154C64.0529 12.2666 64.1853 9.88287 65.7305 8.49586C67.2757 7.10885 69.6595 7.23039 71.0501 8.79019C80.0261 18.8109 80.0261 33.9304 71.0501 43.9514C69.6618 45.5047 67.2813 45.6303 65.7305 44.2458Z'
                    fill='url(#paint3_linear_7548_24303)'
                />
                <path
                    d='M51.3948 37.6716C45.1631 37.6716 40.0938 32.6022 40.0938 26.3706C40.0938 20.139 45.1631 15.0696 51.3948 15.0696C57.6264 15.0696 62.6958 20.139 62.6958 26.3706C62.6958 32.6022 57.6264 37.6716 51.3948 37.6716Z'
                    fill='url(#paint4_linear_7548_24303)'
                />
            </g>
            <defs>
                <filter
                    id='filter0_d_7548_24303'
                    x='0'
                    y='0'
                    width='102.789'
                    height='72.74'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dy='10' />
                    <feGaussianBlur stdDeviation='5' />
                    <feComposite in2='hardAlpha' operator='out' />
                    <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.305882 0 0 0 0 0.67451 0 0 0 0 0.976471 0 0 0 0.2 0'
                    />
                    <feBlend
                        mode='normal'
                        in2='BackgroundImageFix'
                        result='effect1_dropShadow_7548_24303'
                    />
                    <feBlend
                        mode='normal'
                        in='SourceGraphic'
                        in2='effect1_dropShadow_7548_24303'
                        result='shape'
                    />
                </filter>
                <linearGradient
                    id='paint0_linear_7548_24303'
                    x1='17.51'
                    y1='52.74'
                    x2='17.51'
                    y2='0.00415039'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#3C9FFF' />
                    <stop offset='1' stopColor='#76C0FF' />
                </linearGradient>
                <linearGradient
                    id='paint1_linear_7548_24303'
                    x1='85.2796'
                    y1='52.7397'
                    x2='85.2796'
                    y2='0'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#3C9FFF' />
                    <stop offset='1' stopColor='#76C0FF' />
                </linearGradient>
                <linearGradient
                    id='paint2_linear_7548_24303'
                    x1='31.6625'
                    y1='45.2059'
                    x2='31.6625'
                    y2='7.53809'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#3C9FFF' />
                    <stop offset='1' stopColor='#76C0FF' />
                </linearGradient>
                <linearGradient
                    id='paint3_linear_7548_24303'
                    x1='71.1313'
                    y1='45.2059'
                    x2='71.1313'
                    y2='7.53247'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#3C9FFF' />
                    <stop offset='1' stopColor='#76C0FF' />
                </linearGradient>
                <linearGradient
                    id='paint4_linear_7548_24303'
                    x1='51.3948'
                    y1='37.6716'
                    x2='51.3948'
                    y2='15.0696'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#3C9FFF' />
                    <stop offset='1' stopColor='#76C0FF' />
                </linearGradient>
            </defs>
        </svg>
    )
}

export const IconPlus = ({ color, width = '15', height = '15' }: SVGProps) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox='0 0 15 15'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M0 7.69767C0 7.31236 0.239671 7 0.53532 7H14.4647C14.7603 7 15 7.31236 15 7.69767C15 8.08298 14.7603 8.39534 14.4647 8.39534H0.53532C0.239671 8.39534 0 8.08298 0 7.69767Z'
                fill={color ?? '#778797'}
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M7.30233 -3.04961e-08C7.68764 -1.36536e-08 8 0.239671 8 0.53532L8 14.4647C8 14.7603 7.68764 15 7.30233 15C6.91702 15 6.60466 14.7603 6.60466 14.4647L6.60466 0.53532C6.60466 0.239671 6.91702 -4.73386e-08 7.30233 -3.04961e-08Z'
                fill={color ?? '#778797'}
            />
        </svg>
    )
}

export const IconEdit = ({ color }: SVGProps) => {
    return (
        <svg
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g clipPath='url(#clip0_5267_22600)'>
                <path
                    d='M9.33218 0.765747H5.6547C2.63602 0.765747 0.738281 2.90616 0.738281 5.93021V14.0992C0.738281 17.1232 2.62619 19.2538 5.6547 19.2538H14.3273C17.3656 19.2538 19.2437 17.1232 19.2437 14.0992V10.1718'
                    stroke={color ?? '#778797'}
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M6.71778 8.7481L14.0629 1.41382C14.2803 1.19621 14.5385 1.02355 14.8229 0.905758C15.1072 0.787962 15.4119 0.727417 15.7197 0.727417C16.0276 0.727417 16.3324 0.787962 16.6167 0.905758C16.901 1.02355 17.1592 1.19621 17.3766 1.41382L18.5762 2.61163C18.7941 2.82869 18.967 3.08665 19.085 3.37054C19.203 3.65442 19.2637 3.95872 19.2637 4.26608C19.2637 4.57343 19.203 4.87773 19.085 5.16162C18.967 5.44551 18.7941 5.70334 18.5762 5.92041L11.1917 13.294C10.994 13.4908 10.7593 13.6468 10.5012 13.7529C10.243 13.8591 9.96649 13.9133 9.68732 13.9126H6L6.08849 10.2013C6.10653 9.65488 6.3314 9.13549 6.71778 8.7481V8.7481Z'
                    stroke={color ?? '#778797'}
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M12.9414 2.55273L17.435 7.02984'
                    stroke={color ?? '#778797'}
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </g>
            <defs>
                <clipPath id='clip0_5267_22600'>
                    <rect width='20' height='20' fill='white' />
                </clipPath>
            </defs>
        </svg>
    )
}

export const IconOptionsEdit = ({ color = '#778797' }: SVGProps) => {
    return (
        <svg
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M9.33144 0.765779H5.65397C2.63529 0.765779 0.737549 2.90619 0.737549 5.93025V14.0992C0.737549 17.1232 2.62545 19.2538 5.65397 19.2538H14.3265C17.3649 19.2538 19.243 17.1232 19.243 14.0992V10.1718'
                stroke={color}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M6.71607 8.74811L14.0612 1.41382C14.2786 1.19622 14.5368 1.02356 14.8211 0.905765C15.1054 0.787969 15.4102 0.727424 15.718 0.727424C16.0258 0.727424 16.3307 0.787969 16.615 0.905765C16.8993 1.02356 17.1575 1.19622 17.3749 1.41382L18.5745 2.61163C18.7924 2.8287 18.9653 3.08665 19.0833 3.37054C19.2012 3.65443 19.262 3.95873 19.262 4.26608C19.262 4.57344 19.2012 4.87774 19.0833 5.16163C18.9653 5.44551 18.7924 5.70335 18.5745 5.92042L11.19 13.294C10.9923 13.4908 10.7576 13.6468 10.4995 13.7529C10.2413 13.8591 9.96478 13.9133 9.68561 13.9126H5.99829L6.08678 10.2013C6.10482 9.65488 6.32969 9.1355 6.71607 8.74811V8.74811Z'
                stroke={color}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M12.9402 2.55278L17.4338 7.02989'
                stroke='#778797'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}

export const IconPlusInBox = ({ width, height, color }: SVGProps) => {
    return (
        <svg
            width={width ?? '20'}
            height={height ?? '20'}
            viewBox='0 0 20 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g clipPath='url(#clip0_5267_22388)'>
                <path
                    d='M10 6.58618V13.4048'
                    stroke={color ?? '#8C929D'}
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M13.4139 9.99072H6.58594'
                    stroke={color ?? '#8C929D'}
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M14.3643 0.697754H5.63875C2.60619 0.697754 0.699219 2.85586 0.699219 5.89772V14.1117C0.699219 17.1536 2.55968 19.3024 5.63875 19.3024H14.3643C17.4062 19.3024 19.3039 17.1536 19.3039 14.1117V5.89772C19.3039 2.85586 17.4434 0.697754 14.3643 0.697754Z'
                    stroke={color ?? '#8C929D'}
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </g>
            <defs>
                <clipPath id='clip0_5267_22388'>
                    <rect width='20' height='20' fill='white' />
                </clipPath>
            </defs>
        </svg>
    )
}

export const IconSearchBlue = () => {
    return (
        <svg
            width='51'
            height='50'
            viewBox='0 0 51 50'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g filter='url(#filter0_d_5904_21996)'>
                <path
                    d='M22.9 25.95C30.0245 25.95 35.8 20.1409 35.8 12.975C35.8 5.8091 30.0245 0 22.9 0C15.7755 0 10 5.8091 10 12.975C10 20.1409 15.7755 25.95 22.9 25.95Z'
                    fill='url(#paint0_linear_5904_21996)'
                />
                <path
                    d='M22.9521 23.02C28.4486 23.02 32.9043 18.5384 32.9043 13.01C32.9043 7.48163 28.4486 3 22.9521 3C17.4557 3 13 7.48163 13 13.01C13 18.5384 17.4557 23.02 22.9521 23.02Z'
                    fill='#EDF7FF'
                />
                <path
                    d='M38.02 29.9399C37.5154 29.928 37.0358 29.7178 36.685 29.3549L33.685 25.785C33.368 25.4978 33.1776 25.0968 33.1551 24.6697C33.1326 24.2426 33.28 23.8239 33.565 23.505C33.844 23.239 34.2146 23.0907 34.6 23.0907C34.9854 23.0907 35.356 23.239 35.635 23.505L39.475 26.505C39.7454 26.7833 39.9301 27.1333 40.0072 27.5136C40.0844 27.8939 40.0506 28.2883 39.91 28.65C39.7722 29.0125 39.5311 29.3266 39.2164 29.5532C38.9018 29.7799 38.5275 29.9091 38.14 29.9249L38.02 29.9399Z'
                    fill='url(#paint1_linear_5904_21996)'
                />
            </g>
            <defs>
                <filter
                    id='filter0_d_5904_21996'
                    x='0'
                    y='0'
                    width='50.0479'
                    height='49.9399'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dy='10' />
                    <feGaussianBlur stdDeviation='5' />
                    <feComposite in2='hardAlpha' operator='out' />
                    <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.305882 0 0 0 0 0.67451 0 0 0 0 0.976471 0 0 0 0.2 0'
                    />
                    <feBlend
                        mode='normal'
                        in2='BackgroundImageFix'
                        result='effect1_dropShadow_5904_21996'
                    />
                    <feBlend
                        mode='normal'
                        in='SourceGraphic'
                        in2='effect1_dropShadow_5904_21996'
                        result='shape'
                    />
                </filter>
                <linearGradient
                    id='paint0_linear_5904_21996'
                    x1='22.9'
                    y1='25.95'
                    x2='22.9'
                    y2='0'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#3C9FFF' />
                    <stop offset='1' stopColor='#76C0FF' />
                </linearGradient>
                <linearGradient
                    id='paint1_linear_5904_21996'
                    x1='36.6002'
                    y1='29.9399'
                    x2='36.6002'
                    y2='23.0907'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#3C9FFF' />
                    <stop offset='1' stopColor='#76C0FF' />
                </linearGradient>
            </defs>
        </svg>
    )
}

export const IconBecomeCreator = () => {
    return (
        <svg
            width='50'
            height='50'
            viewBox='0 0 50 50'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g filter='url(#filter0_d_5904_22198)'>
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M16 25.987C16 22.7948 20.1948 22 25.2035 22C30.1997 22 34.407 22.8209 34.407 26.013C34.407 29.2052 30.1997 30 25.2035 30C20.2073 30 16 29.1791 16 25.987Z'
                    fill='url(#paint0_linear_5904_22198)'
                />
                <path
                    d='M16.3397 20C15.4621 18.4798 15 16.7554 15 15C15 13.2446 15.4621 11.5202 16.3397 10C17.2174 8.47981 18.4798 7.21743 20 6.33975C21.5202 5.46206 23.2446 5 25 5C26.7554 5 28.4798 5.46206 30 6.33975C31.5202 7.21743 32.7826 8.47981 33.6603 10C34.5379 11.5202 35 13.2446 35 15C35 16.7554 34.5379 18.4798 33.6603 20L32.0148 19.05C32.7257 17.8186 33.1 16.4218 33.1 15C33.1 13.5782 32.7257 12.1814 32.0148 10.95C31.3039 9.71864 30.2814 8.69612 29.05 7.98519C27.8186 7.27427 26.4218 6.9 25 6.9C23.5782 6.9 22.1814 7.27427 20.95 7.98519C19.7186 8.69612 18.6961 9.71864 17.9852 10.95C17.2743 12.1814 16.9 13.5782 16.9 15C16.9 16.4218 17.2743 17.8186 17.9852 19.05L16.3397 20Z'
                    fill='url(#paint1_linear_5904_22198)'
                />
                <path
                    d='M12.8647 23.8168C11.2387 21.5788 10.2633 18.9347 10.0462 16.1769C9.8292 13.4191 10.379 10.655 11.6349 8.19014C12.8908 5.72532 14.8038 3.6558 17.1625 2.2104C19.5212 0.764991 22.2337 -3.29882e-08 25 0C27.7663 3.29882e-08 30.4788 0.764991 32.8375 2.2104C35.1962 3.6558 37.1092 5.72532 38.3651 8.19014C39.621 10.655 40.1708 13.4191 39.9538 16.1769C39.7367 18.9347 38.7613 21.5788 37.1353 23.8168L35.679 22.7588C37.1099 20.7893 37.9683 18.4625 38.1593 16.0357C38.3503 13.6088 37.8665 11.1764 36.7613 9.00733C35.6561 6.83828 33.9726 5.01711 31.897 3.74515C29.8213 2.47319 27.4344 1.8 25 1.8C22.5656 1.8 20.1787 2.47319 18.103 3.74515C16.0274 5.01711 14.3439 6.83828 13.2387 9.00733C12.1335 11.1764 11.6497 13.6088 11.8407 16.0357C12.0317 18.4625 12.8901 20.7893 14.321 22.7588L12.8647 23.8168Z'
                    fill='url(#paint2_linear_5904_22198)'
                />
                <circle
                    cx='25'
                    cy='15'
                    r='5'
                    fill='url(#paint3_linear_5904_22198)'
                />
            </g>
            <defs>
                <filter
                    id='filter0_d_5904_22198'
                    x='0'
                    y='0'
                    width='50'
                    height='50'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dy='10' />
                    <feGaussianBlur stdDeviation='5' />
                    <feComposite in2='hardAlpha' operator='out' />
                    <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.305882 0 0 0 0 0.67451 0 0 0 0 0.976471 0 0 0 0.2 0'
                    />
                    <feBlend
                        mode='normal'
                        in2='BackgroundImageFix'
                        result='effect1_dropShadow_5904_22198'
                    />
                    <feBlend
                        mode='normal'
                        in='SourceGraphic'
                        in2='effect1_dropShadow_5904_22198'
                        result='shape'
                    />
                </filter>
                <linearGradient
                    id='paint0_linear_5904_22198'
                    x1='25.2035'
                    y1='30'
                    x2='25.2035'
                    y2='22'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#3C9FFF' />
                    <stop offset='1' stopColor='#76C0FF' />
                </linearGradient>
                <linearGradient
                    id='paint1_linear_5904_22198'
                    x1='25'
                    y1='25'
                    x2='25'
                    y2='5'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#3C9FFF' />
                    <stop offset='1' stopColor='#76C0FF' />
                </linearGradient>
                <linearGradient
                    id='paint2_linear_5904_22198'
                    x1='25'
                    y1='30'
                    x2='25'
                    y2='0'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#3C9FFF' />
                    <stop offset='1' stopColor='#76C0FF' />
                </linearGradient>
                <linearGradient
                    id='paint3_linear_5904_22198'
                    x1='25'
                    y1='20'
                    x2='25'
                    y2='10'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#3C9FFF' />
                    <stop offset='1' stopColor='#76C0FF' />
                </linearGradient>
            </defs>
        </svg>
    )
}
/* 
export const IconTwoPeople = () => {
    return (
        <svg
            width='50'
            height='48'
            viewBox='0 0 50 48'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g filter='url(#filter0_d_5904_22211)'>
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M21.026 14.8101C21.9717 14.8224 22.9105 14.6413 23.7887 14.2771C24.6669 13.9128 25.4673 13.3725 26.1444 12.687C26.8214 12.0016 27.3618 11.1845 27.7346 10.2822C28.1073 9.38 28.3052 8.41035 28.317 7.42872C28.3111 6.44579 28.1185 5.47375 27.7502 4.56818C27.3819 3.66261 26.8453 2.84129 26.1708 2.15132C25.4964 1.46135 24.6974 0.916255 23.8197 0.547208C22.9421 0.17816 22.0029 -0.00761912 21.056 0.000591129C20.1104 -0.0117559 19.1717 0.16943 18.2934 0.533711C17.4152 0.897992 16.6147 1.43822 15.9377 2.12366C15.2606 2.8091 14.7204 3.62632 14.3476 4.52855C13.9748 5.43077 13.7769 6.40033 13.7651 7.38196C13.771 8.36285 13.9632 9.33293 14.3307 10.2366C14.6982 11.1403 15.2339 11.9599 15.9069 12.6484C16.58 13.337 17.3772 13.8809 18.2531 14.2491C19.1289 14.6174 20.0661 14.8027 21.0111 14.7945L21.026 14.8101ZM21.0264 18.4384C15.0256 18.4384 10 19.3884 10 23.2036C10 27.0189 15.0406 28 21.0264 28C24.6521 28 27.9311 27.6515 29.9531 26.5287C29.3472 25.4926 29 24.2869 29 23C29 21.8574 29.2738 20.7787 29.7593 19.826C27.7252 18.7762 24.5384 18.4384 21.0264 18.4384ZM29.5021 13.2062C30.639 11.5454 31.2521 9.55963 31.2573 7.52221V7.46484C31.265 5.34347 30.4684 3.28588 29.2621 1.57349C29.2447 1.54569 29.2354 1.51323 29.2354 1.48006C29.2354 1.44688 29.2447 1.41443 29.2621 1.38663C29.2999 1.33809 29.353 1.305 29.4121 1.29319C29.8126 1.21322 30.2194 1.17149 30.6272 1.16859C31.1737 1.15717 31.7191 1.22532 32.2475 1.37104C33.7536 1.69067 35.0842 2.59824 35.9647 3.90642C36.8451 5.21461 37.2083 6.82366 36.9793 8.40168C36.7503 9.9797 35.9466 11.4063 34.734 12.3872C33.5213 13.3681 31.9923 13.8285 30.4622 13.6734C30.1807 13.6586 29.9002 13.6275 29.6221 13.5799C29.5831 13.593 29.5411 13.593 29.5021 13.5799C29.4765 13.5566 29.4561 13.5278 29.4421 13.4955C29.4281 13.4633 29.4208 13.4284 29.4208 13.3931C29.4208 13.3577 29.4281 13.3227 29.4421 13.2905C29.4561 13.2583 29.4765 13.2296 29.5021 13.2062Z'
                    fill='url(#paint0_linear_5904_22211)'
                />
                <path
                    d='M36.0252 27L35.9208 26.9329C34.9985 26.3317 34.141 25.6284 33.3629 24.8353C32.8239 24.2653 32.4125 23.5776 32.1582 22.8217C31.9294 22.1005 31.9493 21.3184 32.2144 20.6109C32.3488 20.2622 32.5547 19.9485 32.8176 19.692C33.0806 19.4354 33.3942 19.2422 33.7363 19.1259C33.8524 19.0842 33.9721 19.0547 34.0937 19.0378H34.1419C34.2536 19.021 34.3664 19.0126 34.4792 19.0126H34.5234C34.7735 19.0208 35.0211 19.0675 35.2582 19.151H35.2823L35.3185 19.1762C35.4061 19.2053 35.4909 19.2432 35.5715 19.2895L35.724 19.3566L35.8405 19.4363C35.8569 19.4534 35.8759 19.4676 35.8967 19.4782C35.9329 19.4981 35.9678 19.5206 36.0011 19.5454C36.4404 19.1939 36.9778 19.0024 37.5311 19C37.7849 18.9998 38.0371 19.0423 38.278 19.1259C38.6176 19.2406 38.9289 19.432 39.1898 19.6864C39.4508 19.9409 39.6549 20.2522 39.7878 20.5983C40.0483 21.3066 40.0696 22.0865 39.8481 22.8091C39.5969 23.5678 39.1851 24.2576 38.6434 24.827C37.8699 25.6186 37.0178 26.3217 36.1015 26.9245L36.0011 26.9874L36.0252 27Z'
                    fill='url(#paint1_linear_5904_22211)'
                />
            </g>
            <defs>
                <filter
                    id='filter0_d_5904_22211'
                    x='0'
                    y='0'
                    width='50'
                    height='48'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dy='10' />
                    <feGaussianBlur stdDeviation='5' />
                    <feComposite in2='hardAlpha' operator='out' />
                    <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.305882 0 0 0 0 0.67451 0 0 0 0 0.976471 0 0 0 0.2 0'
                    />
                    <feBlend
                        mode='normal'
                        in2='BackgroundImageFix'
                        result='effect1_dropShadow_5904_22211'
                    />
                    <feBlend
                        mode='normal'
                        in='SourceGraphic'
                        in2='effect1_dropShadow_5904_22211'
                        result='shape'
                    />
                </filter>
                <linearGradient
                    id='paint0_linear_5904_22211'
                    x1='32.693'
                    y1='24.2626'
                    x2='32.693'
                    y2='16.1302'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#3C9FFF' />
                    <stop offset='1' stopColor='#76C0FF' />
                </linearGradient>
                <linearGradient
                    id='paint1_linear_5904_22211'
                    x1='36'
                    y1='27'
                    x2='36'
                    y2='19'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#3C9FFF' />
                    <stop offset='1' stopColor='#76C0FF' />
                </linearGradient>
            </defs>
        </svg>
    )
}
 */
export const IconTwoPeople = () => {
  const mainPath =
    'M21.026 14.8101C21.9717 14.8224 22.9105 14.6413 23.7887 14.2771C24.6669 13.9128 25.4673 13.3725 26.1444 12.687C26.8214 12.0016 27.3618 11.1845 27.7346 10.2822C28.1073 9.38 28.3052 8.41035 28.317 7.42872C28.3111 6.44579 28.1185 5.47375 27.7502 4.56818C27.3819 3.66261 26.8453 2.84129 26.1708 2.15132C25.4964 1.46135 24.6974 0.916255 23.8197 0.547208C22.9421 0.17816 22.0029 -0.00761912 21.056 0.000591129C20.1104 -0.0117559 19.1717 0.16943 18.2934 0.533711C17.4152 0.897992 16.6147 1.43822 15.9377 2.12366C15.2606 2.8091 14.7204 3.62632 14.3476 4.52855C13.9748 5.43077 13.7769 6.40033 13.7651 7.38196C13.771 8.36285 13.9632 9.33293 14.3307 10.2366C14.6982 11.1403 15.2339 11.9599 15.9069 12.6484C16.58 13.337 17.3772 13.8809 18.2531 14.2491C19.1289 14.6174 20.0661 14.8027 21.0111 14.7945L21.026 14.8101ZM21.0264 18.4384C15.0256 18.4384 10 19.3884 10 23.2036C10 27.0189 15.0406 28 21.0264 28C24.6521 28 27.9311 27.6515 29.9531 26.5287C29.3472 25.4926 29 24.2869 29 23C29 21.8574 29.2738 20.7787 29.7593 19.826C27.7252 18.7762 24.5384 18.4384 21.0264 18.4384ZM29.5021 13.2062C30.639 11.5454 31.2521 9.55963 31.2573 7.52221V7.46484C31.265 5.34347 30.4684 3.28588 29.2621 1.57349C29.2447 1.54569 29.2354 1.51323 29.2354 1.48006C29.2354 1.44688 29.2447 1.41443 29.2621 1.38663C29.2999 1.33809 29.353 1.305 29.4121 1.29319C29.8126 1.21322 30.2194 1.17149 30.6272 1.16859C31.1737 1.15717 31.7191 1.22532 32.2475 1.37104C33.7536 1.69067 35.0842 2.59824 35.9647 3.90642C36.8451 5.21461 37.2083 6.82366 36.9793 8.40168C36.7503 9.9797 35.9466 11.4063 34.734 12.3872C33.5213 13.3681 31.9923 13.8285 30.4622 13.6734C30.1807 13.6586 29.9002 13.6275 29.6221 13.5799C29.5831 13.593 29.5411 13.593 29.5021 13.5799C29.4765 13.5566 29.4561 13.5278 29.4421 13.4955C29.4281 13.4633 29.4208 13.4284 29.4208 13.3931C29.4208 13.3577 29.4281 13.3227 29.4421 13.2905C29.4561 13.2583 29.4765 13.2296 29.5021 13.2062Z'

  const heartPath =
    'M36.0252 27L35.9208 26.9329C34.9985 26.3317 34.141 25.6284 33.3629 24.8353C32.8239 24.2653 32.4125 23.5776 32.1582 22.8217C31.9294 22.1005 31.9493 21.3184 32.2144 20.6109C32.3488 20.2622 32.5547 19.9485 32.8176 19.692C33.0806 19.4354 33.3942 19.2422 33.7363 19.1259C33.8524 19.0842 33.9721 19.0547 34.0937 19.0378H34.1419C34.2536 19.021 34.3664 19.0126 34.4792 19.0126H34.5234C34.7735 19.0208 35.0211 19.0675 35.2582 19.151H35.2823L35.3185 19.1762C35.4061 19.2053 35.4909 19.2432 35.5715 19.2895L35.724 19.3566L35.8405 19.4363C35.8569 19.4534 35.8759 19.4676 35.8967 19.4782C35.9329 19.4981 35.9678 19.5206 36.0011 19.5454C36.4404 19.1939 36.9778 19.0024 37.5311 19C37.7849 18.9998 38.0371 19.0423 38.278 19.1259C38.6176 19.2406 38.9289 19.432 39.1898 19.6864C39.4508 19.9409 39.6549 20.2522 39.7878 20.5983C40.0483 21.3066 40.0696 22.0865 39.8481 22.8091C39.5969 23.5678 39.1851 24.2576 38.6434 24.827C37.8699 25.6186 37.0178 26.3217 36.1015 26.9245L36.0011 26.9874L36.0252 27Z'

  return (
    <span className="iconTwoPeopleWrap">
      <svg
        className="iconTwoPeopleGlow"
        width="50"
        height="48"
        viewBox="0 0 50 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#twoPeopleGlowFilter)">
          <path fillRule="evenodd" clipRule="evenodd" d={mainPath} fill="#4EACF9" />
          <path d={heartPath} fill="#4EACF9" />
        </g>

        <defs>
          <filter
            id="twoPeopleGlowFilter"
            x="-10"
            y="-10"
            width="70"
            height="70"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="10" />
            <feGaussianBlur stdDeviation="5" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.305882 0 0 0 0 0.67451 0 0 0 0 0.976471 0 0 0 0.2 0"
            />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
          </filter>
        </defs>
      </svg>

      <svg
        className="iconTwoPeopleMain"
        width="50"
        height="48"
        viewBox="0 0 50 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path fillRule="evenodd" clipRule="evenodd" d={mainPath} fill="url(#twoPeopleMainGradient)" />
        <path d={heartPath} fill="url(#twoPeopleHeartGradient)" />

        <defs>
          <linearGradient
            id="twoPeopleMainGradient"
            x1="32.693"
            y1="24.2626"
            x2="32.693"
            y2="16.1302"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#3C9FFF" />
            <stop offset="1" stopColor="#76C0FF" />
          </linearGradient>

          <linearGradient
            id="twoPeopleHeartGradient"
            x1="36"
            y1="27"
            x2="36"
            y2="19"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#3C9FFF" />
            <stop offset="1" stopColor="#76C0FF" />
          </linearGradient>
        </defs>
      </svg>
    </span>
  )
}
export const IconUnrestrictUser = () => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='30'
            height='30'
            viewBox='0 0 24 24'
            fill='none'
        >
            {/* User silhouette */}
            <circle cx='9' cy='9' r='3.5' stroke='#6B7280' strokeWidth='1.5' />
            <ellipse
                cx='9'
                cy='15'
                rx='5.5'
                ry='3'
                stroke='#6B7280'
                strokeWidth='1.5'
            />

            {/* Prohibited circle */}
            <circle cx='16' cy='6' r='4' stroke='#EF4444' strokeWidth='1.5' />
            <line
                x1='14.343'
                y1='4.343'
                x2='17.657'
                y2='7.657'
                stroke='#EF4444'
                strokeWidth='1.5'
            />
        </svg>
    )
}

export const supportIcon = () => {
    return (
        <svg
            width='97'
            height='110'
            viewBox='0 0 97 110'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M22.5586 58.2227C27.8895 58.2227 32.2266 53.8856 32.2266 48.5547V35.4492C32.2266 30.1183 27.8895 25.7812 22.5586 25.7812C22.0093 25.7812 21.4711 25.8298 20.9466 25.9183C24.8981 14.5933 35.6845 6.44531 48.3399 6.44531C60.9952 6.44531 71.7817 14.5933 75.7331 25.9183C75.2087 25.8298 74.6705 25.7812 74.1211 25.7812C68.7902 25.7812 64.4532 30.1183 64.4532 35.4492V48.5547C64.4532 53.8856 68.7902 58.2227 74.1211 58.2227C79.452 58.2227 83.7891 53.8856 83.7891 48.5547V35.4492C83.7891 15.9025 67.8866 0 48.3399 0C28.7932 0 12.8907 15.9025 12.8907 35.4492V48.5547C12.8907 53.8856 17.2277 58.2227 22.5586 58.2227ZM96.6365 106.251L91.9856 78.1322C90.6856 70.3306 84.0011 64.668 76.0917 64.668H20.5881C12.6786 64.668 5.99417 70.3306 4.69351 78.1361L0.043215 106.251C-0.111258 107.185 0.152786 108.14 0.764875 108.862C1.37739 109.584 2.27609 110 3.22269 110H19.336L28.1446 106.777H68.75L77.3438 110H93.4571C94.4037 110 95.3024 109.584 95.9147 108.862C96.527 108.14 96.791 107.185 96.6365 106.251Z'
                fill='url(#paint0_linear_4945_14778)'
            />
            <path
                d='M48.3398 64.668C60.7787 64.668 70.8984 54.4517 70.8984 41.8945C70.8984 29.4557 60.7787 19.3359 48.3398 19.3359C35.901 19.3359 25.7812 29.4557 25.7812 41.8945C25.7812 54.4517 35.901 64.668 48.3398 64.668ZM74.1211 77.5586H22.5586C20.7788 77.5586 19.3359 79.0015 19.3359 80.7812V110H77.3438V80.7812C77.3438 79.0015 75.9009 77.5586 74.1211 77.5586ZM48.3398 96.8945C46.5601 96.8945 45.1172 95.4516 45.1172 93.6719C45.1172 91.8921 46.5601 90.4492 48.3398 90.4492C50.1196 90.4492 51.5625 91.8921 51.5625 93.6719C51.5625 95.4516 50.1196 96.8945 48.3398 96.8945Z'
                fill='url(#paint1_linear_4945_14778)'
            />
            <defs>
                <linearGradient
                    id='paint0_linear_4945_14778'
                    x1='48.3399'
                    y1='110'
                    x2='48.3399'
                    y2='0'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#4AA6F0' />
                    <stop offset='1' stopColor='#00C0FF' />
                </linearGradient>
                <linearGradient
                    id='paint1_linear_4945_14778'
                    x1='48.3398'
                    y1='110'
                    x2='48.3398'
                    y2='19.3359'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#ADDCFF' />
                    <stop offset='0.5028' stopColor='#EAF6FF' />
                    <stop offset='1' stopColor='#EAF6FF' />
                </linearGradient>
            </defs>
        </svg>
    )
}

export const chatBubbles = () => {
    return (
        <svg
            width='50'
            height='50'
            viewBox='0 0 50 50'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g filter='url(#filter0_d_4945_14739)'>
                <path
                    d='M35.7792 28.5104L39.5551 29.5551L38.5107 25.7792C39.4525 24.3295 40 22.5998 40 20.7422C40 15.6292 35.8552 11.4844 30.7422 11.4844C25.6292 11.4844 21.4844 15.6292 21.4844 20.7422C21.4844 25.8552 25.6292 30 30.7422 30C32.5998 30 34.3295 29.4525 35.7792 28.5104Z'
                    fill='#BBDFFF'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M11.5884 17.2776C10.5479 15.518 10 13.5136 10 11.4551C10 5.13863 15.1386 0 21.4551 0C27.7715 0 32.9102 5.13863 32.9102 11.4551C32.9102 17.7715 27.7715 22.9102 21.4551 22.9102C19.3965 22.9102 17.3922 22.3622 15.6326 21.3217L10.0421 22.8678L11.5884 17.2776Z'
                    fill='url(#paint0_linear_4945_14739)'
                />
            </g>
            <defs>
                <filter
                    id='filter0_d_4945_14739'
                    x='0'
                    y='0'
                    width='50'
                    height='50'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dy='10' />
                    <feGaussianBlur stdDeviation='5' />
                    <feComposite in2='hardAlpha' operator='out' />
                    <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.305882 0 0 0 0 0.67451 0 0 0 0 0.976471 0 0 0 0.2 0'
                    />
                    <feBlend
                        mode='normal'
                        in2='BackgroundImageFix'
                        result='effect1_dropShadow_4945_14739'
                    />
                    <feBlend
                        mode='normal'
                        in='SourceGraphic'
                        in2='effect1_dropShadow_4945_14739'
                        result='shape'
                    />
                </filter>
                <linearGradient
                    id='paint0_linear_4945_14739'
                    x1='21.4551'
                    y1='22.9102'
                    x2='21.4551'
                    y2='0'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#3C9FFF' />
                    <stop offset='1' stopColor='#76C0FF' />
                </linearGradient>
            </defs>
        </svg>
    )
}

export const IconLightMessage = () => {
    return (
        <svg
            width='30'
            height='28'
            viewBox='0 0 30 28'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M23.1847 9.55408L17.0052 14.6696C16.4396 15.1309 15.7415 15.3815 15.0226 15.3815C14.3037 15.3815 13.6057 15.1309 13.04 14.6696L6.875 9.55408'
                stroke='#0D1444'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M8.16266 1.12842H21.8095C22.7851 1.14496 23.7474 1.36645 24.6385 1.7796C25.5297 2.19274 26.3312 2.78897 26.995 3.53248C27.6588 4.27598 28.1711 5.15141 28.5011 6.10605C28.831 7.06069 28.9719 8.07485 28.9152 9.08755V18.9123C28.9729 19.9273 28.832 20.944 28.5012 21.9008C28.1704 22.8576 27.6564 23.7347 26.9904 24.4792C26.3304 25.2256 25.53 25.8231 24.6388 26.2346C23.7476 26.6461 22.7846 26.8629 21.8095 26.8715H8.16266C3.9369 26.8715 1.08594 23.3057 1.08594 18.9274V9.10261C1.08594 4.70927 3.98031 1.12842 8.16266 1.12842Z'
                stroke='#0D1444'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}

export const IconPostLockedOutline = ({ color = '#545151' }: SVGProps) => {
    return (
        <svg
            width='26'
            height='30'
            viewBox='0 0 26 30'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M20.0909 11.1278V7.89466C20.0909 6.07604 19.3436 4.33196 18.0138 3.04599C16.684 1.76003 14.8805 1.03762 12.9999 1.03762C11.1192 1.03762 9.31571 1.76003 7.9859 3.04599C6.6561 4.33196 5.90906 6.07604 5.90906 7.89466V11.1579'
                stroke={color}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M18.9403 28.8722H6.99761C5.43454 28.8722 3.9355 28.2717 2.83025 27.2029C1.72499 26.1341 1.104 24.6844 1.104 23.1729V16.7217C1.104 15.2102 1.72499 13.7606 2.83025 12.6918C3.9355 11.6229 5.43454 11.0226 6.99761 11.0226H18.878C20.4411 11.0226 21.9401 11.6229 23.0454 12.6918C24.1506 13.7606 24.7716 15.2102 24.7716 16.7217V23.1729C24.7758 24.6753 24.1647 26.1182 23.0719 27.1862C21.9792 28.2541 20.4938 28.8603 18.9403 28.8722V28.8722Z'
                stroke={color}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M12.9999 18.2857V21.624'
                stroke={color}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}

export const IconPremiumPostLockedOutline = ({ color = '#fff' }: SVGProps) => {
    return (
        <svg
            width='26'
            height='30'
            viewBox='0 0 26 30'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g opacity='0.7'>
                <path
                    d='M19.4285 11.1278V7.89464C19.4285 6.07602 18.7059 4.33194 17.4199 3.04598C16.134 1.76001 14.3899 1.0376 12.5713 1.0376C10.7527 1.0376 9.00857 1.76001 7.72261 3.04598C6.43665 4.33194 5.71423 6.07602 5.71423 7.89464V11.1579'
                    stroke={color}
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M18.3159 28.8722H6.76693C5.2554 28.8722 3.80578 28.2717 2.73696 27.2029C1.66815 26.134 1.06763 24.6844 1.06763 23.1729V16.7217C1.06763 15.2102 1.66815 13.7606 2.73696 12.6917C3.80578 11.6229 5.2554 11.0226 6.76693 11.0226H18.2557C19.7672 11.0226 21.2168 11.6229 22.2856 12.6917C23.3545 13.7606 23.955 15.2102 23.955 16.7217V23.1729C23.959 24.6753 23.368 26.1182 22.3113 27.1862C21.2547 28.2541 19.8182 28.8603 18.3159 28.8722V28.8722Z'
                    stroke={color}
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M12.5714 18.2856V21.6239'
                    stroke={color}
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </g>
        </svg>
    )
}

export const IconMasterCard = ({ width, height }: SVGProps) => {
    return (
        <svg
            width={width ?? '49'}
            height={height ?? '30'}
            viewBox='0 0 49 30'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M24.4458 26.4168C21.8566 28.6512 18.4979 30.0001 14.8278 30.0001C6.63865 30.0001 0 23.2843 0 15.0001C0 6.71584 6.63865 0.00012207 14.8278 0.00012207C18.4979 0.00012207 21.8566 1.34896 24.4458 3.58333C27.035 1.34896 30.3937 0.00012207 34.0638 0.00012207C42.2529 0.00012207 48.8916 6.71584 48.8916 15.0001C48.8916 23.2843 42.2529 30.0001 34.0638 30.0001C30.3937 30.0001 27.035 28.6512 24.4458 26.4168Z'
                fill='#ED0006'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M24.4453 26.4167C27.6335 23.6655 29.6552 19.5715 29.6552 15C29.6552 10.4284 27.6335 6.33448 24.4453 3.58321C27.0345 1.34884 30.3932 0 34.0633 0C42.2525 0 48.8911 6.71571 48.8911 15C48.8911 23.2842 42.2525 29.9999 34.0633 29.9999C30.3932 29.9999 27.0345 28.6511 24.4453 26.4167Z'
                fill='#F9A000'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M24.446 26.4167C27.6341 23.6654 29.6557 19.5716 29.6557 15.0001C29.6557 10.4286 27.6341 6.33477 24.446 3.5835C21.2579 6.33477 19.2363 10.4286 19.2363 15.0001C19.2363 19.5716 21.2579 23.6654 24.446 26.4167Z'
                fill='#FF5E00'
            />
        </svg>
    )
}

export const IconVisa = () => {
    return (
        <svg
            width='63'
            height='20'
            viewBox='0 0 63 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M15.6673 19.8443H10.2439L6.17703 4.32889C5.98399 3.61518 5.57413 2.98422 4.97124 2.68684C3.46664 1.93952 1.80868 1.34476 0 1.04479V0.447449H8.73668C9.94247 0.447449 10.8468 1.34476 10.9975 2.38688L13.1077 13.5787L18.5284 0.447449H23.8011L15.6673 19.8443ZM26.8153 19.8443H21.6934L25.911 0.447449H31.0329L26.8153 19.8443ZM37.6598 5.82087C37.8105 4.77617 38.7149 4.17882 39.7699 4.17882C41.4279 4.02884 43.2339 4.32881 44.7412 5.07355L45.6455 0.897309C44.1383 0.299965 42.4803 0 40.9757 0C36.0045 0 32.3871 2.68676 32.3871 6.41563C32.3871 9.25237 34.9494 10.7418 36.7581 11.6392C38.7149 12.5339 39.4685 13.1312 39.3178 14.026C39.3178 15.368 37.8105 15.9654 36.3059 15.9654C34.4972 15.9654 32.6886 15.518 31.0332 14.7707L30.1289 18.9495C31.9376 19.6943 33.8944 19.9942 35.703 19.9942C41.2772 20.1416 44.7412 17.4574 44.7412 13.4286C44.7412 8.35506 37.6598 8.05768 37.6598 5.82087ZM62.6668 19.8443L58.5999 0.447449H54.2315C53.3272 0.447449 52.4228 1.04479 52.1214 1.93952L44.5905 19.8443H49.8632L50.9156 17.0102H57.3941L57.997 19.8443H62.6668ZM54.9852 5.67078L56.4898 12.9811H52.2721L54.9852 5.67078Z'
                fill='#172B85'
            />
        </svg>
    )
}

export const IconCreditCardOutline = ({ width, height, color }: SVGProps) => {
    return (
        <svg
            width={width ?? '20'}
            height={height ?? '16'}
            viewBox='0 0 20 16'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M2.14022 0C0.965347 0 0 1.08116 0 2.39705V13.5951C0 14.911 0.965347 16 2.14022 16H17.8542C19.0291 16 20 14.911 20 13.5951V2.39705C20 1.08116 19.0291 0 17.8542 0H2.14022ZM2.14022 1.59391H17.8542C18.2623 1.59391 18.5713 1.93995 18.5713 2.39705V4.79575H1.42867V2.39705C1.42867 1.93995 1.73212 1.59391 2.14022 1.59391ZM1.42867 6.39594H18.5713V13.5951C18.5713 14.0522 18.2623 14.3982 17.8542 14.3982H2.14022C1.73212 14.3982 1.42867 14.0522 1.42867 13.5951V6.39594ZM13.4984 10.401C13.3119 10.4157 13.138 10.5116 13.0139 10.6681C12.8897 10.8246 12.8252 11.0293 12.8341 11.2385C12.843 11.4476 12.9247 11.6446 13.0617 11.7871C13.1986 11.9296 13.3799 12.0065 13.5668 12.0012H16.4255C16.5207 12.0036 16.6153 11.9846 16.7038 11.9455C16.7923 11.9063 16.8729 11.8477 16.941 11.7732C17.009 11.6986 17.0631 11.6097 17.1 11.5115C17.1369 11.4132 17.1559 11.3077 17.1559 11.2011C17.1559 11.0945 17.1369 10.989 17.1 10.8908C17.0631 10.7925 17.009 10.7035 16.941 10.629C16.8729 10.5544 16.7923 10.4959 16.7038 10.4568C16.6153 10.4176 16.5207 10.3987 16.4255 10.401H13.5668C13.544 10.3998 13.5212 10.3998 13.4984 10.401Z'
                fill={color ?? '#8C929D'}
            />
        </svg>
    )
}

export const IconChatSmall = () => {
    return (
        <svg
            width='12'
            height='12'
            viewBox='0 0 12 12'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M6 0C2.68396 0 0 2.6835 0 6C0 7.0524 0.274475 8.08026 0.795685 8.98682L0.0226135 11.3875C-0.031311 11.5549 0.0130005 11.7383 0.137329 11.8627C0.260468 11.9858 0.443481 12.0318 0.612488 11.9774L3.01318 11.2043C3.91974 11.7255 4.9476 12 6 12C9.31604 12 12 9.3165 12 6C12 2.68396 9.3165 0 6 0ZM6 11.0625C5.04941 11.0625 4.1228 10.7973 3.32034 10.2955C3.2049 10.2233 3.06152 10.2038 2.92813 10.2468L1.19513 10.8049L1.75323 9.07187C1.79553 8.9404 1.77768 8.79684 1.70444 8.67966C1.20273 7.8772 0.9375 6.95059 0.9375 6C0.9375 3.20856 3.20856 0.9375 6 0.9375C8.79144 0.9375 11.0625 3.20856 11.0625 6C11.0625 8.79144 8.79144 11.0625 6 11.0625ZM6.58594 6C6.58594 6.32355 6.32364 6.58594 6 6.58594C5.67636 6.58594 5.41406 6.32355 5.41406 6C5.41406 5.67636 5.67636 5.41406 6 5.41406C6.32364 5.41406 6.58594 5.67636 6.58594 6ZM8.92969 6C8.92969 6.32355 8.66739 6.58594 8.34375 6.58594C8.02011 6.58594 7.75781 6.32355 7.75781 6C7.75781 5.67636 8.02011 5.41406 8.34375 5.41406C8.66739 5.41406 8.92969 5.67636 8.92969 6ZM4.24219 6C4.24219 6.32355 3.97989 6.58594 3.65625 6.58594C3.3327 6.58594 3.07031 6.32355 3.07031 6C3.07031 5.67636 3.3327 5.41406 3.65625 5.41406C3.97989 5.41406 4.24219 5.67636 4.24219 6Z'
                fill='#757576'
            />
        </svg>
    )
}

export const chatBubblesWithQuestion = ({ width, height, color }: SVGProps) => {
    return (
        <svg
            width={width ?? '14'}
            height={height ?? 14}
            viewBox='0 0 14 14'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M14 9.47461C14 7.43398 12.625 5.65108 10.6861 5.11382C10.5642 2.27338 8.21562 0 5.3457 0C2.39803 0 0 2.39803 0 5.3457C0 6.30637 0.255707 7.24171 0.741272 8.06288L0.0196533 10.6716L2.62852 9.95013C3.38336 10.3965 4.23486 10.6479 5.11371 10.6859C5.65086 12.6249 7.43387 14 9.47461 14C10.2892 14 11.0813 13.7831 11.7773 13.3709L13.9802 13.9802L13.3709 11.7773C13.7831 11.0813 14 10.2892 14 9.47461ZM2.75798 9.06317L1.19618 9.49522L1.62823 7.93343L1.52975 7.7794C1.06566 7.0533 0.820312 6.21173 0.820312 5.3457C0.820312 2.85037 2.85037 0.820312 5.3457 0.820312C7.84103 0.820312 9.87109 2.85037 9.87109 5.3457C9.87109 7.84103 7.84103 9.87109 5.3457 9.87109C4.47968 9.87109 3.63821 9.62575 2.912 9.16165L2.75798 9.06317ZM12.8038 12.8038L11.6449 12.4832L11.4901 12.5839C10.8902 12.9736 10.1931 13.1797 9.47461 13.1797C7.87073 13.1797 6.46135 12.1427 5.96201 10.6556C8.41803 10.3725 10.3725 8.41803 10.6557 5.9619C12.1427 6.46135 13.1797 7.87073 13.1797 9.47461C13.1797 10.1931 12.9736 10.8902 12.5839 11.4901L12.4832 11.6449L12.8038 12.8038Z'
                fill={color ?? 'white'}
            />
            <path
                d='M4.9375 7.41016H5.75781V8.23047H4.9375V7.41016Z'
                fill={color ?? 'white'}
            />
            <path
                d='M6.16406 4.10156C6.16406 4.33452 6.06921 4.54953 5.89703 4.70708L4.93359 5.58891V6.58984H5.75391V5.95015L6.45085 5.31227C6.78987 5.00198 6.98438 4.56075 6.98438 4.10156C6.98438 3.19687 6.24844 2.46094 5.34375 2.46094C4.43906 2.46094 3.70312 3.19687 3.70312 4.10156H4.52344C4.52344 3.64922 4.8914 3.28125 5.34375 3.28125C5.7961 3.28125 6.16406 3.64922 6.16406 4.10156Z'
                fill={color ?? 'white'}
            />
        </svg>
    )
}

export const IconThreeUsersOutline = () => {
    return (
        <svg
            width='30'
            height='24'
            viewBox='0 0 30 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M22.6953 10.5989C23.7436 10.5989 24.749 10.1665 25.4903 9.39687C26.2316 8.62726 26.648 7.58347 26.648 6.49508C26.648 5.40669 26.2316 4.3629 25.4903 3.59329C24.749 2.82368 23.7436 2.39136 22.6953 2.39136V2.39136'
                stroke='#0D1444'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M24.5195 15.0847C25.1705 15.1294 25.8174 15.224 26.455 15.3678C26.9198 15.4113 27.3697 15.5607 27.7725 15.8053C28.1754 16.0499 28.5213 16.3837 28.7858 16.7828C28.9068 17.0458 28.9696 17.3334 28.9696 17.6248C28.9696 17.9162 28.9068 18.2039 28.7858 18.4668C28.5199 18.8646 28.1736 19.1973 27.771 19.4418C27.3684 19.6862 26.9193 19.8364 26.455 19.8819'
                stroke='#0D1444'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M7.29254 10.5989C6.24421 10.5989 5.23883 10.1665 4.49754 9.39687C3.75626 8.62726 3.33984 7.58347 3.33984 6.49508C3.33984 5.40669 3.75626 4.3629 4.49754 3.59329C5.23883 2.82368 6.24421 2.39136 7.29254 2.39136V2.39136'
                stroke='#0D1444'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M5.53398 15.0847C4.87847 15.1294 4.22702 15.224 3.58487 15.3678C3.12104 15.4151 2.67259 15.5661 2.27027 15.8103C1.86795 16.0546 1.52126 16.3864 1.25408 16.7828C1.13307 17.0458 1.07031 17.3334 1.07031 17.6248C1.07031 17.9162 1.13307 18.2039 1.25408 18.4668C1.52126 18.8633 1.86795 19.195 2.27027 19.4393C2.67259 19.6835 3.12104 19.8346 3.58487 19.8819'
                stroke='#0D1444'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M14.9945 15.948C19.4107 15.948 23.1726 16.6414 23.1726 19.4292C23.1726 22.2169 19.4107 22.9386 14.9945 22.9386C10.5783 22.9386 6.81641 22.2311 6.81641 19.4575C6.81641 16.6839 10.5374 15.948 14.9945 15.948Z'
                stroke='#0D1444'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M14.9952 11.9858C13.9517 11.9857 12.9319 11.6634 12.0652 11.0601C11.1986 10.4567 10.5243 9.59943 10.1282 8.5972C9.73206 7.59497 9.632 6.49301 9.84059 5.43155C10.0492 4.37009 10.5571 3.39701 11.2997 2.636C12.0423 1.87498 12.9861 1.36047 14.0112 1.15776C15.0362 0.95506 16.0961 1.07334 17.0562 1.49763C18.0163 1.92193 18.8332 2.63303 19.403 3.54055C19.9728 4.44808 20.2699 5.51103 20.2564 6.59427V6.59427C20.2564 8.03563 19.7078 9.41857 18.7299 10.4417C17.7521 11.4649 16.4243 12.0453 15.036 12.0565L14.9952 11.9858Z'
                stroke='#0D1444'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}

export const IconAttach = () => {
    return (
        <svg
            width='12'
            height='12'
            viewBox='0 0 12 12'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g clipPath='url(#clip0_6223_35929)'>
                <path
                    d='M10.8764 1.44302C9.38081 -0.0526207 6.94717 -0.0526207 5.45134 1.44302L0.80115 6.09318C-0.267109 7.16155 -0.267038 8.89989 0.801291 9.96819C1.3355 10.5024 2.03699 10.7695 2.73875 10.7694C3.44033 10.7694 4.14219 10.5023 4.67631 9.96819L8.93885 5.70555C9.24939 5.39505 9.42044 4.9822 9.42049 4.54307C9.42049 4.10392 9.24951 3.69109 8.93892 3.3805C8.29785 2.73951 7.25479 2.73953 6.61387 3.38062L3.82633 6.16809C3.61232 6.38207 3.61232 6.72906 3.82628 6.94309C4.04026 7.15715 4.38726 7.15708 4.60129 6.94309L7.38885 4.1556C7.60253 3.94192 7.95016 3.94188 8.16386 4.15556C8.26736 4.25906 8.32439 4.39668 8.32439 4.54305C8.32439 4.68941 8.26739 4.82699 8.16386 4.93054L3.9013 9.19316C3.26026 9.83413 2.21729 9.83422 1.5763 9.19321C0.935307 8.55217 0.93526 7.50915 1.57618 6.86811L6.22635 2.21803C7.29478 1.14965 9.03311 1.14965 10.1014 2.21803C10.6189 2.73553 10.904 3.42363 10.904 4.15551C10.904 4.88739 10.6189 5.57549 10.1014 6.09304L5.45127 10.7433C5.23729 10.9573 5.23729 11.3042 5.45132 11.5183C5.55834 11.6253 5.69859 11.6788 5.83881 11.6788C5.97906 11.6788 6.11931 11.6252 6.22633 11.5183L10.8764 6.86807C11.601 6.14355 12 5.18022 12 4.15553C12 3.13087 11.601 2.16754 10.8764 1.44302Z'
                    fill='#757576'
                />
            </g>
            <defs>
                <clipPath id='clip0_6223_35929'>
                    <rect width='12' height='12' fill='white' />
                </clipPath>
            </defs>
        </svg>
    )
}

export const IconNotificationHeartFill = ({ color = '#028DFD' }: SVGProps) => {
    return (
        <svg
            width='10'
            height='9'
            viewBox='0 0 10 9'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M9.61016 2.24095C9.45978 1.90779 9.24294 1.60588 8.97178 1.35213C8.70043 1.09763 8.38049 0.895371 8.02937 0.75637C7.66528 0.611661 7.27477 0.537591 6.88052 0.53846C6.32741 0.53846 5.78777 0.683375 5.3188 0.957104C5.20661 1.02258 5.10003 1.09451 4.99905 1.17287C4.89808 1.09451 4.7915 1.02258 4.67931 0.957104C4.21034 0.683375 3.6707 0.53846 3.11759 0.53846C2.7193 0.53846 2.33336 0.611454 1.96874 0.75637C1.61645 0.895918 1.29895 1.09665 1.02632 1.35213C0.754813 1.6056 0.537924 1.90757 0.387948 2.24095C0.232 2.58767 0.152344 2.95586 0.152344 3.33479C0.152344 3.69225 0.228635 4.06474 0.380094 4.44366C0.506872 4.76033 0.688623 5.08881 0.920861 5.4205C1.28885 5.94542 1.79484 6.49288 2.42312 7.04785C3.46426 7.96779 4.49531 8.60328 4.53906 8.62904L4.80496 8.7922C4.92276 8.86412 5.07422 8.86412 5.19202 8.7922L5.45792 8.62904C5.50168 8.6022 6.5316 7.96779 7.57387 7.04785C8.20214 6.49288 8.70813 5.94542 9.07612 5.4205C9.30836 5.08881 9.49123 4.76033 9.61689 4.44366C9.76835 4.06474 9.84464 3.69225 9.84464 3.33479C9.84576 2.95586 9.76611 2.58767 9.61016 2.24095Z'
                fill={color}
            />
        </svg>
    )
}

export const IconNotificationPlayFill = () => {
    return (
        <svg
            width='12'
            height='12'
            viewBox='0 0 12 12'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M12 6.00003C12 7.18672 11.6481 8.34674 10.9888 9.33343C10.3295 10.3201 9.39247 11.0892 8.29611 11.5433C7.19976 11.9974 5.99336 12.1162 4.82947 11.8847C3.66558 11.6532 2.59648 11.0818 1.75736 10.2427C0.918247 9.40354 0.346802 8.33444 0.11529 7.17055C-0.116221 6.00667 0.00260139 4.80028 0.456727 3.70393C0.910853 2.60757 1.6799 1.6705 2.66659 1.01121C3.65329 0.351924 4.81332 3.05176e-05 6.00001 3.05176e-05C7.59131 3.05176e-05 9.11743 0.632149 10.2427 1.75737C11.3679 2.88259 12 4.40873 12 6.00003Z'
                fill='#028DFD'
            />
            <path
                d='M8.40037 6.00001C8.40223 6.15425 8.35144 6.3045 8.25638 6.42598C8.20509 6.49208 8.14893 6.55425 8.08838 6.61198L8.05238 6.64798C7.3423 7.30259 6.53206 7.83939 5.65238 8.23799C5.47602 8.32089 5.28771 8.37557 5.09437 8.40001C4.95871 8.40044 4.82552 8.36379 4.70919 8.29399C4.59286 8.22419 4.49784 8.12389 4.43438 8.00399C4.37375 7.83168 4.32561 7.65522 4.29037 7.47598C4.22436 6.98684 4.19428 6.49354 4.20037 6.00001C4.19231 5.49006 4.22644 4.9803 4.30238 4.47598C4.32989 4.33196 4.36595 4.18973 4.41038 4.05001C4.47634 3.89603 4.5927 3.76906 4.74037 3.68998C4.85753 3.63064 4.98705 3.59983 5.11837 3.60001C5.28937 3.62557 5.4566 3.6719 5.61637 3.738C6.50746 4.14002 7.32799 4.68297 8.04638 5.34599L8.24437 5.55001C8.34591 5.67797 8.40093 5.83665 8.40037 6.00001Z'
                fill='white'
            />
        </svg>
    )
}

export const IconNotificationPhotoFill = () => {
    return (
        <svg
            width='12'
            height='12'
            viewBox='0 0 12 12'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M8.59801 12H3.40199C1.36799 12 0 10.578 0 8.454V3.55201C0 1.42801 1.36799 2.28882e-05 3.40199 2.28882e-05H8.59801C10.632 2.28882e-05 12 1.42801 12 3.55201V8.46001C12 10.584 10.632 12.006 8.59801 12.006'
                fill='#FD027A'
            />
            <path
                d='M3.4137 10.656C2.95508 10.6666 2.50243 10.5503 2.10571 10.32C2.00839 10.2582 1.93932 10.1607 1.91348 10.0483C1.88765 9.93602 1.90716 9.81804 1.96772 9.71999L2.00372 9.66601L2.8497 8.63399C3.3837 7.97399 3.74369 7.78202 4.14569 7.95002C4.31735 8.02996 4.48195 8.12428 4.63769 8.232C4.88875 8.46254 5.204 8.61127 5.54157 8.65842C5.87914 8.70557 6.22308 8.64892 6.52771 8.49601C7.03501 8.17741 7.44901 7.7303 7.72771 7.20002C7.83518 7.01334 7.95336 6.83302 8.08169 6.66001C8.2099 6.45288 8.41293 6.30305 8.64865 6.24161C8.88437 6.18017 9.13471 6.21183 9.34771 6.33001C9.74416 6.59976 10.1103 6.91157 10.4397 7.26001C10.5718 7.38955 10.6759 7.54473 10.7457 7.71601C10.914 8.24346 10.8711 8.81565 10.6257 9.312C10.5003 9.59738 10.3147 9.85233 10.0817 10.0594C9.84876 10.2665 9.57384 10.4209 9.27572 10.512C9.00503 10.6019 8.72086 10.6445 8.4357 10.638L3.4137 10.656ZM2.56171 4.00802C2.56053 3.71228 2.64711 3.42283 2.81055 3.17635C2.97399 2.92988 3.20692 2.73745 3.4798 2.62345C3.75269 2.50945 4.05327 2.47903 4.34348 2.536C4.63368 2.59296 4.90045 2.73478 5.10999 2.94348C5.31953 3.15218 5.46242 3.41834 5.52055 3.70831C5.57869 3.99828 5.54944 4.29901 5.43654 4.57235C5.32364 4.84569 5.13216 5.07937 4.88635 5.2438C4.64053 5.40823 4.35145 5.496 4.05571 5.49601C3.66051 5.49601 3.28139 5.33943 3.00139 5.06054C2.72138 4.78166 2.5633 4.40321 2.56171 4.00802Z'
                fill='white'
            />
        </svg>
    )
}

export const IconNotificationChatFill = () => {
    return (
        <svg
            width='12'
            height='12'
            viewBox='0 0 12 12'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M6 3.24958e-05C4.4087 3.24958e-05 2.88259 0.632784 1.75737 1.75913C0.632155 2.88547 0 4.41315 0 6.00604C0.015275 7.05904 0.293731 8.09144 0.809985 9.00904C0.856302 9.09049 0.884097 9.18115 0.891357 9.27459C0.898618 9.36803 0.885168 9.46192 0.85199 9.54956L0.45 10.8949C0.41932 10.9889 0.426626 11.0912 0.470361 11.1799C0.514097 11.2686 0.590796 11.3366 0.684009 11.3694C0.766832 11.4025 0.859181 11.4025 0.942004 11.3694L2.142 11.009C2.29755 10.9729 2.45936 10.9737 2.61456 11.0113C2.76976 11.0488 2.91407 11.1221 3.036 11.2253C3.83462 11.6805 4.72705 11.9459 5.64441 12.0012C6.56177 12.0565 7.47954 11.9 8.32694 11.544C9.17434 11.188 9.92871 10.6419 10.5319 9.94778C11.135 9.25368 11.5708 8.43018 11.8057 7.54079C12.0405 6.6514 12.0681 5.71987 11.8863 4.81811C11.7046 3.91634 11.3183 3.06844 10.7573 2.33979C10.1963 1.61113 9.47558 1.02119 8.65074 0.615516C7.82591 0.209842 6.91902 -0.000714039 6 3.24958e-05Z'
                fill='#DA02FD'
            />
            <path
                d='M7.98511 6.01199C7.98511 5.85994 8.03014 5.71132 8.11453 5.58489C8.19892 5.45847 8.31887 5.35994 8.4592 5.30175C8.59954 5.24356 8.75396 5.22835 8.90294 5.25802C9.05192 5.28768 9.18877 5.36088 9.29618 5.46839C9.40359 5.57591 9.47671 5.7129 9.50635 5.86203C9.53598 6.01115 9.52079 6.16573 9.46266 6.30621C9.40453 6.44668 9.30609 6.56676 9.1798 6.65123C9.0535 6.7357 8.90502 6.78078 8.75312 6.78078C8.65255 6.78157 8.55279 6.76241 8.45964 6.72444C8.3665 6.68646 8.2818 6.63042 8.2104 6.55951C8.13901 6.4886 8.08233 6.40424 8.04366 6.3113C8.005 6.21837 7.9851 6.11868 7.98511 6.018V6.01199ZM5.21912 6.01199C5.2203 5.86021 5.26636 5.71217 5.35146 5.58654C5.43657 5.46091 5.55692 5.3633 5.69735 5.30604C5.83778 5.24877 5.992 5.23442 6.14058 5.26476C6.28916 5.2951 6.42543 5.36878 6.53224 5.47653C6.63905 5.58428 6.71161 5.72128 6.74076 5.87024C6.76991 6.0192 6.75434 6.17345 6.69604 6.31358C6.63774 6.4537 6.53931 6.57343 6.41315 6.65765C6.28698 6.74186 6.13874 6.78679 5.9871 6.78679C5.88551 6.7876 5.78481 6.76807 5.69087 6.72935C5.59693 6.69062 5.51164 6.6335 5.44009 6.56131C5.36853 6.48912 5.31215 6.40332 5.27419 6.30899C5.23624 6.21466 5.21751 6.11367 5.21912 6.01199ZM2.45312 6.01199C2.45312 5.85994 2.49816 5.71132 2.58254 5.58489C2.66693 5.45847 2.78689 5.35994 2.92722 5.30175C3.06756 5.24356 3.22195 5.22835 3.37092 5.25802C3.5199 5.28768 3.65675 5.36088 3.76416 5.46839C3.87157 5.57591 3.94473 5.7129 3.97437 5.86203C4.004 6.01115 3.98877 6.16573 3.93064 6.30621C3.87251 6.44668 3.77408 6.56676 3.64778 6.65123C3.52148 6.7357 3.373 6.78078 3.22111 6.78078C3.01742 6.78078 2.82208 6.6998 2.67805 6.55563C2.53402 6.41145 2.45312 6.21588 2.45312 6.01199Z'
                fill='white'
            />
        </svg>
    )
}

export const IconNotificationDollarFill = () => {
    return (
        <svg
            width='12'
            height='12'
            viewBox='0 0 12 12'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12Z'
                fill='#2196F3'
            />
            <path
                d='M7.875 7.125C7.875 6.29775 7.03425 5.625 6 5.625C5.39025 5.625 4.875 5.2815 4.875 4.875C4.875 4.4685 5.39025 4.125 6 4.125C6.345 4.125 6.6645 4.233 6.876 4.4205C7.03125 4.557 7.2675 4.54425 7.4055 4.389C7.5435 4.23375 7.5285 3.9975 7.374 3.8595C7.11075 3.62625 6.759 3.46875 6.375 3.4065V3C6.375 2.793 6.207 2.625 6 2.625C5.793 2.625 5.625 2.793 5.625 3V3.405C4.77 3.5445 4.125 4.1505 4.125 4.875C4.125 5.70225 4.9665 6.375 6 6.375C6.60975 6.375 7.125 6.7185 7.125 7.125C7.125 7.5315 6.60975 7.875 6 7.875C5.655 7.875 5.3355 7.767 5.124 7.5795C4.96875 7.443 4.73175 7.45575 4.5945 7.611C4.45725 7.76625 4.47075 8.0025 4.626 8.1405C4.88925 8.37375 5.241 8.5305 5.625 8.5935V9C5.625 9.207 5.793 9.375 6 9.375C6.207 9.375 6.375 9.207 6.375 9V8.595C7.23 8.4555 7.875 7.8495 7.875 7.125Z'
                fill='#FAFAFA'
            />
        </svg>
    )
}

export const IconNotificationCameraFill = () => {
    return (
        <svg
            width='12'
            height='12'
            viewBox='0 0 12 12'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g clipPath='url(#clip0_5720_26302)'>
                <path
                    d='M12.0003 2.97665V9.02498L8.76457 7.25815H8.73242V4.74349H8.76457L12.0003 2.97665Z'
                    fill='#FF9DAF'
                />
                <path
                    d='M8.73213 7.25815V8.61296C8.73213 9.19942 8.25664 9.67491 7.67018 9.67491H1.06195C0.475491 9.67491 0 9.19942 0 8.61296V3.37167C0 2.78521 0.475491 2.30972 1.06195 2.30972H7.67018C8.25664 2.30972 8.73213 2.78521 8.73213 3.37167V7.25815Z'
                    fill='#FF284F'
                />
            </g>
            <defs>
                <clipPath id='clip0_5720_26302'>
                    <rect width='12' height='12' fill='white' />
                </clipPath>
            </defs>
        </svg>
    )
}

export const IconNotificationLiveFill = () => {
    return (
        <svg
            width='13'
            height='8'
            viewBox='0 0 13 8'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M1.19491 7.77181C-0.398305 5.55089 -0.398305 2.44944 1.19491 0.228524C1.37619 -0.0236957 1.71958 -0.0739035 1.95847 0.1147C2.20053 0.304407 2.24854 0.662109 2.06724 0.914901C0.765179 2.73126 0.765179 5.26911 2.06724 7.08543C2.24851 7.33822 2.20053 7.69589 1.95847 7.88563C1.71671 8.07538 1.37426 8.02331 1.19491 7.77181Z'
                fill='#FF284F'
            />
            <path
                d='M10.0428 7.8856C9.80072 7.69589 9.75271 7.33819 9.93401 7.0854C11.2361 5.26904 11.2361 2.73118 9.93401 0.914863C9.75274 0.662071 9.80072 0.304407 10.0428 0.114661C10.2827 -0.0745136 10.6261 -0.024839 10.8063 0.228486C12.3996 2.4494 12.3996 5.55086 10.8063 7.77178C10.627 8.0232 10.2846 8.07542 10.0428 7.8856Z'
                fill='#FF284F'
            />
            <path
                d='M3.15153 6.6669C1.85053 5.14688 1.85053 2.85344 3.15153 1.33337C3.35308 1.09788 3.69858 1.07948 3.92255 1.28873C4.14648 1.49908 4.1657 1.86071 3.96415 2.09563C3.03531 3.18154 3.03531 4.81874 3.96415 5.90464C4.1657 6.13957 4.14652 6.50116 3.92255 6.71155C3.69818 6.92118 3.35311 6.90293 3.15153 6.6669Z'
                fill='#FF9DAF'
            />
            <path
                d='M8.07572 6.71154C7.85178 6.50119 7.83256 6.13956 8.03411 5.90463C8.96296 4.81873 8.96296 3.18152 8.03411 2.09562C7.83256 1.86069 7.85175 1.49911 8.07572 1.28871C8.29968 1.07832 8.64519 1.09676 8.84674 1.33336C10.1477 2.85338 10.1477 5.14683 8.84674 6.66689C8.64552 6.9025 8.30048 6.92155 8.07572 6.71154Z'
                fill='#FF9DAF'
            />
            <path
                d='M6.00127 5.71428C5.09805 5.71428 4.36328 4.94532 4.36328 4.00006C4.36328 3.05479 5.09805 2.28583 6.00127 2.28583C6.9045 2.28583 7.63926 3.05479 7.63926 4.00006C7.63926 4.94532 6.9045 5.71428 6.00127 5.71428Z'
                fill='#FF284F'
            />
        </svg>
    )
}

export const IconFilterOutline = ({ color }: SVGProps) => {
    return (
        <svg
            width='18'
            height='18'
            viewBox='0 0 20 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M8.09512 16.1664H0.759766'
                stroke={color ?? '#262A33'}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M19.2402 16.1664C19.2402 16.7663 19.069 17.3527 18.7484 17.8515C18.4278 18.3503 17.972 18.7391 17.4388 18.9687C16.9057 19.1982 16.319 19.2584 15.753 19.1413C15.187 19.0243 14.667 18.7354 14.259 18.3112C13.8509 17.887 13.573 17.3465 13.4604 16.7582C13.3478 16.1698 13.4056 15.5598 13.6264 15.0056C13.8473 14.4514 14.2213 13.9777 14.7011 13.6444C15.181 13.3111 15.7451 13.1332 16.3222 13.1332C16.7054 13.1332 17.0848 13.2117 17.4388 13.3641C17.7929 13.5165 18.1146 13.7399 18.3855 14.0216C18.6565 14.3032 18.8714 14.6376 19.018 15.0056C19.1647 15.3736 19.2402 15.7681 19.2402 16.1664V16.1664Z'
                stroke={color ?? '#262A33'}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M11.9043 3.82309H19.2396'
                stroke={color ?? '#262A33'}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M0.759766 3.8231C0.759766 4.423 0.930883 5.00937 1.25151 5.50817C1.57214 6.00697 2.02789 6.39581 2.56108 6.62538C3.09426 6.85495 3.68091 6.91495 4.24693 6.79791C4.81296 6.68087 5.33288 6.39198 5.74096 5.96778C6.14904 5.54358 6.42696 5.00312 6.53955 4.41474C6.65214 3.82636 6.59437 3.21654 6.37352 2.6623C6.15266 2.10806 5.77867 1.63437 5.29881 1.30108C4.81896 0.967793 4.25482 0.789917 3.6777 0.789917C3.29452 0.789917 2.9151 0.868384 2.56108 1.02082C2.20706 1.17325 1.88534 1.39663 1.61438 1.67829C1.34343 1.95994 1.12853 2.2943 0.981892 2.6623C0.835252 3.03031 0.759766 3.42478 0.759766 3.8231V3.8231Z'
                stroke={color ?? '#262A33'}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}

export const IconTwoPeopleOutline = ({ color = '#778797' }: SVGProps) => {
    return (
        <svg
            width='17'
            height='16'
            viewBox='0 0 17 16'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M11.0273 1.63108C11.0273 1.22321 11.3767 0.892578 11.8077 0.892578C12.7555 0.892578 13.6565 1.26686 14.3147 1.92053C14.9718 2.573 15.3347 3.4507 15.3347 4.35883C15.3347 5.26696 14.9718 6.14461 14.3147 6.79708C13.6565 7.45075 12.7555 7.82503 11.8077 7.82503C11.3767 7.82503 11.0273 7.49439 11.0273 7.08653C11.0273 6.67867 11.3767 6.34803 11.8077 6.34803C12.3167 6.34803 12.813 6.14753 13.185 5.77811C13.5582 5.40749 13.774 4.89756 13.774 4.35883C13.774 3.82008 13.5582 3.31011 13.185 2.93949C12.813 2.57007 12.3167 2.36957 11.8077 2.36957C11.3767 2.36957 11.0273 2.03894 11.0273 1.63108Z'
                fill={color}
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M12.3126 9.99309C12.3432 9.58626 12.7166 9.28 13.1464 9.30903C13.6191 9.34096 14.0888 9.40626 14.5519 9.50443C14.9788 9.5437 15.3913 9.67137 15.7625 9.87779C16.1514 10.0941 16.4844 10.3909 16.74 10.745C16.7659 10.7809 16.7885 10.8189 16.8073 10.8586C16.9353 11.1279 17.001 11.4203 17.001 11.7153C17.001 12.0103 16.9353 12.3028 16.8073 12.572C16.7885 12.6117 16.7659 12.6498 16.74 12.6857C16.4844 13.0398 16.1514 13.3366 15.7625 13.5529C15.3734 13.7693 14.9389 13.8991 14.49 13.9313C14.0602 13.9621 13.6855 13.6574 13.6529 13.2507C13.6203 12.844 13.9423 12.4894 14.372 12.4585C14.5808 12.4436 14.7855 12.3831 14.9718 12.2795C15.1374 12.1874 15.2856 12.0628 15.4067 11.9113C15.4287 11.8492 15.4403 11.7829 15.4403 11.7153C15.4403 11.6477 15.4287 11.5815 15.4067 11.5194C15.2856 11.3679 15.1374 11.2433 14.9718 11.1512C14.7855 11.0476 14.5808 10.9871 14.372 10.9721C14.333 10.9693 14.2942 10.9638 14.256 10.9554C13.8539 10.8679 13.4459 10.81 13.0354 10.7823C12.6055 10.7532 12.2819 10.3999 12.3126 9.99309Z'
                fill={color}
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M1.81306 12.3082C1.65233 12.4755 1.56063 12.6746 1.56063 12.9555C1.56063 13.2362 1.65217 13.4335 1.81173 13.5988C1.9874 13.7808 2.28022 13.9573 2.72771 14.1062C3.63393 14.4077 4.94603 14.5232 6.47352 14.5232C7.99822 14.5232 9.31007 14.4019 10.2159 14.096C10.6634 13.9449 10.9575 13.7663 11.1343 13.5825C11.2953 13.415 11.3864 13.2169 11.3864 12.939C11.3864 12.6625 11.2954 12.4665 11.1344 12.3007C10.9572 12.1181 10.662 11.9409 10.2128 11.7913C9.30398 11.4886 7.99124 11.3713 6.47352 11.3713C4.94782 11.3713 3.63614 11.4907 2.73046 11.7956C2.28316 11.9462 1.98957 12.1244 1.81306 12.3082ZM2.2074 10.404C3.37633 10.0105 4.91126 9.89429 6.47352 9.89429C8.02713 9.89429 9.56096 10.0084 10.7309 10.398C11.3211 10.5946 11.8733 10.8787 12.2836 11.3013C12.7102 11.7407 12.947 12.2938 12.947 12.939C12.947 13.5827 12.7124 14.1357 12.2885 14.5766C11.8803 15.001 11.3301 15.2879 10.7403 15.4871C9.57152 15.8818 8.03679 16.0002 6.47352 16.0002C4.91305 16.0002 3.37854 15.8883 2.21015 15.4996C1.62033 15.3034 1.06885 15.0191 0.65954 14.595C0.234112 14.1543 0 13.6005 0 12.9555C0 12.3106 0.23396 11.7564 0.658207 11.3147C1.06668 10.8894 1.61739 10.6027 2.2074 10.404Z'
                fill={color}
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M7.56511 1.69386C7.04472 1.47877 6.47413 1.42248 5.92388 1.53036C5.37331 1.63831 4.86201 1.90701 4.45684 2.30846C4.05128 2.7103 3.77093 3.22681 3.65675 3.79434C3.54254 4.362 3.60077 4.95019 3.82268 5.4831C4.0445 6.01578 4.41814 6.46547 4.89061 6.77918C5.36256 7.09254 5.91333 7.25735 6.47336 7.25735H6.49739C6.86694 7.25639 7.23362 7.18329 7.57687 7.04117C7.92056 6.89888 8.23521 6.6897 8.50175 6.42379C8.76834 6.15783 8.98144 5.84038 9.12716 5.48874C9.27289 5.13709 9.34785 4.75923 9.34696 4.37704L10.1273 4.37543L9.34696 4.37382C9.34829 3.79423 9.17627 3.22995 8.8565 2.75265C8.53697 2.27568 8.08599 1.90916 7.56511 1.69386ZM10.9076 4.37542C10.9092 3.5195 10.6555 2.67965 10.1745 1.96176C9.69308 1.24309 9.0039 0.676854 8.18973 0.340327C7.37506 0.00359417 6.47573 -0.0861926 5.60729 0.084079C4.73917 0.254288 3.94683 0.675428 3.32831 1.28828C2.71017 1.90074 2.29281 2.67735 2.12366 3.51807C1.95454 4.35865 2.04003 5.2305 2.37074 6.02466C2.70155 6.81906 3.26463 7.50381 3.9943 7.98829C4.72449 8.47311 5.58731 8.73434 6.47336 8.73434H6.4983L6.50017 8.73434C7.08562 8.73301 7.66414 8.61718 8.20235 8.39435C8.74042 8.17159 9.22654 7.84677 9.63397 7.44031C10.0413 7.0339 10.3622 6.55369 10.5801 6.02801C10.7977 5.50283 10.9087 4.94139 10.9076 4.37542Z'
                fill={color}
            />
        </svg>
    )
}

export const IconProcessingError = () => {
    return (
        <svg
            width='16'
            height='16'
            viewBox='0 0 16 16'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M12 1.33333C13.4707 1.33333 14.6667 2.52933 14.6667 4V12C14.6667 13.4707 13.4707 14.6667 12 14.6667H4C2.52933 14.6667 1.33333 13.4707 1.33333 12V4C1.33333 2.52933 2.52933 1.33333 4 1.33333H12ZM12 0H4C1.79067 0 0 1.79067 0 4V12C0 14.2093 1.79067 16 4 16H12C14.2093 16 16 14.2093 16 12V4C16 1.79067 14.2093 0 12 0Z'
                fill='#FF4B55'
            />
            <path
                d='M7.99967 10.2782C7.63167 10.2782 7.33301 9.98017 7.33301 9.6115V4.50016C7.33301 4.13216 7.63167 3.8335 7.99967 3.8335C8.36767 3.8335 8.66634 4.13216 8.66634 4.50016V9.6115C8.66634 9.98017 8.36767 10.2782 7.99967 10.2782Z'
                fill='#FF4B55'
            />
            <path
                d='M7.99967 12.1668C7.81967 12.1668 7.65301 12.0935 7.52634 11.9735C7.46634 11.9061 7.41967 11.8335 7.38634 11.7535C7.35301 11.6735 7.33301 11.5868 7.33301 11.5001C7.33301 11.4135 7.35301 11.3268 7.38634 11.2468C7.41967 11.1668 7.46634 11.0935 7.52634 11.0268C7.77967 10.7801 8.22634 10.7801 8.47301 11.0268C8.53301 11.0935 8.57967 11.1601 8.61301 11.2468C8.64634 11.3268 8.66634 11.4135 8.66634 11.5001C8.66634 11.6801 8.59967 11.8468 8.47301 11.9735C8.34634 12.0935 8.17967 12.1668 7.99967 12.1668Z'
                fill='#FF4B55'
            />
        </svg>
    )
}

export const IconPollAsk = () => {
    return (
        <svg
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M18.0066 16.0035L18.2378 15.6888C18.9367 14.7372 19.3 13.6391 19.3 12.4814C19.3 10.6352 18.3438 8.90117 16.6919 7.80733L16.4116 7.62169L16.3813 7.28684C16.2286 5.60083 15.4419 4.02766 14.1062 2.80511C12.6282 1.45236 10.6595 0.7 8.5547 0.7C6.44992 0.7 4.48126 1.45236 3.00322 2.80515L3.00321 2.80516C1.50928 4.17246 0.700026 5.97928 0.700026 7.89592C0.700026 9.37251 1.17446 10.7726 2.08508 11.978L2.3242 12.2946L2.17553 12.6623L0.705958 16.2976L0.0569791 16.0353L0.705954 16.2976C0.693538 16.3284 0.701008 16.3634 0.724661 16.3863L0.724684 16.3864C0.740194 16.4014 0.760371 16.4094 0.78147 16.4094V17.1094M18.0066 16.0035L11.9672 13.4247L12.284 14.0488C12.2841 14.0488 12.2841 14.0488 12.2841 14.0488C12.3244 14.0284 12.3732 14.0446 12.3934 14.0844L12.3934 14.0844C12.4137 14.1245 12.3978 14.1733 12.3578 14.1937M18.0066 16.0035L18.153 16.3655L19.2941 19.1883L19.2941 19.1883C19.3065 19.2189 19.2991 19.254 19.2753 19.277L19.2752 19.2771C19.2599 19.2919 19.2398 19.3 19.2186 19.3C19.2076 19.3 19.1968 19.2978 19.1861 19.2931L19.186 19.2931L15.8958 17.8427L15.6357 17.728L15.3692 17.8272C14.6237 18.1047 13.8343 18.2464 13.0156 18.2473L13.0139 18.2471L13.0012 18.2462L12.9782 18.2445L12.9553 18.2444C11.7679 18.2354 10.6186 17.923 9.62755 17.3437C8.75164 16.8315 8.03486 16.1342 7.53033 15.3178M18.0066 16.0035L7.53033 15.3178M0.78147 17.1094L0.781213 16.4094C0.792326 16.4094 0.803385 16.4072 0.814174 16.4024L5.00551 14.5548L5.26891 14.4387L5.53779 14.5415C6.02284 14.7269 6.52269 14.8656 7.03454 14.9576L7.34502 15.0133L7.4309 15.1546L8.96402 15.0811C10.1567 15.024 11.3226 14.7193 12.3578 14.1937M0.78147 17.1094C0.58233 17.1094 0.386314 17.0332 0.237487 16.889L1.09643 17.043C0.995102 17.0876 0.887837 17.1093 0.78147 17.1094ZM12.3578 14.1937L12.6747 14.8178M12.3578 14.1937L12.6747 14.8178M12.6747 14.8178C11.8303 15.2466 10.9089 15.5389 9.9575 15.6843L13.0175 13.7674C13.2129 14.1522 13.0595 14.6224 12.6747 14.8178ZM7.53033 15.3178L8.50632 16.279C9.65355 17.409 11.2791 18.0783 12.9907 18.0828C12.9959 18.0831 13.0029 18.0835 13.011 18.0838L13.027 18.0845L13.043 18.0844C13.9315 18.0798 14.7918 17.9049 15.5968 17.5614C15.6175 17.5526 15.6409 17.5528 15.6614 17.5618L15.6614 17.5618L17.491 18.3683L19.0684 19.0636L18.4223 17.4654L17.8321 16.0055C17.8208 15.9773 17.826 15.9453 17.8456 15.9223C18.6847 14.938 19.1375 13.7458 19.1375 12.4814C19.1375 11.0348 18.5295 9.67754 17.4892 8.6588L16.5389 7.7282L16.3099 9.03838C16.1543 9.9286 15.8175 10.7877 15.3114 11.5676C15.2868 11.6055 15.2364 11.6159 15.1992 11.5917L15.199 11.5916L7.53033 15.3178ZM10.7839 6.07956L10.7838 6.06832C10.7704 4.85127 9.77477 3.86406 8.55446 3.86406C7.32575 3.86406 6.32502 4.8648 6.32502 6.09346C6.32502 6.13835 6.36138 6.17471 6.40626 6.17471C6.45115 6.17471 6.48751 6.13835 6.48751 6.09346C6.48751 4.95315 7.41416 4.02655 8.55446 4.02659L10.7839 6.07956ZM10.7839 6.07956L10.7844 6.0908M10.7839 6.07956L10.7844 6.0908M10.7844 6.0908L10.7844 6.09331V6.09347M10.7844 6.0908L10.7844 6.09347M10.7844 6.09347C10.7846 6.98907 10.2532 7.79402 9.4294 8.14568L9.42931 8.14572M10.7844 6.09347L9.42931 8.14572M9.42931 8.14572C8.93438 8.35708 8.63571 8.84487 8.63571 9.36373V9.41404C8.63571 9.45893 8.59935 9.49529 8.55446 9.49529C8.50958 9.49529 8.47322 9.45893 8.47322 9.41404V9.36377C8.47322 8.75986 8.82688 8.22628 9.36558 7.99632L9.36562 7.9963M9.42931 8.14572L9.36562 7.9963M9.36562 7.9963C10.1181 7.67502 10.6087 6.94342 10.6216 6.12722L10.6219 6.11254M9.36562 7.9963L10.6219 6.11254M10.6219 6.11254L10.6215 6.09786M10.6219 6.11254L10.6215 6.09786M10.6215 6.09786L10.6214 6.0935M10.6215 6.09786L10.6214 6.0935M10.6214 6.0935C10.6214 4.95319 9.69482 4.02661 8.5545 4.02659L10.6214 6.0935ZM15.175 11.4792C15.8744 10.4014 16.2469 9.1622 16.2469 7.89592C16.2469 3.95346 12.73 0.862497 8.5547 0.862497C4.37938 0.862497 0.862523 3.95346 0.862523 7.89592C0.862523 9.48181 1.42931 10.978 2.48428 12.2157L2.48433 12.2157C2.50388 12.2387 2.50914 12.2707 2.49776 12.2988L3.14674 12.5612L15.175 11.4792ZM8.59688 11.914C8.59688 11.9589 8.56052 11.9953 8.51564 11.9953C8.47075 11.9953 8.43439 11.9589 8.43439 11.914C8.43439 11.8692 8.47075 11.8328 8.51564 11.8328C8.56052 11.8328 8.59688 11.8692 8.59688 11.914Z'
                fill='#47A4FC'
                stroke='url(#paint0_linear_5904_24748)'
                strokeWidth='1.4'
            />
            <defs>
                <linearGradient
                    id='paint0_linear_5904_24748'
                    x1='10'
                    y1='0'
                    x2='10'
                    y2='20'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#2894FF' />
                    <stop offset='1' stopColor='#53AFF7' />
                </linearGradient>
            </defs>
        </svg>
    )
}

export const IconPollYesNo = () => {
    return (
        <svg
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <mask id='path-1-inside-1_5904_24741' fill='white'>
                <path d='M9.95202 11.9411H8.63908L8.87437 10.7647C8.94358 10.4337 8.93637 10.0914 8.85329 9.76365C8.77021 9.43593 8.61346 9.13148 8.39496 8.87349C8.17864 8.59304 7.88591 8.38105 7.55197 8.26303C7.21803 8.145 6.85711 8.12596 6.5126 8.20819C6.27582 8.30159 6.07591 8.46958 5.94314 8.68674C5.81036 8.90389 5.75194 9.1584 5.77672 9.41172C5.77672 10.5664 4.49672 11.6164 3.58731 12.1829C3.40069 11.8833 3.12144 11.6527 2.79192 11.5261C2.46241 11.3996 2.10061 11.3839 1.7614 11.4816C1.42219 11.5793 1.12409 11.7849 0.912314 12.0673C0.700537 12.3497 0.58664 12.6934 0.587901 13.0464V17.1976C0.587768 17.5455 0.699267 17.8843 0.906003 18.1641C1.11274 18.4439 1.4038 18.6499 1.73639 18.752C2.06897 18.8541 2.42553 18.8467 2.75363 18.731C3.08173 18.6154 3.36405 18.3975 3.55908 18.1094L4.48202 18.7247C4.57878 18.7889 4.69232 18.8233 4.80849 18.8235H8.46613C9.03478 18.8224 9.58738 18.6349 10.0393 18.2897C10.4911 17.9445 10.8173 17.4607 10.9679 16.9123L11.7003 14.227C11.773 13.9584 11.7828 13.6766 11.7291 13.4036C11.6754 13.1305 11.5595 12.8735 11.3904 12.6525C11.2214 12.4314 11.0037 12.2523 10.7543 12.1289C10.5048 12.0056 10.2303 11.9413 9.95202 11.9411ZM2.66319 17.1976C2.66319 17.3168 2.61585 17.4311 2.53157 17.5154C2.44728 17.5997 2.33297 17.647 2.21378 17.647C2.09459 17.647 1.98028 17.5997 1.896 17.5154C1.81172 17.4311 1.76437 17.3168 1.76437 17.1976V13.0464C1.76437 12.9272 1.81172 12.8129 1.896 12.7286C1.98028 12.6444 2.09459 12.597 2.21378 12.597C2.33297 12.597 2.44728 12.6444 2.53157 12.7286C2.61585 12.8129 2.66319 12.9272 2.66319 13.0464V17.1976ZM10.565 13.9176L9.8326 16.6029C9.75047 16.9025 9.57233 17.1669 9.32549 17.3555C9.07866 17.5441 8.77677 17.6465 8.46613 17.647H4.98672L3.83966 16.8823V13.4C4.70555 12.9153 6.95319 11.4611 6.95319 9.41172C6.95293 9.37747 6.95529 9.34326 6.96025 9.30937C7.17084 9.35436 7.36055 9.46794 7.49966 9.63231C7.60152 9.75575 7.67429 9.90053 7.71258 10.0559C7.75086 10.2113 7.75369 10.3733 7.72084 10.53L7.34496 12.4123C7.32751 12.4978 7.32929 12.5861 7.35018 12.6708C7.37106 12.7555 7.41052 12.8345 7.4657 12.902C7.52088 12.9696 7.5904 13.0241 7.66922 13.0614C7.74804 13.0988 7.83419 13.1182 7.92143 13.1182H9.95202C10.0496 13.1182 10.1459 13.1407 10.2334 13.184C10.3209 13.2273 10.3973 13.2901 10.4566 13.3676C10.5158 13.4452 10.5565 13.5354 10.5753 13.6311C10.5941 13.7269 10.5905 13.8258 10.565 13.92V13.9176Z' />
            </mask>
            <path
                d='M8.63908 11.9411L7.26626 11.6666L6.93135 13.3411H8.63908V11.9411ZM8.87437 10.7647L7.50396 10.4781L7.50156 10.4901L8.87437 10.7647ZM8.39496 8.87349L7.28641 9.72854L7.30594 9.75387L7.32661 9.77828L8.39496 8.87349ZM6.5126 8.20819L6.18755 6.84645L6.09113 6.86947L5.99892 6.90584L6.5126 8.20819ZM5.77672 9.41172H7.17672V9.3434L7.17007 9.2754L5.77672 9.41172ZM3.58731 12.1829L2.39898 12.9231L3.13917 14.1114L4.32751 13.3712L3.58731 12.1829ZM0.587901 13.0464H1.98791L1.98789 13.0414L0.587901 13.0464ZM0.587901 17.1976L1.9879 17.1981V17.1976H0.587901ZM3.55908 18.1094L4.33566 16.9445L3.17904 16.1734L2.39976 17.3245L3.55908 18.1094ZM4.48202 18.7247L3.70544 19.8895L3.70744 19.8909L4.48202 18.7247ZM4.80849 18.8235L4.80627 20.2235H4.80849V18.8235ZM8.46613 18.8235V20.2235L8.46876 20.2235L8.46613 18.8235ZM10.9679 16.9123L12.3179 17.283L12.3186 17.2807L10.9679 16.9123ZM11.7003 14.227L13.0509 14.5954L13.0516 14.5928L11.7003 14.227ZM1.76437 17.1976H0.364371H1.76437ZM2.66319 13.0464H4.06319H2.66319ZM10.565 13.9176H11.965L9.21429 13.5492L10.565 13.9176ZM9.8326 16.6029L11.1828 16.9731L11.1833 16.9713L9.8326 16.6029ZM8.46613 17.647V19.047L8.46853 19.047L8.46613 17.647ZM4.98672 17.647L4.21014 18.8119L4.56284 19.047H4.98672V17.647ZM3.83966 16.8823H2.43966V17.6316L3.06308 18.0472L3.83966 16.8823ZM3.83966 13.4L3.15582 12.1783L2.43966 12.5792V13.4H3.83966ZM6.95319 9.41172H8.35324L8.35315 9.40083L6.95319 9.41172ZM6.96025 9.30937L7.25273 7.94026L5.79166 7.62813L5.57504 9.10639L6.96025 9.30937ZM7.49966 9.63231L8.57951 8.74128L8.57396 8.73455L8.56832 8.72789L7.49966 9.63231ZM7.72084 10.53L6.35058 10.2426L6.34794 10.2558L7.72084 10.53ZM7.34496 12.4123L8.71668 12.6923L8.71785 12.6865L7.34496 12.4123ZM7.92143 13.1182V11.7182L7.92114 11.7182L7.92143 13.1182ZM9.95202 13.1182L9.95236 11.7182H9.95202V13.1182ZM10.565 13.92H9.16496L11.916 14.2868L10.565 13.92ZM9.95202 10.5411H8.63908V13.3411H9.95202V10.5411ZM10.0119 12.2157L10.2472 11.0392L7.50156 10.4901L7.26626 11.6666L10.0119 12.2157ZM10.2447 11.0512C10.3575 10.5118 10.3458 9.95381 10.2104 9.41964L7.49621 10.1077C7.52696 10.2289 7.52962 10.3556 7.50401 10.4781L10.2447 11.0512ZM10.2104 9.41964C10.075 8.88546 9.81945 8.38922 9.4633 7.9687L7.32661 9.77828C7.40747 9.87374 7.46547 9.9864 7.49621 10.1077L10.2104 9.41964ZM9.50351 8.01843C9.12244 7.52439 8.60677 7.15096 8.0185 6.94305L7.08544 9.58301C7.16505 9.61114 7.23484 9.66168 7.28641 9.72854L9.50351 8.01843ZM8.0185 6.94305C7.43024 6.73513 6.79443 6.70159 6.18755 6.84645L6.83766 9.56993C6.91979 9.55033 7.00583 9.55487 7.08544 9.58301L8.0185 6.94305ZM5.99892 6.90584C5.47909 7.11087 5.04021 7.47968 4.74871 7.95642L7.13756 9.41705C7.11161 9.45948 7.07256 9.4923 7.02629 9.51055L5.99892 6.90584ZM4.74871 7.95642C4.45721 8.43317 4.32896 8.9919 4.38338 9.54804L7.17007 9.2754C7.17491 9.32489 7.1635 9.37462 7.13756 9.41705L4.74871 7.95642ZM4.37672 9.41172C4.37672 9.47736 4.3266 9.70226 3.98654 10.0768C3.66957 10.4259 3.23752 10.7514 2.84711 10.9946L4.32751 13.3712C4.84652 13.0479 5.50917 12.5652 6.05956 11.959C6.58684 11.3782 7.17672 10.5008 7.17672 9.41172H4.37672ZM4.77565 11.4427C4.42798 10.8846 3.90775 10.455 3.29388 10.2192L2.28997 12.8331C2.33513 12.8504 2.3734 12.882 2.39898 12.9231L4.77565 11.4427ZM3.29388 10.2192C2.68001 9.98345 2.00599 9.95432 1.37407 10.1363L2.14873 12.827C2.19522 12.8136 2.24481 12.8157 2.28997 12.8331L3.29388 10.2192ZM1.37407 10.1363C0.742151 10.3182 0.186803 10.7012 -0.207726 11.2273L2.03235 12.9072C2.06138 12.8685 2.10224 12.8403 2.14873 12.827L1.37407 10.1363ZM-0.207726 11.2273C-0.602256 11.7534 -0.814439 12.3938 -0.81209 13.0514L1.98789 13.0414C1.98772 12.993 2.00333 12.9459 2.03235 12.9072L-0.207726 11.2273ZM-0.812099 13.0464V17.1976H1.9879V13.0464H-0.812099ZM-0.812099 17.1971C-0.812347 17.8446 -0.604804 18.4752 -0.219989 18.996L2.032 17.3321C2.00334 17.2933 1.98788 17.2464 1.9879 17.1981L-0.812099 17.1971ZM-0.219989 18.996C0.164825 19.5168 0.706602 19.9004 1.32567 20.0904L2.1471 17.4136C2.101 17.3995 2.06065 17.3709 2.032 17.3321L-0.219989 18.996ZM1.32567 20.0904C1.94474 20.2804 2.60843 20.2667 3.21915 20.0514L2.28811 17.4107C2.24263 17.4267 2.1932 17.4278 2.1471 17.4136L1.32567 20.0904ZM3.21915 20.0514C3.82986 19.8361 4.35537 19.4304 4.7184 18.8942L2.39976 17.3245C2.37272 17.3645 2.33359 17.3947 2.28811 17.4107L3.21915 20.0514ZM2.7825 19.2742L3.70544 19.8895L5.2586 17.5598L4.33566 16.9445L2.7825 19.2742ZM3.70744 19.8909C4.03313 20.1072 4.41529 20.2229 4.80627 20.2235L4.8107 17.4235C4.96936 17.4237 5.12443 17.4707 5.2566 17.5585L3.70744 19.8909ZM4.80849 20.2235H8.46613V17.4235H4.80849V20.2235ZM8.46876 20.2235C9.34367 20.2218 10.1939 19.9334 10.8891 19.4022L9.18937 17.1772C8.98086 17.3365 8.72588 17.423 8.4635 17.4235L8.46876 20.2235ZM10.8891 19.4022C11.5844 18.8711 12.0863 18.1267 12.3179 17.283L9.61786 16.5416C9.54839 16.7947 9.39787 17.0179 9.18937 17.1772L10.8891 19.4022ZM12.3186 17.2807L13.0509 14.5954L10.3496 13.8587L9.61723 16.5439L12.3186 17.2807ZM13.0516 14.5928C13.1805 14.1167 13.198 13.6173 13.1028 13.1333L10.3554 13.6739C10.3677 13.736 10.3654 13.8001 10.3489 13.8612L13.0516 14.5928ZM13.1028 13.1333C13.0075 12.6493 12.8021 12.1938 12.5025 11.802L10.2784 13.503C10.3169 13.5533 10.3432 13.6118 10.3554 13.6739L13.1028 13.1333ZM12.5025 11.802C12.2029 11.4102 11.817 11.0927 11.3749 10.874L10.1336 13.3839C10.1904 13.4119 10.2399 13.4527 10.2784 13.503L12.5025 11.802ZM11.3749 10.874C10.9327 10.6553 10.4462 10.5415 9.95291 10.5411L9.95112 13.3411C10.0144 13.3412 10.0769 13.3558 10.1336 13.3839L11.3749 10.874ZM1.26319 17.1976C1.26319 16.9455 1.36334 16.7037 1.54162 16.5254L3.52151 18.5053C3.86835 18.1585 4.06319 17.6881 4.06319 17.1976H1.26319ZM1.54162 16.5254C1.71988 16.3472 1.96167 16.247 2.21378 16.247V19.047C2.70428 19.047 3.17468 18.8522 3.52151 18.5053L1.54162 16.5254ZM2.21378 16.247C2.4659 16.247 2.70768 16.3472 2.88595 16.5254L0.906051 18.5053C1.25288 18.8522 1.72329 19.047 2.21378 19.047V16.247ZM2.88595 16.5254C3.06422 16.7037 3.16437 16.9455 3.16437 17.1976H0.364371C0.364371 17.6881 0.559219 18.1585 0.906051 18.5053L2.88595 16.5254ZM3.16437 17.1976V13.0464H0.364371V17.1976H3.16437ZM3.16437 13.0464C3.16437 13.2985 3.06422 13.5403 2.88595 13.7186L0.906051 11.7387C0.55922 12.0855 0.364371 12.5559 0.364371 13.0464H3.16437ZM2.88595 13.7186C2.70768 13.8969 2.46589 13.997 2.21378 13.997V11.197C1.72329 11.197 1.25288 11.3919 0.906051 11.7387L2.88595 13.7186ZM2.21378 13.997C1.96167 13.997 1.71989 13.8969 1.54162 13.7186L3.52151 11.7387C3.17468 11.3919 2.70428 11.197 2.21378 11.197V13.997ZM1.54162 13.7186C1.36335 13.5403 1.26319 13.2985 1.26319 13.0464H4.06319C4.06319 12.5559 3.86835 12.0855 3.52151 11.7387L1.54162 13.7186ZM1.26319 13.0464V17.1976H4.06319V13.0464H1.26319ZM9.21429 13.5492L8.48193 16.2345L11.1833 16.9713L11.9156 14.286L9.21429 13.5492ZM8.48243 16.2327C8.4813 16.2368 8.47887 16.2405 8.47549 16.243L10.1755 18.4679C10.6658 18.0933 11.0196 17.5681 11.1828 16.9731L8.48243 16.2327ZM8.47549 16.243C8.47211 16.2456 8.46798 16.247 8.46374 16.247L8.46853 19.047C9.08556 19.046 9.68521 18.8425 10.1755 18.4679L8.47549 16.243ZM8.46613 16.247H4.98672V19.047H8.46613V16.247ZM5.7633 16.4821L4.61625 15.7174L3.06308 18.0472L4.21014 18.8119L5.7633 16.4821ZM5.23966 16.8823V13.4H2.43966V16.8823H5.23966ZM4.52351 14.6216C5.01048 14.349 5.91673 13.789 6.71849 12.9751C7.50583 12.1758 8.35319 10.9651 8.35319 9.41172H5.55319C5.55319 9.90774 5.27673 10.4488 4.72377 11.0101C4.18525 11.5568 3.53473 11.9662 3.15582 12.1783L4.52351 14.6216ZM8.35315 9.40083C8.35344 9.43814 8.35087 9.47542 8.34546 9.51234L5.57504 9.10639C5.5597 9.21109 5.55241 9.31681 5.55324 9.42262L8.35315 9.40083ZM6.66777 10.6785C6.57534 10.6587 6.49207 10.6089 6.431 10.5367L8.56832 8.72789C8.22904 8.327 7.76634 8.04998 7.25273 7.94026L6.66777 10.6785ZM6.41982 10.5233C6.38796 10.4847 6.36521 10.4395 6.35323 10.3909L9.07192 9.72098C8.98337 9.3616 8.81507 9.02676 8.57951 8.74128L6.41982 10.5233ZM6.35323 10.3909C6.34126 10.3423 6.34037 10.2916 6.35065 10.2426L9.09103 10.8173C9.167 10.4551 9.16047 10.0804 9.07192 9.72098L6.35323 10.3909ZM6.34794 10.2558L5.97206 12.1382L8.71785 12.6865L9.09374 10.8041L6.34794 10.2558ZM5.97324 12.1323C5.91427 12.4212 5.92029 12.7196 5.99088 13.0059L8.70947 12.3356C8.73829 12.4525 8.74075 12.5744 8.71667 12.6923L5.97324 12.1323ZM5.99088 13.0059C6.06147 13.2922 6.19485 13.5592 6.38136 13.7876L8.55005 12.0165C8.62619 12.1097 8.68065 12.2187 8.70947 12.3356L5.99088 13.0059ZM6.38136 13.7876C6.56786 14.016 6.80284 14.2 7.06925 14.3264L8.26919 11.7965C8.37796 11.8481 8.4739 11.9232 8.55005 12.0165L6.38136 13.7876ZM7.06925 14.3264C7.33567 14.4527 7.62685 14.5183 7.92171 14.5182L7.92114 11.7182C8.04153 11.7182 8.16042 11.7449 8.26919 11.7965L7.06925 14.3264ZM7.92143 14.5182H9.95202V11.7182H7.92143V14.5182ZM9.95168 14.5182C9.83418 14.5182 9.71827 14.4911 9.61294 14.439L10.8539 11.929C10.5736 11.7904 10.2651 11.7183 9.95236 11.7182L9.95168 14.5182ZM9.61294 14.439C9.50762 14.3869 9.41571 14.3113 9.34435 14.2179L11.5688 12.5174C11.3789 12.2689 11.1342 12.0676 10.8539 11.929L9.61294 14.439ZM9.34435 14.2179C9.27299 14.1246 9.2241 14.016 9.20147 13.9008L11.9491 13.3615C11.8888 13.0547 11.7587 12.7658 11.5688 12.5174L9.34435 14.2179ZM9.20147 13.9008C9.17884 13.7855 9.18309 13.6665 9.21388 13.5531L11.916 14.2868C11.998 13.985 12.0093 13.6684 11.9491 13.3615L9.20147 13.9008ZM11.965 13.92V13.9176H9.16496V13.92H11.965Z'
                fill='url(#paint0_linear_5904_24741)'
                mask='url(#path-1-inside-1_5904_24741)'
            />
            <mask id='path-3-inside-2_5904_24741' fill='white'>
                <path d='M17.7862 0.487549C17.5207 0.487641 17.2593 0.55278 17.0248 0.677268C16.7902 0.801757 16.5898 0.981804 16.4409 1.20167L15.518 0.588137C15.4213 0.523675 15.3077 0.489287 15.1915 0.489314H11.5339C10.9653 0.490248 10.4127 0.67763 9.96081 1.02273C9.50893 1.36783 9.18269 1.85161 9.03211 2.3999L8.29976 5.08402C8.22673 5.35275 8.21661 5.6347 8.27018 5.90798C8.32376 6.18125 8.43959 6.43851 8.60868 6.65977C8.77777 6.88104 8.99558 7.06036 9.24519 7.18382C9.49481 7.30728 9.76952 7.37156 10.048 7.37167H11.3609L11.1256 8.54814C11.0564 8.87916 11.0636 9.22161 11.1467 9.54943C11.2298 9.87724 11.3865 10.1818 11.6051 10.4399C11.7849 10.6562 12.0073 10.8332 12.2585 10.9599C12.5097 11.0866 12.7842 11.1603 13.0651 11.1764C13.2097 11.1772 13.3533 11.1523 13.4892 11.1028C13.7264 11.009 13.9265 10.8403 14.059 10.6223C14.1916 10.4043 14.2492 10.149 14.2233 9.8952C14.2233 8.74108 15.5033 7.69049 16.4127 7.12402C16.5992 7.42338 16.8781 7.65382 17.2073 7.78045C17.5364 7.90707 17.8979 7.92299 18.2369 7.82579C18.5759 7.72858 18.874 7.52355 19.0861 7.24174C19.2982 6.95993 19.4126 6.6167 19.4121 6.26402V2.11343C19.4116 1.68236 19.2402 1.26909 18.9354 0.964275C18.6306 0.659464 18.2173 0.488016 17.7862 0.487549ZM13.0468 9.89931C13.0471 9.93376 13.0447 9.96817 13.0398 10.0023C12.829 9.95724 12.6393 9.84342 12.5003 9.67873C12.3985 9.55538 12.3258 9.41069 12.2875 9.25541C12.2492 9.10012 12.2464 8.93821 12.2792 8.78167L12.6551 6.89931C12.6725 6.81384 12.6707 6.72555 12.6498 6.64085C12.629 6.55615 12.5895 6.47716 12.5343 6.40959C12.4791 6.34202 12.4096 6.28757 12.3308 6.25018C12.252 6.2128 12.1658 6.19341 12.0786 6.19343H10.048C9.95036 6.19331 9.85406 6.17071 9.76656 6.12738C9.67907 6.08405 9.60273 6.02116 9.54345 5.94357C9.48418 5.86598 9.44357 5.77579 9.42477 5.67997C9.40598 5.58416 9.40949 5.48531 9.43506 5.39108L10.1674 2.70578C10.2496 2.40626 10.4277 2.14196 10.6746 1.95346C10.9214 1.76495 11.2233 1.66265 11.5339 1.66225H15.0133L16.1603 2.42696V5.90931C15.2945 6.3952 13.0468 7.84931 13.0468 9.89637V9.89931ZM18.2356 6.26402C18.2356 6.32304 18.224 6.38148 18.2014 6.436C18.1788 6.49053 18.1457 6.54007 18.104 6.5818C18.0623 6.62353 18.0127 6.65664 17.9582 6.67922C17.9037 6.70181 17.8452 6.71343 17.7862 6.71343C17.7272 6.71343 17.6688 6.70181 17.6142 6.67922C17.5597 6.65664 17.5102 6.62353 17.4684 6.5818C17.4267 6.54007 17.3936 6.49053 17.371 6.436C17.3484 6.38148 17.3368 6.32304 17.3368 6.26402V2.11343C17.3368 1.99424 17.3842 1.87993 17.4684 1.79565C17.5527 1.71137 17.667 1.66402 17.7862 1.66402C17.9054 1.66402 18.0197 1.71137 18.104 1.79565C18.1883 1.87993 18.2356 1.99424 18.2356 2.11343V6.26402Z' />
            </mask>
            <path
                d='M16.4409 1.20167L15.6659 2.36756L16.822 3.13607L17.6002 1.98654L16.4409 1.20167ZM15.518 0.588137L14.7413 1.75294L14.743 1.75404L15.518 0.588137ZM15.1915 0.489314V1.88931L15.1918 1.88931L15.1915 0.489314ZM11.5339 0.489314V-0.910688L11.5316 -0.910685L11.5339 0.489314ZM9.03211 2.3999L7.6821 2.02915L7.68149 2.03139L9.03211 2.3999ZM8.29976 5.08402L6.94913 4.7155L6.94876 4.71687L8.29976 5.08402ZM10.048 7.37167L10.0475 8.77167H10.048V7.37167ZM11.3609 7.37167L12.7338 7.64623L13.0687 5.97167H11.3609V7.37167ZM11.1256 8.54814L12.4961 8.83467L12.4985 8.8227L11.1256 8.54814ZM11.6051 10.4399L12.6816 9.54482L12.6736 9.53531L11.6051 10.4399ZM13.0651 11.1764L12.985 12.5741L13.021 12.5761L13.057 12.5763L13.0651 11.1764ZM13.4892 11.1028L13.968 12.4184L13.9861 12.4118L14.0039 12.4048L13.4892 11.1028ZM14.2233 9.8952H12.8233V9.96658L12.8306 10.0376L14.2233 9.8952ZM16.4127 7.12402L17.601 6.38383L16.8608 5.19549L15.6725 5.9357L16.4127 7.12402ZM19.4121 6.26402H18.0121L18.0121 6.26596L19.4121 6.26402ZM19.4121 2.11343H20.8121L20.8121 2.11191L19.4121 2.11343ZM13.0468 9.89931H11.6468L11.6469 9.90887L13.0468 9.89931ZM13.0398 10.0023L12.7473 11.3714L14.2109 11.6841L14.4253 10.2028L13.0398 10.0023ZM12.5003 9.67873L11.4206 10.5699L11.4254 10.5757L11.4303 10.5814L12.5003 9.67873ZM12.2792 8.78167L13.6495 9.06878L13.6521 9.05582L12.2792 8.78167ZM12.6551 6.89931L11.2833 6.61931L11.2822 6.62516L12.6551 6.89931ZM12.0786 6.19343V7.59343H12.0789L12.0786 6.19343ZM10.048 6.19343L10.0463 7.59343H10.048V6.19343ZM9.43506 5.39108L8.08438 5.02271L8.08388 5.02457L9.43506 5.39108ZM10.1674 2.70578L8.81727 2.33547L8.81674 2.33742L10.1674 2.70578ZM11.5339 1.66225V0.262254L11.5321 0.262256L11.5339 1.66225ZM15.0133 1.66225L15.7899 0.497384L15.4372 0.262255H15.0133V1.66225ZM16.1603 2.42696H17.5603V1.6777L16.9369 1.26209L16.1603 2.42696ZM16.1603 5.90931L16.8455 7.13023L17.5603 6.72907V5.90931H16.1603ZM18.2356 6.26402H16.8356H18.2356ZM17.3368 6.26402H18.7368H17.3368ZM17.3368 2.11343L15.9368 2.11343V2.11343H17.3368ZM18.2356 2.11343H19.6356V2.11343L18.2356 2.11343ZM17.7857 -0.912451C17.2915 -0.912279 16.8049 -0.791031 16.3683 -0.559311L17.6812 1.91385C17.7137 1.89659 17.7499 1.88756 17.7867 1.88755L17.7857 -0.912451ZM16.3683 -0.559311C15.9318 -0.32759 15.5587 0.0075466 15.2816 0.416795L17.6002 1.98654C17.6209 1.95606 17.6487 1.9311 17.6812 1.91385L16.3683 -0.559311ZM17.216 0.0357682L16.293 -0.577761L14.743 1.75404L15.6659 2.36756L17.216 0.0357682ZM16.2947 -0.576663C15.9679 -0.794545 15.584 -0.910774 15.1912 -0.910686L15.1918 1.88931C15.0315 1.88935 14.8747 1.84189 14.7413 1.75294L16.2947 -0.576663ZM15.1915 -0.910686H11.5339V1.88931H15.1915V-0.910686ZM11.5316 -0.910685C10.6567 -0.909246 9.80641 -0.620922 9.11109 -0.0899108L10.8105 2.13537C11.019 1.97618 11.2739 1.88974 11.5362 1.88931L11.5316 -0.910685ZM9.11109 -0.0899108C8.41577 0.4411 7.91379 1.18549 7.6821 2.02915L10.3821 2.77066C10.4516 2.51773 10.6021 2.29457 10.8105 2.13537L9.11109 -0.0899108ZM7.68149 2.03139L6.94913 4.7155L9.65039 5.45253L10.3827 2.76842L7.68149 2.03139ZM6.94876 4.71687C6.81932 5.19319 6.80138 5.69293 6.89633 6.17731L9.64403 5.63864C9.63184 5.57647 9.63414 5.51232 9.65076 5.45117L6.94876 4.71687ZM6.89633 6.17731C6.99129 6.66169 7.1966 7.11767 7.49631 7.50985L9.72105 5.80969C9.68257 5.75935 9.65622 5.70082 9.64403 5.63864L6.89633 6.17731ZM7.49631 7.50985C7.79602 7.90204 8.18208 8.21989 8.62452 8.43872L9.86587 5.92893C9.80907 5.90084 9.75952 5.86004 9.72105 5.80969L7.49631 7.50985ZM8.62452 8.43872C9.06696 8.65755 9.55387 8.77148 10.0475 8.77167L10.0485 5.97167C9.98516 5.97164 9.92266 5.95702 9.86587 5.92893L8.62452 8.43872ZM10.048 8.77167H11.3609V5.97167H10.048V8.77167ZM9.98812 7.0971L9.75283 8.27357L12.4985 8.8227L12.7338 7.64623L9.98812 7.0971ZM9.75528 8.26161C9.64249 8.80106 9.65423 9.35912 9.78961 9.89334L12.5038 9.20551C12.473 9.0841 12.4704 8.95726 12.496 8.83466L9.75528 8.26161ZM9.78961 9.89334C9.925 10.4276 10.1805 10.9239 10.5365 11.3445L12.6736 9.53531C12.5926 9.43972 12.5346 9.32692 12.5038 9.20551L9.78961 9.89334ZM10.5285 11.3349C10.8311 11.6989 11.2054 11.9967 11.628 12.2099L12.889 9.70994C12.8093 9.66972 12.7387 9.61353 12.6816 9.54486L10.5285 11.3349ZM11.628 12.2099C12.0506 12.4231 12.5125 12.547 12.985 12.5741L13.1451 9.77866C13.0559 9.77356 12.9688 9.75017 12.889 9.70994L11.628 12.2099ZM13.057 12.5763C13.3676 12.5781 13.6761 12.5247 13.968 12.4184L13.0103 9.78728C13.0304 9.77996 13.0517 9.77627 13.0731 9.7764L13.057 12.5763ZM14.0039 12.4048C14.5249 12.1988 14.9643 11.8283 15.2554 11.3495L12.8627 9.89509C12.8887 9.85236 12.9279 9.81929 12.9744 9.80091L14.0039 12.4048ZM15.2554 11.3495C15.5464 10.8708 15.673 10.3101 15.616 9.75281L12.8306 10.0376C12.8255 9.98785 12.8368 9.93781 12.8627 9.89509L15.2554 11.3495ZM15.6233 9.8952C15.6233 9.82993 15.6733 9.60503 16.0135 9.23025C16.3306 8.88102 16.7627 8.55541 17.1529 8.31234L15.6725 5.9357C15.1533 6.2591 14.4907 6.74202 13.9404 7.34823C13.4133 7.92889 12.8233 8.80635 12.8233 9.8952H15.6233ZM15.2244 7.86421C15.5717 8.42189 16.0914 8.85119 16.7046 9.08709L17.7099 6.4738C17.6648 6.45644 17.6266 6.42486 17.601 6.38383L15.2244 7.86421ZM16.7046 9.08709C17.3178 9.323 17.9912 9.35265 18.6228 9.17156L17.851 6.48001C17.8046 6.49333 17.755 6.49115 17.7099 6.4738L16.7046 9.08709ZM18.6228 9.17156C19.2543 8.99047 19.8097 8.60851 20.2048 8.08352L17.9674 6.39996C17.9384 6.43859 17.8975 6.46669 17.851 6.48001L18.6228 9.17156ZM20.2048 8.08352C20.5998 7.55852 20.813 6.9191 20.8121 6.26208L18.0121 6.26596C18.0122 6.3143 17.9965 6.36134 17.9674 6.39996L20.2048 8.08352ZM20.8121 6.26402V2.11343H18.0121V6.26402H20.8121ZM20.8121 2.11191C20.8112 1.31007 20.4923 0.541317 19.9253 -0.0256747L17.9454 1.95422C17.9881 1.99685 18.012 2.05466 18.0121 2.11495L20.8121 2.11191ZM19.9253 -0.0256747C19.3583 -0.592665 18.5896 -0.911581 17.7877 -0.91245L17.7847 1.88755C17.845 1.88761 17.9028 1.91159 17.9454 1.95422L19.9253 -0.0256747ZM11.6469 9.90887C11.6466 9.87299 11.6491 9.83716 11.6542 9.80169L14.4253 10.2028C14.4403 10.0992 14.4475 9.99452 14.4468 9.88976L11.6469 9.90887ZM13.3323 8.63315C13.4253 8.65303 13.5091 8.70329 13.5704 8.77601L11.4303 10.5814C11.7695 10.9836 12.2328 11.2614 12.7473 11.3714L13.3323 8.63315ZM13.5801 8.78757C13.612 8.82623 13.6348 8.87158 13.6468 8.92026L10.9282 9.59055C11.0168 9.9498 11.1851 10.2845 11.4206 10.5699L13.5801 8.78757ZM13.6468 8.92026C13.6588 8.96894 13.6597 9.0197 13.6494 9.06876L10.9089 8.49457C10.833 8.85671 10.8396 9.23129 10.9282 9.59055L13.6468 8.92026ZM13.6521 9.05582L14.028 7.17346L11.2822 6.62516L10.9063 8.50752L13.6521 9.05582ZM14.0268 7.17931C14.0857 6.89041 14.0797 6.592 14.0091 6.30571L11.2905 6.97599C11.2617 6.8591 11.2593 6.73727 11.2833 6.61931L14.0268 7.17931ZM14.0091 6.30571C13.9385 6.01942 13.8052 5.75241 13.6187 5.52404L11.45 7.29514C11.3738 7.2019 11.3194 7.09288 11.2905 6.97599L14.0091 6.30571ZM13.6187 5.52404C13.4321 5.29566 13.1972 5.11162 12.9308 4.98526L11.7308 7.51511C11.622 7.46352 11.5261 7.38838 11.45 7.29514L13.6187 5.52404ZM12.9308 4.98526C12.6643 4.85889 12.3732 4.79337 12.0783 4.79343L12.0789 7.59343C11.9585 7.59346 11.8396 7.56671 11.7308 7.51511L12.9308 4.98526ZM12.0786 4.79343H10.048V7.59343H12.0786V4.79343ZM10.0497 4.79343C10.167 4.79357 10.2827 4.82073 10.3879 4.8728L9.14526 7.38197C9.42539 7.52069 9.7337 7.59306 10.0463 7.59343L10.0497 4.79343ZM10.3879 4.8728C10.493 4.92487 10.5847 5.00045 10.656 5.09368L8.43094 6.79345C8.62071 7.04187 8.86513 7.24324 9.14526 7.38197L10.3879 4.8728ZM10.656 5.09368C10.7272 5.18692 10.776 5.2953 10.7986 5.41044L8.05097 5.94951C8.11115 6.25627 8.24117 6.54504 8.43094 6.79345L10.656 5.09368ZM10.7986 5.41044C10.8212 5.52556 10.8169 5.64435 10.7862 5.75759L8.08388 5.02457C8.00204 5.32627 7.99078 5.64276 8.05097 5.94951L10.7986 5.41044ZM10.7857 5.75944L11.5181 3.07415L8.81674 2.33742L8.08439 5.02271L10.7857 5.75944ZM11.5175 3.0761C11.5186 3.07212 11.521 3.06862 11.5243 3.06612L9.82487 0.840801C9.33446 1.21531 8.98049 1.74039 8.81727 2.33547L11.5175 3.0761ZM11.5243 3.06612C11.5275 3.06362 11.5316 3.06226 11.5357 3.06225L11.5321 0.262256C10.915 0.263047 10.3153 0.466291 9.82487 0.840801L11.5243 3.06612ZM11.5339 3.06225H15.0133V0.262255H11.5339V3.06225ZM14.2367 2.82713L15.3838 3.59183L16.9369 1.26209L15.7899 0.497384L14.2367 2.82713ZM14.7603 2.42696V5.90931H17.5603V2.42696H14.7603ZM15.4752 4.6884C14.9892 4.96113 14.0832 5.52126 13.2816 6.33481C12.4947 7.13352 11.6468 8.34371 11.6468 9.89637H14.4468C14.4468 9.40197 14.7228 8.86158 15.2761 8.29999C15.8148 7.75325 16.4656 7.34337 16.8455 7.13023L15.4752 4.6884ZM11.6468 9.89637V9.89931H14.4468V9.89637H11.6468ZM16.8356 6.26402C16.8356 6.13918 16.8602 6.01557 16.908 5.90025L19.4949 6.97176C19.5878 6.74739 19.6356 6.5069 19.6356 6.26402H16.8356ZM16.908 5.90025C16.9558 5.78493 17.0258 5.68013 17.1141 5.59185L19.094 7.57175C19.2657 7.40001 19.4019 7.19613 19.4949 6.97176L16.908 5.90025ZM17.1141 5.59185C17.2023 5.50358 17.3071 5.43356 17.4225 5.38579L18.494 7.97265C18.7184 7.87971 18.9222 7.74348 19.094 7.57175L17.1141 5.59185ZM17.4225 5.38579C17.5378 5.33802 17.6614 5.31343 17.7862 5.31343V8.11343C18.0291 8.11343 18.2696 8.0656 18.494 7.97265L17.4225 5.38579ZM17.7862 5.31343C17.9111 5.31343 18.0347 5.33802 18.15 5.38579L17.0785 7.97265C17.3029 8.0656 17.5434 8.11343 17.7862 8.11343V5.31343ZM18.15 5.38579C18.2653 5.43356 18.3701 5.50358 18.4584 5.59185L16.4785 7.57175C16.6502 7.74348 16.8541 7.87971 17.0785 7.97265L18.15 5.38579ZM18.4584 5.59185C18.5467 5.68012 18.6167 5.78491 18.6645 5.90025L16.0776 6.97176C16.1705 7.19614 16.3068 7.40002 16.4785 7.57175L18.4584 5.59185ZM18.6645 5.90025C18.7122 6.01558 18.7368 6.13919 18.7368 6.26402H15.9368C15.9368 6.50688 15.9847 6.74737 16.0776 6.97176L18.6645 5.90025ZM18.7368 6.26402V2.11343H15.9368V6.26402H18.7368ZM18.7368 2.11343C18.7368 2.36554 18.6367 2.60733 18.4584 2.7856L16.4785 0.8057C16.1317 1.15253 15.9368 1.62294 15.9368 2.11343L18.7368 2.11343ZM18.4584 2.7856C18.2801 2.96387 18.0383 3.06402 17.7862 3.06402V0.264019C17.2957 0.264019 16.8253 0.458869 16.4785 0.8057L18.4584 2.7856ZM17.7862 3.06402C17.5341 3.06402 17.2923 2.96387 17.1141 2.7856L19.094 0.8057C18.7471 0.458867 18.2767 0.264019 17.7862 0.264019V3.06402ZM17.1141 2.7856C16.9358 2.60733 16.8356 2.36554 16.8356 2.11343L19.6356 2.11343C19.6356 1.62294 19.4408 1.15253 19.094 0.8057L17.1141 2.7856ZM16.8356 2.11343V6.26402H19.6356V2.11343H16.8356Z'
                fill='url(#paint1_linear_5904_24741)'
                mask='url(#path-3-inside-2_5904_24741)'
            />
            <defs>
                <linearGradient
                    id='paint0_linear_5904_24741'
                    x1='6.17555'
                    y1='8.15796'
                    x2='6.17555'
                    y2='18.8235'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#2894FF' />
                    <stop offset='1' stopColor='#53AFF7' />
                </linearGradient>
                <linearGradient
                    id='paint1_linear_5904_24741'
                    x1='13.8242'
                    y1='0.487549'
                    x2='13.8242'
                    y2='11.1764'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#2894FF' />
                    <stop offset='1' stopColor='#53AFF7' />
                </linearGradient>
            </defs>
        </svg>
    )
}

export const IconPollGradient = () => {
    return (
        <svg
            width='18'
            height='20'
            viewBox='0 0 18 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <mask id='path-1-inside-1_5904_24734' fill='white'>
                <path d='M15 2C15.5523 2 16 2.44772 16 3L16 7C16 7.55228 15.5523 8 15 8L0.000346875 8L0.000347137 2L15 2Z' />
            </mask>
            <path
                d='M15 2C15.5523 2 16 2.44772 16 3L16 7C16 7.55228 15.5523 8 15 8L0.000346875 8L0.000347137 2L15 2Z'
                stroke='url(#paint0_linear_5904_24734)'
                strokeWidth='2.8'
                mask='url(#path-1-inside-1_5904_24734)'
            />
            <rect
                x='1.40039'
                width='20'
                height='1.39997'
                transform='rotate(90 1.40039 0)'
                fill='#52AFF8'
            />
            <mask id='path-3-inside-2_5904_24734' fill='white'>
                <path d='M17 7C17.5523 7 18 7.44772 18 8L18 12C18 12.5523 17.5523 13 17 13L0.000392652 13L0.000392914 7L17 7Z' />
            </mask>
            <path
                d='M17 7C17.5523 7 18 7.44772 18 8L18 12C18 12.5523 17.5523 13 17 13L0.000392652 13L0.000392914 7L17 7Z'
                stroke='url(#paint1_linear_5904_24734)'
                strokeWidth='2.8'
                mask='url(#path-3-inside-2_5904_24734)'
            />
            <mask id='path-4-inside-3_5904_24734' fill='white'>
                <path d='M10 12C10.5523 12 11 12.4477 11 13L11 17C11 17.5523 10.5523 18 10 18L0.000240064 18L0.000240326 12L10 12Z' />
            </mask>
            <path
                d='M10 12C10.5523 12 11 12.4477 11 13L11 17C11 17.5523 10.5523 18 10 18L0.000240064 18L0.000240326 12L10 12Z'
                stroke='url(#paint2_linear_5904_24734)'
                strokeWidth='2.8'
                mask='url(#path-4-inside-3_5904_24734)'
            />
            <defs>
                <linearGradient
                    id='paint0_linear_5904_24734'
                    x1='16'
                    y1='5'
                    x2='0.000347006'
                    y2='5'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#2894FF' />
                    <stop offset='1' stopColor='#53AFF7' />
                </linearGradient>
                <linearGradient
                    id='paint1_linear_5904_24734'
                    x1='18'
                    y1='10'
                    x2='0.000392783'
                    y2='10'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#2894FF' />
                    <stop offset='1' stopColor='#53AFF7' />
                </linearGradient>
                <linearGradient
                    id='paint2_linear_5904_24734'
                    x1='11'
                    y1='15'
                    x2='0.000240195'
                    y2='15'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#2894FF' />
                    <stop offset='1' stopColor='#53AFF7' />
                </linearGradient>
            </defs>
        </svg>
    )
}

export const IconPoll = ({ color = '#200E32' }: SVGProps) => {
    return (
        <svg
            width='18'
            height='20'
            viewBox='0 0 18 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <mask id='path-1-inside-1_5774_24220' fill='white'>
                <path d='M15 2.00012C15.5523 2.00012 16 2.44784 16 3.00012L16 7.00012C16 7.55241 15.5523 8.00012 15 8.00012L0.000346875 8.00012L0.000347137 2.00012L15 2.00012Z' />
            </mask>
            <path
                d='M15 2.00012C15.5523 2.00012 16 2.44784 16 3.00012L16 7.00012C16 7.55241 15.5523 8.00012 15 8.00012L0.000346875 8.00012L0.000347137 2.00012L15 2.00012Z'
                stroke={color}
                strokeWidth='2.8'
                mask='url(#path-1-inside-1_5774_24220)'
            />
            <rect
                x='1.40039'
                width='20'
                height='1.39997'
                transform='rotate(90 1.40039 0)'
                fill={color}
            />
            <mask id='path-3-inside-2_5774_24220' fill='white'>
                <path d='M17 7.00012C17.5523 7.00012 18 7.44784 18 8.00012L18 12.0001C18 12.5524 17.5523 13.0001 17 13.0001L0.000392652 13.0001L0.000392914 7.00012L17 7.00012Z' />
            </mask>
            <path
                d='M17 7.00012C17.5523 7.00012 18 7.44784 18 8.00012L18 12.0001C18 12.5524 17.5523 13.0001 17 13.0001L0.000392652 13.0001L0.000392914 7.00012L17 7.00012Z'
                stroke={color}
                strokeWidth='2.8'
                mask='url(#path-3-inside-2_5774_24220)'
            />
            <mask id='path-4-inside-3_5774_24220' fill='white'>
                <path d='M10 12.0001C10.5523 12.0001 11 12.4478 11 13.0001L11 17.0001C11 17.5524 10.5523 18.0001 10 18.0001L0.000240064 18.0001L0.000240326 12.0001L10 12.0001Z' />
            </mask>
            <path
                d='M10 12.0001C10.5523 12.0001 11 12.4478 11 13.0001L11 17.0001C11 17.5524 10.5523 18.0001 10 18.0001L0.000240064 18.0001L0.000240326 12.0001L10 12.0001Z'
                stroke={color}
                strokeWidth='2.8'
                mask='url(#path-4-inside-3_5774_24220)'
            />
        </svg>
    )
}

export const IconPollBgImg = () => {
    return (
        <svg
            width='30'
            height='30'
            viewBox='0 0 30 30'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M28.8725 8.66677V20.9914C28.8725 25.5004 26.0317 28.7319 21.4927 28.7319H8.49172C3.9827 28.7319 1.12695 25.5304 1.12695 20.9914V8.74181C1.12695 4.2328 3.96767 1.0013 8.49172 1.0013H21.4927C26.0317 0.926145 28.8725 4.1277 28.8725 8.66677Z'
                stroke='white'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M4.92773 21.7034L7.22729 19.2685C7.41714 19.0626 7.64616 18.8965 7.901 18.7803C8.15583 18.664 8.43132 18.5999 8.7113 18.5915C8.99128 18.5831 9.27017 18.6307 9.53152 18.7315C9.79286 18.8323 10.0314 18.9842 10.2333 19.1784H10.3084L11.6461 20.5312C12.0459 20.9277 12.5861 21.15 13.1491 21.15C13.7122 21.15 14.2524 20.9277 14.6521 20.5312L14.8174 20.3506L18.1692 16.2775C18.38 16.0203 18.6394 15.8073 18.9327 15.6506C19.2261 15.4939 19.5475 15.3967 19.8784 15.3646C20.2094 15.3325 20.5434 15.3661 20.8614 15.4635C21.1794 15.5608 21.475 15.72 21.7313 15.9319L21.9417 16.1273L25.068 19.3437'
                stroke='white'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M12.489 10.6714C12.486 11.191 12.3292 11.698 12.0383 12.1286C11.7475 12.5591 11.3357 12.8939 10.8549 13.0907C10.374 13.2875 9.84566 13.3375 9.33644 13.2344C8.82721 13.1312 8.35995 12.8794 7.9936 12.5109C7.62726 12.1425 7.37825 11.6739 7.27797 11.1641C7.17769 10.6542 7.23065 10.1261 7.43016 9.64637C7.62967 9.16663 7.96677 8.75683 8.39899 8.46848C8.8312 8.18012 9.33912 8.02613 9.85869 8.02612V8.02612C10.2054 8.02612 10.5486 8.09464 10.8687 8.22776C11.1888 8.36088 11.4794 8.55601 11.7239 8.80184C11.9683 9.04768 12.1618 9.33946 12.2931 9.66031C12.4244 9.98117 12.4909 10.3248 12.489 10.6714V10.6714Z'
                stroke='white'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}

export const IconExcMarkCircle = ({
    color,
    width = '20',
    height = '20'
}: SVGProps) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox='0 0 20 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g clipPath='url(#clip0_6035_33488)'>
                <path
                    d='M0 10C0 8.02219 0.586489 6.08871 1.6853 4.44422C2.78412 2.79973 4.3459 1.51811 6.17316 0.761235C8.00042 0.00435829 10.0111 -0.193709 11.9509 0.192143C13.8907 0.577995 15.6725 1.53043 17.071 2.92896C18.4696 4.32748 19.422 6.10927 19.8079 8.04908C20.1937 9.98889 19.9956 11.9995 19.2388 13.8268C18.4819 15.654 17.2002 17.2159 15.5557 18.3147C13.9112 19.4135 11.9778 20 10 20C7.34784 20 4.80432 18.9464 2.92896 17.071C1.05359 15.1957 0 12.6522 0 10ZM1.5 10C1.5 11.6811 1.9985 13.3245 2.9325 14.7223C3.86649 16.1201 5.19402 17.2096 6.74719 17.8529C8.30036 18.4963 10.0094 18.6646 11.6583 18.3367C13.3071 18.0087 14.8217 17.1991 16.0104 16.0104C17.1992 14.8216 18.0087 13.307 18.3367 11.6582C18.6646 10.0094 18.4963 8.30037 17.853 6.7472C17.2096 5.19402 16.1202 3.86649 14.7224 2.9325C13.3245 1.99851 11.6811 1.5 10 1.5C7.74566 1.5 5.58362 2.39557 3.98956 3.98963C2.3955 5.58369 1.5 7.74566 1.5 10ZM9.23999 13.7999C9.24284 13.6195 9.3098 13.446 9.42889 13.3104C9.54798 13.1748 9.71146 13.086 9.89001 13.0599H10C10.1981 13.0652 10.3863 13.1476 10.5245 13.2896C10.6628 13.4315 10.7401 13.6218 10.74 13.82C10.7356 13.9984 10.6693 14.1697 10.5526 14.3047C10.4359 14.4397 10.2759 14.5299 10.1 14.5599H10C9.80281 14.56 9.61351 14.4824 9.47314 14.3439C9.33278 14.2054 9.25263 14.0171 9.25 13.82L9.23999 13.7999ZM9.23999 10.73V6.19996C9.2452 6.00188 9.32758 5.81365 9.46954 5.67542C9.61151 5.53719 9.80185 5.4599 10 5.45997C10.1801 5.45831 10.3546 5.52244 10.4908 5.64026C10.6271 5.75808 10.7157 5.92152 10.74 6.09998V10.62C10.7413 10.7189 10.7229 10.817 10.6857 10.9086C10.6485 11.0002 10.5932 11.0834 10.5233 11.1533C10.4534 11.2232 10.3702 11.2785 10.2786 11.3157C10.187 11.3529 10.0889 11.3713 9.98999 11.37C9.80897 11.3692 9.63436 11.3029 9.49835 11.1835C9.36235 11.064 9.27413 10.8994 9.25 10.72L9.23999 10.73Z'
                    fill={color ?? '#B0B0B0'}
                />
            </g>
            <defs>
                <clipPath id='clip0_6035_33488'>
                    <rect width='20' height='20' fill={'white'} />
                </clipPath>
            </defs>
        </svg>
    )
}

export const IconCalendarClockOutline = ({ color }: SVGProps) => {
    return (
        <svg
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <rect x='5' width='1' height='2' rx='0.5' fill={color ?? 'white'} />
            <rect
                x='14'
                width='1'
                height='2'
                rx='0.5'
                fill={color ?? 'white'}
            />
            <circle
                cx='14'
                cy='14'
                r='5.3'
                stroke={color ?? 'white'}
                strokeWidth='1.4'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M18 2.4H2C1.66863 2.4 1.4 2.66863 1.4 3V13C1.4 13.3314 1.66863 13.6 2 13.6H7.01124C7.00378 13.7324 7 13.8658 7 14C7 14.3395 7.02417 14.6734 7.07089 15H2C0.895431 15 0 14.1046 0 13V3C0 1.89543 0.895431 1 2 1H18C19.1046 1 20 1.89543 20 3V10.3924C19.6221 9.76533 19.1488 9.20231 18.6 8.7235V3C18.6 2.66863 18.3314 2.4 18 2.4ZM19.511 13C19.366 12.1956 19.0492 11.451 18.6 10.8054V13H19.511Z'
                fill={color ?? 'white'}
            />
            <rect
                x='13.5'
                y='11'
                width='1'
                height='4'
                rx='0.5'
                fill={color ?? 'white'}
            />
            <rect
                x='17.5'
                y='14'
                width='1'
                height='4'
                rx='0.5'
                transform='rotate(90 17.5 14)'
                fill={color ?? 'white'}
            />
        </svg>
    )
}

export const IconCalendarClockOutline2 = ({ color = 'white' }: SVGProps) => {
    return (
        <svg
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M18.6667 4.38667C18.6658 3.5524 18.3339 2.75257 17.744 2.16265C17.1541 1.57274 16.3543 1.24092 15.52 1.24H14.9524V0.666667C14.9524 0.489856 14.8822 0.320286 14.7571 0.195262C14.6321 0.0702379 14.4625 0 14.2857 0C14.1089 0 13.9394 0.0702379 13.8143 0.195262C13.6893 0.320286 13.6191 0.489856 13.6191 0.666667V1.24H5.04813V0.666667C5.04813 0.489856 4.9779 0.320286 4.85287 0.195262C4.72785 0.0702379 4.55828 0 4.38147 0C4.20466 0 4.03509 0.0702379 3.91006 0.195262C3.78504 0.320286 3.7148 0.489856 3.7148 0.666667V1.24H3.14667C2.3124 1.24092 1.51257 1.57274 0.922651 2.16265C0.332735 2.75257 0.000917591 3.5524 0 4.38667V15.52C0.000917591 16.3543 0.332735 17.1541 0.922651 17.744C1.51257 18.3339 2.3124 18.6658 3.14667 18.6667H10.2753C11.3281 19.5237 12.6426 19.9942 14 20C15.5908 19.9982 17.1159 19.3655 18.2407 18.2407C19.3655 17.1159 19.9982 15.5908 20 14C19.9942 12.6426 19.5237 11.3281 18.6667 10.2753V4.38667ZM3.14667 2.57333H3.71427V3.14227C3.71427 3.31908 3.7845 3.48865 3.90953 3.61367C4.03455 3.7387 4.20412 3.80893 4.38093 3.80893C4.55774 3.80893 4.72731 3.7387 4.85234 3.61367C4.97736 3.48865 5.0476 3.31908 5.0476 3.14227V2.57333H13.618V3.14227C13.618 3.31908 13.6882 3.48865 13.8133 3.61367C13.9383 3.7387 14.1079 3.80893 14.2847 3.80893C14.4615 3.80893 14.631 3.7387 14.7561 3.61367C14.8811 3.48865 14.9513 3.31908 14.9513 3.14227V2.57333H15.52C16.0008 2.5739 16.4617 2.76513 16.8016 3.10507C17.1415 3.44501 17.3328 3.90591 17.3333 4.38667V4.95253H1.33333V4.38667C1.3339 3.90591 1.52513 3.44501 1.86507 3.10507C2.20501 2.76513 2.66591 2.5739 3.14667 2.57333ZM1.33333 15.52V6.28587H17.3333V9.01573C16.18 8.24232 14.794 7.89329 13.4119 8.02824C12.0299 8.16319 10.7376 8.77376 9.75566 9.75566C8.77376 10.7376 8.16319 12.0299 8.02824 13.4119C7.89329 14.794 8.24232 16.18 9.01573 17.3333H3.14667C2.66592 17.3327 2.20504 17.1415 1.86511 16.8016C1.52517 16.4616 1.33393 16.0007 1.33333 15.52ZM14 18.6667C13.077 18.6667 12.1748 18.393 11.4073 17.8802C10.6399 17.3674 10.0418 16.6386 9.68856 15.7859C9.33535 14.9331 9.24294 13.9948 9.423 13.0896C9.60307 12.1843 10.0475 11.3528 10.7002 10.7002C11.3528 10.0475 12.1843 9.60307 13.0896 9.423C13.9948 9.24294 14.9331 9.33535 15.7859 9.68856C16.6386 10.0418 17.3674 10.6399 17.8802 11.4073C18.393 12.1748 18.6667 13.077 18.6667 14C18.6652 15.2372 18.173 16.4233 17.2982 17.2982C16.4233 18.173 15.2372 18.6652 14 18.6667Z'
                fill={color}
            />
            <path
                d='M14.6673 13.724V11.3333C14.6673 11.1565 14.5971 10.9869 14.4721 10.8619C14.347 10.7369 14.1775 10.6667 14.0007 10.6667C13.8238 10.6667 13.6543 10.7369 13.5292 10.8619C13.4042 10.9869 13.334 11.1565 13.334 11.3333V14C13.334 14.0875 13.3512 14.1742 13.3847 14.2551C13.4182 14.336 13.4674 14.4095 13.5293 14.4713L14.8626 15.8046C14.9884 15.9261 15.1568 15.9933 15.3316 15.9918C15.5064 15.9902 15.6736 15.9201 15.7972 15.7965C15.9208 15.6729 15.9909 15.5057 15.9924 15.3309C15.9939 15.1561 15.9268 14.9877 15.8053 14.862L14.6673 13.724Z'
                fill={color}
            />
        </svg>
    )
}

export const IconPencil = ({ color, width, height }: SVGProps) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox='0 0 14 14'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M1.64939 8.29974L8.29473 1.6247C8.4914 1.42666 8.72504 1.26952 8.98226 1.16231C9.23948 1.0551 9.51522 1 9.79371 1C10.0722 1 10.348 1.0551 10.6052 1.16231C10.8624 1.26952 11.096 1.42666 11.2927 1.6247L12.378 2.71485C12.5752 2.9124 12.7316 3.14717 12.8383 3.40554C12.9451 3.66391 13 3.94086 13 4.22059C13 4.50032 12.9451 4.77726 12.8383 5.03563C12.7316 5.294 12.5752 5.52866 12.378 5.72622L5.6971 12.437C5.5182 12.6161 5.30588 12.7581 5.07233 12.8547C4.83878 12.9513 4.58858 13.0006 4.33601 13H1L1.08006 9.62233C1.09638 9.12501 1.29982 8.65231 1.64939 8.29974V8.29974Z'
                stroke={color ?? 'white'}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M7.2793 2.66138L11.3448 6.73606'
                stroke={color ?? 'white'}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}

export const IconChatBubbleWhite = ({
    bubbleColor,
    dotsColor,
    width,
    height
}: SVGProps) => {
    return (
        <svg
            width={width ?? '28'}
            height={height ?? '28'}
            viewBox='0 0 28 28'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g clipPath='url(#clip0_4945_48623)'>
                <path
                    d='M14 3.51335e-05C10.287 3.51335e-05 6.72605 1.47645 4.10054 4.10459C1.47503 6.73273 0 10.2973 0 14.0141C0.0356416 16.4711 0.685372 18.88 1.88997 21.0211C1.99804 21.2111 2.06289 21.4227 2.07983 21.6407C2.09677 21.8587 2.06539 22.0778 1.98798 22.2823L1.05 25.4214C0.978415 25.6408 0.99546 25.8795 1.09751 26.0864C1.19956 26.2934 1.37852 26.4521 1.59602 26.5286C1.78928 26.6058 2.00476 26.6058 2.19801 26.5286L4.99801 25.6877C5.36095 25.6035 5.73851 25.6053 6.10065 25.6929C6.46278 25.7805 6.79949 25.9515 7.084 26.1922C8.94746 27.2544 11.0298 27.8738 13.1703 28.0028C15.3108 28.1317 17.4523 27.7667 19.4295 26.936C21.4068 26.1052 23.167 24.831 24.5743 23.2114C25.9817 21.5919 26.9986 19.6704 27.5465 17.5951C28.0945 15.5199 28.1589 13.3463 27.7348 11.2422C27.3106 9.1381 26.4094 7.15966 25.1004 5.45946C23.7914 3.75927 22.1097 2.38274 20.1851 1.43616C18.2605 0.48959 16.1444 -0.00170678 14 3.51335e-05Z'
                    fill={bubbleColor ?? 'white'}
                />
                <path
                    d='M18.634 14.028C18.634 13.6732 18.7391 13.3264 18.936 13.0314C19.1329 12.7365 19.4128 12.5065 19.7402 12.3708C20.0677 12.235 20.428 12.1995 20.7756 12.2687C21.1232 12.3379 21.4426 12.5087 21.6932 12.7596C21.9438 13.0105 22.1144 13.3301 22.1836 13.6781C22.2527 14.026 22.2173 14.3867 22.0816 14.7145C21.946 15.0423 21.7163 15.3225 21.4216 15.5196C21.1269 15.7167 20.7805 15.8218 20.426 15.8218C20.1914 15.8237 19.9586 15.779 19.7413 15.6904C19.5239 15.6018 19.3263 15.471 19.1597 15.3056C18.9931 15.1401 18.8609 14.9433 18.7706 14.7264C18.6804 14.5095 18.634 14.2769 18.634 14.042V14.028ZM12.18 14.028C12.1828 13.6738 12.2903 13.3284 12.4888 13.0353C12.6874 12.7422 12.9682 12.5144 13.2959 12.3808C13.6236 12.2472 13.9834 12.2137 14.3301 12.2845C14.6768 12.3553 14.9948 12.5272 15.244 12.7786C15.4932 13.03 15.6625 13.3497 15.7305 13.6972C15.7985 14.0448 15.7622 14.4047 15.6262 14.7317C15.4902 15.0587 15.2605 15.338 14.9661 15.5345C14.6717 15.731 14.3258 15.8359 13.972 15.8359C13.7349 15.8378 13.5 15.7922 13.2808 15.7018C13.0616 15.6115 12.8626 15.4782 12.6956 15.3097C12.5287 15.1413 12.3971 14.9411 12.3085 14.721C12.22 14.5009 12.1763 14.2653 12.18 14.028ZM5.72604 14.028C5.72604 13.6732 5.83111 13.3264 6.02802 13.0314C6.22493 12.7365 6.50482 12.5065 6.83227 12.3708C7.15971 12.235 7.51996 12.1995 7.86757 12.2687C8.21519 12.3379 8.53451 12.5087 8.78513 12.7596C9.03574 13.0105 9.20646 13.3301 9.2756 13.6781C9.34475 14.026 9.30921 14.3867 9.17358 14.7145C9.03795 15.0423 8.80826 15.3225 8.51357 15.5196C8.21888 15.7167 7.87242 15.8218 7.518 15.8218C7.04273 15.8218 6.58694 15.6329 6.25087 15.2965C5.91481 14.9601 5.72604 14.5038 5.72604 14.028Z'
                    fill={dotsColor ?? '#369DFD'}
                />
            </g>
            <defs>
                <clipPath id='clip0_4945_48623'>
                    <rect width='28' height='28' fill='white' />
                </clipPath>
            </defs>
        </svg>
    )
}

export const IconScissors = () => {
    return (
        <svg
            width='18'
            height='18'
            viewBox='0 0 18 18'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M7.16711 7.49367L7.16798 7.49365C7.35764 7.49084 7.53771 7.41026 7.66929 7.2708C7.8018 7.13207 7.87554 6.94527 7.87554 6.75133C7.87554 6.55729 7.80172 6.37039 7.66907 6.23164L7.66886 6.23142L2.75133 1.11834L2.75108 1.11809C2.61684 0.979484 2.43428 0.901256 2.24336 0.901958C2.05243 0.902659 1.87043 0.982225 1.73715 1.12179C1.60399 1.26123 1.5302 1.44915 1.53086 1.64405C1.53153 1.83888 1.60654 2.02621 1.74057 2.16467C1.74062 2.16471 1.74066 2.16476 1.74071 2.16481L6.658 7.27763L6.65828 7.27793C6.72488 7.34661 6.80407 7.40116 6.89143 7.43826L6.93052 7.34622L6.89143 7.43826C6.9788 7.47537 7.07249 7.49423 7.16711 7.49367Z'
                fill='#262A33'
                stroke='#262A33'
                strokeWidth='0.2'
            />
            <path
                d='M1.84366 16.1172C2.39827 16.7019 3.1435 17.0511 3.93382 17.0952C4.7244 17.1394 5.5018 16.8751 6.11387 16.3551C6.72581 15.8352 7.12834 15.0973 7.24376 14.2862C7.35541 13.5016 7.19083 12.7022 6.78131 12.0342L9.00928 9.71768L11.2376 12.0346C10.8347 12.7023 10.675 13.4985 10.7889 14.2788C10.9066 15.0854 11.3083 15.8187 11.9172 16.336C12.5263 16.8534 13.2991 17.1176 14.0859 17.0765C14.8727 17.0355 15.616 16.692 16.1719 16.114C16.7277 15.5361 17.0567 14.7649 17.096 13.9502C17.1354 13.1354 16.8824 12.334 16.3853 11.7014C15.8881 11.0686 15.1819 10.6496 14.4031 10.5267C13.6521 10.4083 12.8864 10.5736 12.2443 10.9905L10.0148 8.67228L16.2794 2.16489L16.2794 2.16486C16.3458 2.09581 16.3983 2.01406 16.434 1.92435C16.4698 1.83464 16.4881 1.73863 16.4881 1.64175C16.4881 1.54487 16.4698 1.44886 16.434 1.35915C16.3983 1.26945 16.3458 1.18769 16.2794 1.11865C16.213 1.04959 16.1339 0.994601 16.0467 0.957006C15.9594 0.919408 15.8656 0.9 15.7709 0.9C15.6762 0.9 15.5824 0.919408 15.4951 0.957006C15.4079 0.994601 15.3288 1.04959 15.2624 1.11865L15.2624 1.11867L5.77465 10.99C5.13235 10.5664 4.36354 10.3959 3.6084 10.5121C2.82531 10.6325 2.11459 11.0524 1.61487 11.6883C1.11524 12.3241 0.862239 13.1302 0.904569 13.9489C0.946887 14.7673 1.2814 15.5406 1.84366 16.1172ZM1.84366 16.1172C1.84349 16.117 1.84332 16.1168 1.84315 16.1167L1.91572 16.0479M1.84366 16.1172C1.84382 16.1174 1.84398 16.1175 1.84414 16.1177L1.91572 16.0479M1.91572 16.0479C2.45323 16.6148 3.17488 16.9527 3.9394 16.9954C4.70392 17.0381 5.45625 16.7826 6.04912 16.2789C6.64199 15.7752 7.0327 15.0596 7.14476 14.2721C7.25683 13.4846 7.08218 12.682 6.655 12.0213M1.91572 16.0479C1.37051 15.489 1.04554 14.7386 1.00444 13.9437C0.963333 13.1488 1.20906 12.3665 1.6935 11.7501C2.17794 11.1337 2.86623 10.7274 3.6236 10.6109C4.38098 10.4944 5.15291 10.676 5.78829 11.1201L6.655 12.0213M6.655 12.0213L8.93991 9.64555L6.655 12.0213ZM12.6957 12.4997C13.023 12.1598 13.4659 11.9696 13.9268 11.9696C14.3877 11.9696 14.8306 12.1598 15.1579 12.4997C15.4024 12.7536 15.5693 13.0776 15.6371 13.4309C15.7049 13.7843 15.6703 14.1505 15.5378 14.4832C15.4054 14.8159 15.1813 15.0997 14.8945 15.299C14.6077 15.4983 14.271 15.6044 13.9268 15.6044C13.5827 15.6044 13.2459 15.4983 12.9591 15.299C12.6723 15.0997 12.4482 14.8159 12.3158 14.4832C12.1834 14.1505 12.1488 13.7843 12.2166 13.4309C12.2843 13.0776 12.4513 12.7536 12.6957 12.4997ZM2.86062 12.4997C3.18796 12.1598 3.63084 11.9696 4.09173 11.9696C4.55263 11.9696 4.99551 12.1598 5.32285 12.4997C5.56729 12.7536 5.73424 13.0776 5.802 13.4309C5.86976 13.7843 5.83517 14.1505 5.70275 14.4832C5.57034 14.8159 5.34625 15.0997 5.05942 15.299C4.77264 15.4983 4.43588 15.6044 4.09173 15.6044C3.74758 15.6044 3.41083 15.4983 3.12405 15.299C2.83722 15.0997 2.61313 14.8159 2.48072 14.4832C2.34829 14.1505 2.3137 13.7843 2.38147 13.4309C2.44923 13.0776 2.61618 12.7536 2.86062 12.4997Z'
                fill='#262A33'
                stroke='#262A33'
                strokeWidth='0.2'
            />
        </svg>
    )
}

export const IconUnlocked = ({ color = '#fff' }: SVGProps) => {
    return (
        <svg
            width='10'
            height='12'
            viewBox='0 0 10 12'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g clipPath='url(#clip0_6035_31479)'>
                <path
                    d='M7.48822 12.0001H2.51178C2.18578 12.004 1.86222 11.9424 1.55956 11.8188C1.25689 11.6952 0.981032 11.5121 0.747788 11.2797C0.514545 11.0474 0.328506 10.7705 0.200195 10.4648C0.071885 10.1591 0.0038396 9.83055 0 9.49803V6.53403C0.0038396 6.20152 0.071885 5.87304 0.200195 5.56734C0.328506 5.26164 0.514545 4.98471 0.747788 4.75238C0.981032 4.52004 1.25689 4.33684 1.55956 4.21324C1.86222 4.08964 2.18578 4.02808 2.51178 4.03204H7.48822C8.14614 4.02563 8.77977 4.28528 9.25049 4.75417C9.72121 5.22306 9.9907 5.86299 10 6.53403V9.49803C9.99616 9.83055 9.92812 10.1591 9.7998 10.4648C9.67149 10.7705 9.48546 11.0474 9.25221 11.2797C9.01897 11.5121 8.74311 11.6952 8.44044 11.8188C8.13778 11.9424 7.81422 12.004 7.48822 12.0001ZM5 6.83403C4.93258 6.83243 4.86556 6.84459 4.80282 6.86981C4.74008 6.89502 4.68288 6.93281 4.63465 6.98088C4.58642 7.02896 4.54814 7.08638 4.52199 7.14978C4.49583 7.21318 4.48233 7.28127 4.48235 7.35006V8.67603C4.47458 8.75051 4.48228 8.82583 4.5049 8.89708C4.52752 8.96833 4.56459 9.03394 4.61368 9.08963C4.66278 9.14532 4.72276 9.18985 4.78982 9.22033C4.85689 9.25082 4.92952 9.26655 5.00294 9.26655C5.07637 9.26655 5.149 9.25082 5.21606 9.22033C5.28313 9.18985 5.34311 9.14532 5.3922 9.08963C5.4413 9.03394 5.47837 8.96833 5.50099 8.89708C5.52361 8.82583 5.53131 8.75051 5.52354 8.67603V7.35006C5.52278 7.28099 5.50855 7.21277 5.48175 7.14934C5.45495 7.08591 5.41613 7.02851 5.36743 6.98051C5.31874 6.93252 5.26118 6.89488 5.19811 6.86974C5.13504 6.84459 5.0677 6.83244 5 6.83403Z'
                    fill={color}
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M6 0.372329C5.67816 0.265476 5.33926 0.209717 4.99506 0.209717C4.18169 0.209717 3.39797 0.521075 2.79887 1.08221C2.19977 1.64335 1.82894 2.41341 1.75977 3.24004V4.12806C1.97352 4.06306 2.19554 4.03069 2.41859 4.03204H2.80095V3.22806C2.81331 2.64133 3.05173 2.08313 3.46458 1.67438C3.87744 1.26562 4.43149 1.03919 5.00683 1.04406C5.3547 1.04116 5.69468 1.12328 6 1.27939V0.372329Z'
                    fill={color}
                />
            </g>
            <defs>
                <clipPath id='clip0_6035_31479'>
                    <rect width='10' height='12' fill={color} />
                </clipPath>
            </defs>
        </svg>
    )
}

export const IconLocked = ({
    color = '#fff',
    width = '10',
    height = '12'
}: SVGProps) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox='0 0 10 12'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M7.48822 12.0001H2.51178C2.18578 12.004 1.86222 11.9424 1.55956 11.8188C1.25689 11.6952 0.981032 11.5121 0.747788 11.2797C0.514545 11.0474 0.328506 10.7705 0.200195 10.4648C0.071885 10.1591 0.0038396 9.83055 0 9.49803V6.53403C0.0038396 6.20152 0.071885 5.87304 0.200195 5.56734C0.328506 5.26164 0.514545 4.98471 0.747788 4.75238C0.981032 4.52004 1.25689 4.33684 1.55956 4.21324C1.86222 4.08964 2.18578 4.02808 2.51178 4.03204H7.48822C8.14614 4.02563 8.77977 4.28528 9.25049 4.75417C9.72121 5.22306 9.9907 5.86299 10 6.53403V9.49803C9.99616 9.83055 9.92812 10.1591 9.7998 10.4648C9.67149 10.7705 9.48546 11.0474 9.25221 11.2797C9.01897 11.5121 8.74311 11.6952 8.44044 11.8188C8.13778 11.9424 7.81422 12.004 7.48822 12.0001ZM5 6.83403C4.93258 6.83243 4.86556 6.84459 4.80282 6.86981C4.74008 6.89502 4.68288 6.93281 4.63465 6.98088C4.58642 7.02896 4.54814 7.08638 4.52199 7.14978C4.49583 7.21318 4.48233 7.28127 4.48235 7.35006V8.67603C4.47458 8.75051 4.48228 8.82583 4.5049 8.89708C4.52752 8.96833 4.56459 9.03394 4.61368 9.08963C4.66278 9.14532 4.72276 9.18985 4.78982 9.22033C4.85689 9.25082 4.92952 9.26655 5.00294 9.26655C5.07637 9.26655 5.149 9.25082 5.21606 9.22033C5.28313 9.18985 5.34311 9.14532 5.3922 9.08963C5.4413 9.03394 5.47837 8.96833 5.50099 8.89708C5.52361 8.82583 5.53131 8.75051 5.52354 8.67603V7.35006C5.52278 7.28099 5.50855 7.21277 5.48175 7.14934C5.45495 7.08591 5.41613 7.02851 5.36743 6.98051C5.31874 6.93252 5.26118 6.89488 5.19811 6.86974C5.13504 6.84459 5.0677 6.83244 5 6.83403Z'
                fill={color}
            />
            <path
                d='M8.24802 3.24004V4.12206C8.03339 4.06192 7.81178 4.03164 7.5892 4.03204H7.20094V3.24004C7.19473 2.6523 6.96025 2.09106 6.54894 1.67939C6.13763 1.26773 5.58307 1.03926 5.00683 1.04406C4.43149 1.03919 3.87744 1.26562 3.46458 1.67438C3.05173 2.08313 2.81331 2.64133 2.80095 3.22806V4.03204H2.41859C2.19554 4.03069 1.97352 4.06306 1.75977 4.12806V3.24004C1.82894 2.41341 2.19977 1.64335 2.79887 1.08221C3.39797 0.521075 4.18169 0.209717 4.99506 0.209717C5.80843 0.209717 6.59215 0.521075 7.19125 1.08221C7.79034 1.64335 8.16118 2.41341 8.23035 3.24004'
                fill={color}
            />
        </svg>
    )
}

export const IconCheckmarkGradient = () => {
    return (
        <svg
            width='16'
            height='16'
            viewBox='0 0 16 16'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M13.6573 2.34274C12.1456 0.831084 10.1366 0 8 0C5.86339 0 3.8544 0.831084 2.34274 2.34274C0.831084 3.8544 0 5.86339 0 8C0 10.1366 0.831084 12.1456 2.34274 13.6573C3.8544 15.1689 5.86339 16 8 16C10.1366 16 12.1456 15.1689 13.6573 13.6573C15.1689 12.1456 16 10.1366 16 8C16 5.86339 15.1689 3.8544 13.6573 2.34274ZM8 15.1166C4.07689 15.1166 0.883436 11.9231 0.883436 8C0.883436 4.07689 4.07689 0.883436 8 0.883436C11.9231 0.883436 15.1166 4.07689 15.1166 8C15.1166 11.9231 11.9231 15.1166 8 15.1166Z'
                fill='url(#paint0_linear_5668_24973)'
            />
            <path
                d='M9.86832 6.15456L7.11659 8.90956L6.13172 7.9247C5.9583 7.75128 5.68019 7.75128 5.50677 7.9247C5.33336 8.09811 5.33336 8.37623 5.50677 8.54964L6.80575 9.84862C6.89082 9.93369 7.00534 9.9795 7.11659 9.9795C7.22783 9.9795 7.34235 9.93696 7.42742 9.84862L10.4933 6.78278C10.6667 6.60936 10.6667 6.33124 10.4933 6.15783C10.3231 5.98114 10.0417 5.98114 9.86832 6.15456Z'
                fill='url(#paint1_linear_5668_24973)'
            />
            <defs>
                <linearGradient
                    id='paint0_linear_5668_24973'
                    x1='-0.00559259'
                    y1='7.9928'
                    x2='15.9944'
                    y2='7.9928'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#4481EB' />
                    <stop offset='1' stopColor='#04BEFE' />
                </linearGradient>
                <linearGradient
                    id='paint1_linear_5668_24973'
                    x1='5.37488'
                    y1='8.00042'
                    x2='10.6215'
                    y2='8.00042'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#4481EB' />
                    <stop offset='1' stopColor='#04BEFE' />
                </linearGradient>
            </defs>
        </svg>
    )
}

export const IconStarGradient = () => {
    return (
        <svg
            width='10'
            height='10'
            viewBox='0 0 10 10'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g clipPath='url(#clip0_5668_25512)'>
                <path
                    d='M9.97385 3.83559C9.90801 3.6331 9.72841 3.48974 9.51677 3.47059L6.63006 3.20852L5.48922 0.537573C5.40499 0.341341 5.21333 0.214691 5.00001 0.214691C4.78669 0.214691 4.59496 0.341341 4.51127 0.537573L3.37042 3.20852L0.48326 3.47059C0.271617 3.49012 0.0923996 3.63348 0.0261753 3.83559C-0.0396675 4.03807 0.0211398 4.26017 0.181207 4.40055L2.36333 6.31396L1.71993 9.14772C1.67286 9.35608 1.75373 9.57154 1.92661 9.69651C2.01954 9.76403 2.12872 9.79775 2.23828 9.79775C2.33243 9.79775 2.42665 9.77273 2.51081 9.72237L5.00001 8.234L7.48876 9.72237C7.67134 9.83147 7.90091 9.82148 8.07341 9.69651C8.2463 9.57154 8.32717 9.35608 8.2801 9.14772L7.6367 6.31396L9.81882 4.40055C9.97881 4.26017 10.0397 4.03853 9.97385 3.83559Z'
                    fill='#CDE6FF'
                />
            </g>
            <defs>
                <clipPath id='clip0_5668_25512'>
                    <rect width='10' height='10' fill='white' />
                </clipPath>
            </defs>
        </svg>
    )
}

export const IconRequestSent = () => {
    return (
        <svg width='60' height='60' viewBox='0 0 60 60' fill='none'>
            <g filter='url(#filter0_d_4945_53503)'>
                <rect
                    x='10'
                    width='40'
                    height='40'
                    rx='20'
                    fill='url(#paint0_linear_4945_53503)'
                />
            </g>
            <path
                d='M35.1749 16.269C35.5285 16.6278 35.5285 17.2095 35.1749 17.5682L29.1027 23.731C28.7491 24.0897 28.1761 24.0897 27.8226 23.731L24.9319 20.7972C24.5784 20.4385 24.5784 19.8568 24.9319 19.4982C25.2853 19.1393 25.8585 19.1393 26.2119 19.4982L28.4625 21.7823L33.8948 16.269C34.2484 15.9103 34.8215 15.9103 35.1749 16.269Z'
                fill='white'
            />
            <defs>
                <filter
                    id='filter0_d_4945_53503'
                    x='0'
                    y='0'
                    width='60'
                    height='60'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dy='10' />
                    <feGaussianBlur stdDeviation='5' />
                    <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.305882 0 0 0 0 0.67451 0 0 0 0 0.976471 0 0 0 0.2 0'
                    />
                    <feBlend
                        mode='normal'
                        in2='BackgroundImageFix'
                        result='effect1_dropShadow_4945_53503'
                    />
                    <feBlend
                        mode='normal'
                        in='SourceGraphic'
                        in2='effect1_dropShadow_4945_53503'
                        result='shape'
                    />
                </filter>
                <linearGradient
                    id='paint0_linear_4945_53503'
                    x1='6.99059'
                    y1='-40.7999'
                    x2='58.8218'
                    y2='-38.1281'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#53AFF7' />
                    <stop offset='1' stopColor='#2894FF' />
                </linearGradient>
            </defs>
        </svg>
    )
}

export const IconVideoOutlineCounter = ({ color = '#fff' }: SVGProps) => {
    return (
        <svg
            width='16'
            height='13'
            viewBox='0 0 16 13'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M3.44107 12C2.5215 12.0237 1.62881 11.6966 0.953292 11.0883C0.639764 10.7822 0.393641 10.417 0.229966 10.0151C0.0662906 9.61315 -0.0114986 9.18289 0.00137212 8.75066V3.29612C-0.00872319 2.86423 0.070328 2.43477 0.233847 2.03321C0.397367 1.63165 0.642025 1.26617 0.953292 0.958453C1.62881 0.350218 2.5215 0.0230401 3.44107 0.0467308H8.45665C8.91258 0.0312118 9.36715 0.103799 9.79414 0.260275C10.2211 0.41675 10.6121 0.654052 10.9444 0.958453C11.5078 1.5016 11.8442 2.22909 11.8883 3.00001L14.0082 2.15068C14.3647 2.01178 14.7632 2.01568 15.1168 2.16162C15.4704 2.30757 15.7504 2.58374 15.896 2.92991C15.9512 3.06458 15.9862 3.20623 16 3.35062V8.63376C16 9.00782 15.8474 9.36659 15.5759 9.63109C15.3044 9.89559 14.9361 10.0442 14.5521 10.0442C14.4025 10.0444 14.2539 10.0207 14.1122 9.974L14.0082 9.93509L11.8883 9.09347C11.8463 9.86333 11.5129 10.5907 10.9524 11.135C10.2749 11.7452 9.37897 12.0725 8.45665 12.0468L3.44107 12ZM1.20127 3.26492V8.71946C1.16845 9.2454 1.35141 9.76256 1.70994 10.1571C2.06847 10.5516 2.5732 10.7913 3.11312 10.8234C3.22229 10.8313 3.33189 10.8313 3.44107 10.8234H8.45665C8.99437 10.8756 9.53138 10.7179 9.94981 10.3848C10.3682 10.0517 10.6339 9.57047 10.6884 9.04677C10.6965 8.94042 10.6965 8.83361 10.6884 8.72726V3.27272C10.7191 2.74808 10.5351 2.23305 10.1768 1.84021C9.81852 1.44738 9.31506 1.20878 8.77662 1.17666C8.66763 1.16489 8.55764 1.16489 8.44865 1.17666H3.44107C3.17462 1.14974 2.90535 1.17439 2.64873 1.24923C2.39211 1.32408 2.15323 1.44757 1.94581 1.61269C1.73839 1.7778 1.56652 1.98131 1.44012 2.21137C1.31371 2.44143 1.23527 2.6935 1.20928 2.95321C1.19466 3.05649 1.19197 3.16106 1.20127 3.26492ZM14.4641 8.80517C14.5236 8.82885 14.5903 8.82909 14.65 8.80583C14.7097 8.78257 14.7578 8.73769 14.7841 8.68056V3.45192C14.7841 3.38786 14.758 3.32648 14.7115 3.28118C14.665 3.23588 14.6019 3.21041 14.5361 3.21041H14.4961H14.4481L11.8883 4.22334V7.80784L14.4641 8.80517Z'
                fill={color}
            />
        </svg>
    )
}

export const IconImageOutlineCounter = ({ color = '#fff' }: SVGProps) => {
    return (
        <svg
            width='12'
            height='12'
            viewBox='0 0 12 12'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M3.40332 11.9919C2.94608 12.0083 2.49047 11.9286 2.06587 11.7582C1.64127 11.5877 1.2571 11.3302 0.93812 11.0022C0.305308 10.3073 -0.0305232 9.39232 0.00242094 8.45301V3.55255C-0.0321075 2.61119 0.303831 1.69381 0.93812 0.997365C1.25703 0.668864 1.64106 0.410645 2.06558 0.239185C2.4901 0.0677247 2.94573 -0.0131407 3.40332 0.00173615H8.59768C9.05527 -0.0131407 9.5109 0.0677247 9.93542 0.239185C10.3599 0.410645 10.744 0.668864 11.0629 0.997365C11.6972 1.69381 12.0331 2.61119 11.9986 3.55255V8.45301C12.0331 9.39437 11.6972 10.3118 11.0629 11.0082C10.7439 11.3362 10.3597 11.5937 9.93513 11.7642C9.51053 11.9346 9.05493 12.0143 8.59768 11.9979L3.40332 11.9919ZM3.40332 11.0922H8.59768C8.93118 11.1039 9.26344 11.046 9.57328 10.922C9.88312 10.7981 10.1637 10.6109 10.3971 10.3724C10.863 9.84208 11.1059 9.15222 11.0749 8.44701V7.98514L10.8649 7.78723L10.4451 7.37933C10.1676 7.09579 9.85758 6.84613 9.52137 6.63558C9.30075 6.50881 9.039 6.47422 8.79303 6.53937C8.54706 6.60451 8.33675 6.76416 8.20779 6.98351L8.13582 7.08543C8.13582 7.12142 8.08183 7.15745 8.05784 7.19943L7.8239 7.57131C7.55898 8.11251 7.14212 8.56475 6.62429 8.87285C6.36725 9.02453 6.07094 9.09641 5.77297 9.07932C5.47501 9.06224 5.18885 8.957 4.95084 8.77693L4.68692 8.61497L4.46499 8.47102C4.3683 8.41119 4.26816 8.3571 4.16509 8.30906C3.76322 8.14112 3.40332 8.30906 2.91148 8.90887L1.82582 10.2344L1.64589 10.4503C1.8809 10.6696 2.15756 10.8394 2.45946 10.9496C2.76136 11.0599 3.08233 11.1084 3.40332 11.0922ZM0.902133 3.54655V8.45301C0.895755 8.86309 0.969081 9.27051 1.11805 9.65263L1.80785 8.81288L2.11376 8.435C2.88151 7.4873 3.58329 7.07344 4.51299 7.46331C4.65435 7.52458 4.79072 7.59676 4.92085 7.67924L5.32271 7.93118C5.71859 8.1831 5.92253 8.21907 6.19244 8.06312C6.49254 7.87817 6.7387 7.61753 6.90622 7.30736L7.08615 7.01946L7.20612 6.82756C7.29609 6.6836 7.38605 6.54561 7.48801 6.41365C7.75075 6.01765 8.15559 5.73772 8.61884 5.63167C9.08209 5.52563 9.56838 5.6016 9.97723 5.84386C10.3869 6.09618 10.7637 6.3984 11.0989 6.74357V3.55255C11.1284 2.84861 10.8881 2.15996 10.4271 1.62719C10.1937 1.38868 9.9131 1.20147 9.60327 1.07754C9.29343 0.953604 8.96116 0.89569 8.62766 0.907452H3.43331C1.8858 0.895456 0.902133 1.93906 0.902133 3.54655ZM2.56361 4.07438C2.56361 3.76594 2.65507 3.46444 2.82643 3.20799C2.99779 2.95153 3.24133 2.75169 3.52629 2.63366C3.81125 2.51562 4.12485 2.48467 4.42736 2.54484C4.72987 2.60502 5.00775 2.75361 5.22585 2.97171C5.44395 3.18981 5.59246 3.46765 5.65264 3.77016C5.71281 4.07267 5.68193 4.38623 5.5639 4.67119C5.44586 4.95615 5.24595 5.19973 4.9895 5.37109C4.73304 5.54245 4.43154 5.63394 4.1231 5.63394C3.9183 5.63394 3.7155 5.59355 3.52629 5.51518C3.33709 5.43681 3.16516 5.32194 3.02035 5.17713C2.87554 5.03232 2.76067 4.8604 2.6823 4.67119C2.60393 4.48198 2.56361 4.27918 2.56361 4.07438ZM3.46332 4.07438C3.46332 4.20488 3.50201 4.33249 3.57451 4.44099C3.64701 4.54949 3.75004 4.63406 3.8706 4.684C3.99116 4.73394 4.12383 4.74695 4.25182 4.72149C4.3798 4.69603 4.49738 4.63321 4.58965 4.54093C4.68192 4.44866 4.74475 4.33109 4.77021 4.2031C4.79566 4.07512 4.78262 3.94249 4.73268 3.82192C4.68274 3.70136 4.59817 3.59833 4.48967 3.52583C4.38117 3.45333 4.25359 3.41461 4.1231 3.41461C3.9486 3.41617 3.7817 3.48619 3.65831 3.60959C3.53491 3.73299 3.46489 3.89988 3.46332 4.07438Z'
                fill={color}
            />
        </svg>
    )
}

export const IconDollarBold = ({ color = '#696B73' }: SVGProps) => {
    return (
        <svg
            width='10'
            height='15'
            viewBox='0 0 10 15'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M5.5625 8.44531C6.82031 8.75 7.25 9.10156 7.25 9.80469C7.25 10.5234 6.69531 11.0156 5.5625 11.1094V8.44531ZM4.78125 6.19531C3.6875 5.90625 3.22656 5.5 3.22656 4.86719C3.22656 4.22656 3.76562 3.71094 4.78125 3.60938V6.19531ZM5.5625 6.375V3.61719C6.46875 3.72656 7.08594 4.21875 7.19531 5.08594H9.27344C9.20312 3.21875 7.76562 2 5.5625 1.85938V0.59375H4.78125V1.85156C2.60156 1.96875 1.03906 3.1875 1.03906 5.07031C1.03906 6.75781 2.15625 7.67188 4.20312 8.13281L4.78125 8.26562V11.1094C3.67969 11.0078 3.10156 10.4531 2.96875 9.64062H0.882812C0.9375 11.6016 2.55469 12.7578 4.78125 12.8672V14.1172H5.5625V12.8594C7.8125 12.7266 9.42969 11.5391 9.42969 9.5625C9.42969 7.85156 8.3125 6.99219 6.17188 6.50781L5.5625 6.375Z'
                fill={color}
            />
        </svg>
    )
}
export const IconGoalSmall = ({ color = '#FFFFFF' }: SVGProps) => {
    return (
        <svg
            width='14'
            height='14'
            viewBox='0 0 22 22'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <mask
                id='path-1-outside-1_5983_22648'
                maskUnits='userSpaceOnUse'
                x='-1.19249e-08'
                y='-1.19249e-08'
                width='22'
                height='22'
                fill='black'
            >
                <rect
                    fill='white'
                    x='-1.19249e-08'
                    y='-1.19249e-08'
                    width='22'
                    height='22'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M11.9615 19.7816C11.6457 19.8158 11.3249 19.8333 11 19.8333C6.12148 19.8333 2.16667 15.8785 2.16667 11C2.16667 6.12148 6.12148 2.16667 11 2.16667C15.8785 2.16667 19.8333 6.12148 19.8333 11C19.8333 11.7936 19.7287 12.5628 19.5324 13.2945C19.8709 13.6323 20.1611 14.0184 20.392 14.4415C20.7853 13.3685 21 12.2093 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21C11.6726 21 12.3297 20.9336 12.9651 20.807C12.5835 20.5151 12.2452 20.1696 11.9615 19.7816ZM17.5784 12.0874C17.6365 11.7335 17.6667 11.3703 17.6667 11C17.6667 7.3181 14.6819 4.33333 11 4.33333C7.3181 4.33333 4.33333 7.3181 4.33333 11C4.33333 14.6819 7.3181 17.6667 11 17.6667C11.0231 17.6667 11.0461 17.6665 11.0691 17.6663C11.0237 17.3953 11 17.117 11 16.8331C11 16.7212 11.0037 16.6101 11.0109 16.5C11.0073 16.5 11.0036 16.5 11 16.5C7.96243 16.5 5.5 14.0376 5.5 11C5.5 7.96243 7.96243 5.5 11 5.5C14.0376 5.5 16.5 7.96243 16.5 11C16.5 11.2897 16.4776 11.5741 16.4345 11.8517C16.8308 11.8858 17.2139 11.9662 17.5784 12.0874ZM11 13.1667C12.1966 13.1667 13.1667 12.1966 13.1667 11C13.1667 9.80338 12.1966 8.83333 11 8.83333C9.80338 8.83333 8.83333 9.80338 8.83333 11C8.83333 12.1966 9.80338 13.1667 11 13.1667Z'
                />
            </mask>
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M11.9615 19.7816C11.6457 19.8158 11.3249 19.8333 11 19.8333C6.12148 19.8333 2.16667 15.8785 2.16667 11C2.16667 6.12148 6.12148 2.16667 11 2.16667C15.8785 2.16667 19.8333 6.12148 19.8333 11C19.8333 11.7936 19.7287 12.5628 19.5324 13.2945C19.8709 13.6323 20.1611 14.0184 20.392 14.4415C20.7853 13.3685 21 12.2093 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21C11.6726 21 12.3297 20.9336 12.9651 20.807C12.5835 20.5151 12.2452 20.1696 11.9615 19.7816ZM17.5784 12.0874C17.6365 11.7335 17.6667 11.3703 17.6667 11C17.6667 7.3181 14.6819 4.33333 11 4.33333C7.3181 4.33333 4.33333 7.3181 4.33333 11C4.33333 14.6819 7.3181 17.6667 11 17.6667C11.0231 17.6667 11.0461 17.6665 11.0691 17.6663C11.0237 17.3953 11 17.117 11 16.8331C11 16.7212 11.0037 16.6101 11.0109 16.5C11.0073 16.5 11.0036 16.5 11 16.5C7.96243 16.5 5.5 14.0376 5.5 11C5.5 7.96243 7.96243 5.5 11 5.5C14.0376 5.5 16.5 7.96243 16.5 11C16.5 11.2897 16.4776 11.5741 16.4345 11.8517C16.8308 11.8858 17.2139 11.9662 17.5784 12.0874ZM11 13.1667C12.1966 13.1667 13.1667 12.1966 13.1667 11C13.1667 9.80338 12.1966 8.83333 11 8.83333C9.80338 8.83333 8.83333 9.80338 8.83333 11C8.83333 12.1966 9.80338 13.1667 11 13.1667Z'
                fill={color}
            />
            <path
                d='M11.9615 19.7816L12.0422 19.7226L12.0081 19.676L11.9507 19.6822L11.9615 19.7816ZM2.16667 11L2.06667 11L2.16667 11ZM19.5324 13.2945L19.4358 13.2685L19.4208 13.3244L19.4618 13.3652L19.5324 13.2945ZM20.392 14.4415L20.3042 14.4894L20.41 14.6832L20.4859 14.476L20.392 14.4415ZM12.9651 20.807L12.9846 20.9051L13.2014 20.8619L13.0258 20.7276L12.9651 20.807ZM17.5784 12.0874L17.5469 12.1822L17.6581 12.2192L17.6771 12.1035L17.5784 12.0874ZM11.0691 17.6663L11.0701 17.7663L11.1871 17.7651L11.1677 17.6498L11.0691 17.6663ZM11.0109 16.5L11.1107 16.5066L11.1177 16.3998L11.0107 16.4L11.0109 16.5ZM16.4345 11.8517L16.3356 11.8364L16.3192 11.9422L16.4259 11.9513L16.4345 11.8517ZM11 19.9333C11.3285 19.9333 11.6529 19.9156 11.9722 19.881L11.9507 19.6822C11.6385 19.716 11.3213 19.7333 11 19.7333L11 19.9333ZM2.06667 11C2.06667 15.9337 6.06626 19.9333 11 19.9333L11 19.7333C6.17671 19.7333 2.26667 15.8233 2.26667 11L2.06667 11ZM11 2.06667C6.06626 2.06667 2.06667 6.06626 2.06667 11L2.26667 11C2.26667 6.17671 6.17671 2.26667 11 2.26667L11 2.06667ZM19.9333 11C19.9333 6.06626 15.9337 2.06667 11 2.06667L11 2.26667C15.8233 2.26667 19.7333 6.17671 19.7333 11L19.9333 11ZM19.629 13.3204C19.8275 12.5803 19.9333 11.8024 19.9333 11L19.7333 11C19.7333 11.7848 19.6298 12.5452 19.4358 13.2685L19.629 13.3204ZM19.4618 13.3652C19.7935 13.6964 20.078 14.0748 20.3042 14.4894L20.4798 14.3936C20.2443 13.962 19.9482 13.5682 19.6031 13.2237L19.4618 13.3652ZM20.4859 14.476C20.8832 13.3921 21.1 12.2212 21.1 11L20.9 11C20.9 12.1974 20.6875 13.345 20.2981 14.4071L20.4859 14.476ZM21.1 11C21.1 5.42192 16.5781 0.9 11 0.9L11 1.1C16.4676 1.1 20.9 5.53238 20.9 11L21.1 11ZM11 0.9C5.42192 0.9 0.9 5.42192 0.9 11L1.1 11C1.1 5.53238 5.53238 1.1 11 1.1L11 0.9ZM0.9 11C0.9 16.5781 5.42192 21.1 11 21.1L11 20.9C5.53238 20.9 1.1 16.4676 1.1 11L0.9 11ZM11 21.1C11.6792 21.1 12.3428 21.0329 12.9846 20.9051L12.9455 20.7089C12.3165 20.8343 11.666 20.9 11 20.9L11 21.1ZM13.0258 20.7276C12.6519 20.4415 12.3203 20.1028 12.0422 19.7226L11.8808 19.8406C12.1702 20.2363 12.5152 20.5888 12.9043 20.8864L13.0258 20.7276ZM17.6771 12.1035C17.736 11.7444 17.7667 11.3757 17.7667 11L17.5667 11C17.5667 11.3648 17.5369 11.7226 17.4798 12.0712L17.6771 12.1035ZM17.7667 11C17.7667 7.26287 14.7371 4.23333 11 4.23333L11 4.43333C14.6267 4.43333 17.5667 7.37333 17.5667 11L17.7667 11ZM11 4.23333C7.26287 4.23333 4.23333 7.26287 4.23333 11L4.43333 11C4.43333 7.37333 7.37333 4.43333 11 4.43333L11 4.23333ZM4.23333 11C4.23333 14.7371 7.26287 17.7667 11 17.7667L11 17.5667C7.37333 17.5667 4.43333 14.6267 4.43333 11L4.23333 11ZM11 17.7667C11.0234 17.7667 11.0468 17.7665 11.0701 17.7663L11.0681 17.5663C11.0454 17.5666 11.0227 17.5667 11 17.5667L11 17.7667ZM11.1677 17.6498C11.1232 17.3842 11.1 17.1114 11.1 16.8331L10.9 16.8331C10.9 17.1226 10.9241 17.4064 10.9705 17.6829L11.1677 17.6498ZM11.1 16.8331C11.1 16.7234 11.1036 16.6145 11.1107 16.5066L10.9111 16.4934C10.9038 16.6057 10.9 16.719 10.9 16.8331L11.1 16.8331ZM11 16.6C11.0037 16.6 11.0074 16.6 11.0111 16.6L11.0107 16.4C11.0072 16.4 11.0036 16.4 11 16.4L11 16.6ZM5.4 11C5.4 14.0928 7.90721 16.6 11 16.6L11 16.4C8.01766 16.4 5.6 13.9823 5.6 11L5.4 11ZM11 5.4C7.90721 5.4 5.4 7.90721 5.4 11L5.6 11C5.6 8.01766 8.01766 5.6 11 5.6L11 5.4ZM16.6 11C16.6 7.90721 14.0928 5.4 11 5.4L11 5.6C13.9823 5.6 16.4 8.01766 16.4 11L16.6 11ZM16.5333 11.8671C16.5772 11.5844 16.6 11.2948 16.6 11L16.4 11C16.4 11.2845 16.378 11.5638 16.3356 11.8364L16.5333 11.8671ZM16.4259 11.9513C16.8143 11.9848 17.1898 12.0635 17.5469 12.1822L17.61 11.9925C17.2381 11.8688 16.8473 11.7869 16.443 11.7521L16.4259 11.9513ZM13.0667 11C13.0667 12.1414 12.1414 13.0667 11 13.0667L11 13.2667C12.2518 13.2667 13.2667 12.2518 13.2667 11L13.0667 11ZM11 8.93333C12.1414 8.93333 13.0667 9.85861 13.0667 11L13.2667 11C13.2667 9.74815 12.2518 8.73333 11 8.73333L11 8.93333ZM8.93333 11C8.93333 9.85861 9.85861 8.93333 11 8.93333L11 8.73333C9.74815 8.73333 8.73333 9.74815 8.73333 11L8.93333 11ZM11 13.0667C9.85861 13.0667 8.93333 12.1414 8.93333 11L8.73333 11C8.73333 12.2518 9.74815 13.2667 11 13.2667L11 13.0667Z'
                fill={color}
                mask='url(#path-1-outside-1_5983_22648)'
            />
            <circle cx='11' cy='11' r='2.5' fill={color} />
            <path
                d='M16.4494 16.46C16.0993 16.3137 15.8139 16.1892 15.616 16.0671C15.4144 15.9428 15.3234 15.8328 15.3234 15.7222C15.3234 15.3517 15.71 15.0315 16.2109 15.0315C16.7119 15.0315 17.0984 15.3517 17.0984 15.7222C17.0984 15.9647 17.3423 16.1426 17.6172 16.1426C17.8921 16.1426 18.1359 15.9647 18.1359 15.7222C18.1359 15.0132 17.5322 14.4259 16.7297 14.2472V13.8704C16.7297 13.6279 16.4858 13.45 16.2109 13.45C15.9361 13.45 15.6922 13.6279 15.6922 13.8704V14.2472C14.8897 14.4259 14.2859 15.0132 14.2859 15.7222C14.2859 16.1189 14.5207 16.4107 14.8439 16.6409C15.1655 16.87 15.5837 17.0446 15.9697 17.2058L15.9728 17.2071C16.3228 17.3533 16.6081 17.4778 16.8059 17.5998C17.0075 17.7241 17.0984 17.8341 17.0984 17.9444C17.0984 18.3149 16.7118 18.6352 16.2109 18.6352C15.71 18.6352 15.3234 18.3149 15.3234 17.9444C15.3234 17.7019 15.0796 17.5241 14.8047 17.5241C14.5298 17.5241 14.2859 17.7019 14.2859 17.9444C14.2859 18.6534 14.8897 19.2408 15.6922 19.4195V19.7963C15.6922 20.0388 15.9361 20.2167 16.2109 20.2167C16.4858 20.2167 16.7297 20.0388 16.7297 19.7963V19.4195C17.5322 19.2408 18.1359 18.6534 18.1359 17.9444C18.1359 17.5479 17.9013 17.2562 17.5781 17.0261C17.2566 16.7971 16.8385 16.6225 16.4527 16.4613L16.4494 16.46L16.4302 16.5061L16.4494 16.46Z'
                fill={color}
                stroke={color}
                strokeWidth='0.1'
            />
        </svg>
    )
}

export const IconGoal = ({ color = '#AFAFAF' }: SVGProps) => {
    return (
        <svg
            width='22'
            height='22'
            viewBox='0 0 22 22'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <mask
                id='path-1-outside-1_5983_22648'
                maskUnits='userSpaceOnUse'
                x='-1.19249e-08'
                y='-1.19249e-08'
                width='22'
                height='22'
                fill='black'
            >
                <rect
                    fill='white'
                    x='-1.19249e-08'
                    y='-1.19249e-08'
                    width='22'
                    height='22'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M11.9615 19.7816C11.6457 19.8158 11.3249 19.8333 11 19.8333C6.12148 19.8333 2.16667 15.8785 2.16667 11C2.16667 6.12148 6.12148 2.16667 11 2.16667C15.8785 2.16667 19.8333 6.12148 19.8333 11C19.8333 11.7936 19.7287 12.5628 19.5324 13.2945C19.8709 13.6323 20.1611 14.0184 20.392 14.4415C20.7853 13.3685 21 12.2093 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21C11.6726 21 12.3297 20.9336 12.9651 20.807C12.5835 20.5151 12.2452 20.1696 11.9615 19.7816ZM17.5784 12.0874C17.6365 11.7335 17.6667 11.3703 17.6667 11C17.6667 7.3181 14.6819 4.33333 11 4.33333C7.3181 4.33333 4.33333 7.3181 4.33333 11C4.33333 14.6819 7.3181 17.6667 11 17.6667C11.0231 17.6667 11.0461 17.6665 11.0691 17.6663C11.0237 17.3953 11 17.117 11 16.8331C11 16.7212 11.0037 16.6101 11.0109 16.5C11.0073 16.5 11.0036 16.5 11 16.5C7.96243 16.5 5.5 14.0376 5.5 11C5.5 7.96243 7.96243 5.5 11 5.5C14.0376 5.5 16.5 7.96243 16.5 11C16.5 11.2897 16.4776 11.5741 16.4345 11.8517C16.8308 11.8858 17.2139 11.9662 17.5784 12.0874ZM11 13.1667C12.1966 13.1667 13.1667 12.1966 13.1667 11C13.1667 9.80338 12.1966 8.83333 11 8.83333C9.80338 8.83333 8.83333 9.80338 8.83333 11C8.83333 12.1966 9.80338 13.1667 11 13.1667Z'
                />
            </mask>
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M11.9615 19.7816C11.6457 19.8158 11.3249 19.8333 11 19.8333C6.12148 19.8333 2.16667 15.8785 2.16667 11C2.16667 6.12148 6.12148 2.16667 11 2.16667C15.8785 2.16667 19.8333 6.12148 19.8333 11C19.8333 11.7936 19.7287 12.5628 19.5324 13.2945C19.8709 13.6323 20.1611 14.0184 20.392 14.4415C20.7853 13.3685 21 12.2093 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21C11.6726 21 12.3297 20.9336 12.9651 20.807C12.5835 20.5151 12.2452 20.1696 11.9615 19.7816ZM17.5784 12.0874C17.6365 11.7335 17.6667 11.3703 17.6667 11C17.6667 7.3181 14.6819 4.33333 11 4.33333C7.3181 4.33333 4.33333 7.3181 4.33333 11C4.33333 14.6819 7.3181 17.6667 11 17.6667C11.0231 17.6667 11.0461 17.6665 11.0691 17.6663C11.0237 17.3953 11 17.117 11 16.8331C11 16.7212 11.0037 16.6101 11.0109 16.5C11.0073 16.5 11.0036 16.5 11 16.5C7.96243 16.5 5.5 14.0376 5.5 11C5.5 7.96243 7.96243 5.5 11 5.5C14.0376 5.5 16.5 7.96243 16.5 11C16.5 11.2897 16.4776 11.5741 16.4345 11.8517C16.8308 11.8858 17.2139 11.9662 17.5784 12.0874ZM11 13.1667C12.1966 13.1667 13.1667 12.1966 13.1667 11C13.1667 9.80338 12.1966 8.83333 11 8.83333C9.80338 8.83333 8.83333 9.80338 8.83333 11C8.83333 12.1966 9.80338 13.1667 11 13.1667Z'
                fill={color}
            />
            <path
                d='M11.9615 19.7816L12.0422 19.7226L12.0081 19.676L11.9507 19.6822L11.9615 19.7816ZM2.16667 11L2.06667 11L2.16667 11ZM19.5324 13.2945L19.4358 13.2685L19.4208 13.3244L19.4618 13.3652L19.5324 13.2945ZM20.392 14.4415L20.3042 14.4894L20.41 14.6832L20.4859 14.476L20.392 14.4415ZM12.9651 20.807L12.9846 20.9051L13.2014 20.8619L13.0258 20.7276L12.9651 20.807ZM17.5784 12.0874L17.5469 12.1822L17.6581 12.2192L17.6771 12.1035L17.5784 12.0874ZM11.0691 17.6663L11.0701 17.7663L11.1871 17.7651L11.1677 17.6498L11.0691 17.6663ZM11.0109 16.5L11.1107 16.5066L11.1177 16.3998L11.0107 16.4L11.0109 16.5ZM16.4345 11.8517L16.3356 11.8364L16.3192 11.9422L16.4259 11.9513L16.4345 11.8517ZM11 19.9333C11.3285 19.9333 11.6529 19.9156 11.9722 19.881L11.9507 19.6822C11.6385 19.716 11.3213 19.7333 11 19.7333L11 19.9333ZM2.06667 11C2.06667 15.9337 6.06626 19.9333 11 19.9333L11 19.7333C6.17671 19.7333 2.26667 15.8233 2.26667 11L2.06667 11ZM11 2.06667C6.06626 2.06667 2.06667 6.06626 2.06667 11L2.26667 11C2.26667 6.17671 6.17671 2.26667 11 2.26667L11 2.06667ZM19.9333 11C19.9333 6.06626 15.9337 2.06667 11 2.06667L11 2.26667C15.8233 2.26667 19.7333 6.17671 19.7333 11L19.9333 11ZM19.629 13.3204C19.8275 12.5803 19.9333 11.8024 19.9333 11L19.7333 11C19.7333 11.7848 19.6298 12.5452 19.4358 13.2685L19.629 13.3204ZM19.4618 13.3652C19.7935 13.6964 20.078 14.0748 20.3042 14.4894L20.4798 14.3936C20.2443 13.962 19.9482 13.5682 19.6031 13.2237L19.4618 13.3652ZM20.4859 14.476C20.8832 13.3921 21.1 12.2212 21.1 11L20.9 11C20.9 12.1974 20.6875 13.345 20.2981 14.4071L20.4859 14.476ZM21.1 11C21.1 5.42192 16.5781 0.9 11 0.9L11 1.1C16.4676 1.1 20.9 5.53238 20.9 11L21.1 11ZM11 0.9C5.42192 0.9 0.9 5.42192 0.9 11L1.1 11C1.1 5.53238 5.53238 1.1 11 1.1L11 0.9ZM0.9 11C0.9 16.5781 5.42192 21.1 11 21.1L11 20.9C5.53238 20.9 1.1 16.4676 1.1 11L0.9 11ZM11 21.1C11.6792 21.1 12.3428 21.0329 12.9846 20.9051L12.9455 20.7089C12.3165 20.8343 11.666 20.9 11 20.9L11 21.1ZM13.0258 20.7276C12.6519 20.4415 12.3203 20.1028 12.0422 19.7226L11.8808 19.8406C12.1702 20.2363 12.5152 20.5888 12.9043 20.8864L13.0258 20.7276ZM17.6771 12.1035C17.736 11.7444 17.7667 11.3757 17.7667 11L17.5667 11C17.5667 11.3648 17.5369 11.7226 17.4798 12.0712L17.6771 12.1035ZM17.7667 11C17.7667 7.26287 14.7371 4.23333 11 4.23333L11 4.43333C14.6267 4.43333 17.5667 7.37333 17.5667 11L17.7667 11ZM11 4.23333C7.26287 4.23333 4.23333 7.26287 4.23333 11L4.43333 11C4.43333 7.37333 7.37333 4.43333 11 4.43333L11 4.23333ZM4.23333 11C4.23333 14.7371 7.26287 17.7667 11 17.7667L11 17.5667C7.37333 17.5667 4.43333 14.6267 4.43333 11L4.23333 11ZM11 17.7667C11.0234 17.7667 11.0468 17.7665 11.0701 17.7663L11.0681 17.5663C11.0454 17.5666 11.0227 17.5667 11 17.5667L11 17.7667ZM11.1677 17.6498C11.1232 17.3842 11.1 17.1114 11.1 16.8331L10.9 16.8331C10.9 17.1226 10.9241 17.4064 10.9705 17.6829L11.1677 17.6498ZM11.1 16.8331C11.1 16.7234 11.1036 16.6145 11.1107 16.5066L10.9111 16.4934C10.9038 16.6057 10.9 16.719 10.9 16.8331L11.1 16.8331ZM11 16.6C11.0037 16.6 11.0074 16.6 11.0111 16.6L11.0107 16.4C11.0072 16.4 11.0036 16.4 11 16.4L11 16.6ZM5.4 11C5.4 14.0928 7.90721 16.6 11 16.6L11 16.4C8.01766 16.4 5.6 13.9823 5.6 11L5.4 11ZM11 5.4C7.90721 5.4 5.4 7.90721 5.4 11L5.6 11C5.6 8.01766 8.01766 5.6 11 5.6L11 5.4ZM16.6 11C16.6 7.90721 14.0928 5.4 11 5.4L11 5.6C13.9823 5.6 16.4 8.01766 16.4 11L16.6 11ZM16.5333 11.8671C16.5772 11.5844 16.6 11.2948 16.6 11L16.4 11C16.4 11.2845 16.378 11.5638 16.3356 11.8364L16.5333 11.8671ZM16.4259 11.9513C16.8143 11.9848 17.1898 12.0635 17.5469 12.1822L17.61 11.9925C17.2381 11.8688 16.8473 11.7869 16.443 11.7521L16.4259 11.9513ZM13.0667 11C13.0667 12.1414 12.1414 13.0667 11 13.0667L11 13.2667C12.2518 13.2667 13.2667 12.2518 13.2667 11L13.0667 11ZM11 8.93333C12.1414 8.93333 13.0667 9.85861 13.0667 11L13.2667 11C13.2667 9.74815 12.2518 8.73333 11 8.73333L11 8.93333ZM8.93333 11C8.93333 9.85861 9.85861 8.93333 11 8.93333L11 8.73333C9.74815 8.73333 8.73333 9.74815 8.73333 11L8.93333 11ZM11 13.0667C9.85861 13.0667 8.93333 12.1414 8.93333 11L8.73333 11C8.73333 12.2518 9.74815 13.2667 11 13.2667L11 13.0667Z'
                fill={color}
                mask='url(#path-1-outside-1_5983_22648)'
            />
            <circle cx='11' cy='11' r='2.5' fill={color} />
            <path
                d='M16.4494 16.46C16.0993 16.3137 15.8139 16.1892 15.616 16.0671C15.4144 15.9428 15.3234 15.8328 15.3234 15.7222C15.3234 15.3517 15.71 15.0315 16.2109 15.0315C16.7119 15.0315 17.0984 15.3517 17.0984 15.7222C17.0984 15.9647 17.3423 16.1426 17.6172 16.1426C17.8921 16.1426 18.1359 15.9647 18.1359 15.7222C18.1359 15.0132 17.5322 14.4259 16.7297 14.2472V13.8704C16.7297 13.6279 16.4858 13.45 16.2109 13.45C15.9361 13.45 15.6922 13.6279 15.6922 13.8704V14.2472C14.8897 14.4259 14.2859 15.0132 14.2859 15.7222C14.2859 16.1189 14.5207 16.4107 14.8439 16.6409C15.1655 16.87 15.5837 17.0446 15.9697 17.2058L15.9728 17.2071C16.3228 17.3533 16.6081 17.4778 16.8059 17.5998C17.0075 17.7241 17.0984 17.8341 17.0984 17.9444C17.0984 18.3149 16.7118 18.6352 16.2109 18.6352C15.71 18.6352 15.3234 18.3149 15.3234 17.9444C15.3234 17.7019 15.0796 17.5241 14.8047 17.5241C14.5298 17.5241 14.2859 17.7019 14.2859 17.9444C14.2859 18.6534 14.8897 19.2408 15.6922 19.4195V19.7963C15.6922 20.0388 15.9361 20.2167 16.2109 20.2167C16.4858 20.2167 16.7297 20.0388 16.7297 19.7963V19.4195C17.5322 19.2408 18.1359 18.6534 18.1359 17.9444C18.1359 17.5479 17.9013 17.2562 17.5781 17.0261C17.2566 16.7971 16.8385 16.6225 16.4527 16.4613L16.4494 16.46L16.4302 16.5061L16.4494 16.46Z'
                fill={color}
                stroke={color}
                strokeWidth='0.1'
            />
        </svg>
    )
}

export const IconMinus = ({ color = '#9B9B9B' }: SVGProps) => {
    return (
        <svg
            width='10'
            height='2'
            viewBox='0 0 10 2'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <rect width='10' height='1.5' rx='0.75' fill={color} />
        </svg>
    )
}

export const IconAddFriend = ({ color = 'white' }: SVGProps) => {
    return (
        <svg
            width='18'
            height='18'
            viewBox='0 0 18 18'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M7.16643 11.8643C3.83673 11.8643 1 12.3701 1 14.4017C1 16.4333 3.81079 17 7.16643 17C10.5221 17 13.3242 16.4507 13.3242 14.3842C13.3242 12.3177 10.5048 11.8643 7.16643 11.8643Z'
                stroke={color}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M7.16679 8.96946C7.9485 8.96946 8.71264 8.7358 9.36261 8.29795C10.0126 7.8601 10.5192 7.23776 10.8183 6.50965C11.1175 5.78153 11.1957 4.98032 11.0432 4.20736C10.8907 3.4344 10.5143 2.72439 9.96153 2.16712C9.40878 1.60984 8.70454 1.23032 7.93785 1.07656C7.17116 0.922813 6.3765 1.00173 5.6543 1.30333C4.93209 1.60492 4.3148 2.11565 3.88051 2.77094C3.44621 3.42622 3.21439 4.19662 3.21439 4.98472V4.98472C3.21212 5.50572 3.31165 6.02211 3.50731 6.50433C3.70296 6.98654 3.99089 7.42512 4.35469 7.79514C4.71849 8.16516 5.15103 8.45936 5.62759 8.66085C6.10415 8.86234 6.61545 8.96718 7.13222 8.96946H7.16679Z'
                stroke={color}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M15.2271 6.16188V9.64961'
                stroke={color}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M16.9997 7.91447H13.4624'
                stroke={color}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}

export const IconFriendPending = ({ color = '#778797' }: SVGProps) => {
    return (
        <svg
            width='17'
            height='16'
            viewBox='0 0 17 16'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M0 13.2396C0 11.1863 2.88 10.669 6.26087 10.669C9.64174 10.669 12.5217 11.2022 12.5217 13.2555C12.5217 15.3088 9.64174 15.8261 6.26087 15.8261C2.88 15.8261 0 15.2929 0 13.2396ZM2.12033 4.70805C2.03773 4.14886 2.08093 3.5793 2.24704 3.03725C2.41316 2.49519 2.69838 1.99306 3.08376 1.56421C3.46915 1.13536 3.94586 0.789614 4.48222 0.54997C5.01858 0.310326 5.6023 0.182285 6.19458 0.174316C6.78686 0.166347 7.37415 0.278633 7.91739 0.503751C8.46063 0.728869 8.94737 1.06165 9.34529 1.47996C9.74322 1.89827 10.0432 2.39255 10.2253 2.92992C10.4074 3.46729 10.4674 4.03545 10.4014 4.59665V4.70805C10.2881 5.67092 9.81029 6.56132 9.05747 7.21221C8.30465 7.8631 7.32858 8.22978 6.31238 8.24346C5.29618 8.25713 4.30968 7.91686 3.53789 7.28648C2.7661 6.6561 2.26205 5.77892 2.12033 4.81948V4.70805Z'
                fill={color}
            />
            <path
                d='M12.8779 3.58405L12.8779 3.58405C9.71781 2.98045 6.98047 5.71779 7.58407 8.87784L7.58407 8.87785C7.92296 10.6518 9.34862 12.0775 11.1226 12.4164C14.2827 13.02 17.02 10.2826 16.4164 7.1226L15.9253 7.2164L16.4164 7.12259C16.0775 5.34859 14.6519 3.92292 12.8779 3.58405Z'
                fill={color}
                stroke='white'
            />
        </svg>
    )
}

export const IconUpcomingLive = () => {
    return (
        <svg
            width='30'
            height='30'
            viewBox='0 0 30 30'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M27.3633 30H2.63672C1.18277 30 0 28.8172 0 27.3633V16.8164C0 15.3625 1.18277 14.1797 2.63672 14.1797H27.3633C28.8172 14.1797 30 15.3625 30 16.8164V27.3633C30 28.8172 28.8172 30 27.3633 30ZM7.96875 24.7266H5.33203V18.5742C5.33203 18.0884 4.93893 17.6953 4.45312 17.6953C3.96732 17.6953 3.57422 18.0884 3.57422 18.5742V25.6055C3.57422 26.0913 3.96732 26.4844 4.45312 26.4844H7.96875C8.45455 26.4844 8.84766 26.0913 8.84766 25.6055C8.84766 25.1197 8.45455 24.7266 7.96875 24.7266ZM10.6055 18.5742C10.6055 18.0884 10.9986 17.6953 11.4844 17.6953C11.9702 17.6953 12.3633 18.0884 12.3633 18.5742V25.6055C12.3633 26.0913 11.9702 26.4844 11.4844 26.4844C10.9986 26.4844 10.6055 26.0913 10.6055 25.6055V18.5742ZM25.5469 22.9688C26.0327 22.9688 26.4258 22.5756 26.4258 22.0898C26.4258 21.604 26.0327 21.2109 25.5469 21.2109H22.9102V19.4531H25.5469C26.0327 19.4531 26.4258 19.06 26.4258 18.5742C26.4258 18.0884 26.0327 17.6953 25.5469 17.6953H22.0312C21.5454 17.6953 21.1523 18.0884 21.1523 18.5742V25.6055C21.1523 26.0913 21.5454 26.4844 22.0312 26.4844H25.5469C26.0327 26.4844 26.4258 26.0913 26.4258 25.6055C26.4258 25.1197 26.0327 24.7266 25.5469 24.7266H22.9102V22.9688H25.5469ZM17.6193 25.8164L19.3771 18.7852C19.4825 18.3105 19.2013 17.8359 18.7267 17.7304C18.252 17.6074 17.7775 17.8886 17.6544 18.3633L16.7579 21.9844L15.8614 18.3633C15.756 17.9589 15.3868 17.6953 15.0001 17.6953C14.9304 17.6953 14.8605 17.7127 14.7907 17.73L14.7892 17.7304C14.3145 17.8359 14.0333 18.3105 14.1388 18.7852L15.0001 22.1953L15.8966 25.8164C16.0021 26.2031 16.3536 26.4844 16.7579 26.4844C17.1622 26.4844 17.5138 26.2031 17.6193 25.8164Z'
                fill='white'
            />
            <path
                d='M7.2648 11.954C4.70015 8.53796 4.70015 3.76749 7.2648 0.351417C7.55659 -0.0365315 8.10937 -0.113758 8.49392 0.176339C8.88357 0.468136 8.96085 1.01833 8.669 1.40716C6.57304 4.20097 6.57304 8.10454 8.669 10.8983C8.9608 11.2871 8.88357 11.8372 8.49392 12.1291C8.10474 12.421 7.55349 12.3409 7.2648 11.954Z'
                fill='white'
            />
            <path
                d='M21.5059 12.1291C21.1162 11.8373 21.0389 11.2871 21.3308 10.8983C23.4268 8.10451 23.4268 4.20093 21.3308 1.40718C21.039 1.01836 21.1162 0.46822 21.5059 0.176364C21.8921 -0.114612 22.4448 -0.0382059 22.735 0.351443C25.2997 3.76752 25.2997 8.53799 22.735 11.9541C22.4464 12.3408 21.8951 12.4211 21.5059 12.1291Z'
                fill='white'
            />
            <path
                d='M10.4151 10.2546C8.3208 7.91664 8.3208 4.38901 10.4151 2.05094C10.7395 1.68872 11.2957 1.66042 11.6562 1.98227C12.0167 2.30583 12.0476 2.86206 11.7232 3.2234C10.228 4.89368 10.228 7.41192 11.7232 9.08219C12.0476 9.44354 12.0167 9.99971 11.6562 10.3233C11.295 10.6458 10.7395 10.6177 10.4151 10.2546Z'
                fill='white'
            />
            <path
                d='M18.344 10.3233C17.9836 9.99972 17.9526 9.44349 18.2771 9.08214C19.7723 7.41187 19.7723 4.89363 18.2771 3.22335C17.9526 2.86201 17.9835 2.30583 18.344 1.98222C18.7046 1.65861 19.2607 1.68697 19.5852 2.05089C21.6794 4.3889 21.6794 7.91654 19.5852 10.2546C19.2613 10.617 18.7058 10.6463 18.344 10.3233Z'
                fill='white'
            />
            <path
                d='M15 8.78943C13.5461 8.78943 12.3633 7.60666 12.3633 6.15271C12.3633 4.69876 13.5461 3.51599 15 3.51599C16.4539 3.51599 17.6367 4.69876 17.6367 6.15271C17.6367 7.60666 16.4539 8.78943 15 8.78943Z'
                fill='white'
            />
        </svg>
    )
}

export const IconShare = ({ color = '#FCFCFC' }: SVGProps) => {
    return (
        <svg
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g clipPath='url(#clip0_6035_30745)'>
                <path
                    d='M18.2452 4.40936C18.3937 4.55691 18.4755 4.75268 18.4755 4.9605C18.4755 5.16848 18.3937 5.3641 18.2452 5.51165L15.1124 8.62475C14.8065 8.92886 14.805 9.42355 15.1091 9.72949C15.2617 9.88314 15.4625 9.96005 15.6631 9.96005C15.8623 9.96005 16.0614 9.88436 16.2138 9.733L19.3466 6.6199C19.7923 6.17678 20.0378 5.58764 20.0378 4.9605C20.0378 4.33337 19.7923 3.74407 19.3466 3.30111L16.2138 0.188011C15.9079 -0.116096 15.4132 -0.114571 15.1091 0.191521C14.805 0.497612 14.8065 0.99215 15.1124 1.29626L18.2452 4.40936ZM16.5614 4.92327C16.5614 4.49175 16.2117 4.14202 15.7803 4.14202C12.9634 4.14202 10.3151 5.23898 8.32321 7.23086C6.33133 9.22274 5.23438 11.8711 5.23438 14.688V15.2739C5.23438 15.7053 5.58411 16.055 6.01562 16.055C6.44699 16.055 6.79672 15.7053 6.79672 15.2739V14.688C6.79672 9.73437 10.8267 5.70437 15.7803 5.70437C16.2117 5.70437 16.5614 5.35464 16.5614 4.92327Z'
                    fill={color}
                />
                <path
                    d='M9.33218 0.766602H5.6547C2.63602 0.766602 0.738281 2.90701 0.738281 5.93107V14.1C0.738281 17.1241 2.62619 19.2547 5.6547 19.2547H14.3273C17.3656 19.2547 19.2437 17.1241 19.2437 14.1V10.1727'
                    stroke={color}
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </g>
            <defs>
                <clipPath id='clip0_6035_30745'>
                    <rect width='20' height='20' fill='white' />
                </clipPath>
            </defs>
        </svg>
    )
}

export const IconPlaylist = ({ color = 'grey' }: SVGProps) => {
    return (
        <svg
            width='14'
            height='12'
            viewBox='0 0 14 12'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <rect width='14' height='1.5' rx='0.75' fill='grey' />
            <rect y='5' width='6.8' height='1.5' rx='0.75' fill='grey' />
            <rect y='10' width='6.8' height='1.5' rx='0.75' fill='grey' />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M10.5418 6.59798C11.2208 6.97181 11.8533 7.44266 12.4215 7.99972C11.8518 8.55723 11.2182 9.02922 10.5382 9.40496C10.4894 8.94194 10.4671 8.47599 10.4716 8.00982L10.4716 7.99438C10.4652 7.52757 10.4887 7.061 10.5418 6.59798ZM9.68898 5.14109C9.85364 5.04681 10.0448 4.99614 10.2429 5.00023C10.2933 5.00127 10.3435 5.00725 10.3926 5.01808C10.5722 5.05764 10.7465 5.11672 10.9126 5.19399C10.9191 5.19699 10.9255 5.20007 10.9318 5.20324C11.8955 5.68508 12.7787 6.32485 13.5502 7.09659C13.5616 7.10802 13.5726 7.11981 13.5832 7.13195L13.768 7.34374C13.7867 7.36525 13.8041 7.38782 13.8201 7.41132C13.9404 7.58868 14 7.79348 14 7.99661C14 8.19974 13.9404 8.40453 13.8201 8.5819C13.8064 8.60203 13.7917 8.62148 13.776 8.64017L13.5975 8.85195C13.5845 8.8674 13.5709 8.8823 13.5565 8.89664C12.7997 9.65362 11.9364 10.2849 10.9953 10.7663C10.9888 10.7697 10.9823 10.7729 10.9757 10.776C10.795 10.8619 10.6061 10.9295 10.4114 10.9776C10.3533 10.9919 10.2935 10.9995 10.2334 11C10.0221 11.0017 9.82069 10.9416 9.65137 10.8351C9.48297 10.7291 9.35544 10.5833 9.27284 10.4217C9.25327 10.3834 9.2374 10.3435 9.22543 10.3024C9.17305 10.1228 9.13107 9.9401 9.0997 9.75529C9.09784 9.74432 9.09625 9.73331 9.09494 9.72227C9.02724 9.15265 8.99588 8.57882 9.00103 8.00479C8.99339 7.41552 9.02814 6.82643 9.10501 6.2427C9.11316 6.11628 9.14405 5.98655 9.15823 5.92759C9.18065 5.83442 9.20523 5.7485 9.21611 5.7135C9.22336 5.69017 9.23188 5.66722 9.24164 5.64473C9.32594 5.45046 9.47079 5.27433 9.6701 5.15227C9.67634 5.14845 9.68263 5.14472 9.68898 5.14109Z'
                fill={color}
            />
        </svg>
    )
}
export const IconPlaylistWhite = ({ color = 'white' }: SVGProps) => {
    return (
        <svg
            width='14'
            height='12'
            viewBox='0 0 14 12'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <rect width='14' height='1.5' rx='0.75' fill={color} />
            <rect y='5' width='6.8' height='1.5' rx='0.75' fill={color} />
            <rect y='10' width='6.8' height='1.5' rx='0.75' fill={color} />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M10.5418 6.59798C11.2208 6.97181 11.8533 7.44266 12.4215 7.99972C11.8518 8.55723 11.2182 9.02922 10.5382 9.40496C10.4894 8.94194 10.4671 8.47599 10.4716 8.00982L10.4716 7.99438C10.4652 7.52757 10.4887 7.061 10.5418 6.59798ZM9.68898 5.14109C9.85364 5.04681 10.0448 4.99614 10.2429 5.00023C10.2933 5.00127 10.3435 5.00725 10.3926 5.01808C10.5722 5.05764 10.7465 5.11672 10.9126 5.19399C10.9191 5.19699 10.9255 5.20007 10.9318 5.20324C11.8955 5.68508 12.7787 6.32485 13.5502 7.09659C13.5616 7.10802 13.5726 7.11981 13.5832 7.13195L13.768 7.34374C13.7867 7.36525 13.8041 7.38782 13.8201 7.41132C13.9404 7.58868 14 7.79348 14 7.99661C14 8.19974 13.9404 8.40453 13.8201 8.5819C13.8064 8.60203 13.7917 8.62148 13.776 8.64017L13.5975 8.85195C13.5845 8.8674 13.5709 8.8823 13.5565 8.89664C12.7997 9.65362 11.9364 10.2849 10.9953 10.7663C10.9888 10.7697 10.9823 10.7729 10.9757 10.776C10.795 10.8619 10.6061 10.9295 10.4114 10.9776C10.3533 10.9919 10.2935 10.9995 10.2334 11C10.0221 11.0017 9.82069 10.9416 9.65137 10.8351C9.48297 10.7291 9.35544 10.5833 9.27284 10.4217C9.25327 10.3834 9.2374 10.3435 9.22543 10.3024C9.17305 10.1228 9.13107 9.9401 9.0997 9.75529C9.09784 9.74432 9.09625 9.73331 9.09494 9.72227C9.02724 9.15265 8.99588 8.57882 9.00103 8.00479C8.99339 7.41552 9.02814 6.82643 9.10501 6.2427C9.11316 6.11628 9.14405 5.98655 9.15823 5.92759C9.18065 5.83442 9.20523 5.7485 9.21611 5.7135C9.22336 5.69017 9.23188 5.66722 9.24164 5.64473C9.32594 5.45046 9.47079 5.27433 9.6701 5.15227C9.67634 5.14845 9.68263 5.14472 9.68898 5.14109Z'
                fill={color}
            />
        </svg>
    )
}


export const IconOptionsPlaylist = ({ color = '#778797' }: SVGProps) => {
    return (
        <svg
            width='20'
            height='21'
            viewBox='0 0 20 21'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <rect width='20' height='1.53846' rx='0.769231' fill={color} />
            <rect
                y='6.15381'
                width='20'
                height='1.53846'
                rx='0.769231'
                fill={color}
            />
            <rect
                y='12.3076'
                width='8'
                height='1.53846'
                rx='0.769231'
                fill={color}
            />
            <rect
                y='18.4614'
                width='8'
                height='1.53846'
                rx='0.769231'
                fill={color}
            />
            <path
                d='M17.591 16.1224C16.3925 17.3806 15.03 18.4249 13.5508 19.2192C13.3206 19.334 13.0812 19.4238 12.8359 19.4873C12.7341 19.4882 12.6341 19.4581 12.5464 19.4001C12.4586 19.3422 12.3865 19.2585 12.3376 19.1581C12.261 18.8822 12.1994 18.6014 12.1535 18.317C12.0436 17.3467 11.9929 16.369 12.0018 15.3909C11.9887 14.3755 12.0466 13.3604 12.1751 12.3552C12.1751 12.1723 12.2943 11.7334 12.3159 11.6602C12.3689 11.532 12.456 11.4255 12.5651 11.3554C12.6483 11.3054 12.7415 11.2803 12.8359 11.2823C13.0478 11.3314 13.2547 11.4048 13.4533 11.5017C14.9665 12.2958 16.3592 13.3532 17.5802 14.6351L17.8943 15.0129C17.963 15.1192 18 15.2473 18 15.3787C18 15.5102 17.963 15.6383 17.8943 15.7445L17.591 16.1224Z'
                stroke={color}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}

export const IconPin = ({ color = '#fff' }: SVGProps) => {
    return (
        <svg
            width='12'
            height='12'
            viewBox='0 0 12 12'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M7.355 1.145C7.30838 1.09838 7.25303 1.0614 7.19212 1.03617C7.13121 1.01094 7.06593 0.997955 7 0.997955C6.93407 0.997955 6.86878 1.01094 6.80787 1.03617C6.74696 1.0614 6.69162 1.09838 6.645 1.145C6.55084 1.23915 6.49795 1.36685 6.49795 1.5C6.49795 1.63315 6.55084 1.76085 6.645 1.855L6.745 1.955L2.74499 5.055L2.33999 4.645C2.24584 4.55085 2.11815 4.49795 1.98499 4.49795C1.85184 4.49795 1.72415 4.55085 1.62999 4.645C1.53584 4.73915 1.48295 4.86685 1.48295 5C1.48295 5.13315 1.53584 5.26085 1.62999 5.355L3.79 7.5L1.16999 10.12C1.12313 10.1665 1.08593 10.2218 1.06055 10.2827C1.03516 10.3436 1.02209 10.409 1.02209 10.475C1.02209 10.541 1.03516 10.6064 1.06055 10.6673C1.08593 10.7282 1.12313 10.7835 1.16999 10.83C1.21648 10.8769 1.27178 10.9141 1.33271 10.9394C1.39364 10.9648 1.45899 10.9779 1.52499 10.9779C1.591 10.9779 1.65635 10.9648 1.71728 10.9394C1.77821 10.9141 1.83351 10.8769 1.87999 10.83L4.5 8.2L6.645 10.34C6.69148 10.3869 6.74678 10.4241 6.80771 10.4494C6.86864 10.4748 6.93399 10.4879 7 10.4879C7.066 10.4879 7.13136 10.4748 7.19229 10.4494C7.25321 10.4241 7.30852 10.3869 7.355 10.34C7.40186 10.2935 7.43906 10.2382 7.46444 10.1773C7.48983 10.1164 7.5029 10.051 7.5029 9.985C7.5029 9.91899 7.48983 9.85364 7.46444 9.79271C7.43906 9.73178 7.40186 9.67648 7.355 9.63L6.955 9.23L10.045 5.23L10.145 5.33C10.1915 5.37686 10.2468 5.41406 10.3077 5.43945C10.3686 5.46483 10.434 5.4779 10.5 5.4779C10.566 5.4779 10.6314 5.46483 10.6923 5.43945C10.7532 5.41406 10.8085 5.37686 10.855 5.33C10.9019 5.28352 10.9391 5.22822 10.9644 5.16729C10.9898 5.10636 11.0029 5.04101 11.0029 4.975C11.0029 4.90899 10.9898 4.84364 10.9644 4.78271C10.9391 4.72178 10.9019 4.66648 10.855 4.62L7.355 1.145ZM6.24 8.5L3.49999 5.765L7.5 2.665L9.375 4.54L6.24 8.5Z'
                fill={color}
            />
        </svg>
    )
}

export const IconOptionsPin = ({ color = '#778797' }: SVGProps) => {
    return (
        <svg
            width='16'
            height='20'
            viewBox='0 0 16 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M13.5915 19.8001L7.97498 16.6716L2.38848 19.8001C2.16283 19.927 1.90783 19.9926 1.64895 19.99C1.4089 19.9887 1.17199 19.9353 0.954592 19.8335C0.73719 19.7317 0.54446 19.5839 0.389729 19.4004L0.289785 19.2804L0.199845 19.1205C0.0761859 18.8756 0.0111771 18.6052 0.00996131 18.3308V4.44776C-0.0272001 3.8299 0.0736997 3.21161 0.305339 2.63763C0.536979 2.06364 0.893539 1.54842 1.34912 1.12947C2.39851 0.329683 3.69976 -0.0674705 5.01684 0.0100348H11.0131C14.1911 0.0100348 16.01 1.56926 16.01 4.26792V18.3308C16.0116 18.5493 15.9701 18.7661 15.8877 18.9685C15.8054 19.1708 15.6839 19.355 15.5303 19.5103C15.3824 19.669 15.2028 19.7946 15.003 19.879C14.8032 19.9634 14.5878 20.0047 14.371 20C14.0982 20.0019 13.8297 19.9329 13.5915 19.8001ZM8.64458 15.3924L14.2411 18.5208H14.371C14.3994 18.5199 14.4273 18.5132 14.4531 18.5012C14.4789 18.4891 14.5019 18.472 14.5209 18.4508C14.5635 18.4081 14.5884 18.351 14.5908 18.2908V4.2279C14.5908 2.36883 13.3716 1.41936 10.9931 1.41936H4.99684C2.57835 1.41936 1.39911 2.41886 1.39911 4.41786V18.4109V18.4708C1.41867 18.5008 1.44528 18.5257 1.47664 18.5431C1.50799 18.5605 1.54313 18.57 1.57899 18.5707H1.66893L7.24543 15.4323C7.45056 15.3194 7.6809 15.2602 7.91502 15.2602C8.14915 15.2602 8.37946 15.3194 8.58459 15.4323L8.64458 15.3924ZM4.54713 7.77617C4.45264 7.78273 4.35776 7.77052 4.26795 7.74042C4.17814 7.71032 4.09514 7.66291 4.02369 7.60072C3.95223 7.53854 3.89372 7.46285 3.85149 7.37805C3.80927 7.29326 3.78416 7.20097 3.7776 7.10646C3.77103 7.01196 3.78315 6.91713 3.81325 6.8273C3.84335 6.73748 3.89085 6.65439 3.95302 6.58292C4.0152 6.51145 4.09084 6.45299 4.17563 6.41076C4.26042 6.36854 4.3527 6.34339 4.44719 6.33683H11.4428C11.5373 6.33026 11.6322 6.34235 11.722 6.37245C11.8118 6.40256 11.8948 6.45009 11.9663 6.51228C12.0377 6.57446 12.0962 6.65014 12.1384 6.73494C12.1807 6.81974 12.2058 6.91203 12.2123 7.00654C12.2189 7.10104 12.2068 7.19587 12.1767 7.28569C12.1466 7.37552 12.0991 7.45849 12.0369 7.52996C11.9748 7.60142 11.8991 7.66 11.8143 7.70223C11.7295 7.74446 11.6373 7.76961 11.5428 7.77617H4.54713Z'
                fill={color}
            />
        </svg>
    )
}

export const IconDiscovery = ({ color = '#200E32' }: SVGProps) => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='30'
            height='30'
            viewBox='0 0 30 30'
            fill='none'
        >
            <path
                d='M10.1641 19.8504L12.4662 12.4807L19.8359 10.1641L17.5337 17.5338L10.1641 19.8504Z'
                stroke={color}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M15 28.9141C22.6846 28.9141 28.9141 22.6846 28.9141 15C28.9141 7.31549 22.6846 1.08594 15 1.08594C7.31549 1.08594 1.08594 7.31549 1.08594 15C1.08594 22.6846 7.31549 28.9141 15 28.9141Z'
                stroke={color}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}

export const IconPurchases = ({ color = '#2894FF' }: SVGProps) => {
    return (
        <svg
            width='14'
            height='16'
            viewBox='0 0 14 16'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M3.17523 3.90244H2.10335C1.36268 3.90244 0.747873 4.4562 0.695026 5.17112L0.00357685 14.537C-0.0242588 14.9151 0.111283 15.2874 0.378344 15.5649C0.645808 15.8423 1.01978 16 1.4119 16H12.5881C12.9802 16 13.3542 15.8423 13.6217 15.5649C13.8887 15.2874 14.0243 14.9151 13.9964 14.537L13.305 5.17112C13.2521 4.4562 12.6373 3.90244 11.8967 3.90244H10.8324V3.70732C10.8324 1.65971 9.11672 0 7 0C4.96074 0 3.07598 1.57112 3.16756 3.70732C3.17038 3.7721 3.17281 3.83727 3.17523 3.90244ZM9.6222 3.90244V3.70732C9.6222 2.30634 8.44826 1.17073 7 1.17073C5.55174 1.17073 4.3778 2.30634 4.3778 3.70732V3.90244H9.6222Z'
                fill={color}
            />
        </svg>
    )
}

export const IconWaveBackground = () => {
    return (
        <svg
            width='371'
            height='360'
            viewBox='0 0 371 360'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                opacity='0.2'
                d='M771.79 140.472C983.612 140.472 906.269 12.9116 995 31.2273V582H-1064V-118.081C-985.429 -130.176 -715.519 -18.8426 -517.363 -18.8426C-291.875 -18.8426 -291.875 99.5052 -125.606 99.5052C-46.6075 99.5052 -57.2766 181.438 56.6062 181.438C170.489 181.438 220.597 19.8478 352.701 19.8478C484.805 19.8478 559.968 140.472 771.79 140.472Z'
                fill='url(#paint0_linear_6004_29496)'
            />
            <defs>
                <linearGradient
                    id='paint0_linear_6004_29496'
                    x1='-34.5'
                    y1='-226.434'
                    x2='-34.5'
                    y2='595.656'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#2894FF' />
                    <stop offset='1' stopColor='#15161C' stopOpacity='0' />
                </linearGradient>
            </defs>
        </svg>
    )
}

export const IconNoteOutlineSquare = () => {
    return (
        <svg
            width='18'
            height='20'
            viewBox='0 0 18 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M2.24925 0C1.653 0 1.08113 0.226043 0.65925 0.627779C0.23775 1.02916 0 1.57659 0 2.14473V17.8553C0 18.4234 0.23775 18.9708 0.65925 19.3722C1.08113 19.774 1.653 20 2.24925 20H15.7507C16.3474 20 16.9223 19.774 17.3438 19.3722C17.7656 18.9708 18 18.4234 18 17.8553V2.14473C18 1.57659 17.7656 1.02916 17.3438 0.627779C16.9223 0.226043 16.3474 0 15.7507 0H2.24925ZM2.24925 1.42982H15.7507C15.951 1.42982 16.1407 1.50481 16.2817 1.63908C16.4224 1.77299 16.5015 1.95368 16.5015 2.14473V17.8553C16.5015 18.0463 16.4224 18.227 16.2817 18.3609C16.1411 18.4952 15.951 18.5702 15.7507 18.5702H2.24925C2.049 18.5702 1.86225 18.4952 1.72125 18.3609C1.58063 18.227 1.5015 18.0463 1.5015 17.8553V2.14473C1.5015 1.95368 1.58063 1.77299 1.72125 1.63908C1.86225 1.50481 2.049 1.42982 2.24925 1.42982Z'
                fill='#777788'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M6.3738 5.00147C5.96317 5.00111 5.62455 5.32214 5.62305 5.71352V5.71388C5.62305 6.10597 5.96167 6.42843 6.37305 6.42843H11.6238C12.0352 6.42843 12.3738 6.10597 12.3738 5.71388V5.71352C12.3727 5.32214 12.034 5.00111 11.623 5.00147H6.3738Z'
                fill='#777788'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M6.3738 9.28491C6.3738 9.28491 6.37342 9.28491 6.37305 9.28491C5.96167 9.28491 5.62305 9.60737 5.62305 9.99911V10.0005C5.62305 10.3926 5.96167 10.7147 6.37305 10.7147H11.6238C12.0352 10.7147 12.3738 10.3926 12.3738 10.0005V9.99911C12.3738 9.60737 12.0352 9.28491 11.6238 9.28491C11.6234 9.28491 11.6234 9.28491 11.623 9.28491H6.3738Z'
                fill='#777788'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M6.3738 13.5715C6.3738 13.5715 6.37342 13.5715 6.37305 13.5715C5.96167 13.5715 5.62305 13.894 5.62305 14.2857V14.2864C5.62455 14.6778 5.96317 14.9989 6.3738 14.9985H11.623C12.034 14.9989 12.3727 14.6778 12.3738 14.2864C12.3738 14.2864 12.3738 14.2861 12.3738 14.2857C12.3738 13.894 12.0352 13.5715 11.6238 13.5715C11.6234 13.5715 11.6234 13.5715 11.623 13.5715H6.3738Z'
                fill='#777788'
            />
        </svg>
    )
}

export const IconBlockOutline = () => {
    return (
        <svg
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M10 0C11.9778 0 13.9112 0.58649 15.5557 1.6853C17.2002 2.78412 18.4819 4.3459 19.2388 6.17316C19.9957 8.00043 20.1937 10.0111 19.8078 11.9509C19.422 13.8907 18.4696 15.6725 17.0711 17.0711C15.6725 18.4696 13.8907 19.422 11.9509 19.8078C10.0111 20.1937 8.00042 19.9957 6.17316 19.2388C4.3459 18.4819 2.78412 17.2002 1.6853 15.5557C0.586489 13.9112 0 11.9778 0 10C0.00312805 7.34879 1.0577 4.80707 2.93239 2.93239C4.80707 1.0577 7.34879 0.0031277 10 0ZM18.1818 10C18.1825 8.1447 17.549 6.34489 16.3864 4.89909L4.89909 16.3864C6.10135 17.35 7.55156 17.9542 9.08241 18.1291C10.6133 18.304 12.1624 18.0425 13.551 17.3748C14.9396 16.7072 16.1112 15.6605 16.9306 14.3556C17.75 13.0508 18.1837 11.5408 18.1818 10ZM3.61364 15.1009L15.1009 3.61364C13.5307 2.35491 11.5512 1.71986 9.54183 1.83015C7.53241 1.94044 5.63435 2.78833 4.21134 4.21134C2.78833 5.63435 1.94044 7.53241 1.83015 9.54183C1.71986 11.5512 2.35491 13.5307 3.61364 15.1009Z'
                fill='#777788'
            />
        </svg>
    )
}
export const IconBlockedOutline = () => {
    return (
        <svg
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M10 0C11.9778 0 13.9112 0.58649 15.5557 1.6853C17.2002 2.78412 18.4819 4.3459 19.2388 6.17316C19.9957 8.00043 20.1937 10.0111 19.8078 11.9509C19.422 13.8907 18.4696 15.6725 17.0711 17.0711C15.6725 18.4696 13.8907 19.422 11.9509 19.8078C10.0111 20.1937 8.00042 19.9957 6.17316 19.2388C4.3459 18.4819 2.78412 17.2002 1.6853 15.5557C0.586489 13.9112 0 11.9778 0 10C0.00312805 7.34879 1.0577 4.80707 2.93239 2.93239C4.80707 1.0577 7.34879 0.0031277 10 0ZM18.1818 10C18.1825 8.1447 17.549 6.34489 16.3864 4.89909L4.89909 16.3864C6.10135 17.35 7.55156 17.9542 9.08241 18.1291C10.6133 18.304 12.1624 18.0425 13.551 17.3748C14.9396 16.7072 16.1112 15.6605 16.9306 14.3556C17.75 13.0508 18.1837 11.5408 18.1818 10ZM3.61364 15.1009L15.1009 3.61364C13.5307 2.35491 11.5512 1.71986 9.54183 1.83015C7.53241 1.94044 5.63435 2.78833 4.21134 4.21134C2.78833 5.63435 1.94044 7.53241 1.83015 9.54183C1.71986 11.5512 2.35491 13.5307 3.61364 15.1009Z'
                fill='#bd2121'
            />
        </svg>
    )
}
export const IconClockArrowCircle = () => {
    return (
        <svg
            width='22'
            height='20'
            viewBox='0 0 22 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M10.8466 10.8935L10.8466 10.8935L10.8494 10.8956L14.5994 13.7081C14.9198 13.9485 15.374 13.8836 15.6144 13.5631C15.8547 13.2427 15.7898 12.7886 15.4695 12.5482C15.4695 12.5482 15.4694 12.5482 15.4694 12.5481L12.0375 9.95028V4.6875C12.0375 4.28696 11.713 3.9625 11.3125 3.9625C10.912 3.9625 10.5875 4.28696 10.5875 4.6875V10.3125C10.5875 10.5464 10.6852 10.7635 10.8466 10.8935Z'
                fill='#777788'
                stroke='#777788'
                strokeWidth='0.2'
            />
            <path
                d='M3.92368 8.23582L3.76355 8.39725C4.61675 4.19622 8.64545 1.38542 12.914 2.07902C17.2885 2.78985 20.259 6.91223 19.5482 11.2871C18.917 15.1718 15.5616 18.0256 11.6259 18.025L11.6241 18.025C9.14382 18.07 6.79797 16.9 5.34151 14.8916C5.10914 14.5658 4.65661 14.4893 4.33041 14.7217C4.00426 14.954 3.92769 15.4067 4.1601 15.733L4.16048 15.7335C5.88821 18.1261 8.67624 19.5231 11.6268 19.475C16.8594 19.4746 21.1009 15.2328 21.1009 10C21.1009 4.76696 16.859 0.525 11.6259 0.525C7.08506 0.525 3.19552 3.7439 2.32791 8.17764L2.22765 8.02857L2.22756 8.02843C2.00325 7.69614 1.55236 7.60837 1.21997 7.83274C0.887768 8.05699 0.799962 8.50771 1.02412 8.84007C1.02417 8.84015 1.02423 8.84024 1.02429 8.84032L2.27364 10.7143C2.2737 10.7144 2.27376 10.7145 2.27382 10.7146C2.39307 10.8957 2.58725 11.0141 2.80289 11.0369L2.80284 11.0375H2.81342H2.87592L2.8763 11.0375C3.0683 11.0368 3.25206 10.96 3.38732 10.8238C3.3874 10.8237 3.38747 10.8236 3.38754 10.8236L4.94976 9.26134C5.23288 8.97822 5.23288 8.51865 4.94976 8.23554C4.66665 7.95242 4.20708 7.95242 3.92396 8.23554L3.92368 8.23582Z'
                fill='#777788'
                stroke='#777788'
                strokeWidth='0.2'
            />
        </svg>
    )
}

export const IconChatOutlineTransparentBg = ({ color = 'white' }: SVGProps) => {
    return (
        <svg
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M9.99599 3.03846e-06C11.5271 -0.00119081 13.038 0.349437 14.4122 1.02492C15.7864 1.70045 16.9872 2.68277 17.9217 3.89599C18.8563 5.10921 19.4998 6.52092 19.8026 8.02225C20.1053 9.52357 20.0594 11.0744 19.6682 12.5552C19.277 14.0359 18.551 15.407 17.5462 16.5627C16.5414 17.7184 15.2846 18.6278 13.8727 19.2206C12.4608 19.8135 10.9317 20.074 9.4032 19.9819C7.87473 19.8899 6.38782 19.4478 5.05725 18.6898C5.01332 18.6648 4.97179 18.6358 4.9332 18.6032C4.84448 18.5281 4.73957 18.4749 4.62685 18.4476C4.52098 18.4221 4.41095 18.42 4.30448 18.4415L2.51533 18.9785C2.21617 19.0792 1.89161 19.0766 1.59375 18.9708C1.24912 18.8491 0.965769 18.5975 0.804113 18.2699C0.644045 17.9455 0.615825 17.572 0.724881 17.2276L1.33719 15.1795C1.34316 15.1595 1.34989 15.1398 1.35736 15.1203C1.36492 15.1006 1.36801 15.0794 1.36637 15.0583C1.36473 15.0373 1.35841 15.0168 1.3479 14.9986L1.3435 14.9909L1.34354 14.9909C0.490076 13.4688 0.0284809 11.7582 0.000215597 10.0133L0 10H0.000107799C0.000107799 7.34808 1.05312 4.80459 2.92769 2.92917C4.80221 1.0538 7.34471 9.51039e-05 9.99599 3.03846e-06ZM9.99599 3.03846e-06C9.99611 3.03846e-06 9.99622 3.03846e-06 9.99634 3.03846e-06V0.822183L9.99567 3.29982e-06C9.99578 3.29982e-06 9.99589 3.03846e-06 9.99599 3.03846e-06ZM13.6862 2.50049C12.5382 1.9362 11.276 1.64332 9.99701 1.64436L9.99634 1.64436C7.78173 1.64436 5.65771 2.52447 4.09152 4.09137C2.52687 5.65673 1.64701 7.77946 1.64525 9.99336C1.67015 11.4623 2.05897 12.9022 2.77687 14.1838C2.90767 14.4128 2.98612 14.668 3.00657 14.9309C3.02621 15.1836 2.99184 15.4375 2.90587 15.6757L2.4235 17.2892L3.8611 16.8576C3.87787 16.8526 3.89479 16.8481 3.91184 16.8442C4.27454 16.7601 4.65179 16.7619 5.01355 16.8494C5.34761 16.9301 5.65993 17.0818 5.9295 17.2938C7.02625 17.9071 8.24746 18.265 9.50213 18.3406C10.7788 18.4174 12.0561 18.1998 13.2355 17.7046C14.4149 17.2094 15.4649 16.4497 16.3044 15.4841C17.144 14.5185 17.7506 13.3728 18.0775 12.1353C18.4045 10.8979 18.4429 9.60184 18.1899 8.34719C17.9368 7.09253 17.3991 5.91287 16.6182 4.89917C15.8373 3.88546 14.8342 3.0648 13.6862 2.50049ZM2.29268 17.7258L2.29451 17.72C2.29393 17.7219 2.29332 17.7239 2.29268 17.7258Z'
                fill={color}
            />
            <path
                d='M12.8839 9.98637C12.8821 9.77073 12.9443 9.5594 13.0627 9.3792C13.181 9.199 13.3502 9.05802 13.5487 8.97421C13.7473 8.89041 13.9662 8.86753 14.1777 8.90846C14.3892 8.9494 14.5838 9.05232 14.7368 9.20416C14.8898 9.35599 14.9944 9.54994 15.0371 9.76131C15.0798 9.97268 15.0588 10.192 14.9768 10.3914C14.8948 10.5908 14.7554 10.7613 14.5764 10.8813C14.3973 11.0014 14.1868 11.0654 13.9713 11.0654C13.6846 11.0654 13.4093 10.9521 13.2057 10.75C13.002 10.5479 12.8864 10.2734 12.8839 9.98637ZM8.66462 9.98637C8.66462 9.69772 8.77915 9.42087 8.98307 9.21676C9.18699 9.01265 9.46358 8.89802 9.75197 8.89802C10.0404 8.89802 10.3169 9.01265 10.5209 9.21676C10.7248 9.42087 10.8393 9.69772 10.8393 9.98637C10.8369 10.2743 10.7216 10.5497 10.5182 10.7533C10.3148 10.9568 10.0396 11.0723 9.75197 11.0747C9.46358 11.0747 9.18699 10.9601 8.98307 10.756C8.77915 10.5519 8.66462 10.275 8.66462 9.98637ZM4.44531 9.98637C4.44532 9.77072 4.50932 9.55991 4.62921 9.38073C4.74911 9.20156 4.91945 9.0621 5.11868 8.98C5.31792 8.89791 5.53703 8.87689 5.74821 8.91965C5.95939 8.9624 6.15315 9.06697 6.30484 9.22011C6.45654 9.37326 6.55936 9.56809 6.60026 9.77982C6.64116 9.99155 6.61825 10.2107 6.53452 10.4094C6.45079 10.6081 6.31 10.7774 6.12996 10.8959C5.94993 11.0143 5.7388 11.0766 5.52335 11.0747C5.23658 11.0723 4.96239 10.9565 4.76047 10.7527C4.55856 10.5488 4.4453 10.2734 4.44531 9.98637Z'
                fill={color}
            />
        </svg>
    )
}

export const IconPlayBlue = () => {
    return (
        <svg
            width='12'
            height='12'
            viewBox='0 0 12 12'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g clipPath='url(#clip0_5382_19692)'>
                <path
                    d='M12 6C12 7.18669 11.6481 8.3467 10.9888 9.3334C10.3295 10.3201 9.39247 11.0891 8.29611 11.5433C7.19976 11.9974 5.99336 12.1162 4.82947 11.8847C3.66558 11.6532 2.59648 11.0817 1.75736 10.2426C0.918247 9.40351 0.346802 8.33441 0.11529 7.17052C-0.116221 6.00663 0.00260139 4.80025 0.456727 3.70389C0.910853 2.60754 1.6799 1.67047 2.66659 1.01118C3.65329 0.351893 4.81332 0 6.00001 0C7.59131 0 9.11743 0.632118 10.2427 1.75734C11.3679 2.88256 12 4.4087 12 6Z'
                    fill='#028DFD'
                />
                <path
                    d='M8.40037 6.0001C8.40223 6.15434 8.35144 6.30459 8.25638 6.42607C8.20509 6.49217 8.14893 6.55434 8.08838 6.61207L8.05238 6.64807C7.3423 7.30268 6.53206 7.83948 5.65238 8.23809C5.47602 8.32098 5.28771 8.37566 5.09437 8.4001C4.95871 8.40054 4.82552 8.36388 4.70919 8.29408C4.59286 8.22428 4.49784 8.12398 4.43438 8.00408C4.37375 7.83177 4.32561 7.65531 4.29037 7.47607C4.22436 6.98693 4.19428 6.49364 4.20037 6.0001C4.19231 5.49016 4.22644 4.9804 4.30238 4.47607C4.32989 4.33206 4.36595 4.18983 4.41038 4.0501C4.47634 3.89613 4.5927 3.76915 4.74037 3.69008C4.85753 3.63073 4.98705 3.59992 5.11837 3.6001C5.28937 3.62566 5.4566 3.67199 5.61637 3.73809C6.50746 4.14011 7.32799 4.68306 8.04638 5.34608L8.24437 5.5501C8.34591 5.67806 8.40093 5.83674 8.40037 6.0001Z'
                    fill='white'
                />
            </g>
            <defs>
                <clipPath id='clip0_5382_19692'>
                    <rect width='12' height='12' fill='white' />
                </clipPath>
            </defs>
        </svg>
    )
}
export const IconPlayBlueLarge = () => {
    return (
        <svg
            width='30'
            height='30'
            viewBox='0 0 12 12'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            style={{
                display: 'block',
                overflow: 'visible',
                filter: 'drop-shadow(0px 0px 6px rgba(2, 141, 253, 0.22))',
            }}
        >
            <path
                d='M12 6C12 7.18669 11.6481 8.3467 10.9888 9.3334C10.3295 10.3201 9.39247 11.0891 8.29611 11.5433C7.19976 11.9974 5.99336 12.1162 4.82947 11.8847C3.66558 11.6532 2.59648 11.0817 1.75736 10.2426C0.918247 9.40351 0.346802 8.33441 0.11529 7.17052C-0.116221 6.00663 0.00260139 4.80025 0.456727 3.70389C0.910853 2.60754 1.6799 1.67047 2.66659 1.01118C3.65329 0.351893 4.81332 0 6.00001 0C7.59131 0 9.11743 0.632118 10.2427 1.75734C11.3679 2.88256 12 4.4087 12 6Z'
                fill='rgba(2, 141, 253, 0.5)'
            />
            <path
                d='M8.40037 6.0001C8.40223 6.15434 8.35144 6.30459 8.25638 6.42607C8.20509 6.49217 8.14893 6.55434 8.08838 6.61207L8.05238 6.64807C7.3423 7.30268 6.53206 7.83948 5.65238 8.23809C5.47602 8.32098 5.28771 8.37566 5.09437 8.4001C4.95871 8.40054 4.82552 8.36388 4.70919 8.29408C4.59286 8.22428 4.49784 8.12398 4.43438 8.00408C4.37375 7.83177 4.32561 7.65531 4.29037 7.47607C4.22436 6.98693 4.19428 6.49364 4.20037 6.0001C4.19231 5.49016 4.22644 4.9804 4.30238 4.47607C4.32989 4.33206 4.36595 4.18983 4.41038 4.0501C4.47634 3.89613 4.5927 3.76915 4.74037 3.69008C4.85753 3.63073 4.98705 3.59992 5.11837 3.6001C5.28937 3.62566 5.4566 3.67199 5.61637 3.73809C6.50746 4.14011 7.32799 4.68306 8.04638 5.34608L8.24437 5.5501C8.34591 5.67806 8.40093 5.83674 8.40037 6.0001Z'
                fill='rgba(255,255,255,0.9)'
            />
        </svg>
    )
}

export const IconImagePink = () => {
    return (
        <svg
            width='12'
            height='12'
            viewBox='0 0 12 12'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g clipPath='url(#clip0_5382_19791)'>
                <path
                    d='M8.59801 12H3.40199C1.36799 12 0 10.578 0 8.45398V3.55199C0 1.42799 1.36799 0 3.40199 0H8.59801C10.632 0 12 1.42799 12 3.55199V8.45998C12 10.584 10.632 12.006 8.59801 12.006'
                    fill='#FD027A'
                />
                <path
                    d='M3.4137 10.656C2.95508 10.6667 2.50243 10.5504 2.10571 10.32C2.00839 10.2583 1.93932 10.1607 1.91348 10.0484C1.88765 9.93607 1.90716 9.81809 1.96772 9.72004L2.00372 9.66606L2.8497 8.63404C3.3837 7.97404 3.74369 7.78207 4.14569 7.95007C4.31735 8.03001 4.48195 8.12433 4.63769 8.23205C4.88875 8.46259 5.204 8.61131 5.54157 8.65847C5.87914 8.70562 6.22308 8.64897 6.52771 8.49605C7.03501 8.17745 7.44901 7.73035 7.72771 7.20007C7.83518 7.01339 7.95336 6.83307 8.08169 6.66005C8.2099 6.45293 8.41293 6.3031 8.64865 6.24166C8.88437 6.18021 9.13471 6.21188 9.34771 6.33006C9.74416 6.59981 10.1103 6.91161 10.4397 7.26005C10.5718 7.38959 10.6759 7.54478 10.7457 7.71606C10.914 8.2435 10.8711 8.8157 10.6257 9.31204C10.5003 9.59743 10.3147 9.85238 10.0817 10.0595C9.84876 10.2666 9.57384 10.4209 9.27572 10.512C9.00503 10.602 8.72086 10.6446 8.4357 10.6381L3.4137 10.656ZM2.56171 4.00806C2.56053 3.71233 2.64711 3.42287 2.81055 3.1764C2.97399 2.92992 3.20692 2.73749 3.4798 2.62349C3.75269 2.5095 4.05327 2.47908 4.34348 2.53604C4.63368 2.59301 4.90045 2.73483 5.10999 2.94353C5.31953 3.15222 5.46242 3.41839 5.52055 3.70836C5.57869 3.99833 5.54944 4.29905 5.43654 4.57239C5.32364 4.84574 5.13216 5.07941 4.88635 5.24384C4.64053 5.40827 4.35145 5.49605 4.05571 5.49605C3.66051 5.49605 3.28139 5.33947 3.00139 5.06059C2.72138 4.78171 2.5633 4.40326 2.56171 4.00806Z'
                    fill='white'
                />
            </g>
            <defs>
                <clipPath id='clip0_5382_19791'>
                    <rect width='12' height='12' fill='white' />
                </clipPath>
            </defs>
        </svg>
    )
}

export const IconChatPurple = () => {
    return (
        <svg
            width='12'
            height='12'
            viewBox='0 0 12 12'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g clipPath='url(#clip0_5382_19741)'>
                <path
                    d='M6 1.97823e-06C4.4087 1.97823e-06 2.88259 0.632753 1.75737 1.7591C0.632155 2.88544 0 4.41312 0 6.00601C0.015275 7.05901 0.293731 8.09141 0.809985 9.00901C0.856302 9.09046 0.884097 9.18112 0.891357 9.27456C0.898618 9.368 0.885168 9.46189 0.85199 9.54953L0.45 10.8949C0.41932 10.9889 0.426626 11.0912 0.470361 11.1799C0.514097 11.2686 0.590796 11.3366 0.684009 11.3694C0.766832 11.4025 0.859181 11.4025 0.942004 11.3694L2.142 11.009C2.29755 10.9729 2.45936 10.9737 2.61456 11.0112C2.76976 11.0488 2.91407 11.122 3.036 11.2252C3.83462 11.6804 4.72705 11.9459 5.64441 12.0012C6.56177 12.0564 7.47954 11.9 8.32694 11.544C9.17434 11.1879 9.92871 10.6418 10.5319 9.94775C11.135 9.25365 11.5708 8.43015 11.8057 7.54076C12.0405 6.65137 12.0681 5.71984 11.8863 4.81808C11.7046 3.91631 11.3183 3.06841 10.7573 2.33976C10.1963 1.6111 9.47558 1.02116 8.65074 0.615486C7.82591 0.209811 6.91902 -0.000744557 6 1.97823e-06Z'
                    fill='#DA02FD'
                />
                <path
                    d='M7.98511 6.01192C7.98511 5.85987 8.03014 5.71124 8.11453 5.58482C8.19892 5.45839 8.31887 5.35986 8.4592 5.30167C8.59954 5.24349 8.75396 5.22828 8.90294 5.25794C9.05192 5.2876 9.18877 5.3608 9.29618 5.46832C9.40359 5.57583 9.47671 5.71282 9.50635 5.86195C9.53598 6.01108 9.52079 6.16566 9.46266 6.30613C9.40453 6.44661 9.30609 6.56668 9.1798 6.65115C9.0535 6.73563 8.90502 6.7807 8.75312 6.7807C8.65255 6.78149 8.55279 6.76234 8.45964 6.72436C8.3665 6.68638 8.2818 6.63034 8.2104 6.55944C8.13901 6.48853 8.08233 6.40416 8.04366 6.31123C8.005 6.21829 7.9851 6.1186 7.98511 6.01793V6.01192ZM5.21912 6.01192C5.2203 5.86013 5.26636 5.7121 5.35146 5.58647C5.43657 5.46084 5.55692 5.36323 5.69735 5.30596C5.83778 5.2487 5.992 5.23435 6.14058 5.26468C6.28916 5.29502 6.42543 5.36871 6.53224 5.47646C6.63905 5.58421 6.71161 5.7212 6.74076 5.87016C6.76991 6.01912 6.75434 6.17337 6.69604 6.3135C6.63774 6.45362 6.53931 6.57336 6.41315 6.65757C6.28698 6.74178 6.13874 6.78671 5.9871 6.78671C5.88551 6.78753 5.78481 6.76799 5.69087 6.72927C5.59693 6.69055 5.51164 6.63342 5.44009 6.56123C5.36853 6.48904 5.31215 6.40325 5.27419 6.30892C5.23624 6.21459 5.21751 6.1136 5.21912 6.01192ZM2.45312 6.01192C2.45312 5.85987 2.49816 5.71124 2.58254 5.58482C2.66693 5.45839 2.78689 5.35986 2.92722 5.30167C3.06756 5.24349 3.22195 5.22828 3.37092 5.25794C3.5199 5.2876 3.65675 5.3608 3.76416 5.46832C3.87157 5.57583 3.94473 5.71282 3.97437 5.86195C4.004 6.01108 3.98877 6.16566 3.93064 6.30613C3.87251 6.44661 3.77408 6.56668 3.64778 6.65115C3.52148 6.73563 3.373 6.7807 3.22111 6.7807C3.01742 6.7807 2.82208 6.69972 2.67805 6.55555C2.53402 6.41138 2.45312 6.21581 2.45312 6.01192Z'
                    fill='white'
                />
            </g>
            <defs>
                <clipPath id='clip0_5382_19741'>
                    <rect width='12' height='12' fill='white' />
                </clipPath>
            </defs>
        </svg>
    )
}

export const IconMediaSubscriptions = () => {
    return (
        <svg
            width='16'
            height='16'
            viewBox='0 0 16 16'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M5.87998 10.5425C2.67998 10.5425 0 11.0847 0 13.2625C0 15.4403 2.68798 16.0003 5.87998 16.0003C9.07198 16.0003 11.76 15.4581 11.76 13.2803C11.76 11.1025 9.07198 10.5425 5.87998 10.5425Z'
                fill='#2894FF'
            />
            <path
                opacity='0.4'
                d='M5.87979 8.47126C6.38407 8.47831 6.88471 8.37494 7.35303 8.167C7.82135 7.95907 8.24819 7.65065 8.60923 7.2594C8.97027 6.86815 9.25844 6.40173 9.45723 5.88673C9.65602 5.37174 9.76156 4.81825 9.76782 4.25793C9.76468 3.69687 9.66196 3.14202 9.46558 2.62512C9.26919 2.10822 8.983 1.6394 8.62334 1.24556C8.26368 0.851724 7.83761 0.540582 7.36958 0.329927C6.90156 0.119273 6.40075 0.0132291 5.8958 0.0179155C5.39151 0.0108678 4.89093 0.11429 4.42261 0.322223C3.95429 0.530157 3.5274 0.838523 3.16636 1.22978C2.80532 1.62103 2.5172 2.0875 2.31841 2.6025C2.11962 3.11749 2.01408 3.67092 2.00781 4.23124C2.01095 4.79114 2.11344 5.34486 2.30942 5.86069C2.50541 6.37651 2.79104 6.84436 3.14995 7.23737C3.50887 7.63038 3.93402 7.94085 4.40107 8.15105C4.86813 8.36126 5.36793 8.46705 5.87183 8.46236'
                fill='#2894FF'
            />
            <path
                opacity='0.4'
                d='M11.336 4.31147C11.3333 5.47444 11.0063 6.60792 10.4 7.55593C10.3864 7.56928 10.3755 7.58566 10.3681 7.60406C10.3606 7.62245 10.3567 7.64242 10.3567 7.6626C10.3567 7.68277 10.3606 7.70269 10.3681 7.72108C10.3755 7.73947 10.3864 7.75591 10.4 7.76926C10.4209 7.77673 10.4433 7.77673 10.4641 7.76926C10.6124 7.79637 10.7619 7.81418 10.9121 7.82259C11.728 7.91113 12.5434 7.64834 13.19 7.08843C13.8367 6.52853 14.2653 5.71422 14.3874 4.81347C14.5095 3.91273 14.3159 2.99428 13.8463 2.24756C13.3768 1.50084 12.6673 0.982794 11.8641 0.800344C11.5823 0.717168 11.2915 0.678267 11 0.684784C10.7825 0.686443 10.5656 0.710261 10.3521 0.75591C10.3206 0.762651 10.2922 0.781539 10.2721 0.809241C10.2628 0.825112 10.2578 0.843637 10.2578 0.862572C10.2578 0.881508 10.2628 0.900033 10.2721 0.915904C10.9154 1.89334 11.2602 3.07388 11.2561 4.28477'
                fill='#2894FF'
            />
            <path
                d='M15.8237 10.8178C15.6097 10.4457 15.3202 10.1345 14.9784 9.90915C14.6367 9.68378 14.2521 9.55047 13.8557 9.51999C12.8675 9.307 11.8621 9.20873 10.8557 9.22669C10.8505 9.23439 10.8477 9.24371 10.8477 9.25333C10.8477 9.26295 10.8505 9.27233 10.8557 9.28002C11.4157 9.58225 13.5757 10.8889 13.3037 13.6622C13.301 13.71 13.3142 13.7572 13.3407 13.7948C13.3673 13.8325 13.4053 13.8581 13.4477 13.8667H13.4957C14.0237 13.7778 15.3997 13.4578 15.8237 12.4622C15.9382 12.202 15.9977 11.9163 15.9977 11.6266C15.9977 11.337 15.9382 11.0513 15.8237 10.7911'
                fill='#2894FF'
            />
        </svg>
    )
}

export const IconMediaClock = () => {
    return (
        <svg
            width='16'
            height='16'
            viewBox='0 0 16 16'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M8 0C6.41775 0 4.87103 0.469192 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.00346627 6.40034 -0.15496 8.00887 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C15.9966 5.87931 15.1527 3.84644 13.6531 2.34688C12.1536 0.847326 10.1207 0.00338499 8 0ZM10.968 10.968C10.8163 11.1167 10.6124 11.2 10.4 11.2C10.1876 11.2 9.98365 11.1167 9.832 10.968L7.432 8.568C7.28465 8.41545 7.20158 8.21209 7.2 8V4C7.2 3.78783 7.28429 3.58434 7.43432 3.43431C7.58435 3.28428 7.78783 3.2 8 3.2C8.21217 3.2 8.41566 3.28428 8.56569 3.43431C8.71572 3.58434 8.8 3.78783 8.8 4V7.672L10.968 9.832C11.1179 9.98304 11.202 10.1872 11.202 10.4C11.202 10.6128 11.1179 10.817 10.968 10.968Z'
                fill='#2894FF'
            />
        </svg>
    )
}

export const IconMediaHeart = () => {
    return (
        <svg
            width='16'
            height='16'
            viewBox='0 0 16 16'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M7.99965 15.9999L7.79164 15.8651C5.95429 14.6583 4.24577 13.2466 2.69565 11.6546C1.62185 10.5104 0.802217 9.12993 0.295648 7.61251C-0.160155 6.16478 -0.120522 4.59484 0.40766 3.17463C0.675355 2.47467 1.08557 1.845 1.60942 1.32995C2.13327 0.814905 2.75799 0.427006 3.43964 0.193566C3.67081 0.109872 3.90933 0.0506393 4.15165 0.0167313H4.24765C4.47023 -0.0168533 4.69482 -0.0337616 4.91967 -0.0338186H5.00766C5.50597 -0.0173093 5.99927 0.0763404 6.47167 0.244091H6.51967L6.59164 0.294615C6.76627 0.352965 6.93507 0.429107 7.09565 0.521974L7.39965 0.656714L7.63163 0.816716C7.66436 0.85102 7.70221 0.87947 7.74365 0.900932C7.81579 0.940858 7.88529 0.985876 7.95165 1.03567C8.82685 0.330243 9.89735 -0.0542602 10.9997 -0.0590808C11.5053 -0.0594598 12.0077 0.0258572 12.4876 0.193566C13.1643 0.423865 13.7845 0.808038 14.3043 1.31885C14.8242 1.82966 15.2309 2.45461 15.4956 3.14936C16.0147 4.5711 16.057 6.13674 15.6157 7.58725C15.1153 9.11027 14.2949 10.4948 13.2157 11.6378C11.6747 13.2268 9.97707 14.6383 8.15165 15.8483L7.95165 15.9746L7.99965 15.9999ZM11.9276 2.62724C11.7934 2.6297 11.6633 2.67543 11.5545 2.75825C11.4458 2.84107 11.3638 2.95701 11.3197 3.09041C11.2708 3.25799 11.285 3.43896 11.3595 3.59576C11.434 3.75256 11.563 3.87315 11.7197 3.93252C11.9718 4.03718 12.1882 4.2192 12.3409 4.45495C12.4935 4.69071 12.5753 4.96933 12.5756 5.25463C12.5588 5.44297 12.6134 5.63067 12.7276 5.77673C12.7836 5.84826 12.853 5.90687 12.9314 5.94889C13.0099 5.99091 13.0958 6.01542 13.1836 6.02092C13.346 6.01702 13.5011 5.9491 13.6181 5.83057C13.7352 5.71204 13.8057 5.55158 13.8157 5.38094V5.28829C13.8285 4.71479 13.6733 4.15104 13.3714 3.6735C13.0694 3.19595 12.6352 2.82775 12.1276 2.61883C12.0688 2.61538 12.0099 2.61818 11.9517 2.62724H11.9276Z'
                fill='#2894FF'
            />
        </svg>
    )
}

export const IconOptionsReport = ({ color = '#778797' }: SVGProps) => {
    return (
        <svg
            width='16'
            height='20'
            viewBox='0 0 16 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M0 0V20H1.45248V13.7102L14.4567 7.86808L16 7.18492L14.4567 6.50177L1.02128 0.471143L0 0ZM1.45248 2.28504L12.3461 7.18492L1.45248 12.0848V2.28504Z'
                fill={color}
            />
        </svg>
    )
}

export const IconOptionsCopy = ({ color = '#778797' }: SVGProps) => {
    return (
        <svg
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M5 0C4.43168 0 3.88663 0.225765 3.48477 0.627628C3.08291 1.02949 2.85714 1.57454 2.85714 2.14286C2.85714 2.3323 2.9324 2.51398 3.06635 2.64793C3.20031 2.78189 3.38199 2.85714 3.57143 2.85714C3.76087 2.85714 3.94255 2.78189 4.0765 2.64793C4.21046 2.51398 4.28571 2.3323 4.28571 2.14286C4.28571 1.95342 4.36097 1.77174 4.49492 1.63778C4.62888 1.50383 4.81056 1.42857 5 1.42857H17.8571C18.0466 1.42857 18.2283 1.50383 18.3622 1.63778C18.4962 1.77174 18.5714 1.95342 18.5714 2.14286V15C18.5714 15.1894 18.4962 15.3711 18.3622 15.5051C18.2283 15.639 18.0466 15.7143 17.8571 15.7143C17.6677 15.7143 17.486 15.7895 17.3521 15.9235C17.2181 16.0574 17.1429 16.2391 17.1429 16.4286C17.1429 16.618 17.2181 16.7997 17.3521 16.9336C17.486 17.0676 17.6677 17.1429 17.8571 17.1429C18.4255 17.1429 18.9705 16.9171 19.3724 16.5152C19.7742 16.1134 20 15.5683 20 15V2.14286C20 1.57454 19.7742 1.02949 19.3724 0.627628C18.9705 0.225765 18.4255 0 17.8571 0H5ZM2.14286 4.57143C1.57454 4.57143 1.02949 4.79719 0.627628 5.19906C0.225765 5.60092 0 6.14596 0 6.71429V17.8571C0 18.4255 0.225765 18.9705 0.627628 19.3724C1.02949 19.7742 1.57454 20 2.14286 20H13.2857C13.854 20 14.3991 19.7742 14.8009 19.3724C15.2028 18.9705 15.4286 18.4255 15.4286 17.8571V6.71429C15.4286 6.14596 15.2028 5.60092 14.8009 5.19906C14.3991 4.79719 13.854 4.57143 13.2857 4.57143H2.14286ZM2.14286 6H13.2857C13.4752 6 13.6568 6.07526 13.7908 6.20921C13.9247 6.34316 14 6.52485 14 6.71429V17.8571C14 18.0466 13.9247 18.2283 13.7908 18.3622C13.6568 18.4962 13.4752 18.5714 13.2857 18.5714H2.14286C1.95342 18.5714 1.77174 18.4962 1.63778 18.3622C1.50383 18.2283 1.42857 18.0466 1.42857 17.8571V6.71429C1.42857 6.52485 1.50383 6.34316 1.63778 6.20921C1.77174 6.07526 1.95342 6 2.14286 6Z'
                fill={color}
            />
        </svg>
    )
}

export const IconOptionsHide = ({ color = '#778797' }: SVGProps) => {
    return (
        <svg
            width='20'
            height='18'
            viewBox='0 0 20 18'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M1.57916 17.7777C1.44204 17.644 1.35835 17.4599 1.34534 17.263C1.33232 17.0661 1.39096 16.8715 1.50916 16.7189L1.57916 16.6236L3.57916 14.5696C2.07004 13.0886 0.876802 11.2837 0.0791626 9.27543C0.0398335 9.17656 0.0195313 9.07032 0.0195312 8.96303C0.0195313 8.85575 0.0398335 8.74951 0.0791626 8.65063C0.980644 6.35177 2.41065 4.32812 4.23914 2.76364C5.88116 1.39376 7.90868 0.644612 9.99915 0.635397C11.8885 0.649485 13.7282 1.27778 15.2692 2.43535L17.3591 0.254237C17.4998 0.105524 17.6904 0.0219727 17.8892 0.0219727C18.0879 0.0219727 18.2785 0.105524 18.4191 0.254237C18.5563 0.387904 18.6399 0.572044 18.653 0.768914C18.666 0.965783 18.6073 1.16047 18.4891 1.31306L18.4191 1.39772L2.63916 17.8413C2.56566 17.9109 2.47992 17.9645 2.38684 17.999C2.29376 18.0335 2.19514 18.0482 2.09668 18.0423C1.99822 18.0364 1.90186 18.01 1.81305 17.9646C1.72424 17.9192 1.64477 17.8556 1.57916 17.7777ZM5.14917 4.01298C3.62632 5.31916 2.41672 6.98819 1.61914 8.88367V8.98953V9.09539C2.32727 10.7635 3.34789 12.262 4.61914 13.5001L6.75916 11.2766C6.32358 10.6036 6.09321 9.80539 6.09912 8.98953C6.10705 7.90179 6.52213 6.86173 7.25323 6.09754C7.98434 5.33335 8.97182 4.90745 9.99915 4.91309C10.7778 4.91536 11.539 5.15814 12.1891 5.61182L14.1891 3.49417C12.9479 2.61785 11.491 2.1467 9.99915 2.13897C8.2278 2.16897 6.51829 2.83319 5.14917 4.02358V4.01298ZM7.58917 8.98953C7.57879 9.38835 7.66845 9.7829 7.84912 10.133L11.0892 6.74483C10.7503 6.5677 10.377 6.47704 9.99915 6.48012C9.68576 6.47593 9.37466 6.53725 9.08374 6.66069C8.79282 6.78413 8.52782 6.96723 8.30389 7.19941C8.07997 7.43158 7.90152 7.70831 7.77887 8.01369C7.65622 8.31906 7.59178 8.6471 7.58917 8.97893V8.98953ZM7.22913 16.9095C7.13692 16.8794 7.05131 16.8302 6.97717 16.7647C6.90303 16.6993 6.84188 16.6191 6.79724 16.5285C6.7526 16.4379 6.72535 16.3388 6.7171 16.237C6.70885 16.1352 6.71974 16.0327 6.74915 15.9353C6.78018 15.8304 6.83149 15.7335 6.89978 15.6506C6.96807 15.5677 7.05186 15.5007 7.14587 15.4539C7.23989 15.4071 7.34208 15.3816 7.44592 15.3788C7.54977 15.376 7.65301 15.396 7.74915 15.4377C8.48716 15.6998 9.26071 15.8321 10.0391 15.8295C13.3391 15.8295 16.4191 13.4366 18.3091 9.34949L18.4691 9.01073V8.88367C18.0998 8.06789 17.6684 7.28522 17.1791 6.54359L16.9391 6.19422C16.8266 6.03357 16.7783 5.8325 16.8044 5.63444C16.8306 5.43637 16.9293 5.25716 17.0792 5.1354C17.2341 5.02617 17.4215 4.98089 17.6058 5.00821C17.7901 5.03554 17.9585 5.13358 18.0792 5.28365C18.8347 6.34808 19.469 7.50311 19.9691 8.72482C20.0084 8.8237 20.0287 8.92994 20.0287 9.03722C20.0287 9.14451 20.0084 9.25062 19.9691 9.34949C17.8891 14.3577 14.1692 17.4283 10.0292 17.4283C9.07589 17.4219 8.12999 17.2503 7.22913 16.9201V16.9095ZM9.82916 12.3671C9.79698 12.1624 9.84172 11.9526 9.95386 11.7824C10.066 11.6122 10.2366 11.4952 10.4291 11.4565C10.9064 11.3701 11.3472 11.1311 11.6923 10.7714C12.0373 10.4117 12.27 9.94868 12.3591 9.44475C12.3926 9.25703 12.4889 9.08839 12.6304 8.96976C12.7718 8.85112 12.9489 8.79047 13.1292 8.79889H13.2291C13.4227 8.83264 13.5958 8.94639 13.7101 9.11516C13.8245 9.28393 13.8709 9.494 13.8392 9.69899C13.6913 10.5184 13.3119 11.271 12.7512 11.8571C12.1905 12.4432 11.4749 12.8353 10.6992 12.9813H10.5591C10.3857 12.9796 10.2182 12.9144 10.0851 12.7966C9.95198 12.6789 9.86153 12.5159 9.82916 12.3354V12.3671Z'
                fill={color}
            />
        </svg>
    )
}

export const IconGif = () => {
    return (
        <svg
            width='26'
            height='26'
            viewBox='0 0 26 26'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g clipPath='url(#clip0_4945_41118)'>
                <path
                    d='M13 0C5.82029 0 0 5.82029 0 13C0 20.1797 5.82029 25.9999 13 25.9999C20.1797 25.9999 25.9999 20.1797 25.9999 13C25.9923 5.8235 20.1765 0.00767159 13 0ZM13 24.1428C6.84594 24.1428 1.85712 19.154 1.85712 13C1.85712 6.84594 6.84594 1.85712 13 1.85712C19.154 1.85712 24.1428 6.84594 24.1428 13C24.1362 19.1513 19.1513 24.1362 13 24.1428Z'
                    fill='#778797'
                />
                <path
                    d='M18.0674 11.1858V12.5847H20.1375C20.6139 12.5847 21 12.9761 21 13.459C21 13.9419 20.6139 14.3333 20.1375 14.3333H18.0674V16.1257C18.0674 16.6086 17.6813 17 17.2049 17C16.7286 17 16.3423 16.6086 16.3423 16.1257V11.1858C16.3423 9.98053 17.3096 9 18.4987 9H20.1375C20.6139 9 21 9.39139 21 9.87432C21 10.3572 20.6139 10.7486 20.1375 10.7486H18.4987C18.261 10.7486 18.0674 10.9447 18.0674 11.1858ZM10.3046 12.6284H8.79515C8.3189 12.6284 7.93261 13.0198 7.93261 13.5027C7.93261 13.9857 8.3189 14.377 8.79515 14.377H9.39825C9.20266 14.9013 8.69879 15.2514 8.10512 15.2514C7.34417 15.2514 6.72507 14.6238 6.72507 13.8525V12.1913C6.72507 11.4199 7.34417 10.7923 8.10512 10.7923C8.59097 10.7923 9.03235 11.0441 9.28538 11.4655C9.53302 11.8781 10.0637 12.0089 10.4707 11.7577C10.8775 11.5067 11.0066 10.9688 10.7589 10.5564C10.1902 9.60912 9.19811 9.04372 8.10512 9.04372C6.39303 9.04372 5 10.4558 5 12.1913V13.8525C5 15.5879 6.39303 17 8.10512 17C8.82631 17 9.52695 16.7515 10.0782 16.3005C10.6312 15.8478 11.0121 15.2097 11.1506 14.5039C11.1616 14.4477 11.1671 14.3905 11.1671 14.3333V13.5027C11.1671 13.0198 10.781 12.6284 10.3046 12.6284ZM13.7547 9C13.2785 9 12.8922 9.39139 12.8922 9.87432V16.1257C12.8922 16.6086 13.2785 17 13.7547 17C14.2311 17 14.6173 16.6086 14.6173 16.1257V9.87432C14.6173 9.39139 14.2311 9 13.7547 9Z'
                    fill='#778797'
                />
            </g>
            <defs>
                <clipPath id='clip0_4945_41118'>
                    <rect width='26' height='26' fill='white' />
                </clipPath>
            </defs>
        </svg>
    )
}

export const IconDollarCircleArrowsNoShadow = () => {
    return (
        <svg
            width='40'
            height='40'
            viewBox='0 0 40 40'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M19.9996 32.8954C27.1186 32.8954 32.8898 27.1205 32.8898 19.9969C32.8898 12.8732 27.1186 7.09827 19.9996 7.09827C12.8805 7.09827 7.10938 12.8732 7.10938 19.9969C7.10938 27.1205 12.8805 32.8954 19.9996 32.8954Z'
                fill='url(#paint0_linear_5904_22984)'
            />
            <path
                d='M21.1717 27.0324C21.1717 27.6805 20.6476 28.205 19.9999 28.205C19.3522 28.205 18.828 27.6805 18.828 27.0324V25.6369C18.1876 25.41 17.6131 25.0194 17.1893 24.4547C16.8002 23.9371 16.9032 23.2019 17.4204 22.8126C17.9332 22.4255 18.6701 22.524 19.0615 23.0439C19.6794 23.8661 21.1717 23.3599 21.1717 22.342C21.1717 21.695 20.6453 21.1694 19.9999 21.1694C18.0614 21.1694 16.4844 19.5914 16.4844 17.6516C16.4844 16.1248 17.467 14.8354 18.828 14.3498V12.9612C18.828 12.313 19.3522 11.7886 19.9999 11.7886C20.6476 11.7886 21.1717 12.313 21.1717 12.9612V14.3566C21.8122 14.5835 22.3867 14.9741 22.8105 15.5389C23.1995 16.0564 23.0966 16.7917 22.5793 17.181C22.0666 17.568 21.3319 17.4684 20.9383 16.9497C20.714 16.6507 20.3707 16.479 19.9999 16.479C19.3544 16.479 18.828 17.0046 18.828 17.6516C18.828 18.2985 19.3544 18.8242 19.9999 18.8242C21.9384 18.8242 23.5154 20.4022 23.5154 22.342C23.5154 23.8687 22.5328 25.1582 21.1717 25.6438V27.0324Z'
                fill='#EDF7FF'
            />
            <path
                d='M7.49169 7.48157C13.6013 1.36584 23.1238 0.718328 29.975 5.50839C29.4456 5.45797 28.9288 5.75433 28.7518 6.28153C28.5482 6.89644 28.88 7.5606 29.4934 7.76557L34.4668 9.42253C34.8677 9.55879 35.3376 9.46662 35.6661 9.1397C35.9797 8.82591 36.0896 8.36101 35.95 7.93958L34.2929 2.96409C34.0869 2.34918 33.4209 2.02163 32.8098 2.22316C32.1964 2.42696 31.8645 3.0912 32.0683 3.70611L32.2607 4.28256C24.4477 -1.89821 13.0456 -1.39227 5.83463 5.82343C0.561369 11.1001 -1.31537 18.8125 0.936747 25.95C1.13354 26.5735 1.79445 26.9081 2.40615 26.7161C3.0241 26.5203 3.3651 25.8618 3.17058 25.2446C1.18393 18.943 2.83864 12.1376 7.49169 7.48157ZM39.0632 14.0437C38.8687 13.4264 38.2141 13.0898 37.5938 13.2776C36.9759 13.4734 36.6349 14.1318 36.8294 14.749C38.816 21.0506 37.1612 27.856 32.5082 32.5121C26.3986 38.6278 16.8762 39.2753 10.025 34.4853C10.5555 34.5359 11.0712 34.2405 11.2481 33.7121C11.4518 33.0972 11.1199 32.4331 10.5066 32.2281L5.53316 30.5711C5.112 30.4292 4.64967 30.5425 4.33382 30.854C4.02024 31.1677 3.9104 31.6326 4.05 32.0541L5.70706 37.0296C5.91174 37.6396 6.57218 37.9766 7.19013 37.7705C7.80355 37.5667 8.13541 36.9025 7.93167 36.2875L7.73926 35.7111C11.3441 38.5627 15.7081 40 20.078 40C25.1796 40 30.2812 38.0568 34.1652 34.1702C39.4386 28.8935 41.3153 21.1812 39.0632 14.0437Z'
                fill='url(#paint1_linear_5904_22984)'
            />
            <defs>
                <linearGradient
                    id='paint0_linear_5904_22984'
                    x1='19.9996'
                    y1='32.8954'
                    x2='19.9996'
                    y2='7.09827'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#3C9FFF' />
                    <stop offset='1' stopColor='#76C0FF' />
                </linearGradient>
                <linearGradient
                    id='paint1_linear_5904_22984'
                    x1='20'
                    y1='40'
                    x2='20'
                    y2='0'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#3C9FFF' />
                    <stop offset='1' stopColor='#76C0FF' />
                </linearGradient>
            </defs>
        </svg>
    )
}

export const IconDotInCircle = ({
    color = '#F0F0F0',
    backgroundColor = 'white',
    width = '20',
    height = '20'
}: SVGProps) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox='0 0 20 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <rect
                x='1.5'
                y='1.5'
                width='17'
                height='17'
                rx='8.5'
                fill={backgroundColor}
                stroke={color}
                strokeWidth='3'
            />
            <path
                d='M10 6C7.79431 6 6 7.79431 6 10C6 12.2057 7.79431 14 10 14C12.2057 14 14 12.2057 14 10C14 7.79431 12.2057 6 10 6Z'
                fill={color}
            />
        </svg>
    )
}

export const IconDollarCircleArrowsOutline = ({
    color = '#CFD0DA',
    width = '40',
    height = '40'
}: SVGProps) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox='0 0 40 40'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g clipPath='url(#clip0_5684_30473)'>
                <path
                    d='M7.01367 20C7.01367 27.1609 12.8395 32.9869 20.0004 32.9869C27.1613 32.9869 32.9871 27.1609 32.9871 20C32.9871 12.8392 27.1613 7.01318 20.0004 7.01318C12.8395 7.01318 7.01367 12.8392 7.01367 20ZM31.1401 20C31.1401 26.1426 26.1428 31.1399 20.0004 31.1399C13.858 31.1399 8.86072 26.1426 8.86072 20C8.86072 13.8575 13.858 8.86023 20.0004 8.86023C26.1428 8.86023 31.1401 13.8575 31.1401 20Z'
                    fill={color}
                />
                <path
                    d='M19.1689 12.7233V14.1699C18.6492 14.2899 18.1587 14.5156 17.7073 14.849C16.4721 15.7606 15.917 17.0238 16.2222 18.2282C16.5159 19.3864 17.5696 20.2282 18.9723 20.4249C22.1525 20.8705 22.6702 21.3454 22.534 22.4593C22.4615 23.0528 22.1204 23.4778 21.5201 23.7217C20.5053 24.1345 18.7461 23.9594 17.1023 22.6385L15.9453 24.0783C16.9392 24.877 18.062 25.4057 19.1687 25.6364V27.2766H21.0157V25.7334C21.4348 25.6849 21.8382 25.5861 22.2157 25.4326C23.4301 24.9389 24.2143 23.9368 24.3675 22.6831C24.5414 21.2601 23.9832 20.159 22.7534 19.4989C21.8004 18.9872 20.5423 18.7795 19.2286 18.5954C18.5743 18.5038 18.1198 18.1967 18.0127 17.7741C17.8983 17.323 18.1942 16.7851 18.8041 16.3349C19.4499 15.8583 20.211 15.7881 21.1309 16.1201C21.9113 16.402 22.4863 16.8736 22.492 16.8783L23.0834 16.169L23.6775 15.4618C23.5979 15.395 22.8693 14.7973 21.8189 14.4052C21.5476 14.3039 21.2797 14.2265 21.0158 14.1709V12.7231L19.1689 12.7233Z'
                    fill={color}
                />
                <path
                    d='M20 1.84705C23.9724 1.84705 27.7511 3.11622 30.873 5.46075H28.4442V7.3078H34.3874V1.3646H32.5404V4.41827C28.9972 1.5562 24.6173 0 20 0C8.97199 0 0 8.97199 0 20H1.84705C1.84705 9.99046 9.99046 1.84705 20 1.84705Z'
                    fill={color}
                />
                <path
                    d='M38.1537 20C38.1537 30.0095 30.0103 38.153 20.0008 38.153C16.141 38.153 12.4536 36.9503 9.37946 34.7248H11.7909V32.8778H5.84766V38.821H7.69471V35.7668C11.1975 38.5094 15.4922 40 20.0008 40C31.0289 40 40.0007 31.0281 40.0007 20H38.1537Z'
                    fill={color}
                />
            </g>
            <defs>
                <clipPath id='clip0_5684_30473'>
                    <rect width='40' height='40' fill='white' />
                </clipPath>
            </defs>
        </svg>
    )
}

export const IconHeartAddOutline = () => {
    return (
        <svg
            width='18'
            height='18'
            viewBox='0 0 18 18'
            fill='none'
            version='1.1'
            id='svg27'
        >
            <defs id='defs31' />

            <mask
                id='path-1-outside-1_4945_40322'
                maskUnits='userSpaceOnUse'
                x='0'
                y='0.000854492'
                width='18'
                height='18'
                fill='black'
            >
                <rect
                    fill='white'
                    y='0.000854492'
                    width='18'
                    height='18'
                    id='rect18'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M8.52517 16.798L8.71707 16.9159L8.69306 16.9074C8.78427 16.9671 8.88952 16.9987 8.99691 16.9987C9.00381 16.9987 9.0107 16.9986 9.01758 16.9983V15.6621C7.40594 14.6103 5.90819 13.3759 4.55113 11.9811C3.60979 10.9923 2.89353 9.79177 2.45618 8.46954C2.06595 7.26158 2.10286 5.94584 2.56014 4.76425C2.77814 4.21822 3.10521 3.72801 3.51913 3.32696C3.93305 2.92591 4.42412 2.62341 4.95894 2.44003L4.97494 2.43161C5.56725 2.23234 6.19493 2.17803 6.81016 2.27289C7.42539 2.36774 8.01196 2.60928 8.52517 2.97899L8.6851 3.0969C8.78447 3.17482 8.90504 3.21686 9.02892 3.21686C9.15281 3.21686 9.27338 3.17482 9.37275 3.0969C9.89623 2.68623 10.5049 2.41248 11.1486 2.29828C11.7923 2.18407 12.4525 2.23266 13.0749 2.44003C13.6107 2.62383 14.1025 2.92743 14.5165 3.33004C14.9305 3.73266 15.2571 4.22479 15.4737 4.77268C15.9351 5.95627 15.9721 7.27624 15.5777 8.4864C15.5203 8.65976 15.4582 8.83103 15.3914 9.00001H16.6378C16.6525 8.95803 16.6669 8.91593 16.6811 8.87373C17.1697 7.35871 17.1127 5.70745 16.5212 4.23372C16.2362 3.53416 15.8117 2.9074 15.2764 2.39594C14.7411 1.88447 14.1075 1.50025 13.4187 1.2695L13.2108 1.20216C12.5446 1.00741 11.8485 0.953229 11.1623 1.04283C10.4762 1.13243 9.81366 1.36404 9.21282 1.72427L8.99691 1.85903L8.78105 1.72427C8.14937 1.34646 7.45006 1.11093 6.72744 1.03265C6.00481 0.954376 5.27463 1.03502 4.58315 1.2695C3.89565 1.49838 3.26318 1.88105 2.72909 2.39121C2.19501 2.90136 1.77191 3.52696 1.4887 4.22529C0.897664 5.69621 0.840738 7.34463 1.32877 8.85687C1.82174 10.3687 2.64316 11.7384 3.72757 12.8569C5.18364 14.3532 6.79266 15.6749 8.52517 16.798Z'
                    id='path20'
                />
            </mask>
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M8.52517 16.798L8.71707 16.9159L8.69306 16.9074C8.78427 16.9671 8.88952 16.9987 8.99691 16.9987C9.00381 16.9987 9.0107 16.9986 9.01758 16.9983V15.6621C7.40594 14.6103 5.90819 13.3759 4.55113 11.9811C3.60979 10.9923 2.89353 9.79177 2.45618 8.46954C2.06595 7.26158 2.10286 5.94584 2.56014 4.76425C2.77814 4.21822 3.10521 3.72801 3.51913 3.32696C3.93305 2.92591 4.42412 2.62341 4.95894 2.44003L4.97494 2.43161C5.56725 2.23234 6.19493 2.17803 6.81016 2.27289C7.42539 2.36774 8.01196 2.60928 8.52517 2.97899L8.6851 3.0969C8.78447 3.17482 8.90504 3.21686 9.02892 3.21686C9.15281 3.21686 9.27338 3.17482 9.37275 3.0969C9.89623 2.68623 10.5049 2.41248 11.1486 2.29828C11.7923 2.18407 12.4525 2.23266 13.0749 2.44003C13.6107 2.62383 14.1025 2.92743 14.5165 3.33004C14.9305 3.73266 15.2571 4.22479 15.4737 4.77268C15.9351 5.95627 15.9721 7.27624 15.5777 8.4864C15.5203 8.65976 15.4582 8.83103 15.3914 9.00001H16.6378C16.6525 8.95803 16.6669 8.91593 16.6811 8.87373C17.1697 7.35871 17.1127 5.70745 16.5212 4.23372C16.2362 3.53416 15.8117 2.9074 15.2764 2.39594C14.7411 1.88447 14.1075 1.50025 13.4187 1.2695L13.2108 1.20216C12.5446 1.00741 11.8485 0.953229 11.1623 1.04283C10.4762 1.13243 9.81366 1.36404 9.21282 1.72427L8.99691 1.85903L8.78105 1.72427C8.14937 1.34646 7.45006 1.11093 6.72744 1.03265C6.00481 0.954376 5.27463 1.03502 4.58315 1.2695C3.89565 1.49838 3.26318 1.88105 2.72909 2.39121C2.19501 2.90136 1.77191 3.52696 1.4887 4.22529C0.897664 5.69621 0.840738 7.34463 1.32877 8.85687C1.82174 10.3687 2.64316 11.7384 3.72757 12.8569C5.18364 14.3532 6.79266 15.6749 8.52517 16.798Z'
                fill='#778797'
                id='path23'
            />
            <path
                d='M8.71707 16.9159L8.65083 17.1046L8.82177 16.7455L8.71707 16.9159ZM8.52517 16.798L8.41636 16.9658L8.42047 16.9684L8.52517 16.798ZM8.69306 16.9074L8.7593 16.7187L8.58354 17.0748L8.69306 16.9074ZM9.01758 16.9983L9.02514 17.1982L9.21758 17.1909V16.9983H9.01758ZM9.01758 15.6621H9.21758V15.5538L9.12689 15.4946L9.01758 15.6621ZM4.55113 11.9811L4.40627 12.119L4.40778 12.1205L4.55113 11.9811ZM2.45618 8.46954L2.26586 8.53102L2.2663 8.53234L2.45618 8.46954ZM2.56014 4.76425L2.37438 4.69009L2.37362 4.69207L2.56014 4.76425ZM3.51913 3.32696L3.6583 3.4706L3.51913 3.32696ZM4.95894 2.44003L5.02381 2.62922L5.03844 2.62421L5.05212 2.617L4.95894 2.44003ZM4.97494 2.43161L4.91117 2.24205L4.89596 2.24716L4.88176 2.25464L4.97494 2.43161ZM8.52517 2.97899L8.64386 2.818L8.64208 2.81672L8.52517 2.97899ZM8.6851 3.0969L8.80857 2.93945L8.80378 2.93592L8.6851 3.0969ZM9.37275 3.0969L9.49616 3.25428L9.49619 3.25426L9.37275 3.0969ZM11.1486 2.29828L11.1836 2.4952L11.1486 2.29828ZM13.0749 2.44003L13.1398 2.25085L13.1381 2.25029L13.0749 2.44003ZM15.4737 4.77268L15.66 4.70004L15.6597 4.69915L15.4737 4.77268ZM15.5777 8.4864L15.7675 8.5492L15.7678 8.54837L15.5777 8.4864ZM15.3914 9.00001L15.2054 8.92647L15.0972 9.20001H15.3914V9.00001ZM16.6378 9.00001V9.20001H16.7797L16.8265 9.06607L16.6378 9.00001ZM16.6811 8.87373L16.8707 8.93751L16.8715 8.93512L16.6811 8.87373ZM16.5212 4.23372L16.7068 4.15922L16.7064 4.15828L16.5212 4.23372ZM15.2764 2.39594L15.1382 2.54054L15.2764 2.39594ZM13.4187 1.2695L13.4823 1.07985L13.4803 1.07923L13.4187 1.2695ZM13.2108 1.20216L13.2725 1.01182L13.2669 1.0102L13.2108 1.20216ZM11.1623 1.04283L11.1882 1.24115L11.1623 1.04283ZM9.21282 1.72427L9.10996 1.5527L9.10692 1.5546L9.21282 1.72427ZM8.99691 1.85903L8.89099 2.02868L8.9969 2.0948L9.10281 2.02869L8.99691 1.85903ZM8.78105 1.72427L8.88699 1.55458L8.88371 1.55262L8.78105 1.72427ZM6.72744 1.03265L6.7059 1.23149L6.72744 1.03265ZM4.58315 1.2695L4.64633 1.45926L4.64737 1.4589L4.58315 1.2695ZM2.72909 2.39121L2.59095 2.24658L2.72909 2.39121ZM1.4887 4.22529L1.30336 4.15013L1.30312 4.15073L1.4887 4.22529ZM1.32877 8.85687L1.13843 8.9183L1.13862 8.91888L1.32877 8.85687ZM3.72757 12.8569L3.58398 12.9961L3.58424 12.9964L3.72757 12.8569ZM8.82177 16.7455L8.62987 16.6276L8.42047 16.9684L8.61237 17.0863L8.82177 16.7455ZM8.62681 17.0962L8.65083 17.1046L8.78331 16.7272L8.7593 16.7187L8.62681 17.0962ZM8.99691 16.7987C8.92899 16.7987 8.86171 16.7788 8.80257 16.7401L8.58354 17.0748C8.70683 17.1555 8.85005 17.1987 8.99691 17.1987V16.7987ZM9.01001 16.7985C9.00567 16.7986 9.0013 16.7987 8.99691 16.7987V17.1987C9.00632 17.1987 9.01573 17.1986 9.02514 17.1982L9.01001 16.7985ZM9.21758 16.9983V15.6621H8.81758V16.9983H9.21758ZM4.40778 12.1205C5.775 13.5258 7.28415 14.7696 8.90827 15.8296L9.12689 15.4946C7.52774 14.451 6.04138 13.226 4.69448 11.8416L4.40778 12.1205ZM2.2663 8.53234C2.71273 9.88205 3.44415 11.1084 4.40628 12.119L4.69598 11.8431C3.77543 10.8762 3.07433 9.70149 2.64607 8.40673L2.2663 8.53234ZM2.37362 4.69207C1.89974 5.91655 1.86155 7.27948 2.26587 8.53102L2.6465 8.40806C2.27034 7.24368 2.30598 5.97513 2.74666 4.83644L2.37362 4.69207ZM3.37996 3.18332C2.94537 3.6044 2.60264 4.11842 2.37439 4.69009L2.74588 4.83841C2.95365 4.31801 3.26505 3.85162 3.6583 3.4706L3.37996 3.18332ZM4.89407 2.25085C4.33089 2.44395 3.81458 2.76222 3.37996 3.18332L3.6583 3.4706C4.05152 3.0896 4.51736 2.80287 5.02381 2.62922L4.89407 2.25085ZM4.88176 2.25464L4.86575 2.26307L5.05212 2.617L5.06813 2.60857L4.88176 2.25464ZM6.84064 2.07522C6.19365 1.97547 5.53366 2.03262 4.91117 2.24205L5.03872 2.62117C5.60084 2.43205 6.1962 2.38059 6.77968 2.47055L6.84064 2.07522ZM8.64208 2.81672C8.10369 2.42887 7.4876 2.17497 6.84064 2.07522L6.77968 2.47055C7.36319 2.56052 7.92023 2.78969 8.40827 3.14127L8.64208 2.81672ZM8.80378 2.93592L8.64385 2.81801L8.40649 3.13998L8.56642 3.25788L8.80378 2.93592ZM9.02892 3.01686C8.95067 3.01686 8.87337 2.99038 8.80852 2.93952L8.56169 3.25428C8.69556 3.35926 8.85941 3.41686 9.02892 3.41686V3.01686ZM9.24933 2.93952C9.18448 2.99038 9.10718 3.01686 9.02892 3.01686V3.41686C9.19844 3.41686 9.36229 3.35926 9.49616 3.25428L9.24933 2.93952ZM11.1137 2.10135C10.4371 2.2214 9.79812 2.509 9.2493 2.93954L9.49619 3.25426C9.99435 2.86346 10.5728 2.60357 11.1836 2.4952L11.1137 2.10135ZM13.1381 2.25029C12.4843 2.03242 11.7903 1.98131 11.1137 2.10135L11.1836 2.4952C11.7943 2.38684 12.4208 2.4329 13.0117 2.62978L13.1381 2.25029ZM14.6559 3.18666C14.2212 2.76388 13.7041 2.44442 13.1398 2.25085L13.01 2.62922C13.5174 2.80324 13.9838 3.09098 14.3771 3.47343L14.6559 3.18666ZM15.6597 4.69915C15.4329 4.12548 15.0907 3.6094 14.6559 3.18666L14.3771 3.47343C14.7704 3.85591 15.0813 4.32409 15.2877 4.84622L15.6597 4.69915ZM15.7678 8.54837C16.1765 7.29434 16.1383 5.9268 15.66 4.70004L15.2874 4.84533C15.732 5.98574 15.7676 7.25813 15.3875 8.42442L15.7678 8.54837ZM15.5773 9.07355C15.6456 8.90103 15.709 8.72618 15.7675 8.5492L15.3878 8.42359C15.3316 8.59334 15.2708 8.76103 15.2054 8.92647L15.5773 9.07355ZM15.3914 9.20001H16.6378V8.80001H15.3914V9.20001ZM16.4915 8.80996C16.4776 8.85139 16.4634 8.89272 16.449 8.93395L16.8265 9.06607C16.8415 9.02333 16.8562 8.98047 16.8707 8.9375L16.4915 8.80996ZM16.3356 4.30823C16.9097 5.73849 16.965 7.34167 16.4908 8.81235L16.8715 8.93512C17.3743 7.37575 17.3158 5.67641 16.7068 4.15922L16.3356 4.30823ZM15.1382 2.54054C15.6527 3.03213 16.0614 3.63517 16.3359 4.30917L16.7064 4.15828C16.4111 3.43314 15.9707 2.78267 15.4145 2.25133L15.1382 2.54054ZM13.3552 1.45914C14.0155 1.68037 14.6237 2.04898 15.1382 2.54054L15.4145 2.25133C14.8584 1.71996 14.1995 1.32014 13.4823 1.07986L13.3552 1.45914ZM13.1492 1.39244L13.3571 1.45977L13.4803 1.07923L13.2724 1.01189L13.1492 1.39244ZM11.1882 1.24115C11.8468 1.15515 12.515 1.20712 13.1547 1.39413L13.2669 1.0102C12.5742 0.807692 11.8501 0.751311 11.1364 0.844515L11.1882 1.24115ZM9.31566 1.8958C9.89327 1.54951 10.5297 1.32715 11.1882 1.24115L11.1364 0.844515C10.4227 0.937717 9.73405 1.17858 9.10998 1.55273L9.31566 1.8958ZM9.10281 2.02869L9.31872 1.89393L9.10692 1.5546L8.89101 1.68937L9.10281 2.02869ZM8.67513 1.89392L8.89099 2.02868L9.10283 1.68938L8.88697 1.55461L8.67513 1.89392ZM6.7059 1.23149C7.39946 1.30662 8.07115 1.53272 8.67839 1.89591L8.88371 1.55262C8.22759 1.16021 7.50066 0.915244 6.74898 0.833817L6.7059 1.23149ZM4.64737 1.4589C5.31142 1.23373 6.01234 1.15636 6.7059 1.23149L6.74898 0.833817C5.99728 0.75239 5.23783 0.836315 4.51892 1.08009L4.64737 1.4589ZM2.86724 2.53583C3.3804 2.04566 3.9874 1.67863 4.64632 1.45926L4.51997 1.07974C3.8039 1.31814 3.14596 1.71645 2.59095 2.24658L2.86724 2.53583ZM1.67404 4.30046C1.94684 3.62781 2.35405 3.02603 2.86724 2.53583L2.59095 2.24658C2.03597 2.77669 1.59699 3.42611 1.30336 4.15013L1.67404 4.30046ZM1.5191 8.79545C1.04539 7.32759 1.10072 5.72728 1.67428 4.29986L1.30312 4.15073C0.694608 5.66514 0.636082 7.36168 1.13844 8.9183L1.5191 8.79545ZM3.87116 12.7177C2.80839 11.6215 2.00265 10.2784 1.51892 8.79487L1.13862 8.91888C1.64083 10.459 2.47792 11.8553 3.58398 12.9961L3.87116 12.7177ZM8.63396 16.6301C6.91412 15.5153 5.31667 14.2031 3.8709 12.7174L3.58424 12.9964C5.05061 14.5032 6.67119 15.8346 8.41639 16.9658L8.63396 16.6301Z'
                fill='#778797'
                mask='url(#path-1-outside-1_4945_40322)'
                id='path25'
            />
            <path
                d='m 12.299191,15.871434 v 0.125 h 0.0372 c 0.0369,0.1019 0.099,0.1935 0.1814,0.2658 0.1091,0.0957 0.2472,0.152 0.3922,0.1598 l 0.0013,10e-5 c 0.0848,0.0037 0.1694,-0.0096 0.249,-0.0389 l -0.0433,-0.1173 0.0433,0.1173 c 0.0795,-0.0293 0.1525,-0.0741 0.2146,-0.1319 0.062,-0.0577 0.112,-0.1272 0.1469,-0.2045 0.035,-0.0772 0.0542,-0.1607 0.0565,-0.2454 h 10e-5 v -0.0034 -1.865 h 1.9333 0.0108 l 0.0106,-0.0018 c 0.1453,-0.0252 0.2775,-0.0998 0.3741,-0.2113 0.0964,-0.1112 0.1514,-0.2523 0.1558,-0.3993 0.0035,-0.0834 -0.0095,-0.1667 -0.0384,-0.245 -0.029,-0.0787 -0.0733,-0.1508 -0.1305,-0.2121 -0.0571,-0.0614 -0.1259,-0.1108 -0.2023,-0.1453 -0.0764,-0.0345 -0.1589,-0.0535 -0.2427,-0.0558 v -10e-5 h -0.0035 -1.8746 v -1.93826 -0.01147 l -0.0021,-0.01127 c -0.0264,-0.14269 -0.1001,-0.2724 -0.2092,-0.36817 -0.1091,-0.09579 -0.2472,-0.15197 -0.3922,-0.15977 v 0 l -0.0013,-6e-5 c -0.0846,-0.0037 -0.1692,0.0094 -0.2489,0.03878 -0.0797,0.02935 -0.1526,0.07429 -0.2146,0.132 -0.0621,0.05773 -0.112,0.1272 -0.147,0.20449 -0.0349,0.07724 -0.0541,0.16067 -0.0565,0.24542 v 0 0.0035 1.86485 h -1.94073 -0.01164 l -0.01145,0.0022 c -0.14224,0.0267 -0.27117,0.1009 -0.3657599,0.2103 -0.09435,0.1091 -0.14901,0.2469 -0.15503,0.391 -0.00477,0.0841 0.00736,0.1683 0.03565,0.2477 0.02841,0.0797 0.07256,0.1529 0.12983,0.2152 0.05728,0.0623 0.1264799,0.1125 0.2035199,0.1476 l 0.05181,-0.1138 -0.05181,0.1138 c 0.07707,0.0351 0.16039,0.0543 0.24499,0.0566 v 10e-5 h 0.0034 1.86721 z'
                fill='#778797'
                stroke='#778797'
                strokeWidth='0.25'
                id='path153'
            />
        </svg>
    )
}

export const IconQuotes = ({ color = '#778797' }: SVGProps) => {
    return (
        <svg
            width='12'
            height='12'
            viewBox='0 0 12 12'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g clipPath='url(#clip0_6035_33799)'>
                <path
                    d='M9.52501 4.785C9.7725 4.16251 10.1625 3.5475 10.6837 2.95499C10.8487 2.76749 10.8712 2.49751 10.7363 2.28751C10.6312 2.1225 10.4588 2.03251 10.2713 2.03251C10.2188 2.03251 10.1662 2.03624 10.1137 2.05501C9.01126 2.3775 6.43499 3.52125 6.36374 7.18877C6.33751 8.60251 7.37249 9.8175 8.71875 9.95626C9.465 10.0313 10.2075 9.78752 10.7588 9.29252C11.31 8.79376 11.625 8.08125 11.625 7.33876C11.625 6.10126 10.7475 5.0175 9.52501 4.785Z'
                    fill={color}
                />
                <path
                    d='M2.7342 9.95626C3.47672 10.0313 4.21921 9.78752 4.77045 9.29252C5.32171 8.79377 5.63672 8.08126 5.63672 7.33877C5.63672 6.10127 4.75921 5.01752 3.5367 4.78502C3.78422 4.16254 4.17421 3.54753 4.69547 2.95503C4.86047 2.76753 4.88297 2.49754 4.74795 2.28754C4.64296 2.12254 4.47045 2.03254 4.28295 2.03254C4.23047 2.03254 4.17796 2.03627 4.12546 2.05504C3.02296 2.37754 0.446708 3.52128 0.375458 7.18878L0.375458 7.24126C0.375458 8.63252 1.3992 9.81751 2.7342 9.95626Z'
                    fill={color}
                />
            </g>
            <defs>
                <clipPath id='clip0_6035_33799'>
                    <rect
                        width='12'
                        height='12'
                        fill='white'
                        transform='translate(12 12) rotate(-180)'
                    />
                </clipPath>
            </defs>
        </svg>
    )
}

export const IconShareCircles = ({
    color = '#CFD0DA',
    width = '14',
    height = '14'
}: SVGProps) => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width={width}
            height={height}
            viewBox='0 0 14 14'
            fill={color}
        >
            <path
                d='M10.8384 8.7171C10.0221 8.7171 9.29126 9.0895 8.80634 9.67324L5.65201 7.88233C5.7501 7.6063 5.80401 7.30949 5.80401 7.00018C5.80401 6.69094 5.7501 6.39414 5.65201 6.1181L8.8061 4.32676C9.29095 4.91068 10.0219 5.28321 10.8383 5.28321C12.2945 5.28321 13.4793 4.09804 13.4793 2.6412C13.4794 1.1848 12.2946 0 10.8384 0C9.38202 0 8.19715 1.1848 8.19715 2.64114C8.19715 2.95045 8.251 3.24732 8.34916 3.52341L5.19488 5.31482C4.71003 4.7312 3.97928 4.35892 3.16312 4.35892C1.70653 4.35892 0.521484 5.54372 0.521484 7.00012C0.521484 8.45646 1.70653 9.64127 3.16312 9.64127C3.97928 9.64127 4.70997 9.26899 5.19482 8.68543L8.34916 10.4764C8.251 10.7525 8.19709 11.0494 8.19709 11.3588C8.19709 12.8151 9.38196 13.9999 10.8384 13.9999C12.2946 13.9999 13.4793 12.8151 13.4793 11.3588C13.4794 9.90221 12.2946 8.7171 10.8384 8.7171ZM10.8384 0.924231C11.785 0.924231 12.5551 1.69442 12.5551 2.64114C12.5551 3.58836 11.785 4.35892 10.8384 4.35892C9.89164 4.35892 9.12138 3.58836 9.12138 2.64114C9.12138 1.69442 9.89164 0.924231 10.8384 0.924231ZM3.16318 8.7171C2.21621 8.7171 1.44578 7.94684 1.44578 7.00018C1.44578 6.0534 2.21621 5.28321 3.16318 5.28321C4.10978 5.28321 4.87985 6.0534 4.87985 7.00018C4.87985 7.94684 4.10972 8.7171 3.16318 8.7171ZM10.8384 13.0758C9.89164 13.0758 9.12138 12.3055 9.12138 11.3589C9.12138 10.4118 9.89164 9.64133 10.8384 9.64133C11.785 9.64133 12.5551 10.4118 12.5551 11.3589C12.5551 12.3055 11.785 13.0758 10.8384 13.0758Z'
                fill='white'
            />
        </svg>
    )
}

export const IconNewStory = ({
    color = '#2894FF',
    width = '24',
    height = '24'
}: SVGProps) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M12.0007 0.837219C14.2085 0.837219 16.3667 1.4919 18.2024 2.71849C20.0381 3.94507 21.4689 5.68838 22.3138 7.72812C23.1586 9.76785 23.3797 12.0124 22.949 14.1778C22.5183 16.3432 21.4551 18.3321 19.894 19.8933C18.3328 21.4544 16.3438 22.5176 14.1784 22.9483C12.0131 23.379 9.76859 23.1579 7.72886 22.3131C5.68912 21.4682 3.94574 20.0374 2.71916 18.2017C1.49258 16.366 0.837891 14.2078 0.837891 12C0.837891 9.03945 2.01396 6.20018 4.10739 4.10675C6.20082 2.01332 9.04012 0.837219 12.0007 0.837219V0.837219Z'
                stroke={color}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M16.8012 12H7.20117'
                stroke={color}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M12 16.8V7.19998'
                stroke={color}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}

export const IconCLoseSquare = ({ color = '#200E32' }: SVGProps) => {
    return (
        <svg
            width='10'
            height='10'
            viewBox='0 0 10 10'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M6.52134 3.4686C6.72393 3.6712 6.72393 3.99967 6.52133 4.20227L4.20202 6.52156C3.99942 6.72415 3.67095 6.72415 3.46835 6.52155C3.26576 6.31895 3.26576 5.99048 3.46836 5.78788L5.78767 3.4686C5.99027 3.266 6.31874 3.266 6.52134 3.4686Z'
                fill={color}
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M3.46835 3.4686C3.67095 3.266 3.99942 3.266 4.20202 3.4686L6.52618 5.79273C6.72878 5.99532 6.72878 6.3238 6.52619 6.5264C6.32359 6.72899 5.99512 6.729 5.79252 6.5264L3.46836 4.20227C3.26576 3.99967 3.26576 3.6712 3.46835 3.4686Z'
                fill={color}
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M0.786387 0.865799C1.3078 0.30857 2.04543 0 2.90105 0H7.09414C7.95797 0 8.697 0.307656 9.21734 0.867775C9.73362 1.42353 9.99518 2.18476 9.99518 3.02691V6.98278C9.99518 7.8238 9.72655 8.58225 9.20856 9.13507C8.68721 9.69146 7.94973 10 7.09414 10H2.90105C2.03787 10 1.29968 9.68876 0.779923 9.13009C0.264087 8.57563 0 7.81749 0 6.98278V3.02206C0 2.17905 0.268375 1.4194 0.786387 0.865799ZM1.544 1.57471C1.23403 1.90598 1.03756 2.39797 1.03756 3.02206V6.98278C1.03756 7.60066 1.23105 8.09174 1.53957 8.42335C1.84417 8.75076 2.29711 8.96244 2.90105 8.96244H7.09414C7.69114 8.96244 8.14479 8.75289 8.45143 8.42564C8.76142 8.09481 8.95762 7.60403 8.95762 6.98278V3.02691C8.95762 2.3971 8.76403 1.90427 8.45717 1.57395C8.15437 1.24799 7.70226 1.03756 7.09414 1.03756H2.90105C2.30407 1.03756 1.85057 1.24708 1.544 1.57471Z'
                fill={color}
            />
        </svg>
    )
}

export const IconCameraPortraitOutline = ({
    color = '#2894FF',
    width = '18',
    height = '16'
}: SVGProps) => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width={width}
            height={height}
            viewBox='0 0 18 16'
            fill='none'
        >
            <path
                d='M3.87558 16.0001C2.84926 16.0001 1.86483 15.5929 1.13828 14.868C0.411727 14.1431 0.0023954 13.1597 4.14436e-05 12.1334V6.86225C-0.00469086 5.84064 0.396022 4.85888 1.11425 4.13233C1.83247 3.40577 2.80955 2.99376 3.83115 2.98671H3.90228C3.93326 2.98298 3.96271 2.97115 3.98767 2.95242C4.01264 2.9337 4.03222 2.90875 4.04448 2.88005L4.48892 1.99116L4.8267 1.2978C4.99939 0.919907 5.27742 0.599804 5.62743 0.375926C5.97743 0.152049 6.38458 0.033859 6.80006 0.0355401H10.9778C11.3918 0.0352546 11.7974 0.153075 12.1469 0.375058C12.4964 0.597041 12.7754 0.914017 12.9512 1.2889C13.0045 1.39557 13.0667 1.52 13.1556 1.71555L13.7334 2.91564C13.7507 2.94971 13.7776 2.97796 13.8108 2.99691C13.8439 3.01587 13.8819 3.0247 13.92 3.0223H14.1067C15.0979 3.0725 16.0319 3.50186 16.7153 4.22163C17.3986 4.9414 17.7791 5.89644 17.7778 6.88895V12.16C17.7755 13.1863 17.3661 14.1698 16.6396 14.8947C15.913 15.6196 14.9286 16.0268 13.9023 16.0268L3.87558 16.0001ZM6.01784 1.85781L5.82225 2.26666L5.25335 3.44895C5.14372 3.69091 4.97295 3.90007 4.75785 4.05594C4.54276 4.21181 4.2908 4.30901 4.02673 4.33784H3.87558C3.20134 4.33784 2.55471 4.60566 2.07795 5.08242C1.60119 5.55917 1.33337 6.20581 1.33337 6.88005V12.1511C1.33337 12.4845 1.39919 12.8147 1.52706 13.1227C1.65493 13.4306 1.84231 13.7102 2.07849 13.9456C2.31468 14.1809 2.59503 14.3674 2.90342 14.4942C3.2118 14.621 3.54215 14.6857 3.87558 14.6845H13.9023C14.575 14.6845 15.2203 14.4178 15.6968 13.943C16.1733 13.4681 16.4421 12.8238 16.4445 12.1511V6.88005C16.4478 6.23057 16.2015 5.60457 15.7566 5.13146C15.3116 4.65835 14.7018 4.3743 14.0534 4.33784H13.7689C13.5012 4.31376 13.2447 4.2187 13.026 4.06245C12.8072 3.9062 12.6341 3.69441 12.5245 3.44895L11.9023 2.14231L11.76 1.85781C11.6969 1.70045 11.5875 1.56606 11.4462 1.47239C11.3049 1.37872 11.1385 1.33023 10.969 1.33339H6.80891C6.63809 1.32964 6.47032 1.37884 6.32865 1.47434C6.18699 1.56985 6.07842 1.70695 6.01784 1.8667V1.85781ZM8.88893 12.6756C7.96316 12.6733 7.07599 12.3044 6.42137 11.6498C5.76676 10.9952 5.39795 10.108 5.3956 9.18224C5.39161 8.72629 5.47924 8.27425 5.65331 7.85281C5.82738 7.43138 6.08436 7.04913 6.40895 6.7289C6.73191 6.3987 7.11771 6.13658 7.54366 5.95796C7.96961 5.77934 8.42705 5.6879 8.88893 5.68897H9.07562C10.0021 5.71254 10.8813 6.10311 11.5197 6.77491C12.1582 7.4467 12.5036 8.34462 12.48 9.27111C12.4564 10.1976 12.0658 11.0768 11.394 11.7152C10.7222 12.3537 9.82432 12.6992 8.89783 12.6756H8.88893ZM8.74673 7.0223C8.20112 7.06455 7.69116 7.30979 7.31759 7.70969C6.94402 8.1096 6.73398 8.63502 6.72894 9.18224C6.72894 9.60945 6.85563 10.0271 7.09298 10.3823C7.33032 10.7375 7.66764 11.0143 8.06232 11.1778C8.45701 11.3413 8.89132 11.3841 9.31032 11.3007C9.72932 11.2174 10.1142 11.0117 10.4163 10.7096C10.7184 10.4075 10.9241 10.0227 11.0074 9.60368C11.0908 9.18468 11.048 8.75032 10.8845 8.35564C10.7211 7.96095 10.4442 7.62358 10.089 7.38623C9.73375 7.14889 9.31614 7.0223 8.88893 7.0223H8.74673ZM13.2445 7.10227C13.1527 7.09118 13.0629 7.06728 12.9778 7.0312C12.8695 6.98828 12.7723 6.92135 12.6934 6.83556C12.5346 6.67078 12.4454 6.45114 12.4445 6.22228C12.4458 6.10037 12.4699 5.97975 12.5156 5.8667C12.6077 5.65286 12.7801 5.48368 12.9956 5.39557C13.1563 5.32941 13.3329 5.31182 13.5036 5.345C13.6742 5.37818 13.8314 5.46074 13.9556 5.58231C14.0225 5.65104 14.0793 5.72874 14.1245 5.81332V5.8667C14.1773 5.9778 14.2046 6.09929 14.2045 6.22228C14.2011 6.45674 14.1053 6.68034 13.9378 6.84446C13.7924 6.99067 13.6008 7.08183 13.3956 7.10227H13.2267H13.2445Z'
                fill={color}
            />
        </svg>
    )
}

export const IconChatBUbblesOutline = ({
    color = '#2894FF',
    width = '16',
    height = '16'
}: SVGProps) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox='0 0 16 16'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g clipPath='url(#clip0_6057_34203)'>
                <path
                    d='M1.84508 12.4793C1.31044 12.4793 0.788114 12.3429 0.314738 12.0771C0.0711794 11.9517 -0.0231551 11.6379 0.122347 11.4018C0.605781 10.6293 0.780351 9.68499 0.55901 8.79693C0.329589 7.87627 -0.0023635 7.10089 1.26859e-05 6.12625C0.00825012 2.70689 2.85432 -0.0651689 6.27021 0.00116624C9.56954 0.0676202 12.2886 2.8411 12.2887 6.1413C12.2887 10.4514 7.77168 13.4775 3.78393 11.8131C3.23428 12.2445 2.5434 12.4793 1.84508 12.4793V12.4793ZM1.19543 11.427C1.94662 11.6603 2.79147 11.4739 3.37075 10.9139C3.51348 10.7759 3.72698 10.7412 3.90606 10.8268C7.32012 12.4591 11.3382 9.90062 11.3382 6.1413C11.3382 3.33606 9.05608 1.00792 6.25108 0.951442C3.36037 0.894017 0.957456 3.23519 0.950486 6.12855C0.948229 7.05427 1.30941 7.7941 1.50679 8.67103C1.71475 9.59517 1.6052 10.5724 1.19543 11.427V11.427Z'
                    fill={color}
                />
                <path
                    d='M14.1546 16.0001C13.4563 16.0001 12.7654 15.7652 12.2158 15.3339C10.0951 16.219 7.57242 15.8159 5.83357 14.3142C5.63492 14.1427 5.61298 13.8426 5.7845 13.6439C5.95606 13.4453 6.25613 13.4233 6.45478 13.5949C7.997 14.9267 10.2556 15.2263 12.0936 14.3476C12.2727 14.2619 12.4861 14.2967 12.6289 14.4347C13.2082 14.9947 14.0531 15.1812 14.8043 14.9477C14.3209 13.9395 14.2539 12.7844 14.6285 11.715C14.6319 11.7054 14.6355 11.6959 14.6395 11.6865C14.9131 11.0416 15.0509 10.3561 15.0492 9.64929C15.0462 8.40306 14.6317 7.25026 13.8503 6.31542C13.682 6.114 13.7088 5.81433 13.9102 5.64601C14.1115 5.47766 14.4113 5.50451 14.5796 5.70589C15.4919 6.79739 15.9962 8.19701 15.9997 9.64699C16.0017 10.4775 15.8406 11.2835 15.5208 12.0429C15.1849 13.0153 15.3394 14.0564 15.8773 14.9224C16.0229 15.1586 15.9285 15.4724 15.6849 15.5979C15.2116 15.8636 14.6891 16 14.1546 16.0001Z'
                    fill={color}
                />
                <path
                    d='M4.8065 5.38915C5.01417 5.41483 5.20628 5.28148 5.26331 5.07903L5.26333 5.07897C5.32427 4.86214 5.41408 4.70239 5.52729 4.59248C5.68412 4.44028 5.8793 4.36303 6.11964 4.36303C6.36744 4.36303 6.57281 4.44757 6.74179 4.61772C6.91293 4.79004 6.99538 4.98495 6.99538 5.20711C6.99538 5.32944 6.96746 5.44026 6.91147 5.54152C6.85533 5.64304 6.72642 5.79039 6.51234 5.9864L6.57981 6.06009L6.51241 5.98634C6.29696 6.18325 6.14366 6.3373 6.05572 6.44601L6.05536 6.44645C5.93764 6.59368 5.84965 6.74233 5.7947 6.89286C5.72083 7.09019 5.68518 7.32078 5.68518 7.58202C5.68518 7.74057 5.8098 7.87521 5.97142 7.87521H6.07142L4.81878 5.28991M4.8065 5.38915L4.81878 5.28991M4.8065 5.38915C4.80653 5.38915 4.80655 5.38916 4.80658 5.38916L4.81878 5.28991M4.8065 5.38915C4.54387 5.35683 4.37782 5.09022 4.45034 4.83563C4.54172 4.51475 4.69628 4.25159 4.91598 4.05027M4.81878 5.28991C4.62045 5.26553 4.48985 5.06195 4.54651 4.86303C4.63358 4.55729 4.77939 4.31105 4.98359 4.12396M4.91598 4.05027C4.91597 4.05028 4.91595 4.0503 4.91594 4.05031L4.98359 4.12396M4.91598 4.05027C5.22186 3.76932 5.62308 3.63328 6.10928 3.63328C6.62305 3.63328 7.04394 3.77883 7.3608 4.07936C7.67455 4.37695 7.8332 4.74023 7.8332 5.1641C7.8332 5.40884 7.77766 5.63626 7.66623 5.84427M4.91598 4.05027C4.916 4.05026 4.91602 4.05024 4.91603 4.05023L4.98359 4.12396M4.98359 4.12396L7.66623 5.84427M6.07142 7.77485H5.97142V7.77521M6.07142 7.77485L5.97142 7.77521M6.07142 7.77485V7.77521V7.87485H5.97142L6.07142 7.77485ZM5.97142 7.77521C5.96757 7.77521 5.96375 7.77509 5.95996 7.77485C5.92748 7.77282 5.89728 7.76217 5.87142 7.74509V7.77485V7.77521H5.97142ZM7.66623 5.84427C7.66624 5.84425 7.66624 5.84424 7.66625 5.84423L7.57807 5.79708L7.66621 5.8443L7.66623 5.84427ZM6.39122 7.59062L6.49109 7.59568L6.49109 7.59564L6.39122 7.59062ZM6.5336 7.24234L6.53361 7.2423L6.5336 7.24234ZM6.97134 6.50174L7.03902 6.57535C7.03903 6.57534 7.03905 6.57533 7.03906 6.57532L6.97134 6.50174ZM6.10409 8.23328C5.85023 8.23328 5.65063 8.44569 5.65063 8.69994C5.65063 8.95419 5.85022 9.16661 6.10409 9.16661C6.35796 9.16661 6.55756 8.95419 6.55756 8.69994C6.55756 8.44569 6.35796 8.23328 6.10409 8.23328Z'
                    fill={color}
                    stroke={color}
                    strokeWidth='0.2'
                />
            </g>
            <defs>
                <clipPath id='clip0_6057_34203'>
                    <rect width='16' height='16' fill='white' />
                </clipPath>
            </defs>
        </svg>
    )
}

export const IconCalendarOutlineDot = ({ color = '#778797' }: SVGProps) => {
    return (
        <svg
            width='25'
            height='26'
            viewBox='0 0 25 26'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M1.81045 5.05241C2.99674 3.88798 4.68949 3.22754 6.70123 3.22754H17.287C19.3154 3.22754 21.0134 3.88707 22.1984 5.06166C23.3776 6.2304 23.9946 7.85443 23.9882 9.70234V18.8097C23.9882 20.6338 23.359 22.2432 22.1778 23.4027C20.9915 24.5671 19.2987 25.2275 17.287 25.2275H6.70123C4.6763 25.2275 2.98301 24.5609 1.79992 23.3929C0.622439 22.2306 0 20.6217 0 18.8097V9.6454C0 7.82127 0.629207 6.2119 1.81045 5.05241ZM2.84187 5.93001C1.94265 6.81266 1.40924 8.09024 1.40924 9.6454V18.8097C1.40924 20.3546 1.93718 21.6327 2.83405 22.518C3.72529 23.3978 5.03031 23.9396 6.70123 23.9396H17.287C18.9466 23.9396 20.2522 23.4028 21.1463 22.5251C22.0456 21.6424 22.579 20.3648 22.579 18.8097V9.70126L22.579 9.69917C22.5846 8.11227 22.0574 6.82179 21.1624 5.93466C20.2731 5.05317 18.9666 4.51543 17.287 4.51543H6.70123C5.04159 4.51543 3.73604 5.05231 2.84187 5.93001Z'
                fill='#200E32'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M1.81045 5.05241C2.99674 3.88798 4.68949 3.22754 6.70123 3.22754H17.287C19.3154 3.22754 21.0134 3.88707 22.1984 5.06166C23.3776 6.2304 23.9946 7.85443 23.9882 9.70234V18.8097C23.9882 20.6338 23.359 22.2432 22.1778 23.4027C20.9915 24.5671 19.2987 25.2275 17.287 25.2275H6.70123C4.6763 25.2275 2.98301 24.5609 1.79992 23.3929C0.622439 22.2306 0 20.6217 0 18.8097V9.6454C0 7.82127 0.629207 6.2119 1.81045 5.05241ZM2.84187 5.93001C1.94265 6.81266 1.40924 8.09024 1.40924 9.6454V18.8097C1.40924 20.3546 1.93718 21.6327 2.83405 22.518C3.72529 23.3978 5.03031 23.9396 6.70123 23.9396H17.287C18.9466 23.9396 20.2522 23.4028 21.1463 22.5251C22.0456 21.6424 22.579 20.3648 22.579 18.8097V9.70126L22.579 9.69917C22.5846 8.11227 22.0574 6.82179 21.1624 5.93466C20.2731 5.05317 18.9666 4.51543 17.287 4.51543H6.70123C5.04159 4.51543 3.73604 5.05231 2.84187 5.93001Z'
                fill={color}
            />
            <path
                d='M23.0317 20.5159C23.0317 22.4576 21.4576 24.0317 19.5159 24.0317C17.5741 24.0317 16 22.4576 16 20.5159C16 18.5741 17.5741 17 19.5159 17C21.4576 17 23.0317 18.5741 23.0317 20.5159Z'
                fill='#FF0000'
            />
            <path
                d='M23.0317 20.5159C23.0317 22.4576 21.4576 24.0317 19.5159 24.0317C17.5741 24.0317 16 22.4576 16 20.5159C16 18.5741 17.5741 17 19.5159 17C21.4576 17 23.0317 18.5741 23.0317 20.5159Z'
                fill={color}
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M24.0317 20.5159C24.0317 23.0099 22.0099 25.0317 19.5159 25.0317C17.0218 25.0317 15 23.0099 15 20.5159C15 18.0218 17.0218 16 19.5159 16C22.0099 16 24.0317 18.0218 24.0317 20.5159ZM19.5159 24.0317C21.4576 24.0317 23.0317 22.4576 23.0317 20.5159C23.0317 18.5741 21.4576 17 19.5159 17C17.5741 17 16 18.5741 16 20.5159C16 22.4576 17.5741 24.0317 19.5159 24.0317Z'
                fill='white'
            />
            <rect
                x='4.5'
                y='9.5'
                width='3'
                height='3'
                rx='0.5'
                stroke={color}
            />
            <path
                d='M4 1.75C4 1.33579 4.33579 1 4.75 1C5.16421 1 5.5 1.33579 5.5 1.75V5.25C5.5 5.66421 5.16421 6 4.75 6C4.33579 6 4 5.66421 4 5.25V1.75Z'
                fill={color}
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M6.5 1.75V5.25C6.5 6.2165 5.7165 7 4.75 7C3.7835 7 3 6.2165 3 5.25V1.75C3 0.783501 3.7835 0 4.75 0C5.7165 0 6.5 0.783502 6.5 1.75ZM4.75 1C4.33579 1 4 1.33579 4 1.75V5.25C4 5.66421 4.33579 6 4.75 6C5.16421 6 5.5 5.66421 5.5 5.25V1.75C5.5 1.33579 5.16421 1 4.75 1Z'
                fill='white'
            />
            <path
                d='M18.5 1.75C18.5 1.33579 18.8358 1 19.25 1C19.6642 1 20 1.33579 20 1.75V5.25C20 5.66421 19.6642 6 19.25 6C18.8358 6 18.5 5.66421 18.5 5.25V1.75Z'
                fill={color}
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M21 1.75V5.25C21 6.2165 20.2165 7 19.25 7C18.2835 7 17.5 6.2165 17.5 5.25V1.75C17.5 0.783501 18.2835 0 19.25 0C20.2165 0 21 0.783502 21 1.75ZM19.25 1C18.8358 1 18.5 1.33579 18.5 1.75V5.25C18.5 5.66421 18.8358 6 19.25 6C19.6642 6 20 5.66421 20 5.25V1.75C20 1.33579 19.6642 1 19.25 1Z'
                fill='white'
            />
            <path
                d='M11.5 1.75C11.5 1.33579 11.8358 1 12.25 1C12.6642 1 13 1.33579 13 1.75V5.25C13 5.66421 12.6642 6 12.25 6C11.8358 6 11.5 5.66421 11.5 5.25V1.75Z'
                fill={color}
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M14 1.75V5.25C14 6.2165 13.2165 7 12.25 7C11.2835 7 10.5 6.2165 10.5 5.25V1.75C10.5 0.783501 11.2835 0 12.25 0C13.2165 0 14 0.783502 14 1.75ZM12.25 1C11.8358 1 11.5 1.33579 11.5 1.75V5.25C11.5 5.66421 11.8358 6 12.25 6C12.6642 6 13 5.66421 13 5.25V1.75C13 1.33579 12.6642 1 12.25 1Z'
                fill='white'
            />
            <rect
                x='4.5'
                y='16.5'
                width='3'
                height='3'
                rx='0.5'
                stroke={color}
            />
            <rect
                x='10.5'
                y='9.5'
                width='3'
                height='3'
                rx='0.5'
                stroke={color}
            />
            <rect
                x='10.5'
                y='16.5'
                width='3'
                height='3'
                rx='0.5'
                stroke={color}
            />
            <rect
                x='16.5'
                y='9.5'
                width='3'
                height='3'
                rx='0.5'
                stroke={color}
            />
        </svg>
    )
}

export const IconManOutline = ({ color = '#778797' }: SVGProps) => {
    return (
        <svg
            width='16'
            height='20'
            viewBox='0 0 16 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g clipPath='url(#clip0_4945_42021)'>
                <path
                    d='M6.68048 19.9599H6.25049C6.11736 19.9703 5.9836 19.9703 5.85046 19.9599C5.06664 19.9026 4.28799 19.7888 3.52051 19.6193L3.2605 19.5591C2.64663 19.4992 2.05536 19.2958 1.5343 18.9651C1.01324 18.6345 0.576938 18.1857 0.260498 17.6553C0.0782591 17.2628 -0.0172806 16.8356 -0.0195312 16.4028C-0.0170529 15.9624 0.0819866 15.5281 0.270508 15.1303C0.623787 14.5862 1.09497 14.1287 1.64899 13.7922C2.20301 13.4557 2.82556 13.2486 3.47046 13.1864C4.24081 13.016 5.02316 12.9055 5.81049 12.8558C6.52049 12.7856 7.25047 12.7556 7.98047 12.7556C8.71047 12.7556 9.43051 12.7556 10.1505 12.8558H10.6105C11.2389 12.9209 11.8632 13.0212 12.4805 13.1563C14.2105 13.507 15.2305 14.1583 15.7005 15.1603C15.8803 15.5533 15.9733 15.9805 15.9733 16.4128C15.9733 16.8451 15.8803 17.2723 15.7005 17.6653C15.2305 18.6673 14.1805 19.2785 12.5005 19.6693L12.0305 19.7696C11.4096 19.8897 10.7816 19.9701 10.1505 20.0101C9.43051 20.0702 8.71048 20.1002 7.99048 20.1002C7.56048 19.99 7.11048 19.98 6.68048 19.9599ZM5.94049 14.2486C5.21775 14.2988 4.49933 14.3992 3.79047 14.5491C3.36282 14.5875 2.94715 14.7109 2.56769 14.9122C2.18822 15.1135 1.85262 15.3887 1.58051 15.7215C1.48928 15.9194 1.44152 16.1347 1.44049 16.3527C1.4417 16.5675 1.48949 16.7795 1.58051 16.974C1.84051 17.505 2.58049 17.9059 3.81049 18.1464L4.16046 18.2165C4.78118 18.3399 5.40912 18.4236 6.04047 18.467C6.13354 18.4768 6.22742 18.4768 6.3205 18.467H6.72046C7.14046 18.467 7.58051 18.467 8.02051 18.467C8.69051 18.467 9.38051 18.467 10.0205 18.3768C10.7476 18.3255 11.4697 18.2182 12.1805 18.0561H12.4105C12.8035 18.0235 13.1851 17.9075 13.53 17.7157C13.8748 17.5239 14.1749 17.2608 14.4105 16.9439C14.5045 16.7468 14.5534 16.5311 14.5534 16.3126C14.5534 16.0941 14.5045 15.8784 14.4105 15.6814C14.1705 15.1603 13.4105 14.7596 12.2005 14.5091C11.4916 14.3592 10.7732 14.2587 10.0505 14.2084C9.38381 14.1483 8.71714 14.1183 8.05048 14.1183C7.3594 14.1135 6.66852 14.1436 5.98047 14.2084L5.94049 14.2486ZM2.69049 5.30061C2.69247 4.2463 3.00644 3.21623 3.59265 2.34071C4.17886 1.46519 5.01097 0.783589 5.98383 0.381956C6.95668 -0.0196759 8.02658 -0.123264 9.05817 0.0843642C10.0898 0.291993 11.0367 0.801446 11.7794 1.54835C12.522 2.29526 13.0269 3.24607 13.2302 4.2805C13.4336 5.31493 13.3262 6.38661 12.9217 7.3599C12.5172 8.33319 11.8338 9.16438 10.9578 9.74847C10.0819 10.3326 9.05268 10.6432 8.00049 10.6412C7.30148 10.6412 6.60935 10.5031 5.96381 10.2344C5.31826 9.96579 4.73199 9.57205 4.23865 9.07586C3.74531 8.57967 3.3546 7.99074 3.08893 7.3429C2.82325 6.69506 2.68786 6.00101 2.69049 5.30061ZM4.13049 5.30061C4.13247 6.06953 4.36193 6.82062 4.78992 7.45885C5.2179 8.09709 5.82518 8.59385 6.53491 8.88627C7.24464 9.17869 8.02497 9.25362 8.77722 9.10167C9.52948 8.94971 10.2199 8.57763 10.7611 8.03251C11.3023 7.4874 11.6701 6.79381 11.8179 6.03927C11.9656 5.28473 11.8868 4.5032 11.5913 3.79356C11.2958 3.08393 10.7969 2.47796 10.1578 2.05241C9.51862 1.62687 8.76788 1.40082 8.00049 1.4028C7.49059 1.40279 6.98573 1.50377 6.51489 1.6999C6.04405 1.89603 5.61652 2.1835 5.2569 2.54571C4.89727 2.90792 4.61262 3.33778 4.41931 3.81057C4.22601 4.28335 4.12786 4.78969 4.13049 5.30061Z'
                    fill={color}
                />
            </g>
            <defs>
                <clipPath id='clip0_4945_42021'>
                    <rect width='16' height='20' fill='white' />
                </clipPath>
            </defs>
        </svg>
    )
}

export const IconMuteOutline = ({ color = '#778797' }: SVGProps) => {
    return (
        <svg
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M1.29143 19.7642C1.14921 19.6262 1.06287 19.4403 1.04905 19.2424C1.03523 19.0444 1.0949 18.8483 1.21656 18.6918L1.29143 18.606L4.26466 15.6248H3.92247C3.20597 15.6253 2.51707 15.3475 2.00055 14.8495C1.48403 14.3516 1.18005 13.6724 1.15239 12.9545C0.949204 10.9508 0.949204 8.93151 1.15239 6.92774C1.21195 6.26137 1.50235 5.63692 1.9732 5.16286C2.44404 4.68879 3.06556 4.395 3.7299 4.33252H5.86894L9.61225 1.26551C10.08 0.871608 10.6456 0.612241 11.2486 0.514893H11.4197C12.0166 0.523082 12.5936 0.731249 13.0587 1.10633C13.5239 1.48141 13.8506 2.00175 13.9866 2.58452C14.0712 2.938 14.1354 3.29605 14.1791 3.65691L14.286 4.63282L14.3503 5.11534C14.3503 5.20828 14.3503 5.31557 14.3503 5.43711L17.5802 2.19312C17.7306 2.04251 17.9345 1.95789 18.1471 1.95789C18.3596 1.95789 18.5635 2.04251 18.7139 2.19312C18.8561 2.33113 18.9424 2.51696 18.9562 2.71492C18.9701 2.91288 18.9104 3.10899 18.7887 3.26551L18.7139 3.36199L2.37166 19.7534C2.22528 19.8898 2.03343 19.9665 1.83363 19.9685C1.63384 19.9705 1.44047 19.8976 1.29143 19.7642ZM2.74596 7.16363C2.55347 9.02459 2.55347 10.9005 2.74596 12.7615C2.84222 13.555 3.20585 13.9733 3.81548 14.0269H5.89035L12.8529 7.03495V5.96257C12.8529 5.65157 12.8529 5.44781 12.8529 5.27622L12.7673 4.56841L12.7032 4.05369C12.6756 3.69282 12.622 3.33442 12.5428 2.9813C12.5012 2.73849 12.3774 2.51741 12.1924 2.35531C12.0073 2.19321 11.7723 2.10003 11.5267 2.09127C11.2754 2.14364 11.0383 2.24962 10.8315 2.40217L10.7353 2.47731L6.76736 5.69447C6.65025 5.78812 6.50959 5.84754 6.36094 5.86609H3.99728C3.82754 5.85962 3.65838 5.88911 3.50077 5.95262C3.34317 6.01612 3.20067 6.11215 3.0826 6.23459C2.96453 6.35703 2.87355 6.5031 2.81555 6.66318C2.75754 6.82325 2.73381 6.99376 2.74596 7.16363ZM11.4839 19.4639C10.9113 19.4472 10.3582 19.2523 9.90104 18.9062L9.72995 18.7775L8.2326 17.555C8.07655 17.4271 7.97423 17.245 7.94603 17.0448C7.91782 16.8447 7.96585 16.6414 8.08043 16.4751C8.19502 16.3089 8.36782 16.1919 8.56447 16.1476C8.76112 16.1033 8.96716 16.1348 9.14166 16.236L9.24865 16.3111L10.7459 17.5444C10.9575 17.7181 11.213 17.8294 11.4839 17.866C11.717 17.8467 11.9374 17.7513 12.1112 17.5944C12.2851 17.4375 12.4029 17.2279 12.4465 16.9975L12.5107 16.7507C12.5107 16.622 12.5107 16.4933 12.5748 16.3432L12.7032 15.1958C12.7032 14.6918 12.8101 13.8017 12.8208 12.4826C12.8222 12.377 12.8444 12.2727 12.886 12.1757C12.9276 12.0786 12.9878 11.9908 13.0633 11.9171C13.1388 11.8434 13.228 11.7853 13.3259 11.7461C13.4237 11.707 13.5283 11.6877 13.6337 11.6891C13.7394 11.689 13.8441 11.7103 13.9416 11.7515C14.039 11.7927 14.1272 11.853 14.201 11.929C14.2748 12.005 14.3326 12.0951 14.3711 12.1938C14.4096 12.2926 14.4279 12.3981 14.4251 12.5041V13.3835C14.4251 14.1985 14.3609 14.8205 14.3182 15.2602L14.1898 16.3326C14.1591 16.6953 14.0947 17.0543 13.9973 17.405C13.8659 17.9637 13.5571 18.4644 13.1173 18.8319C12.6775 19.1993 12.1305 19.4136 11.5588 19.4424L11.4839 19.4639Z'
                fill={color}
            />
        </svg>
    )
}

export const IconClockOutline = () => {
    return (
        <svg
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M12 0C5.37926 0 0 5.37926 0 12C0 18.6207 5.37926 24 12 24C18.6207 24 24 18.6207 24 12C24 5.37926 18.6207 0 12 0ZM12 0.996934C18.0821 0.996934 23.0031 5.91791 23.0031 12C23.0031 18.0821 18.0821 23.0031 12 23.0031C5.91791 23.0031 0.996934 18.0821 0.996934 12C0.996934 5.91791 5.91791 0.996934 12 0.996934Z'
                fill='#0D1444'
            />
            <path
                d='M12.0017 2.42796C6.72026 2.42796 2.42969 6.71854 2.42969 12C2.42969 17.2815 6.72026 21.572 12.0017 21.572C17.2832 21.572 21.5738 17.2815 21.5738 12C21.5738 6.71854 17.2832 2.42796 12.0017 2.42796ZM12.0017 3.42122C16.7445 3.42122 20.5768 7.25719 20.5768 12C20.5768 16.7428 16.7445 20.5751 12.0017 20.5751C7.25891 20.5751 3.42294 16.7428 3.42294 12C3.42294 7.25719 7.25891 3.42122 12.0017 3.42122Z'
                fill='#0D1444'
            />
            <path
                d='M11.9984 10.5064C11.1787 10.5064 10.5049 11.1802 10.5049 12C10.5049 12.8198 11.1787 13.4936 11.9984 13.4936C12.8182 13.4936 13.492 12.8198 13.492 12C13.492 11.1802 12.8182 10.5064 11.9984 10.5064ZM11.9984 11.4997C12.2796 11.4997 12.4951 11.7189 12.4951 12C12.4951 12.2811 12.2796 12.4966 11.9984 12.4966C11.7173 12.4966 11.4981 12.2811 11.4981 12C11.4981 11.7189 11.7173 11.4997 11.9984 11.4997Z'
                fill='#0D1444'
            />
            <path
                d='M11.501 5.52176V11.0031H12.4979V5.52176H11.501Z'
                fill='#0D1444'
            />
            <path
                d='M12.8481 12.1471L12.1455 12.8498L15.1326 15.8406L15.8389 15.1343L12.8481 12.1471Z'
                fill='#0D1444'
            />
        </svg>
    )
}

export const IconSharedFiles = ({ color = '#778797' }: SVGProps) => {
    return (
        <svg
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g clipPath='url(#clip0_4945_42006)'>
                <path
                    d='M16.8743 8.75H12.291C11.946 8.75 11.666 8.47 11.666 8.125C11.666 7.78 11.946 7.5 12.291 7.5H16.8743C17.2193 7.5 17.4993 7.78 17.4993 8.125C17.4993 8.47 17.2193 8.75 16.8743 8.75Z'
                    fill={color}
                />
                <path
                    d='M16.8743 12.0833H12.291C11.946 12.0833 11.666 11.8033 11.666 11.4583C11.666 11.1133 11.946 10.8333 12.291 10.8333H16.8743C17.2193 10.8333 17.4993 11.1133 17.4993 11.4583C17.4993 11.8033 17.2193 12.0833 16.8743 12.0833Z'
                    fill={color}
                />
                <path
                    d='M16.8743 15.4167H12.291C11.946 15.4167 11.666 15.1367 11.666 14.7917C11.666 14.4467 11.946 14.1667 12.291 14.1667H16.8743C17.2193 14.1667 17.4993 14.4467 17.4993 14.7917C17.4993 15.1367 17.2193 15.4167 16.8743 15.4167Z'
                    fill={color}
                />
                <path
                    d='M7.70833 10.8334H3.95833C3.15417 10.8334 2.5 10.1793 2.5 9.37509V8.12509C2.5 7.32092 3.15417 6.66675 3.95833 6.66675H7.70833C8.5125 6.66675 9.16667 7.32092 9.16667 8.12509V9.37509C9.16667 10.1793 8.5125 10.8334 7.70833 10.8334ZM3.95833 7.91675C3.84333 7.91675 3.75 8.01009 3.75 8.12509V9.37509C3.75 9.49009 3.84333 9.58342 3.95833 9.58342H7.70833C7.82333 9.58342 7.91667 9.49009 7.91667 9.37509V8.12509C7.91667 8.01009 7.82333 7.91675 7.70833 7.91675H3.95833Z'
                    fill={color}
                />
                <path
                    d='M7.70833 16.6667H3.95833C3.15417 16.6667 2.5 16.0125 2.5 15.2083V13.9583C2.5 13.1542 3.15417 12.5 3.95833 12.5H7.70833C8.5125 12.5 9.16667 13.1542 9.16667 13.9583V15.2083C9.16667 16.0125 8.5125 16.6667 7.70833 16.6667ZM3.95833 13.75C3.84333 13.75 3.75 13.8433 3.75 13.9583V15.2083C3.75 15.3233 3.84333 15.4167 3.95833 15.4167H7.70833C7.82333 15.4167 7.91667 15.3233 7.91667 15.2083V13.9583C7.91667 13.8433 7.82333 13.75 7.70833 13.75H3.95833Z'
                    fill={color}
                />
                <path
                    d='M17.7083 19.1666H2.29167C1.0275 19.1666 0 18.1391 0 16.8749V3.12492C0 1.86075 1.0275 0.833252 2.29167 0.833252H17.7083C18.9725 0.833252 20 1.86075 20 3.12492V16.8749C20 18.1391 18.9725 19.1666 17.7083 19.1666ZM2.29167 2.08325C1.7175 2.08325 1.25 2.55075 1.25 3.12492V16.8749C1.25 17.4491 1.7175 17.9166 2.29167 17.9166H17.7083C18.2825 17.9166 18.75 17.4491 18.75 16.8749V3.12492C18.75 2.55075 18.2825 2.08325 17.7083 2.08325H2.29167Z'
                    fill={color}
                />
                <path
                    d='M19.375 5H0.625C0.28 5 0 4.72 0 4.375C0 4.03 0.28 3.75 0.625 3.75H19.375C19.72 3.75 20 4.03 20 4.375C20 4.72 19.72 5 19.375 5Z'
                    fill={color}
                />
            </g>
            <defs>
                <clipPath id='clip0_4945_42006'>
                    <rect width='20' height='20' fill='white' />
                </clipPath>
            </defs>
        </svg>
    )
}

export const desktopNavFeed = ({
    color = '#65697E',
    width = '20',
    height = '19'
}: SVGProps) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox='0 0 20 19'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M17.6172 0.757812C17.6172 0.434219 17.3548 0.171875 17.0312 0.171875H15.2734V1.92969C15.2734 2.25328 15.0111 2.51562 14.6875 2.51562C14.3639 2.51562 14.1016 2.25328 14.1016 1.92969V0.171875H9.41406V1.92969C9.41406 2.25328 9.15172 2.51562 8.82812 2.51562C8.50453 2.51562 8.24219 2.25328 8.24219 1.92969V0.171875H3.51562V1.92969C3.51562 2.25328 3.25328 2.51562 2.92969 2.51562C2.60609 2.51562 2.34375 2.25328 2.34375 1.92969V0.171875H0.585938C0.262344 0.171875 0 0.434219 0 0.757812V3.72656H17.6172V0.757812ZM5.27344 6.07031H2.92969C2.60609 6.07031 2.34375 6.33266 2.34375 6.65625V9C2.34375 9.32359 2.60609 9.58594 2.92969 9.58594H5.27344C5.59703 9.58594 5.85938 9.32359 5.85938 9V6.65625C5.85938 6.33266 5.59703 6.07031 5.27344 6.07031ZM10 6.07031H7.65625C7.33266 6.07031 7.07031 6.33266 7.07031 6.65625V9C7.07031 9.32359 7.33266 9.58594 7.65625 9.58594H10C10.3236 9.58594 10.5859 9.32359 10.5859 9V6.65625C10.5859 6.33266 10.3236 6.07031 10 6.07031ZM12.3438 6.07031C12.0202 6.07031 11.7578 6.33266 11.7578 6.65625V9C11.7578 9.32359 12.0202 9.58594 12.3438 9.58594H14.6875C15.0111 9.58594 15.2734 9.32359 15.2734 9V6.65625C15.2734 6.33266 15.0111 6.07031 14.6875 6.07031H12.3438ZM10 10.7578H7.65625C7.33266 10.7578 7.07031 11.0202 7.07031 11.3438V13.6875C7.07031 14.0111 7.33266 14.2734 7.65625 14.2734H10C10.3236 14.2734 10.5859 14.0111 10.5859 13.6875V11.3438C10.5859 11.0202 10.3236 10.7578 10 10.7578ZM5.27344 10.7578H2.92969C2.60609 10.7578 2.34375 11.0202 2.34375 11.3438V13.6875C2.34375 14.0111 2.60609 14.2734 2.92969 14.2734H5.27344C5.59703 14.2734 5.85938 14.0111 5.85938 13.6875V11.3438C5.85938 11.0202 5.59703 10.7578 5.27344 10.7578ZM15.8594 10.7578C13.5978 10.7578 11.7578 12.5978 11.7578 14.8594C11.7578 17.1425 13.5978 19 15.8594 19C18.1311 19 20 17.1223 20 14.8594C20 12.5978 18.1425 10.7578 15.8594 10.7578ZM17.0312 15.4453H15.8594C15.5358 15.4453 15.2734 15.183 15.2734 14.8594V13.6875C15.2734 13.3639 15.5358 13.1016 15.8594 13.1016C16.183 13.1016 16.4453 13.3639 16.4453 13.6875V14.2734H17.0312C17.3548 14.2734 17.6172 14.5358 17.6172 14.8594C17.6172 15.183 17.3548 15.4453 17.0312 15.4453Z'
                fill={color}
            />
        </svg>
    )
}

export const EyeIcon = ({ width = '25', height = '22' }: SVGProps) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox='0 0 35 35'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M17.162 4.341c-10.562 0-17.162 11.659-17.162 11.659s6.537 11.659 17.162 11.659c9.938 0 17.481-11.659 17.481-11.659s-7.481-11.659-17.481-11.659zM17.256 21.251c-2.894 0-5.238-2.345-5.238-5.238s2.345-5.239 5.238-5.239 5.239 2.346 5.239 5.239-2.346 5.238-5.239 5.238zM17.288 13.394c-1.44 0-2.607 1.168-2.607 2.607s1.167 2.607 2.607 2.607 2.607-1.167 2.607-2.607c0.001-1.439-1.166-2.607-2.607-2.607z'
                fill='#ffffff'
            />
        </svg>
    )
}
